// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAA5JREFUeNpiYGBgAAgwAAAEAAGbA+oJAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === Base Styles & Variables === */
html {
  box-sizing: border-box;
}
*,
*::before,
*::after {
  box-sizing: inherit;
}
body * {
  font-family: var(--body-font-family-none, Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, color emoji, segoe ui emoji, noto color emoji, android emoji);
}
body * .ant-typography {
  font-family: var(--body-font-family-none, Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, color emoji, segoe ui emoji, noto color emoji, android emoji);
}
body {
  margin: 0;
  background-color: #f5f7fa;
}
body a {
  color: rgb(var(--color-primary-none, 89, 96, 109));
}
body a:hover {
  color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);
}
.nkl-deck-app-root .nkl-content-root .ant-layout-content .main-layout {
  padding-top: 24px;
}
.primary-background:not(:disabled) {
  background: rgb(var(--color-primary-none, 89, 96, 109)) !important;
}
.primary-background:not(:disabled).ant-btn.primary-background:not(:disabled):not(:disabled) {
  border-color: rgb(var(--color-primary-none, 89, 96, 109)) !important;
}
.primary-background:not(:disabled).ant-btn.primary-background:not(:disabled):not(:disabled):hover {
  background-color: rgba(var(--color-primary-none, 89, 96, 109), 0.9) !important;
}
.primary-color {
  color: rgb(var(--color-primary-none, 89, 96, 109)) !important;
}
.primary-background-avatar {
  background-color: rgb(var(--color-primary-none, 89, 96, 109)) !important;
}
.primary-fill {
  fill: rgb(var(--color-primary-none, 89, 96, 109)) !important;
}
.primary-gradient {
  background: linear-gradient(180deg, #ffffff 0%, rgba(var(--color-primary-none, 89, 96, 109), 0.07) 100%) !important;
}
.primary-border {
  border-color: rgb(var(--color-primary-none, 89, 96, 109)) !important;
}
.primary-border:hover {
  border-color: rgba(var(--color-primary-none, 89, 96, 109), 0.9) !important;
}
.primary-hover:hover {
  color: rgba(var(--color-primary-none, 89, 96, 109), 0.9) !important;
}
.primary-highlight.highlighted {
  background-color: rgba(var(--color-primary-none, 30, 112, 235), 0.1) !important;
}
.primary-highlight.ant-menu-item-selected {
  background-color: rgba(var(--color-primary-none, 30, 112, 235), 0.1) !important;
}
.primary-highlight:active {
  background-color: rgba(var(--color-primary-none, 30, 112, 235), 0.1) !important;
}
.primary-highlight-hover:hover {
  background-color: rgba(var(--color-primary-none, 30, 112, 235), 0.1) !important;
}
.primary-error-background {
  background-color: #de1b1b !important;
}
.primary-error-background.ant-btn {
  border-color: #de1b1b !important;
}
.primary-error {
  color: #de1b1b !important;
}
.primary-info-background {
  background-color: #1d5bbf !important;
}
.primary-info-background.ant-btn {
  border-color: #1d5bbf !important;
}
.primary-info {
  color: #1d5bbf !important;
}
.primary-warning-background {
  background-color: #fcc419 !important;
}
.primary-warning-background.ant-btn {
  border-color: #fcc419 !important;
}
.primary-warning {
  color: #fcc419 !important;
}
.primary-success-background {
  background-color: #038537 !important;
}
.primary-success-background.ant-btn {
  border-color: #038537 !important;
}
.primary-success {
  color: #038537 !important;
}
.react-calendar .react-calender__tile--now {
  border-color: rgb(var(--color-primary-none, 89, 96, 109)) !important;
}
.ant-btn.nkl-deck-site-content:not(:disabled) {
  border-color: rgb(var(--color-primary-none, 89, 96, 109)) !important;
}
.ant-btn.nkl-deck-site-content:not(:disabled):focus {
  border-color: rgb(var(--color-primary-none, 89, 96, 109)) !important;
}
.ant-btn.nkl-deck-site-content:not(:disabled):hover {
  border-color: rgba(var(--color-primary-none, 89, 96, 109), 0.9) !important;
}
.secondary-background {
  background: rgb(var(--color-secondary-none, 255, 255, 255)) !important;
}
.secondary-background.ant-btn {
  color: #000 !important;
  border-color: #fff !important;
}
.secondary-color {
  color: rgb(var(--color-secondary-none, 255, 255, 255)) !important;
}
.ant-alert {
  padding: 16px;
  display: flex;
  border-radius: 12px;
}
.ant-alert .ant-alert-content .ant-alert-message {
  font-weight: 600;
  margin-bottom: 0px;
}
.ant-alert .ant-alert-content .ant-alert-description {
  font-size: 14px;
  font-weight: 400;
  color: #59606d;
}
.ant-alert .ant-alert-content .ant-alert-description .ant-alert-description-inner {
  margin-bottom: 8px;
}
.ant-alert .ant-alert-close-icon svg {
  height: 16px;
  width: 16px;
  color: #59606d;
}
.ant-alert.ant-alert-info {
  background-color: #f0f5fc;
  border: 1px solid #1d5bbf;
}
.ant-alert.ant-alert-info .ant-alert-icon {
  color: #1d5bbf;
}
.ant-alert.ant-alert-success {
  background-color: #e1faeb;
  border: 1px solid #038537;
}
.ant-alert.ant-alert-success .ant-alert-icon {
  color: #038537;
}
.ant-alert.ant-alert-warning {
  background-color: #fff9db;
  border: 1px solid #fcc419;
}
.ant-alert.ant-alert-warning .ant-alert-icon {
  color: #fcc419;
}
.ant-alert.ant-alert-error {
  background-color: #faf0f0;
  border: 1px solid #de1b1b;
}
.ant-alert.ant-alert-error .ant-alert-icon {
  color: #de1b1b;
}
.ant-alert.ant-alert-neutral {
  background-color: white;
  border: 1px solid #59606d;
}
.ant-alert.ant-alert-neutral .ant-alert-icon {
  color: #59606d;
}
.ant-alert.no-description {
  align-items: center;
}
.ant-alert.no-description .ant-alert-content {
  display: flex;
  align-items: center;
}
.ant-avatar {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, color emoji, segoe ui emoji, noto color emoji, android emoji;
  background-color: #c9d1df;
  color: #ffffff;
  border: none;
}
.ant-avatar.ant-avatar-image {
  border: none;
}
.ant-avatar.jumbo-avatar .ant-avatar-string {
  font-size: 30px;
}
.ant-avatar.large-avatar .ant-avatar-string {
  font-size: 18px;
}
.ant-avatar.medium-avatar {
  margin-inline-start: -10px;
  margin: 0px;
}
.ant-avatar.medium-avatar .ant-avatar-string {
  font-size: 16px;
}
.ant-avatar.small-avatar .ant-avatar-string {
  font-size: 12px;
}
.ant-avatar.mini-avatar .ant-avatar-string {
  font-size: 10px;
}
.ant-avatar-group {
  display: inline-flex;
}
.ant-avatar-group.large-avatar .ant-avatar {
  margin-inline-start: -14px;
}
.ant-avatar-group.large-avatar .ant-avatar .ant-avatar-string {
  font-size: 18px;
}
.ant-avatar-group.medium-avatar .ant-avatar {
  margin-inline-start: -10px;
}
.ant-avatar-group.medium-avatar .ant-avatar .ant-avatar-string {
  font-size: 16px;
}
.ant-avatar-group.small-avatar .ant-avatar {
  margin-inline-start: -8px;
}
.ant-avatar-group.small-avatar .ant-avatar .ant-avatar-string {
  font-size: 12px;
}
.ant-avatar-group.mini-avatar .ant-avatar {
  margin-inline-start: -4px;
}
.ant-avatar-group.mini-avatar .ant-avatar .ant-avatar-string {
  font-size: 10px;
}
.ant-avatar-group .ant-avatar {
  background-color: rgb(var(--color-primary-none, 89, 96, 109));
  border: 1px solid #ffffff;
}
.avatar-container {
  display: inline-flex;
  align-items: center;
}
.avatar-container .avatar-info-container {
  display: flex;
  flex-direction: column;
  padding: 8px;
}
.avatar-container .avatar-info-container .avatar-info-name {
  font-size: 16px;
  display: inline-flex;
  font-weight: 600;
  align-items: center;
}
.avatar-container .avatar-info-container .avatar-info-name .avatar-info-pronouns {
  font-size: 14px;
  flex-direction: row;
  color: #59606d;
  display: inline-flex;
  font-weight: 400;
  align-items: center;
}
.avatar-container .avatar-info-container .avatar-info-name-mini {
  font-size: 14px;
  display: flex;
  font-weight: 600;
  align-items: center;
}
.avatar-container .avatar-info-container .avatar-info-name-mini .avatar-info-pronouns {
  font-size: 12px;
  flex-direction: row;
  color: #59606d;
  display: flex;
  font-weight: 400;
  align-items: center;
}
.avatar-container .avatar-info-content {
  font-size: 14px;
  font-weight: 600;
  color: #59606d;
  display: flex;
  align-items: center;
}
.ant-avatar-group-popover .ant-popover-content .ant-popover-inner-content {
  text-align: center;
}
.ant-badge .ant-badge-count {
  height: 21px;
  padding: 1px 8px 0 8px;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  border-radius: 16px;
}
.ant-badge.ant-badge-status .ant-badge-status-text {
  color: #59606d;
}
.default .ant-badge-count,
.neutral .ant-badge-count,
.warning .ant-badge-count {
  color: black;
}
.ant-badge.badge-size-large .ant-badge-count {
  height: 26px;
  padding: 2px 10px;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  border-radius: 20px;
}
.ant-badge.badge-size-medium .ant-badge-count {
  height: 21px;
  padding: 1px 8px 0 8px;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  border-radius: 16px;
}
.ant-badge.badge-size-small .ant-badge-count {
  height: 16px;
  min-width: 16px;
  padding: 2px 6px;
  font-weight: 600;
  font-size: 10px;
  line-height: 14px;
  border-radius: 10px;
}
.ant-breadcrumb ol li:not(:last-child) {
  color: #59606d;
}
.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-link,
.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-overlay-link {
  display: inline-flex;
  align-items: center;
}
.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-link .anticon,
.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-overlay-link .anticon,
.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-link svg,
.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-overlay-link svg {
  color: #59606d;
  width: 16px;
  height: 16px;
}
.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-link .anticon + span,
.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-overlay-link .anticon + span,
.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-link svg + span,
.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-overlay-link svg + span {
  margin-left: 4px;
}
.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-link a,
.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-overlay-link a,
.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-link span,
.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-overlay-link span {
  color: #59606d;
}
.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-link:hover,
.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-overlay-link:hover {
  background-color: transparent;
  color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-link:hover .anticon,
.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-overlay-link:hover .anticon,
.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-link:hover svg,
.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-overlay-link:hover svg,
.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-link:hover a,
.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-overlay-link:hover a,
.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-link:hover span,
.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-overlay-link:hover span {
  color: rgb(var(--color-primary-none, 89, 96, 109));
  background-color: transparent;
}
.ant-dropdown-trigger .anticon {
  display: none;
}
.ant-dropdown-trigger .breadcrumbDropdown {
  display: flex;
  align-items: center;
}
.ant-dropdown-trigger .breadcrumbDropdown svg {
  margin-left: 2px;
}
.dropdown-icon {
  margin-left: 8px;
  display: flex;
  align-items: center;
}
.ant-btn.ant-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  font-family: var(--body-font-family-none, Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, color emoji, segoe ui emoji, noto color emoji, android emoji);
  line-height: 20px;
  box-shadow: none;
  color: #59606d;
}
.ant-btn.ant-btn .ant-btn-icon > svg {
  width: 20px;
  height: 20px;
}
.ant-btn.ant-btn > svg {
  width: 20px;
  height: 20px;
}
.ant-btn.ant-btn.ant-btn {
  gap: 9px;
}
.ant-btn.ant-btn.ant-btn-circle:not(.ant-btn-icon-only) {
  padding: 8px 12px;
}
.ant-btn.ant-btn.ant-btn.ant-btn.success {
  background-color: #038537;
}
.ant-btn.ant-btn.ant-btn-icon-only {
  padding: 8px;
  width: 36px;
  height: 36px;
}
.ant-btn.ant-btn:not(.ant-btn-lg, .ant-btn-sm) {
  min-width: 36px;
  height: 36px;
}
.ant-btn.ant-btn.ant-btn-sm {
  padding: 5px 12px 5px 12px;
  height: 26px;
  font-size: 12px;
  line-height: 16px;
  border-radius: 25px;
}
.ant-btn.ant-btn.ant-btn-sm .ant-btn-icon > svg {
  width: 16px;
  height: 16px;
}
.ant-btn.ant-btn.ant-btn-sm > svg {
  width: 16px;
  height: 16px;
}
.ant-btn.ant-btn.ant-btn-sm.ant-btn-icon-only {
  padding: 5px;
  width: 26px;
  height: 26px;
}
.ant-btn.ant-btn.ant-btn-lg {
  padding: 10px 20px 10px 20px;
  height: 44px;
  font-size: 16px;
  line-height: 24px;
}
.ant-btn.ant-btn.ant-btn-lg .ant-btn-icon {
  height: 24px;
  width: 24px;
}
.ant-btn.ant-btn.ant-btn-lg .ant-btn-icon > svg {
  width: 24px;
  height: 24px;
}
.ant-btn.ant-btn.ant-btn-lg.ant-btn-icon-only {
  padding: 10px;
  width: 44px;
  height: 44px;
}
.ant-btn.ant-btn.ant-btn-lg.ant-btn-icon-only .ant-btn-icon {
  height: 24px;
  width: 24px;
}
.ant-btn.ant-btn:not(.ant-btn-round, .ant-btn-circle) {
  border-radius: 6px;
}
.ant-btn.ant-btn:not(.ant-btn-round, .ant-btn-circle).ant-btn-sm {
  border-radius: 4px;
}
.ant-btn.ant-btn:not(.ant-btn-round, .ant-btn-circle).ant-btn-lg {
  border-radius: 8px;
}
.ant-btn.ant-btn.ant-btn-default {
  box-shadow: none;
}
.ant-btn.ant-btn:disabled {
  color: #b1baca;
  background-color: #f5f7fa;
  border-color: #c9d1df;
}
.ant-btn.ant-btn:disabled.ant-btn-link,
.ant-btn.ant-btn:disabled.ant-btn-background-ghost {
  background-color: transparent;
}
.ant-btn.ant-btn:disabled.ant-btn-text,
.ant-btn.ant-btn:disabled.ant-btn-link {
  border: none;
}
.ant-btn.ant-btn:disabled.ant-btn-text {
  background-color: #f5f7fa;
}
.ant-btn.ant-btn:disabled.ant-btn-link {
  background-color: transparent;
}
.ant-btn.ant-btn:not(.ant-btn-icon-only) .ant-btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.ant-btn.ant-btn.ant-btn-primary:not(:disabled) {
  color: #fff;
  background-color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-btn.ant-btn.ant-btn-primary:not(:disabled):hover {
  background-color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);
}
.ant-btn.ant-btn.ant-btn-primary:not(:disabled).ant-btn-dangerous {
  background-color: #de1b1b;
}
.ant-btn.ant-btn.ant-btn-primary:not(:disabled).ant-btn-dangerous:hover {
  background-color: #f55353;
}
.ant-btn.ant-btn.ant-btn-primary:not(:disabled).ant-btn-background-ghost {
  color: rgb(var(--color-primary-none, 89, 96, 109));
  background-color: transparent;
  border-color: #c9d1df;
}
.ant-btn.ant-btn.ant-btn-primary:not(:disabled).ant-btn-background-ghost:hover {
  color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);
}
.ant-btn.ant-btn.ant-btn-default:not(:disabled),
.ant-btn.ant-btn.ant-btn-dashed:not(:disabled),
.ant-btn.ant-btn.ant-btn-text:not(:disabled) {
  background-color: #fff;
  border-color: #c9d1df;
}
.ant-btn.ant-btn.ant-btn-default:not(:disabled):hover,
.ant-btn.ant-btn.ant-btn-dashed:not(:disabled):hover,
.ant-btn.ant-btn.ant-btn-text:not(:disabled):hover {
  border-color: #c9d1df;
  color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);
}
.ant-btn.ant-btn.ant-btn-default:not(:disabled).ant-btn-dangerous,
.ant-btn.ant-btn.ant-btn-dashed:not(:disabled).ant-btn-dangerous,
.ant-btn.ant-btn.ant-btn-text:not(:disabled).ant-btn-dangerous {
  color: #de1b1b;
}
.ant-btn.ant-btn.ant-btn-default:not(:disabled).ant-btn-dangerous:hover,
.ant-btn.ant-btn.ant-btn-dashed:not(:disabled).ant-btn-dangerous:hover,
.ant-btn.ant-btn.ant-btn-text:not(:disabled).ant-btn-dangerous:hover {
  color: #f55353;
}
.ant-btn.ant-btn.ant-btn-default:not(:disabled).ant-btn-background-ghost,
.ant-btn.ant-btn.ant-btn-dashed:not(:disabled).ant-btn-background-ghost,
.ant-btn.ant-btn.ant-btn-text:not(:disabled).ant-btn-background-ghost {
  color: #59606d;
  background-color: transparent;
  border-color: #c9d1df;
}
.ant-btn.ant-btn.ant-btn-default:not(:disabled).ant-btn-background-ghost:hover,
.ant-btn.ant-btn.ant-btn-dashed:not(:disabled).ant-btn-background-ghost:hover,
.ant-btn.ant-btn.ant-btn-text:not(:disabled).ant-btn-background-ghost:hover {
  color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);
}
.ant-btn.ant-btn.ant-btn-default:not(:disabled).ant-btn-background-ghost.ant-btn-dangerous,
.ant-btn.ant-btn.ant-btn-dashed:not(:disabled).ant-btn-background-ghost.ant-btn-dangerous,
.ant-btn.ant-btn.ant-btn-text:not(:disabled).ant-btn-background-ghost.ant-btn-dangerous {
  color: #de1b1b;
}
.ant-btn.ant-btn.ant-btn-default:not(:disabled).ant-btn-background-ghost.ant-btn-dangerous:hover,
.ant-btn.ant-btn.ant-btn-dashed:not(:disabled).ant-btn-background-ghost.ant-btn-dangerous:hover,
.ant-btn.ant-btn.ant-btn-text:not(:disabled).ant-btn-background-ghost.ant-btn-dangerous:hover {
  color: #f55353;
}
.ant-btn.ant-btn.ant-btn-text:not(:disabled) {
  border: none;
}
.ant-btn.ant-btn.ant-btn-text:not(:disabled):hover {
  background-color: #f5f7fa;
}
.ant-btn.ant-btn.ant-btn-link:not(:disabled) {
  color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-btn.ant-btn.ant-btn-link:not(:disabled):hover {
  color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);
}
.ant-btn.ant-btn.ant-btn-link:not(:disabled).ant-btn-dangerous {
  color: #de1b1b;
}
.ant-btn.ant-btn.ant-btn-link:not(:disabled).ant-btn-dangerous:hover {
  color: #f55353;
}
.ant-btn:not(:disabled):focus,
.ant-btn:not(:disabled):focus-visible {
  outline: none;
  box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);
  -webkit-box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);
}
.ant-btn span {
  pointer-events: none;
}
.carousel {
  width: 100%;
}
.carousel .ant-card {
  padding: 0;
  border-radius: 24px;
  position: relative;
}
.carousel .bottom-container {
  bottom: 24px;
  position: absolute;
  right: 24px;
  width: 100%;
  z-index: 10;
  width: auto;
}
.carousel .carousel-content-container.disabled .news-content-container {
  cursor: not-allowed;
}
.carousel .news-content-container {
  height: 100%;
  position: absolute;
  bottom: 0;
  width: 100%;
  cursor: pointer;
  outline-offset: -1px;
  display: flex;
}
.carousel .news-content-container.no-link {
  cursor: default;
}
.carousel .clickable {
  cursor: pointer;
}
.carousel .content-box {
  display: block;
  position: absolute;
  height: 33%;
  bottom: 0;
}
.carousel .content-box .text-container {
  color: #FFFFFF;
  width: 300px;
  position: absolute;
  left: 30px;
  max-height: 100%;
  top: 0;
  padding-bottom: 20px;
  font-size: 16px;
  pointer-events: none;
}
.carousel .img-container {
  width: 100%;
  min-height: 320px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 24px;
}
.carousel .img-container .image {
  height: 320px;
  -o-object-fit: cover;
     object-fit: cover;
  width: 100%;
}
.carousel .img-container .scrim {
  background-image: linear-gradient(rgba(0, 0, 0, 0.54), rgba(0, 0, 0, 0.54));
  height: 100%;
  width: 100%;
  display: block;
  position: absolute;
}
.carousel .video-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.carousel .video-modal .play-control {
  display: flex;
  width: 100%;
  position: absolute;
  justify-content: center;
  align-items: center;
  z-index: 100;
}
.carousel .video-modal .play-control .video-player-button {
  display: flex;
  justify-content: center;
  position: absolute;
}
.carousel .direction-arrow {
  background-color: rgba(0, 0, 0, 0.54);
  color: #FFFFFF;
  margin-right: 10px;
  border-radius: 30px;
  height: 44px;
  width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.carousel .count-container {
  background-color: rgba(0, 0, 0, 0.54);
  color: #FFFFFF;
  border-radius: 30px;
  height: 44px;
  line-height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}
.carousel .controls {
  justify-content: flex-end;
  display: flex;
}
.carousel .nav-button-container {
  display: flex;
  flex-direction: row;
}
.carousel .link-container {
  border-radius: 16px;
}
.carousel .link-container:focus {
  box-shadow: 0 0 0 1px #1f75cb;
  border-color: #1f75cb;
}
@container (max-width: 320px) {
  .carousel .content-box {
    height: 50%;
  }
  .carousel .content-box .text-container {
    width: 200px;
    left: 5px;
    font-size: 14px;
  }
  .carousel .controls {
    margin-right: 0;
  }
  .carousel .bottom-container {
    bottom: 20px;
  }
}
.ant-card.ant-card {
  border-radius: 24px;
}
.ant-checkbox-wrapper {
  color: #000;
}
.ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner {
  background-color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);
}
.ant-checkbox-wrapper .ant-checkbox {
  align-self: flex-start;
  margin-top: 2px;
}
.ant-checkbox-wrapper .ant-checkbox > span.ant-checkbox-inner {
  border-radius: 2px;
}
.ant-checkbox-wrapper .ant-checkbox.ant-checkbox-disabled > span.ant-checkbox-inner {
  background: #f5f7fa;
  border: 1px #c9d1df solid;
}
.ant-checkbox-wrapper .ant-checkbox.ant-checkbox-disabled > span.ant-checkbox-inner::after {
  border-color: #c9d1df;
}
.ant-checkbox-wrapper .ant-checkbox.ant-checkbox-disabled.ant-checkbox-indeterminate > span.ant-checkbox-inner::after {
  background-color: #c9d1df;
}
.ant-checkbox-wrapper.ant-checkbox-wrapper-disabled :nth-child(2) {
  color: #b1baca;
}
.ant-checkbox-wrapper .ant-checkbox:not(.ant-checkbox-disabled) .ant-checkbox-input:focus-visible + .ant-checkbox-inner {
  outline: none;
  box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);
  -webkit-box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);
}
.ant-checkbox-wrapper .ant-checkbox:not(.ant-checkbox-disabled) > span.ant-checkbox-inner {
  border: 1px #b1baca solid;
}
.ant-checkbox-wrapper .ant-checkbox:not(.ant-checkbox-disabled).ant-checkbox-checked > span.ant-checkbox-inner {
  background-color: rgb(var(--color-primary-none, 89, 96, 109));
  border-color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-checkbox-wrapper .ant-checkbox:not(.ant-checkbox-disabled).ant-checkbox-indeterminate ::after {
  background-color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-checkbox-wrapper .ant-checkbox:not(.ant-checkbox-disabled):hover span.ant-checkbox-inner {
  border: 1px #9099a9 solid;
}
.ant-picker {
  padding: 10px 12px;
  min-width: 136px;
  height: 44px;
  border: 1px #c9d1df solid;
  border-radius: 8px;
}
.ant-picker.ant-picker-outlined.ant-picker-status-error:not(.ant-picker-disabled) {
  color: #de1b1b;
}
.ant-picker.ant-picker-outlined.ant-picker-status-error:not(.ant-picker-disabled) .ant-picker-suffix {
  color: #de1b1b;
}
.ant-picker:hover:not(.ant-picker-disabled) {
  border-color: #9099a9;
}
.ant-picker.ant-picker-disabled {
  background-color: #f5f7fa;
}
.ant-picker.ant-picker-disabled.ant-picker-range:hover,
.ant-picker.ant-picker-disabled.ant-picker-outlined:hover {
  background-color: #f5f7fa;
  border-color: #c9d1df;
}
.ant-picker.ant-picker-focused {
  border-color: #9099a9;
  box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);
}
.ant-picker .ant-picker-input input {
  color: #000;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}
.ant-picker .ant-picker-input input::-moz-placeholder {
  color: #c9d1df;
}
.ant-picker .ant-picker-input input::placeholder {
  color: #c9d1df;
}
.ant-picker .ant-picker-suffix,
.ant-picker .ant-picker-separator,
.ant-picker .ant-picker-clear {
  display: flex;
  flex: none;
  align-self: center;
  width: 20px;
  height: 20px;
  color: #b1baca;
  line-height: 20px;
}
.ant-picker .ant-picker-suffix .anticon,
.ant-picker .ant-picker-separator .anticon,
.ant-picker .ant-picker-clear .anticon {
  height: 20px;
}
.ant-picker .ant-picker-suffix svg,
.ant-picker .ant-picker-separator svg,
.ant-picker .ant-picker-clear svg {
  width: 20px;
  height: 20px;
}
.ant-picker .ant-picker-clear:hover {
  color: #b1baca;
}
.ant-picker.ant-picker-range .ant-picker-input > input {
  text-align: center;
}
.ant-picker.ant-picker-range .ant-picker-active-bar {
  background-color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-picker.ant-picker-range .ant-picker-range-separator {
  display: flex;
}
.ant-picker-dropdown {
  color: #59606d;
}
.ant-picker-dropdown .ant-picker-panel {
  border-color: #eceff4;
}
.ant-picker-dropdown .ant-picker-panel .ant-picker-date-panel {
  width: 280px;
}
.ant-picker-dropdown .ant-picker-panel .ant-picker-date-panel .ant-picker-header .ant-picker-month-btn {
  pointer-events: none;
}
.ant-picker-dropdown .ant-picker-panel .ant-picker-date-panel .ant-picker-header .ant-picker-year-btn {
  pointer-events: none;
}
.ant-picker-dropdown .ant-picker-panel .ant-picker-date-panel .ant-picker-body {
  padding: 8px 14px;
}
.ant-picker-dropdown .ant-picker-panel .ant-picker-month-panel .ant-picker-header .ant-picker-year-btn,
.ant-picker-dropdown .ant-picker-panel .ant-picker-year-panel .ant-picker-header .ant-picker-year-btn,
.ant-picker-dropdown .ant-picker-panel .ant-picker-month-panel .ant-picker-header .ant-picker-decade-btn,
.ant-picker-dropdown .ant-picker-panel .ant-picker-year-panel .ant-picker-header .ant-picker-decade-btn {
  pointer-events: none;
}
.ant-picker-dropdown .ant-picker-panel .ant-picker-month-panel .ant-picker-cell,
.ant-picker-dropdown .ant-picker-panel .ant-picker-year-panel .ant-picker-cell {
  padding: 3px 8px;
}
.ant-picker-dropdown .ant-picker-panel .ant-picker-month-panel .ant-picker-cell .current,
.ant-picker-dropdown .ant-picker-panel .ant-picker-year-panel .ant-picker-cell .current {
  border: rgb(var(--color-primary-none, 89, 96, 109)) 1px solid;
  border-radius: 16px;
}
.ant-picker-dropdown .ant-picker-panel .ant-picker-month-panel .ant-picker-cell .ant-picker-cell-inner,
.ant-picker-dropdown .ant-picker-panel .ant-picker-year-panel .ant-picker-cell .ant-picker-cell-inner {
  width: 100%;
}
@media screen and (max-width: 1087px) {
  .ant-picker-dropdown .ant-picker-panel-container .ant-picker-panel-layout {
    flex-direction: column-reverse;
    height: auto;
  }
  .ant-picker-dropdown .ant-picker-panel-container .ant-picker-panel-layout .ant-picker-presets {
    height: 80px;
    width: 100%;
  }
  .ant-picker-dropdown .ant-picker-panel-container .ant-picker-panel-layout .ant-picker-presets ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 280px;
    min-width: none;
    max-width: none;
  }
  .ant-picker-dropdown .ant-picker-panel-container .ant-picker-panel-layout .ant-picker-presets ul li {
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    color: rgb(var(--color-primary-none, 89, 96, 109));
  }
  .ant-picker-dropdown .ant-picker-panel-container .ant-picker-panel-layout .ant-picker-presets ul li + li {
    margin-top: 0;
  }
  .ant-picker-dropdown .ant-picker-panel-container .ant-picker-panel-layout .ant-picker-panels .ant-picker-panel:nth-child(2) {
    display: none;
  }
  .ant-picker-dropdown .ant-picker-panel-container .ant-picker-panel-layout .ant-picker-panels .ant-picker-panel:first-child .ant-picker-header-next-btn,
  .ant-picker-dropdown .ant-picker-panel-container .ant-picker-panel-layout .ant-picker-panels .ant-picker-panel:first-child .ant-picker-header-super-next-btn {
    visibility: visible !important;
  }
}
.ant-picker-dropdown .ant-picker-footer {
  min-height: 40px;
  border-color: #eceff4;
}
.ant-picker-dropdown .ant-picker-footer .ant-picker-ranges {
  align-items: center;
  margin: 0;
  min-height: 42px;
}
.ant-picker-dropdown .ant-picker-footer .ant-picker-today-btn {
  color: rgb(var(--color-primary-none, 89, 96, 109));
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  padding: 0px 12px;
  border-radius: 16px;
}
.ant-picker-dropdown .ant-picker-footer .ant-picker-today-btn:hover {
  background: #f5f7fa;
}
.ant-picker-dropdown .ant-picker-footer .ant-picker-now-btn {
  padding: 0 12px;
  color: rgb(var(--color-primary-none, 89, 96, 109));
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  border-radius: 16px;
}
.ant-picker-dropdown .ant-picker-footer .ant-picker-now-btn:hover {
  background: #f5f7fa;
}
.ant-picker-dropdown .ant-picker-footer .ant-picker-ok button.ant-btn.ant-btn-primary.ant-btn-sm {
  height: 26px;
  padding: 5px 12px;
  font-size: 12px;
  line-height: 16px;
  border-radius: 25px;
}
.ant-picker-dropdown .ant-picker-panel-container {
  box-shadow: 0 4px 16px rgba(52, 56, 63, 0.16);
}
.ant-picker-dropdown .ant-picker-panel-container .ant-picker-presets {
  min-width: 128px;
}
.ant-picker-dropdown .ant-picker-panel-container .ant-picker-presets ul {
  border-inline-end: 1px solid #eceff4;
}
.ant-picker-dropdown .ant-picker-panel-container .ant-picker-presets ul li {
  display: flex;
  align-items: center;
  height: 24px;
  border-radius: 16px;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-picker-dropdown .ant-picker-panel-container .ant-picker-presets ul li:hover {
  background: #f5f7fa;
}
.ant-picker-dropdown .ant-picker-header {
  padding: 0 8px;
  color: #59606d;
  border-bottom: 1px #eceff4 solid;
}
.ant-picker-dropdown .ant-picker-header button {
  min-width: 16px;
  color: #59606d;
  line-height: 37px;
}
.ant-picker-dropdown .ant-picker-header button span[class^="origami-picker-"] {
  display: flex;
  align-items: center;
  justify-content: center;
}
.ant-picker-dropdown .ant-picker-header button span[class^="origami-picker-"] svg {
  width: 16px;
  height: 16px;
}
.ant-picker-dropdown .ant-picker-header button:hover {
  color: #b1baca;
}
.ant-picker-dropdown .ant-picker-header .ant-picker-header-view {
  line-height: 37px;
}
.ant-picker-dropdown .ant-picker-header .ant-picker-header-view button {
  color: #000;
}
.ant-picker-dropdown .ant-picker-header .ant-picker-header-view button:hover {
  color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-picker-dropdown .ant-picker-content tr {
  height: 30px;
}
.ant-picker-dropdown .ant-picker-content th {
  color: #59606d;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-cell {
  height: 28px;
  padding: 3px 6px;
  color: #c9d1df;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view:not(.ant-picker-cell-disabled) {
  color: #59606d;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-disabled {
  cursor: not-allowed;
  color: #c9d1df;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-disabled::before {
  background-color: #f5f7fa;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
  color: #f5f7fa;
  background: rgb(var(--color-primary-none, 89, 96, 109));
  font-weight: 600;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-in-range::before {
  background: #f5f7fa;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover::before,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start::before,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end::before,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover .ant-picker-cell-inner::after,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start .ant-picker-cell-inner::after,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner::after {
  background-color: #dee3ec;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before {
  background: #f5f7fa;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-start.ant-picker-cell-range-hover::before,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-end.ant-picker-cell-range-hover::before,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single).ant-picker-cell-range-hover-start::before,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single).ant-picker-cell-range-hover-end::before {
  background: #dee3ec;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover-start:not(.ant-picker-cell-in-range):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end)::after,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-in-view.ant-picker-cell-range-hover-end:not(.ant-picker-cell-in-range):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end)::after,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover-start.ant-picker-cell-range-start-single::after,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover-start.ant-picker-cell-range-start.ant-picker-cell-range-end.ant-picker-cell-range-end-near-hover::after,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover-end.ant-picker-cell-range-start.ant-picker-cell-range-end.ant-picker-cell-range-start-near-hover::after,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover-end.ant-picker-cell-range-end-single::after,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover:not(.ant-picker-cell-in-range)::after {
  height: 28px;
  border-top: 1px dashed rgb(var(--color-primary-none, 89, 96, 109));
  border-bottom: 1px dashed rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover:first-child::after,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover-end:first-child::after,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-start.ant-picker-cell-range-hover-edge-start.ant-picker-cell-range-hover-edge-start-near-range::after,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover-edge-start:not(.ant-picker-cell-range-hover-edge-start-near-range)::after,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover-start::after {
  inset-inline-start: 3px;
  border-inline-start: 1px dashed rgb(var(--color-primary-none, 89, 96, 109));
  border-start-start-radius: 20px;
  border-end-start-radius: 20px;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover:last-child::after,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover-start:last-child::after,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-end.ant-picker-cell-range-hover-edge-end.ant-picker-cell-range-hover-edge-end-near-range::after,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover-edge-end:not(.ant-picker-cell-range-hover-edge-end-near-range)::after,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover-end::after {
  inset-inline-end: 3px;
  border-inline-end: 1px dashed rgb(var(--color-primary-none, 89, 96, 109));
  border-start-end-radius: 20px;
  border-end-end-radius: 20px;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single):not(.ant-picker-cell-range-end)::before {
  inset-inline-start: 4px;
  border-start-start-radius: 16px;
  border-end-start-radius: 16px;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single):not(.ant-picker-cell-range-end) .ant-picker-cell-inner {
  border-radius: 16px;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-end::before {
  inset-inline-end: 4px;
  border-start-end-radius: 16px;
  border-end-end-radius: 16px;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
  border-radius: 16px;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-disabled {
  cursor: not-allowed;
  color: #c9d1df;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-disabled::before {
  background-color: #f5f7fa;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-today {
  font-weight: 600;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-cell::before {
  height: 28px;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-cell .ant-picker-cell-inner {
  border-radius: 16px;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-cell .ant-picker-cell-inner::before {
  border-radius: 16px;
  border-color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-picker-dropdown .ant-picker-content .ant-picker-cell:hover:not(.ant-picker-cell-in-view) .ant-picker-cell-inner,
.ant-picker-dropdown .ant-picker-content .ant-picker-cell:hover:not(.ant-picker-cell-selected):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end):not(.ant-picker-cell-range-hover-start):not(.ant-picker-cell-range-hover-end) .ant-picker-cell-inner {
  background: #f5f7fa;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-time-panel-column {
  margin: 0;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-time-panel-column li.ant-picker-time-panel-cell {
  margin-inline: 0;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-time-panel-column li.ant-picker-time-panel-cell .ant-picker-time-panel-cell-inner {
  width: 56px;
  padding-inline: 0;
  color: #59606d;
  text-align: center;
  border-radius: 0;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-time-panel-column li.ant-picker-time-panel-cell .ant-picker-time-panel-cell-inner:hover {
  background: #f5f7fa;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-time-panel-column li.ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner {
  color: #fff;
  font-weight: 600;
  background: rgb(var(--color-primary-none, 89, 96, 109));
  border-radius: 0;
}
.ant-picker-dropdown .ant-picker-content .ant-picker-time-panel-column li.ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner:hover {
  background: rgba(var(--color-primary-none, 89, 96, 109), 0.9);
}
.mobile-view-only .ant-picker-panel .ant-picker-header-next-btn,
.mobile-view-only .ant-picker-panel .ant-picker-header-super-next-btn {
  visibility: visible !important;
}
.mobile-view-only .ant-picker-panel:nth-child(2) {
  display: none;
}
.ant-divider.ant-divider-horizontal {
  border-color: #c9d1df;
}
.ant-divider.ant-divider-horizontal.ant-divider-with-text {
  font-weight: 600;
  border-color: #c9d1df;
}
.ant-divider.divider-hidden-left.ant-divider-horizontal.ant-divider-with-text::before {
  border: none;
}
.ant-divider.divider-hidden-right.ant-divider-horizontal.ant-divider-with-text::after {
  border: none;
}
a.ant-dropdown-trigger {
  display: inline-flex;
  align-items: center;
  font-weight: 600;
}
a.ant-dropdown-trigger svg {
  color: #59606d;
  width: 20px;
  height: 20px;
  margin-inline-start: 6px;
}
.ant-dropdown .ant-dropdown-menu {
  padding: 6px;
  color: #59606d;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 4px 16px rgba(52, 56, 63, 0.16);
}
.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item,
.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-submenu {
  padding: 6px 10px;
  font-size: 14px;
  line-height: 20px;
  color: #59606d;
  border-radius: 6px;
}
.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item:hover,
.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-submenu:hover {
  background-color: #f5f7fa;
}
.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item.ant-dropdown-menu-item-disabled,
.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-submenu.ant-dropdown-menu-item-disabled {
  color: #b1baca;
}
.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item.ant-dropdown-menu-item-disabled:hover,
.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-submenu.ant-dropdown-menu-item-disabled:hover {
  background-color: transparent;
}
.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item.ant-dropdown-menu-item-danger:not(.ant-dropdown-menu-item.disabled),
.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-submenu.ant-dropdown-menu-item-danger:not(.ant-dropdown-menu-item.disabled) {
  color: #de1b1b;
}
.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item.ant-dropdown-menu-item-danger:not(.ant-dropdown-menu-item.disabled):hover,
.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-submenu.ant-dropdown-menu-item-danger:not(.ant-dropdown-menu-item.disabled):hover {
  color: #fff;
  background-color: #de1b1b;
}
.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item svg.ant-dropdown-menu-item-icon,
.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-submenu svg.ant-dropdown-menu-item-icon {
  width: 20px;
  height: 20px;
}
.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-submenu .ant-dropdown-menu-submenu-title {
  padding: 0;
  color: #59606d;
}
.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-submenu .ant-dropdown-menu-submenu-title:hover {
  background-color: #f5f7fa;
}
.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-submenu .ant-dropdown-menu-submenu-title svg.ant-dropdown-menu-submenu-expand-icon {
  width: 20px;
  height: 20px;
}
.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-submenu .ant-dropdown-menu-sub .ant-dropdown-menu-item {
  color: #59606d;
}
.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-submenu .ant-dropdown-menu-sub .ant-dropdown-menu-item .ant-dropdown-menu-title-content {
  color: #59606d;
}
.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item-divider {
  background-color: #c9d1df;
}
.ant-dropdown-menu-submenu .ant-dropdown-menu-sub .ant-dropdown-menu-item {
  color: #59606d;
}
.ant-dropdown-menu-submenu .ant-dropdown-menu-sub .ant-dropdown-menu-item:hover {
  background-color: #f5f7fa;
}
.ant-dropdown-menu-submenu .ant-dropdown-menu-sub .ant-dropdown-menu-item .ant-dropdown-menu-title-content {
  color: #59606d;
}
.ant-dropdown-menu-submenu-open {
  background-color: #f5f7fa;
}
.ant-dropdown-menu.ant-dropdown-menu-sub.ant-dropdown-menu-vertical {
  position: relative;
  left: 12px;
  top: -8px;
}
.ant-dropdown-large,
.submenu-item-large {
  font-size: 16px;
  line-height: 24px;
}
.ant-dropdown-large .ant-dropdown-menu,
.submenu-item-large .ant-dropdown-menu {
  padding: 8px;
}
.ant-dropdown-large .ant-dropdown-menu .ant-dropdown-menu-item,
.submenu-item-large .ant-dropdown-menu .ant-dropdown-menu-item,
.ant-dropdown-large .ant-dropdown-menu .ant-dropdown-menu-submenu .ant-dropdown-menu-submenu-title,
.submenu-item-large .ant-dropdown-menu .ant-dropdown-menu-submenu .ant-dropdown-menu-submenu-title {
  font-size: 16px;
  line-height: 24px;
}
.ant-dropdown-large.ant-dropdown-trigger svg,
.submenu-item-large.ant-dropdown-trigger svg {
  width: 24px;
  height: 24px;
}
.ant-dropdown-small,
.submenu-item-small {
  font-size: 12px;
  line-height: 16px;
}
.ant-dropdown-small .ant-dropdown-menu,
.submenu-item-small .ant-dropdown-menu {
  padding: 4px;
}
.ant-dropdown-small .ant-dropdown-menu .ant-dropdown-menu-item,
.submenu-item-small .ant-dropdown-menu .ant-dropdown-menu-item,
.ant-dropdown-small .ant-dropdown-menu .ant-dropdown-menu-submenu .ant-dropdown-menu-submenu-title,
.submenu-item-small .ant-dropdown-menu .ant-dropdown-menu-submenu .ant-dropdown-menu-submenu-title {
  font-size: 12px;
  line-height: 16px;
}
.ant-dropdown-small.ant-dropdown-trigger svg,
.submenu-item-small.ant-dropdown-trigger svg {
  width: 16px;
  height: 16px;
}
.no-arrow {
  margin: 6px 0;
}
.ant-dropdown-button .ant-btn-default.ant-btn-compact-item.ant-btn-compact-first-item {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ant-dropdown-button .ant-btn-default.ant-btn-compact-item.ant-btn-compact-last-item {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-drawer.ant-drawer-open .ant-drawer-mask {
  background: rgba(201, 209, 223, 0.8);
}
.ant-drawer .ant-drawer-mask {
  background: rgba(201, 209, 223, 0.8);
}
input,
.ant-input,
.ant-input-affix-wrapper {
  color: #000;
  font-weight: normal;
  padding: 8px 10px;
  height: 36px;
  font-family: var(--body-font-family-none, Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, color emoji, segoe ui emoji, noto color emoji, android emoji);
  font-size: 14px;
  line-height: 20px;
  border: 1px #c9d1df solid;
}
input:-moz-placeholder, .ant-input:-moz-placeholder, .ant-input-affix-wrapper:-moz-placeholder {
  color: #c9d1df;
}
input:placeholder-shown,
.ant-input:placeholder-shown,
.ant-input-affix-wrapper:placeholder-shown {
  color: #c9d1df;
}
input::-moz-placeholder, .ant-input::-moz-placeholder, .ant-input-affix-wrapper::-moz-placeholder {
  color: #c9d1df;
}
input::placeholder,
.ant-input::placeholder,
.ant-input-affix-wrapper::placeholder {
  color: #c9d1df;
}
input.ant-input-lg,
.ant-input.ant-input-lg,
.ant-input-affix-wrapper.ant-input-lg {
  padding: 10px 12px;
  height: 44px;
  font-size: 16px;
  line-height: 24px;
}
input.ant-input-sm,
.ant-input.ant-input-sm,
.ant-input-affix-wrapper.ant-input-sm {
  padding: 5px 8px;
  height: 26px;
  font-size: 12px;
  line-height: 16px;
}
input:hover,
.ant-input:hover,
.ant-input-affix-wrapper:hover,
input:not(.ant-input-affix-wrapper-disabled):hover,
.ant-input:not(.ant-input-affix-wrapper-disabled):hover,
.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
  border-color: #9099a9;
}
input:focus,
.ant-input:focus,
.ant-input-affix-wrapper:focus,
input.ant-input-affix-wrapper-focused,
.ant-input.ant-input-affix-wrapper-focused,
.ant-input-affix-wrapper.ant-input-affix-wrapper-focused {
  border-color: #9099a9;
  box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);
}
input.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless),
.ant-input.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless),
.ant-input-affix-wrapper.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless),
input.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless),
.ant-input.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless),
.ant-input-affix-wrapper.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless) {
  border-color: #de1b1b;
}
input.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless):hover,
.ant-input.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless):hover,
.ant-input-affix-wrapper.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless):hover,
input.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless):hover,
.ant-input.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless):hover,
.ant-input-affix-wrapper.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless):hover {
  border-color: #f55353;
}
input.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless):focus,
.ant-input.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless):focus,
.ant-input-affix-wrapper.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless):focus,
input.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless):focus,
.ant-input.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless):focus,
.ant-input-affix-wrapper.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless):focus,
input.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input-affix-wrapper-focused,
.ant-input.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input-affix-wrapper-focused,
.ant-input-affix-wrapper.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input-affix-wrapper-focused,
input.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper-focused,
.ant-input.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper-focused,
.ant-input-affix-wrapper.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper-focused {
  border-color: #f55353;
  box-shadow: 0 0 4px 0 rgba(222, 27, 27, 0.5);
}
input.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless),
.ant-input.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless),
.ant-input-affix-wrapper.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless),
input.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless),
.ant-input.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless),
.ant-input-affix-wrapper.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless) {
  border-color: #fcc419;
}
input.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless):hover,
.ant-input.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless):hover,
.ant-input-affix-wrapper.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless):hover,
input.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless):hover,
.ant-input.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless):hover,
.ant-input-affix-wrapper.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless):hover {
  border-color: #ffd43b;
}
input.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless):focus,
.ant-input.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless):focus,
.ant-input-affix-wrapper.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless):focus,
input.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless):focus,
.ant-input.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless):focus,
.ant-input-affix-wrapper.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless):focus,
input.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless).ant-input-affix-wrapper-focused,
.ant-input.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless).ant-input-affix-wrapper-focused,
.ant-input-affix-wrapper.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless).ant-input-affix-wrapper-focused,
input.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper-focused,
.ant-input.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper-focused,
.ant-input-affix-wrapper.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper-focused {
  border-color: #ffd43b;
  box-shadow: 0 0 4px 0 rgba(255, 212, 59, 0.75);
}
.ant-input-affix-wrapper input.ant-input {
  height: 20px;
  font-size: 14px;
  line-height: 20px;
}
.ant-input-affix-wrapper .ant-input-prefix,
.ant-input-affix-wrapper .ant-input-suffix {
  color: #59606d;
}
.ant-input-affix-wrapper .ant-input-prefix .ant-input-clear-icon,
.ant-input-affix-wrapper .ant-input-suffix .ant-input-clear-icon,
.ant-input-affix-wrapper .ant-input-prefix .ant-input-password-icon,
.ant-input-affix-wrapper .ant-input-suffix .ant-input-password-icon {
  color: #b1baca;
  display: flex;
  align-items: center;
}
.ant-input-affix-wrapper .ant-input-prefix .ant-input-clear-icon:hover,
.ant-input-affix-wrapper .ant-input-suffix .ant-input-clear-icon:hover,
.ant-input-affix-wrapper .ant-input-prefix .ant-input-password-icon:hover,
.ant-input-affix-wrapper .ant-input-suffix .ant-input-password-icon:hover {
  color: #59606d;
}
.ant-input-affix-wrapper .ant-input-prefix .ant-btn.ant-input-search-icon,
.ant-input-affix-wrapper .ant-input-suffix .ant-btn.ant-input-search-icon {
  min-width: 20px;
  width: 20px;
  background: none;
  border: none;
}
.ant-input-affix-wrapper .ant-input-prefix .ant-btn.ant-input-search-icon:focus,
.ant-input-affix-wrapper .ant-input-suffix .ant-btn.ant-input-search-icon:focus,
.ant-input-affix-wrapper .ant-input-prefix .ant-btn.ant-input-search-icon:focus-visible,
.ant-input-affix-wrapper .ant-input-suffix .ant-btn.ant-input-search-icon:focus-visible {
  box-shadow: none;
  -webkit-box-shadow: none;
}
.ant-input-affix-wrapper .ant-input-prefix svg,
.ant-input-affix-wrapper .ant-input-suffix svg {
  width: 20px;
  height: 20px;
}
.ant-input-affix-wrapper .ant-input-prefix {
  margin-inline-end: 10px;
  margin-top: 1px;
}
.ant-input-affix-wrapper .ant-input-prefix:has(svg) {
  margin-inline-end: 4px;
}
.ant-input-affix-wrapper .ant-input-prefix .ant-btn.ant-input-search-icon {
  margin-inline-end: 6px;
}
.ant-input-affix-wrapper .ant-input-suffix {
  margin-inline-start: 10px;
  margin-top: 2px;
}
.ant-input-affix-wrapper .ant-input-suffix:has(svg) {
  margin-inline-start: 4px;
}
.ant-input-affix-wrapper .ant-input-suffix .ant-btn.ant-input-search-icon {
  margin-inline-start: 6px;
}
.ant-input-affix-wrapper.ant-input-affix-wrapper-lg {
  padding: 10px 12px;
  height: 44px;
}
.ant-input-affix-wrapper.ant-input-affix-wrapper-lg input.ant-input {
  height: 24px;
  font-size: 16px;
  line-height: 24px;
}
.ant-input-affix-wrapper.ant-input-affix-wrapper-lg .ant-input-prefix,
.ant-input-affix-wrapper.ant-input-affix-wrapper-lg .ant-input-suffix {
  font-size: 16px;
}
.ant-input-affix-wrapper.ant-input-affix-wrapper-lg .ant-input-prefix svg,
.ant-input-affix-wrapper.ant-input-affix-wrapper-lg .ant-input-suffix svg {
  width: 24px;
  height: 24px;
}
.ant-input-affix-wrapper.ant-input-affix-wrapper-lg.ant-input-search .ant-input-prefix button {
  margin-left: -13px;
  padding: 10px 20px 10px 20px;
}
.ant-input-affix-wrapper.ant-input-affix-wrapper-lg.ant-input-search .ant-input-suffix button {
  margin-right: -13px;
}
.ant-input-affix-wrapper.ant-input-affix-wrapper-sm {
  padding: 5px 8px;
  height: 26px;
}
.ant-input-affix-wrapper.ant-input-affix-wrapper-sm input.ant-input {
  height: 16px;
  font-size: 12px;
  line-height: 16px;
}
.ant-input-affix-wrapper.ant-input-affix-wrapper-sm .ant-input-prefix,
.ant-input-affix-wrapper.ant-input-affix-wrapper-sm .ant-input-suffix {
  font-size: 12px;
}
.ant-input-affix-wrapper.ant-input-affix-wrapper-sm .ant-input-prefix svg,
.ant-input-affix-wrapper.ant-input-affix-wrapper-sm .ant-input-suffix svg {
  width: 16px;
  height: 16px;
}
.ant-input-affix-wrapper .anticon.ant-input-password-icon {
  color: #59606d;
}
.ant-input-affix-wrapper.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled) .ant-input-suffix > svg {
  color: #59606d;
}
.ant-input-affix-wrapper.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled) .ant-input-suffix > svg:last-of-type {
  color: #de1b1b;
}
.ant-input-affix-wrapper.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled) .ant-input-suffix > svg {
  color: #59606d;
}
.ant-input-affix-wrapper.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled) .ant-input-suffix > svg:last-of-type {
  color: #fcc419;
}
.ant-input-disabled,
.ant-input[disabled],
.ant-input-affix-wrapper.ant-input-affix-wrapper-disabled {
  color: #b1baca;
  background-color: #f5f7fa;
  border-color: #c9d1df;
}
.ant-input-disabled:hover,
.ant-input[disabled]:hover,
.ant-input-affix-wrapper.ant-input-affix-wrapper-disabled:hover {
  border-color: #c9d1df;
}
.ant-input-disabled .ant-input-prefix,
.ant-input[disabled] .ant-input-prefix,
.ant-input-affix-wrapper.ant-input-affix-wrapper-disabled .ant-input-prefix,
.ant-input-disabled .ant-input-suffix,
.ant-input[disabled] .ant-input-suffix,
.ant-input-affix-wrapper.ant-input-affix-wrapper-disabled .ant-input-suffix {
  color: #c9d1df;
}
.ant-input-disabled .ant-input-prefix svg,
.ant-input[disabled] .ant-input-prefix svg,
.ant-input-affix-wrapper.ant-input-affix-wrapper-disabled .ant-input-prefix svg,
.ant-input-disabled .ant-input-suffix svg,
.ant-input[disabled] .ant-input-suffix svg,
.ant-input-affix-wrapper.ant-input-affix-wrapper-disabled .ant-input-suffix svg {
  color: #b1baca;
}
.ant-input-group-wrapper {
  font-family: var(--body-font-family-none, Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, color emoji, segoe ui emoji, noto color emoji, android emoji);
}
.ant-input-group-wrapper .ant-input-group {
  color: #000;
}
.ant-input-group-wrapper .ant-input-group .ant-input-group-addon {
  color: #59606d;
  padding: 0 11px;
  font-size: 14px;
  line-height: 0;
  background-color: #eceff4;
  border-color: #c9d1df;
}
.ant-input-group-wrapper .ant-input-group .ant-input-group-addon svg {
  width: 20px;
  height: 20px;
}
.ant-input-group-wrapper .ant-input-group .ant-input-group-addon .ant-btn {
  width: auto;
  height: auto;
  padding: 8px 16px;
  font-size: 14px;
  line-height: 20px;
  border: none;
  border-start-start-radius: 0;
  border-end-start-radius: 0;
  box-shadow: none;
}
.ant-input-group-wrapper .ant-input-group .ant-input-group-addon .ant-btn svg {
  width: 20px;
  height: 20px;
}
.ant-input-group-wrapper .ant-input-group .ant-input-group-addon .ant-btn.ant-btn-lg {
  padding: 10px 20px;
  font-size: 16px;
  line-height: 24px;
  border-radius: 8px;
  border-start-start-radius: 0;
  border-end-start-radius: 0;
}
.ant-input-group-wrapper .ant-input-group .ant-input-group-addon .ant-btn.ant-btn-lg svg {
  width: 24px;
  height: 24px;
}
.ant-input-group-wrapper .ant-input-group .ant-input-group-addon .ant-btn.ant-btn-sm {
  padding: 5px 12px;
  font-size: 12px;
  line-height: 16px;
  border-radius: 4px;
  border-start-start-radius: 0;
  border-end-start-radius: 0;
}
.ant-input-group-wrapper .ant-input-group .ant-input-group-addon .ant-btn.ant-btn-sm svg {
  width: 16px;
  height: 16px;
}
.ant-input-group-wrapper.ant-input-group-wrapper-disabled .ant-input-group-addon {
  background-color: #f5f7fa;
  color: #b1baca;
}
.ant-input-group-wrapper.ant-input-group-wrapper-lg .ant-input-group-addon {
  font-size: 16px;
}
.ant-input-group-wrapper.ant-input-group-wrapper-lg .ant-input-group-addon svg {
  width: 24px;
  height: 24px;
}
.ant-input-group-wrapper.ant-input-group-wrapper-sm .ant-input-group-addon {
  font-size: 12px;
}
.ant-input-group-wrapper.ant-input-group-wrapper-sm .ant-input-group-addon svg {
  width: 16px;
  height: 16px;
}
.origami-input-number {
  border: 1px solid #c9d1df;
  display: flex;
  justify-content: space-between;
  width: 320px;
  height: 36px;
  border-radius: 6px;
  font-family: var(--body-font-family-none, Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, color emoji, segoe ui emoji, noto color emoji, android emoji);
}
.origami-input-number .ant-input-number {
  border-radius: 0px;
  border: none;
  border-left: none;
  border-right: none;
  width: 100%;
}
.origami-input-number .ant-input-number:focus {
  box-shadow: none;
}
.origami-input-number .ant-input-number:focus-within {
  box-shadow: none;
}
.origami-input-number .ant-input-number .ant-input-number-input-wrap {
  height: 100%;
}
.origami-input-number .ant-input-number .ant-input-number-input-wrap:focus {
  box-shadow: none;
}
.origami-input-number .ant-input-number .ant-input-number-input-wrap input {
  height: 100%;
  text-align: center;
  border: none;
  color: black;
  font-family: var(--body-font-family-none, Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, color emoji, segoe ui emoji, noto color emoji, android emoji);
  font-size: 14px;
  font-weight: 400;
}
.origami-input-number .ant-input-number .ant-input-number-input-wrap input:focus {
  box-shadow: none;
}
.origami-input-number .ant-input-number .ant-input-number-input-wrap input::-moz-placeholder {
  color: #c9d1df;
}
.origami-input-number .ant-input-number .ant-input-number-input-wrap input::placeholder {
  color: #c9d1df;
}
.origami-input-number .ant-input-number.ant-input-number-disabled input {
  color: #b1baca;
}
.origami-input-number .ant-btn-square {
  border-radius: 0px 8px 8px 0px;
}
.origami-input-number .add-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled),
.origami-input-number .ant-btn.ant-btn.ant-btn-dashed:not(:disabled),
.origami-input-number .ant-btn.ant-btn.ant-btn-text:not(:disabled) {
  height: 100%;
  border: none;
  border-left: 1px solid #c9d1df;
  border-radius: 0px 6px 6px 0px;
}
.origami-input-number .add-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled):focus,
.origami-input-number .ant-btn.ant-btn.ant-btn-dashed:not(:disabled):focus,
.origami-input-number .ant-btn.ant-btn.ant-btn-text:not(:disabled):focus {
  box-shadow: none;
}
.origami-input-number .subtract-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled),
.origami-input-number .ant-btn.ant-btn.ant-btn-dashed:not(:disabled),
.ant-btn.ant-btn.ant-btn-text:not(:disabled) .origami-input-number.ant-btn-square {
  height: 100%;
  border: none;
  border-right: 1px solid #c9d1df;
  border-radius: 6px 0px 0px 6px;
}
.origami-input-number .subtract-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled):focus,
.origami-input-number .ant-btn.ant-btn.ant-btn-dashed:not(:disabled):focus,
.ant-btn.ant-btn.ant-btn-text:not(:disabled) .origami-input-number.ant-btn-square:focus {
  box-shadow: none;
}
.origami-input-number.origami-input-number-large {
  height: 44px;
  border-radius: 8px;
}
.origami-input-number.origami-input-number-large .add-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled),
.origami-input-number.origami-input-number-large .ant-btn.ant-btn.ant-btn-dashed:not(:disabled),
.origami-input-number.origami-input-number-large .ant-btn.ant-btn.ant-btn-text:not(:disabled),
.origami-input-number.origami-input-number-large .ant-btn-square {
  border-radius: 0px 8px 8px 0px;
}
.origami-input-number.origami-input-number-large .subtract-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled),
.origami-input-number.origami-input-number-large .ant-btn.ant-btn.ant-btn-dashed:not(:disabled),
.origami-input-number.origami-input-number-large .ant-btn.ant-btn.ant-btn-text:not(:disabled) {
  border-radius: 8px 0px 0px 8px;
}
.origami-input-number.origami-input-number-large .ant-input-number .ant-input-number-input-wrap input {
  font-size: 16px;
}
.origami-input-number.origami-input-number-small {
  border-radius: 4px;
  height: 26px;
}
.origami-input-number.origami-input-number-small .add-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled),
.origami-input-number.origami-input-number-small .ant-btn.ant-btn.ant-btn-dashed:not(:disabled),
.origami-input-number.origami-input-number-small .ant-btn.ant-btn.ant-btn-text:not(:disabled) {
  border-radius: 0px 4px 4px 0px;
}
.origami-input-number.origami-input-number-small .subtract-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled),
.origami-input-number.origami-input-number-small .ant-btn.ant-btn.ant-btn-dashed:not(:disabled),
.origami-input-number.origami-input-number-small .ant-btn.ant-btn.ant-btn-text:not(:disabled) {
  border-radius: 4px 0px 0px 4px;
}
.origami-input-number.origami-input-number-small .ant-input-number .ant-input-number-input-wrap input {
  font-size: 12px;
}
.origami-input-number.origami-input-number-disabled {
  border-color: #c9d1df;
}
.origami-input-number.origami-input-number-disabled .ant-input-number,
.origami-input-number.origami-input-number-disabled :hover {
  background-color: #f5f7fa;
}
.origami-input-number.origami-input-number-disabled .add-btn.ant-btn.ant-btn.ant-btn-default,
.origami-input-number.origami-input-number-disabled .ant-btn.ant-btn.ant-btn-dashed,
.origami-input-number.origami-input-number-disabled .ant-btn.ant-btn.ant-btn-text {
  height: 100%;
  border: none;
  border-left: 1px solid #c9d1df;
  border-radius: 0px 8px 8px 0px;
}
.origami-input-number.origami-input-number-disabled .subtract-btn.ant-btn.ant-btn.ant-btn-default,
.origami-input-number.origami-input-number-disabled .ant-btn.ant-btn.ant-btn-dashed,
.origami-input-number.origami-input-number-disabled .ant-btn.ant-btn.ant-btn-text {
  height: 100%;
  border: none;
  border-right: 1px solid #c9d1df;
  border-radius: 8px 0px 0px 8px;
}
.origami-input-number.origami-input-number-disabled:hover {
  border-color: #c9d1df;
}
.origami-input-number.origami-input-number-error {
  border: 1px solid #de1b1b;
}
.origami-input-number.origami-input-number-error .ant-input-number-group-wrapper {
  height: 100%;
  width: 100%;
}
.origami-input-number.origami-input-number-error .ant-input-number-group-wrapper .ant-input-number-wrapper {
  height: 100%;
}
.origami-input-number.origami-input-number-error .ant-input-number-group-wrapper .ant-input-number-wrapper .ant-input-number-group-addon {
  height: 100%;
  background-color: #ffffff;
  border: none;
  border-radius: 0px;
}
.origami-input-number.origami-input-number-error .ant-input-number-group-wrapper .ant-input-number-wrapper .ant-input-number-group-addon svg {
  margin-top: 4px;
  color: #de1b1b;
  height: 20px;
  width: 20px;
}
.origami-input-number.origami-input-number-error.origami-input-number-large .ant-input-number-input-wrap input {
  font-size: 16px;
}
.origami-input-number.origami-input-number-error.origami-input-number-large .ant-input-number-group-wrapper .ant-input-number-wrapper .ant-input-number-group-addon svg {
  height: 24px;
  width: 24px;
}
.origami-input-number.origami-input-number-error.origami-input-number-small .ant-input-number-input-wrap input {
  font-size: 12px;
}
.origami-input-number.origami-input-number-error.origami-input-number-small .ant-input-number-group-wrapper .ant-input-number-wrapper .ant-input-number .ant-input-number-input-wrap input {
  padding: 0px 11px;
  font-size: 12px;
}
.origami-input-number.origami-input-number-error.origami-input-number-small .ant-input-number-group-wrapper .ant-input-number-wrapper .ant-input-number-group-addon svg {
  margin-top: 3px;
  height: 16px;
  width: 16px;
}
.origami-input-number.origami-input-number-error .add-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled),
.origami-input-number.origami-input-number-error .ant-btn.ant-btn.ant-btn-dashed:not(:disabled),
.origami-input-number.origami-input-number-error .ant-btn.ant-btn.ant-btn-text:not(:disabled) {
  border-color: #de1b1b;
}
.origami-input-number.origami-input-number-error .subtract-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled),
.origami-input-number.origami-input-number-error .ant-btn.ant-btn.ant-btn-dashed:not(:disabled),
.origami-input-number.origami-input-number-error .ant-btn.ant-btn.ant-btn-text:not(:disabled) {
  border-color: #de1b1b;
}
.origami-input-number.origami-input-number-error:hover {
  border-color: #de1b1b;
}
.origami-input-number.origami-input-number-error:hover .add-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled),
.origami-input-number.origami-input-number-error:hover .ant-btn.ant-btn.ant-btn-dashed:not(:disabled),
.origami-input-number.origami-input-number-error:hover .ant-btn.ant-btn.ant-btn-text:not(:disabled) {
  border-color: #de1b1b;
}
.origami-input-number.origami-input-number-error:hover .subtract-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled),
.origami-input-number.origami-input-number-error:hover .ant-btn.ant-btn.ant-btn-dashed:not(:disabled),
.origami-input-number.origami-input-number-error:hover .ant-btn.ant-btn.ant-btn-text:not(:disabled) {
  border-color: #de1b1b;
}
.origami-input-number.origami-input-number-error:focus {
  box-shadow: 0px 0px 4px 0px #de1b1b;
}
.origami-input-number.origami-input-number-error:focus-within {
  box-shadow: 0px 0px 4px 0px #de1b1b;
}
.origami-input-number:hover {
  border-color: #9099a9;
}
.origami-input-number:hover .add-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled),
.origami-input-number:hover .ant-btn.ant-btn.ant-btn-dashed:not(:disabled),
.origami-input-number:hover .ant-btn.ant-btn.ant-btn-text:not(:disabled) {
  border-color: #9099a9;
}
.origami-input-number:hover .subtract-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled),
.origami-input-number:hover .ant-btn.ant-btn.ant-btn-dashed:not(:disabled),
.origami-input-number:hover .ant-btn.ant-btn.ant-btn-text:not(:disabled) {
  border-color: #9099a9;
}
.origami-input-number:focus {
  box-shadow: 0px 0px 4px 0px #3272D9BF;
}
.origami-input-number:focus-within {
  box-shadow: 0px 0px 4px 0px #3272D9BF;
}
.ant-radio-wrapper {
  color: #000;
  margin-inline-end: 12px;
  display: flex;
}
.ant-radio-wrapper .ant-radio {
  align-self: flex-start;
  margin-top: 2px;
}
.ant-radio-wrapper .ant-radio .ant-radio-inner {
  border-color: #b1baca;
  align-self: flex-start;
}
.ant-radio-wrapper .ant-radio:hover .ant-radio-inner {
  border-color: #9099a9;
}
.ant-radio-wrapper input[type='radio']:focus,
.ant-radio-wrapper .ant-radio-input:focus,
.ant-radio-wrapper input[type='radio']:focus-visible + .ant-radio-inner,
.ant-radio-wrapper .ant-radio-input:focus-visible + .ant-radio-inner {
  outline: none;
  box-shadow: none;
  -webkit-box-shadow: none;
}
.ant-radio-wrapper .ant-radio-checked .ant-radio-inner {
  border-color: rgb(var(--color-primary-none, 89, 96, 109));
  background-color: #fff;
}
.ant-radio-wrapper .ant-radio-checked .ant-radio-inner::after {
  width: 20px;
  height: 20px;
  margin-block-start: -10px;
  margin-inline-start: -10px;
  background-color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-radio-wrapper .ant-radio-checked::after {
  border-color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);
}
.ant-radio-wrapper.origami-radio-error .ant-radio-inner {
  border-color: #de1b1b;
}
.ant-radio-wrapper.origami-radio-error:hover .ant-radio-inner {
  border-color: #f55353;
}
.ant-radio-wrapper.origami-radio-error .ant-radio-checked .ant-radio-inner {
  border-color: #de1b1b;
  background-color: #fff;
}
.ant-radio-wrapper.origami-radio-error .ant-radio-checked .ant-radio-inner::after {
  width: 20px;
  height: 20px;
  margin-block-start: -10px;
  margin-inline-start: -10px;
  background-color: #de1b1b;
}
.ant-radio-wrapper.origami-radio-error .ant-radio-checked::after {
  border-color: #f55353;
}
.ant-radio-wrapper.ant-radio-wrapper-disabled {
  color: #b1baca;
}
.ant-radio-wrapper.ant-radio-wrapper-disabled:active {
  box-shadow: none;
}
.ant-radio-wrapper.ant-radio-wrapper-disabled .ant-radio-disabled .ant-radio-inner {
  background-color: #f5f7fa;
  border-color: #c9d1df;
}
.ant-radio-wrapper.ant-radio-wrapper-disabled .ant-radio-disabled .ant-radio-inner::after {
  background-color: #c9d1df;
}
.ant-radio-wrapper.ant-radio-wrapper-disabled .ant-radio-disabled.ant-radio-checked .ant-radio-inner::after {
  transform: scale(0.375);
}
.ant-radio-wrapper.large {
  font-size: 16px;
}
.ant-radio-wrapper.large .ant-radio-inner {
  height: 24px;
  width: 24px;
}
.ant-radio-wrapper.large .ant-radio-inner::after {
  height: 37px;
  width: 37px;
  margin-block-start: -18.5px;
  margin-inline-start: -18.5px;
  border-radius: 50%;
}
/* === Styles for custom Radio.Button and Radio.Card components === */
.origami-radio-group,
.origami-radio-group-button,
.origami-radio-group-card {
  display: inline-flex;
  width: 100%;
  color: #000;
}
.origami-radio-group .tall .ant-radio-button-wrapper,
.origami-radio-group-button .tall .ant-radio-button-wrapper,
.origami-radio-group-card .tall .ant-radio-button-wrapper {
  min-height: 74px;
}
.origami-radio-group .ant-radio-button-wrapper,
.origami-radio-group-button .ant-radio-button-wrapper,
.origami-radio-group-card .ant-radio-button-wrapper {
  display: inline-flex;
  justify-content: center;
  flex: 1 0 auto;
  height: auto;
  min-height: 52px;
  margin-inline-end: 12px;
  padding-inline: 14px;
  padding-block: 14px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  border-block: unset;
  border-inline: unset;
  border: 1px solid #c9d1df;
  border-radius: 12px;
}
.origami-radio-group .ant-radio-button-wrapper span:not([class^='origami-radio-']):last-child,
.origami-radio-group-button .ant-radio-button-wrapper span:not([class^='origami-radio-']):last-child,
.origami-radio-group-card .ant-radio-button-wrapper span:not([class^='origami-radio-']):last-child {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.origami-radio-group .ant-radio-button-wrapper span:not([class^='origami-radio-']):last-child .origami-radio-button-description,
.origami-radio-group-button .ant-radio-button-wrapper span:not([class^='origami-radio-']):last-child .origami-radio-button-description,
.origami-radio-group-card .ant-radio-button-wrapper span:not([class^='origami-radio-']):last-child .origami-radio-button-description {
  color: #59606d;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
.origami-radio-group .ant-radio-button-wrapper:not(.ant-radio-button-wrapper-disabled):hover,
.origami-radio-group-button .ant-radio-button-wrapper:not(.ant-radio-button-wrapper-disabled):hover,
.origami-radio-group-card .ant-radio-button-wrapper:not(.ant-radio-button-wrapper-disabled):hover {
  color: #000;
  border-color: #9099a9;
}
.origami-radio-group .ant-radio-button-wrapper:has(:focus-visible),
.origami-radio-group-button .ant-radio-button-wrapper:has(:focus-visible),
.origami-radio-group-card .ant-radio-button-wrapper:has(:focus-visible) {
  border-color: rgb(var(--color-primary-none, 89, 96, 109));
  outline: none;
  box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);
  -webkit-box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);
}
.origami-radio-group .ant-radio-button-wrapper::before,
.origami-radio-group-button .ant-radio-button-wrapper::before,
.origami-radio-group-card .ant-radio-button-wrapper::before {
  display: none;
}
.origami-radio-group .ant-radio-button-wrapper.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled),
.origami-radio-group-button .ant-radio-button-wrapper.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled),
.origami-radio-group-card .ant-radio-button-wrapper.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  color: #000;
  border-color: rgb(var(--color-primary-none, 89, 96, 109));
}
.origami-radio-group .ant-radio-button-wrapper.ant-radio-button-wrapper-disabled,
.origami-radio-group-button .ant-radio-button-wrapper.ant-radio-button-wrapper-disabled,
.origami-radio-group-card .ant-radio-button-wrapper.ant-radio-button-wrapper-disabled {
  color: #b1baca;
  background-color: #f5f7fa;
}
.origami-radio-group .ant-radio-button-wrapper.ant-radio-button-wrapper-disabled span:last-child .origami-radio-lock-icon,
.origami-radio-group-button .ant-radio-button-wrapper.ant-radio-button-wrapper-disabled span:last-child .origami-radio-lock-icon,
.origami-radio-group-card .ant-radio-button-wrapper.ant-radio-button-wrapper-disabled span:last-child .origami-radio-lock-icon,
.origami-radio-group .ant-radio-button-wrapper.ant-radio-button-wrapper-disabled span:last-child .origami-radio-button-description,
.origami-radio-group-button .ant-radio-button-wrapper.ant-radio-button-wrapper-disabled span:last-child .origami-radio-button-description,
.origami-radio-group-card .ant-radio-button-wrapper.ant-radio-button-wrapper-disabled span:last-child .origami-radio-button-description {
  color: #b1baca;
}
.origami-radio-lock-icon {
  width: 24px;
  height: 24px;
  color: #59606d;
}
.tall .origami-radio-card-wrapper {
  min-height: 74px;
}
.origami-radio-card-wrapper {
  display: inline-flex;
  justify-content: flex-start;
  flex: 1 0 auto;
  background-color: #fff;
  padding-inline: 14px;
  padding-block: 14px;
  height: auto;
  min-height: 52px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  border: 1px solid #c9d1df;
  border-radius: 12px;
  margin-inline-end: 0;
  align-items: center;
  /* === State styels === */
}
.origami-radio-card-wrapper.no-description.ant-radio-wrapper .ant-radio,
.origami-radio-card-wrapper.no-description.ant-radio-wrapper .ant-checkbox {
  margin-top: 2px;
}
.origami-radio-card-wrapper.ant-checkbox-wrapper .ant-checkbox {
  align-self: center;
}
.origami-radio-card-wrapper.ant-checkbox-wrapper:not(.no-description) .ant-checkbox {
  margin-top: 14px;
}
@media only screen and (max-width: 735px) {
  .origami-radio-card-wrapper.ant-checkbox-wrapper:not(.no-description) .ant-checkbox {
    margin-top: 12px;
  }
}
.origami-radio-card-wrapper:not(.no-description) .ant-radio,
.origami-radio-card-wrapper:not(.no-description) .ant-checkbox {
  align-self: start;
}
.origami-radio-card-wrapper .ant-radio {
  height: 24px;
  align-self: center;
}
.origami-radio-card-wrapper .ant-radio .ant-radio-inner {
  width: 24px;
  height: 24px;
}
.origami-radio-card-wrapper:not(.reversed):not(.show-check-icon) span:not([class^='origami-radio-']):last-child {
  padding-inline-start: 14px;
}
.origami-radio-card-wrapper:not(.reversed).show-check-icon .origami-radio-card-info-wrapper {
  padding-left: 14px;
}
.origami-radio-card-wrapper:not(.reversed).show-check-icon span:not([class^='origami-radio-']):last-child {
  padding-inline-start: 0;
}
.origami-radio-card-wrapper span:not([class^='origami-radio-']):last-child {
  display: inline-flex;
  align-items: flex-start;
  justify-content: space-between;
  flex: auto;
  padding-inline-end: 0;
}
.origami-radio-card-wrapper span:not([class^='origami-radio-']):last-child .origami-radio-card-description {
  color: #59606d;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
.origami-radio-card-wrapper .ant-radio-checked .ant-radio-inner {
  border-color: rgb(var(--color-primary-none, 89, 96, 109));
  background-color: #fff;
}
.origami-radio-card-wrapper .ant-radio-checked .ant-radio-inner::after {
  width: 36px;
  height: 36px;
  margin-block-start: -18px;
  margin-inline-start: -18px;
  background-color: rgb(var(--color-primary-none, 89, 96, 109));
}
.origami-radio-card-wrapper:hover:not(.ant-checkbox-wrapper-disabled) {
  border-color: #9099a9;
}
.origami-radio-card-wrapper:hover:not(.ant-checkbox-wrapper-disabled) .ant-radio-inner {
  border-color: #b1baca;
}
.origami-radio-card-wrapper.ant-radio-wrapper-checked {
  border-color: rgb(var(--color-primary-none, 89, 96, 109));
}
.origami-radio-card-wrapper.ant-radio-wrapper-disabled {
  background-color: #f5f7fa;
  border-color: #c9d1df;
}
.origami-radio-card-wrapper.ant-radio-wrapper-disabled:hover {
  border-color: #c9d1df;
}
.origami-radio-card-wrapper.ant-radio-wrapper-disabled span:not([class^='origami-radio-']):last-child .origami-radio-card-description {
  color: #b1baca;
}
.origami-radio-card-wrapper.ant-radio-wrapper-disabled span:not([class^='origami-radio-']):last-child .origami-radio-lock-icon {
  color: #b1baca;
}
.ant-radio-wrapper.animation-container.collapsed:not(.ant-radio-wrapper-checked) {
  position: relative;
  top: -100px;
}
.origami-radio-card-wrapper.is-checkbox-variant:not(.reversed) .ant-checkbox {
  padding-left: 8px;
}
.origami-radio-card-wrapper.is-checkbox-variant .ant-checkbox .ant-checkbox-input {
  transform: scale(1.5);
}
.origami-radio-card-wrapper.is-checkbox-variant .ant-checkbox .ant-checkbox-inner {
  transform: scale(1.5);
}
.origami-radio-card-wrapper.is-checkbox-variant .ant-checkbox .ant-checkbox-inner::after {
  inset-inline-start: 20%;
  top: 45%;
  border-width: 1px;
  width: 4.7px;
}
.origami-radio-card-wrapper.is-checkbox-variant.ant-checkbox-wrapper-disabled {
  color: #b1baca;
}
.origami-radio-card-wrapper.is-checkbox-variant.ant-checkbox-wrapper-disabled .ant-checkbox-disabled .ant-checkbox-inner {
  background-color: #f5f7fa;
  border-color: #c9d1df;
}
.origami-radio-card-wrapper.is-checkbox-variant.ant-checkbox-wrapper-disabled .ant-checkbox-disabled .ant-checkbox-inner::checkbox {
  background-color: #c9d1df;
}
.origami-radio-card-wrapper.is-checkbox-variant.ant-checkbox-wrapper-disabled .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {
  transform: scale(0.375);
}
.origami-radio-card-wrapper.is-checkbox-variant.ant-checkbox-wrapper-disabled .origami-radio-card-info-wrapper .origami-radio-card-text-wrapper .origami-radio-card-description {
  color: #b1baca;
}
.origami-radio-card-wrapper.is-checkbox-variant.ant-checkbox-wrapper-disabled .origami-radio-card-info-wrapper .origami-radio-card-text-wrapper .origami-radio-lock-icon {
  color: #b1baca;
}
.origami-radio-card-wrapper.is-checkbox-variant.ant-checkbox-wrapper-disabled {
  color: #b1baca;
  background-color: #f5f7fa;
}
.origami-radio-card-wrapper.is-checkbox-variant.ant-checkbox-wrapper-disabled span:last-child .origami-radio-lock-icon,
.origami-radio-card-wrapper.is-checkbox-variant.ant-checkbox-wrapper-disabled span:last-child .origami-radio-button-description {
  color: #b1baca;
}
.origami-radio-card-wrapper.ant-radio-wrapper-checked.show-check-icon .circle-check {
  display: block;
  color: rgb(var(--color-primary-none, 89, 96, 109));
}
.origami-radio-card-wrapper.ant-radio-wrapper-checked.show-check-icon .ant-radio {
  display: none;
}
.origami-radio-card-wrapper .circle {
  display: none;
}
.origami-radio-card-wrapper .circle-check {
  display: none;
}
.origami-radio-card-wrapper .error-circle {
  color: #de1b1b;
  display: block;
}
.origami-radio-card-wrapper.show-check-icon:not(.ant-radio-wrapper-checked) .circle {
  color: #b1baca;
  display: block;
}
.origami-radio-card-wrapper.show-check-icon .ant-radio {
  display: none;
}
.origami-radio-card-wrapper .radio-card-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}
.origami-radio-card-wrapper.full-width {
  width: 100%;
}
.origami-radio-card-wrapper:active {
  box-shadow: 0px 0px 4px 0px #3272D9BF;
}
.origami-radio-card-wrapper .radio-card-container .origami-radio-card-info-wrapper .origami-radio-card-button .ant-btn {
  margin-left: -12px;
}
.origami-radio-card-wrapper .radio-card-container .origami-radio-card-info-wrapper .origami-radio-card-button .ant-btn > span {
  padding-inline-start: 0;
}
.origami-radio-card-wrapper.no-description .ant-checkbox,
.origami-radio-card-wrapper.no-description .ant-radio {
  margin-top: 2px;
}
.origami-radio-card-wrapper.no-description.has-button .ant-checkbox {
  margin-top: 4px;
}
.origami-radio-card-wrapper.no-description.has-button .ant-btn {
  margin-left: -12px;
}
.ant-radio-wrapper.has-error,
.ant-checkbox-wrapper.has-error {
  border-color: #de1b1b;
}
.ant-radio-wrapper.has-error.origami-radio-card-wrapper .ant-radio-checked > .ant-radio-inner,
.ant-checkbox-wrapper.has-error.origami-radio-card-wrapper .ant-radio-checked > .ant-radio-inner,
.ant-radio-wrapper.has-error.origami-radio-card-wrapper .ant-checkbox-checked > .ant-radio-inner,
.ant-checkbox-wrapper.has-error.origami-radio-card-wrapper .ant-checkbox-checked > .ant-radio-inner {
  border-color: #de1b1b;
}
.ant-radio-wrapper.has-error.origami-radio-card-wrapper .ant-radio-checked > span.ant-checkbox-inner,
.ant-checkbox-wrapper.has-error.origami-radio-card-wrapper .ant-radio-checked > span.ant-checkbox-inner,
.ant-radio-wrapper.has-error.origami-radio-card-wrapper .ant-checkbox-checked > span.ant-checkbox-inner,
.ant-checkbox-wrapper.has-error.origami-radio-card-wrapper .ant-checkbox-checked > span.ant-checkbox-inner {
  border-color: #de1b1b;
  background-color: #de1b1b;
}
.ant-radio-wrapper.has-error.origami-radio-card-wrapper .ant-radio-checked .ant-radio-inner::after,
.ant-checkbox-wrapper.has-error.origami-radio-card-wrapper .ant-radio-checked .ant-radio-inner::after,
.ant-radio-wrapper.has-error.origami-radio-card-wrapper .ant-checkbox-checked .ant-radio-inner::after,
.ant-checkbox-wrapper.has-error.origami-radio-card-wrapper .ant-checkbox-checked .ant-radio-inner::after {
  background-color: #de1b1b;
}
.ant-radio-wrapper.origami-radio-card-wrapper .ant-radio,
.ant-checkbox-wrapper.origami-radio-card-wrapper .ant-radio {
  margin-top: 12px;
}
.ant-radio-wrapper:hover.has-error,
.ant-checkbox-wrapper:hover.has-error {
  border-color: #de1b1b;
}
.ant-radio-wrapper:hover.has-error.origami-radio-card-wrapper .ant-radio-checked > .ant-radio-inner,
.ant-checkbox-wrapper:hover.has-error.origami-radio-card-wrapper .ant-radio-checked > .ant-radio-inner,
.ant-radio-wrapper:hover.has-error.origami-radio-card-wrapper .ant-checkbox-checked > .ant-radio-inner,
.ant-checkbox-wrapper:hover.has-error.origami-radio-card-wrapper .ant-checkbox-checked > .ant-radio-inner {
  border-color: #de1b1b;
}
.ant-radio-wrapper:hover.has-error.origami-radio-card-wrapper .ant-radio-checked > span.ant-checkbox-inner,
.ant-checkbox-wrapper:hover.has-error.origami-radio-card-wrapper .ant-radio-checked > span.ant-checkbox-inner,
.ant-radio-wrapper:hover.has-error.origami-radio-card-wrapper .ant-checkbox-checked > span.ant-checkbox-inner,
.ant-checkbox-wrapper:hover.has-error.origami-radio-card-wrapper .ant-checkbox-checked > span.ant-checkbox-inner {
  border-color: #de1b1b;
  background-color: #de1b1b;
}
.ant-radio-wrapper:hover.has-error.origami-radio-card-wrapper .ant-radio-checked .ant-radio-inner::after,
.ant-checkbox-wrapper:hover.has-error.origami-radio-card-wrapper .ant-radio-checked .ant-radio-inner::after,
.ant-radio-wrapper:hover.has-error.origami-radio-card-wrapper .ant-checkbox-checked .ant-radio-inner::after,
.ant-checkbox-wrapper:hover.has-error.origami-radio-card-wrapper .ant-checkbox-checked .ant-radio-inner::after {
  background-color: #de1b1b;
}
.disabled-reason {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #59606d !important;
}
.card-group-selector {
  flex-direction: column;
  gap: 12px;
  height: 100%;
  display: inline-flex;
}
.card-group-selector.collapsed .ant-radio-wrapper {
  position: absolute;
  z-index: 0;
  top: 0;
  display: none;
}
.card-group-selector.collapsed .ant-radio-wrapper.ant-radio-wrapper-checked {
  z-index: 29;
  display: inline-flex;
}
.card-group-selector.collapsed .empty-1 {
  top: 32px;
  z-index: 28;
  width: calc(100% - 24px);
  margin-left: 10px;
  pointer-events: none;
  display: inline-flex;
  color: #fff;
}
.card-group-selector.collapsed .empty-1 .ant-radio {
  display: none;
}
.card-group-selector.collapsed .empty-1:hover {
  border: 1px solid #c9d1df;
}
.card-group-selector.collapsed .empty-2 {
  top: 44px;
  z-index: 27;
  margin-left: 20px;
  width: calc(100% - 44px);
  pointer-events: none;
  display: inline-flex;
  color: #fff;
}
.card-group-selector.collapsed .empty-2 .ant-radio {
  display: none;
}
.card-group-selector.collapsed .empty-2:hover {
  border: 1px solid #c9d1df;
}
.card-group-selector .card-hidden {
  display: none;
  visibility: hidden;
  height: 0;
}
.reversed {
  flex-direction: row-reverse;
  justify-content: space-between;
}
.reversed .radio-card-container {
  flex-direction: row-reverse;
}
.reversed .origami-radio-card-info-wrapper {
  flex-direction: row-reverse;
  width: 100%;
  justify-content: start;
}
.reversed .ant-checkbox {
  margin-left: 14px;
  margin-right: 14px;
}
.origami-radio-card-info-wrapper {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  text-align: left;
  gap: 14px;
  align-items: center;
  flex-wrap: nowrap;
}
@media only screen and (max-width: 735px) {
  .origami-radio-card-info-wrapper {
    flex-wrap: wrap;
  }
}
.origami-radio-card-info-wrapper.has-icon:not(.has-reason, .has-button) {
  flex-wrap: nowrap;
}
.ant-radio-wrapper-disabled .origami-radio-icon,
.ant-checkbox-wrapper-disabled .origami-radio-icon {
  color: #b1baca;
}
.origami-radio-icon {
  width: 24px;
  height: 24px;
  color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-form .ant-form-item .ant-form-item-control-input {
  min-height: 26px;
}
.ant-form .ant-form-item .ant-form-item-label {
  padding-bottom: 0;
}
.ant-form .ant-form-item .ant-form-item-label > label.ant-form-item-no-colon::after {
  content: "";
}
.ant-form .ant-form-item .ant-form-item-label > label::after {
  margin-inline-start: 0;
}
.ant-form .ant-form-item .ant-form-item-label .large .label-content-wrapper {
  margin-bottom: 10px;
}
.ant-form .ant-form-item .ant-form-item-label .small .label-content-wrapper {
  margin-bottom: 6px;
}
.ant-form .ant-form-item .ant-form-item-label .label-content-wrapper {
  margin-bottom: 8px;
}
.ant-form .ant-form-item .nackle-caption {
  margin-top: 2px;
}
.nackle-label.horizontal {
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.nackle-label.horizontal .label-content-wrapper {
  display: inline-flex;
  margin-bottom: 0;
  padding-right: 4px;
}
.nackle-label.horizontal .ant-input {
  width: 100%;
}
.nackle-label.horizontal .ant-input-search .ant-input,
.nackle-label.horizontal .ant-input-password .ant-input {
  width: 100%;
}
.nackle-label .ant-input {
  width: 100%;
}
.nackle-label .input-caption-wrapper {
  display: inline-block;
  width: 100%;
}
.nackle-label .ant-input-search .ant-input {
  width: 100%;
}
.nackle-label .label-content-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 8px;
}
.nackle-label .label-text {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #59606d;
  text-wrap: nowrap;
  white-space: nowrap;
}
.nackle-label .label-text .required {
  color: #de1b1b;
  margin-left: 4px;
}
.nackle-label .label-text .optional-text {
  margin-left: 4px;
  font-weight: 400;
}
.nackle-label .label-icon {
  margin-left: 4px;
  color: rgb(var(--color-primary-none, 89, 96, 109));
  display: flex;
  align-items: center;
}
.nackle-label .label-icon svg {
  width: 20px;
  height: 20px;
}
.nackle-label.small .label-content-wrapper {
  margin-bottom: 6px;
}
.nackle-label.small .label-text {
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: #59606d;
}
.nackle-label.small .label-icon svg {
  width: 16px;
  height: 16px;
}
.nackle-label.large .label-content-wrapper {
  margin-bottom: 10px;
}
.nackle-label.large .label-text {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #59606d;
}
.nackle-label.large .label-icon svg {
  width: 24px;
  height: 24px;
}
.ant-menu {
  border-radius: 30px;
  padding: 15px;
}
.ant-menu .ant-menu-item {
  font-weight: 600;
  font-size: 16px;
  padding: 14px;
  color: #444A53;
}
.ant-menu .ant-menu-item .anticon {
  color: #3F8CFF;
}
.ant-menu .ant-menu-item-group .ant-menu-item-group-list .ant-menu-title-content {
  font-size: 14px;
}
.ant-menu-inline,
.ant-menu-vertical,
.ant-menu-vertical-left {
  border-right: none;
}
.ant-menu.ant-menu-root.ant-menu-vertical:focus,
.ant-menu.ant-menu-root.ant-menu-horizontal:focus {
  box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);
}
.ant-menu.ant-menu-root.ant-menu-vertical:focus-visible,
.ant-menu.ant-menu-root.ant-menu-horizontal:focus-visible {
  box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);
}
.ant-menu.ant-menu-root .ant-menu-item {
  border-radius: 12px;
  display: flex;
  align-items: center;
}
.ant-menu.ant-menu-root.menu-popover {
  border-radius: 10px;
}
.ant-menu.ant-menu-root.menu-popover .ant-menu-item {
  border-radius: 6px;
  font-weight: 400;
  color: #59606d;
}
.ant-menu.ant-menu-root.menu-popover .ant-menu-item-selected {
  background-color: #f5f7fa;
}
.ant-menu.ant-menu-root.menu-popover.menu-lg {
  padding: 8px;
}
.ant-menu.ant-menu-root.menu-popover.menu-lg .ant-menu-item {
  font-size: 16px;
}
.ant-menu.ant-menu-root.menu-popover.menu-md {
  padding: 6px;
}
.ant-menu.ant-menu-root.menu-popover.menu-md .ant-menu-item {
  font-size: 14px;
}
.ant-menu.ant-menu-root.menu-popover.menu-sm {
  padding: 4px;
}
.ant-menu.ant-menu-root.menu-popover.menu-sm .ant-menu-item {
  font-size: 12px;
}
.ant-menu .ant-menu-submenu-title {
  font-size: 16px;
  font-weight: 600;
}
.ant-menu .ant-menu-sub .ant-menu-item .ant-menu-title-content {
  font-weight: 400;
}
.ant-menu .ant-menu-sub .ant-menu-item::after {
  border-right: none;
}
.ant-menu .ant-menu-sub .ant-menu-item-selected::after {
  border-right: none;
}
.ant-menu + div + .ant-menu {
  padding-top: 0;
}
.ant-message .ant-message-notice .ant-message-notice-content {
  border-radius: 6px;
  padding: 8px 10px 8px 10px;
}
.ant-message .ant-message-notice .ant-message-notice-content .ant-message-custom-content {
  display: flex;
  font-size: 12px;
  line-height: 16px;
}
.ant-message .ant-message-notice .ant-message-notice-content .ant-message-custom-content .ant-message-icon {
  height: 16px;
  width: 16px;
  margin-right: 8px;
}
.ant-message .ant-message-notice .ant-message-notice-content .ant-message-custom-content .ant-message-close-icon {
  height: 12px;
  width: 12px;
  color: #59606d;
}
.ant-message .ant-message-notice .ant-message-notice-content .ant-message-custom-content span {
  display: flex;
  color: #59606d;
}
.ant-message .ant-message-notice .ant-message-notice-content .ant-message-custom-content span button {
  height: 16px;
  width: 16px;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 8px;
}
.ant-message .ant-message-notice .ant-message-notice-content .ant-message-info-icon {
  color: #1d5bbf;
}
.ant-message .ant-message-notice .ant-message-notice-content .ant-message-success-icon {
  color: #038537;
}
.ant-message .ant-message-notice .ant-message-notice-content .ant-message-warning-icon {
  color: #fcc419;
}
.ant-message .ant-message-notice .ant-message-notice-content .ant-message-error-icon {
  color: #de1b1b;
}
.ant-message .ant-message-notice .ant-message-notice-content .ant-message-tip-icon {
  color: #7d3cbd;
}
.ant-message .ant-message-notice .ant-message-notice-content .ant-message-loading-icon {
  color: #1d5bbf;
  animation: rotate 1s linear infinite;
}
.ant-message .ant-message-notice .ant-message-close-x {
  display: none;
}
.ant-message .ant-message-notice.ant-message-large .ant-message-notice-content {
  padding: 10px 12px 10px 12px;
}
.ant-message .ant-message-notice.ant-message-large .ant-message-notice-content .ant-message-custom-content {
  display: flex;
  font-size: 14px;
  line-height: 20px;
}
.ant-message .ant-message-notice.ant-message-large .ant-message-notice-content .ant-message-custom-content .ant-message-icon {
  height: 20px;
  width: 20px;
  margin-right: 10px;
}
.ant-message .ant-message-notice.ant-message-large .ant-message-notice-content .ant-message-custom-content .ant-message-close-icon {
  height: 14px;
  width: 14px;
}
.ant-message .ant-message-notice.ant-message-large .ant-message-notice-content .ant-message-custom-content span button {
  height: 20px;
  width: 20px;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 10px;
}
@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
.ant-notification.ant-notification-stack.ant-notification-stack-expanded .ant-notification-notice-wrapper {
  width: auto;
  border-radius: 16px;
}
.ant-notification .ant-notification-notice-wrapper {
  width: auto;
  border-radius: 16px;
}
.ant-notification .ant-notification-notice {
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 0;
}
.ant-notification .ant-notification-notice:not(.ant-notification-large) {
  width: 300px;
}
.ant-notification .ant-notification-notice:not(.ant-notification-large) .ant-notification-notice-message {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 6px;
  padding-top: 3px;
}
.ant-notification .ant-notification-notice:not(.ant-notification-large) .ant-notification-notice-description {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #59606d;
}
.ant-notification .ant-notification-notice:not(.ant-notification-large) .ant-notification-notice-close svg {
  width: 16px;
  height: 16px;
  color: #59606d;
}
.ant-notification .ant-notification-notice:not(.ant-notification-large) .ant-notification-notice-close:hover svg {
  color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-notification .ant-notification-notice:not(.ant-notification-large) .ant-notification-notice-icon {
  height: 26px;
  width: 26px;
}
.ant-notification .ant-notification-notice:not(.ant-notification-large) .ant-notification-icon {
  color: white;
  height: 26px;
  width: 26px;
  padding: 5px;
  border-radius: 50%;
}
.ant-notification .ant-notification-notice.ant-notification-large {
  border-radius: 16px;
  width: 350px;
}
.ant-notification .ant-notification-notice.ant-notification-large .ant-notification-notice-message {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 6px;
  padding-top: 5px;
}
.ant-notification .ant-notification-notice.ant-notification-large .ant-notification-notice-description {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #59606d;
}
.ant-notification .ant-notification-notice.ant-notification-large .ant-notification-notice-with-icon .ant-notification-notice-message,
.ant-notification .ant-notification-notice.ant-notification-large .ant-notification-notice-with-icon .ant-notification-notice-description {
  margin-inline-start: 46px;
}
.ant-notification .ant-notification-notice.ant-notification-large .ant-notification-notice-close svg {
  width: 16px;
  height: 16px;
  color: #59606d;
}
.ant-notification .ant-notification-notice.ant-notification-large .ant-notification-notice-close:hover svg {
  color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-notification .ant-notification-notice.ant-notification-large .ant-notification-notice-icon {
  height: 36px;
  width: 36px;
}
.ant-notification .ant-notification-notice.ant-notification-large .ant-notification-icon {
  color: white;
  height: 36px;
  width: 36px;
  padding: 8px;
  border-radius: 50%;
}
.ant-notification .ant-notification-notice .ant-notification-info-icon {
  background: #1d5bbf;
}
.ant-notification .ant-notification-notice .ant-notification-warning-icon {
  background: #fcc419;
}
.ant-notification .ant-notification-notice .ant-notification-success-icon {
  background: #038537;
}
.ant-notification .ant-notification-notice .ant-notification-error-icon {
  background: #de1b1b;
}
.ant-notification .ant-notification-notice .ant-notification-tip-icon {
  background: #7d3cbd;
}
.ant-notification .ant-notification-notice .ant-notification-loading-icon {
  background: #1d5bbf;
  animation-duration: 1200ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-name: spin;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.ant-modal-root .ant-modal-mask {
  background-color: rgba(201, 209, 223, 0.8);
}
.ant-modal-root .ant-modal-wrap .ant-modal {
  max-width: 100%;
}
.ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content {
  border-radius: 24px;
  padding: 0px;
}
.ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-close {
  margin-top: 24px;
  background-color: #fff;
  min-width: 36px;
  height: 36px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  box-shadow: none;
  color: #59606d;
  padding-inline-start: 0;
  padding-inline-end: 0;
  border-radius: 50%;
  width: 32px;
  border: none;
  top: auto;
}
.ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-close:hover {
  background-color: #f5f7fa;
  border-color: #c9d1df;
  color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);
}
.ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-close .ant-modal-close-x {
  height: 20px;
  width: 20px;
}
.ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-title {
  color: #000000;
  font-size: 24px;
  font-weight: 600;
  margin-right: 32px;
}
.ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-title .ant-modal-subtitle {
  font-size: 14px;
  font-weight: 400;
  color: #59606d;
  margin-top: 8px;
}
.ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-header {
  border-bottom: 1px solid #eceff4;
  margin-bottom: 0px;
  padding: 24px;
  border-radius: 24px 24px 0px 0px;
}
.ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-body {
  padding: 16px 24px 16px 24px;
}
.ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-footer {
  display: flex;
  justify-content: space-between;
  padding: 24px 24px 24px 24px;
  margin-top: 0px;
  flex-wrap: wrap;
}
.ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-footer .ant-btn {
  border-radius: 50px;
  padding: 10px 20px 10px 20px;
  height: 44px;
  font-size: 16px;
  line-height: 24px;
}
.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-confirm-paragraph {
  max-width: 100%;
  row-gap: 0px;
}
.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content {
  padding: 0px;
}
.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body {
  padding: 0px;
}
.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .confirm-modal-header {
  display: flex;
  padding: 24px;
  border-bottom: 1px solid #eceff4;
}
.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .confirm-modal-header .ant-modal-icon {
  color: white;
  height: 36px;
  width: 36px;
  padding: 8px;
  border-radius: 50%;
  margin-right: 8px;
}
.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .confirm-modal-header .warning {
  background: #fcc419;
}
.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .confirm-modal-header .success {
  background: #038537;
}
.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .confirm-modal-header .error {
  background: #de1b1b;
}
.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .confirm-modal-header .info {
  background: #1d5bbf;
}
.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .confirm-modal-header .confirm-modal-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  margin-right: 8px;
}
.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .confirm-modal-header .confirm-modal-header-close {
  margin-right: 0;
  margin-left: auto;
}
.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-content {
  padding: 16px 24px 16px 24px;
}
.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-body-has-title {
  max-width: 100%;
}
.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-btns {
  padding: 24px;
  display: flex;
  margin-top: 0px;
  gap: 14px;
}
@media only screen and (max-width: 735px) {
  .ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-btns {
    flex-wrap: wrap;
  }
}
.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-btns .ant-btn:not(:disabled):focus,
.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-btns .ant-btn:not(:disabled):focus-visible {
  box-shadow: none;
  -webkit-box-shadow: none;
}
.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-btns .ant-btn:first-child {
  margin-left: 0px;
  margin-right: auto;
}
.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-btns .ant-btn:last-child {
  margin-right: 0px;
  margin-left: auto;
}
.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-btns .ant-btn:only-child {
  margin-right: 0px;
  margin-left: auto;
}
.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-btns .ant-btn {
  border-radius: 50px;
  padding: 10px 20px 10px 20px;
  height: 44px;
  font-size: 16px;
  line-height: 24px;
}
@media only screen and (max-width: 735px) {
  .ant-modal-root .ant-modal-wrap .ant-modal {
    width: 100% !important;
    max-width: 100%;
    margin: 0;
    top: auto;
    height: 100%;
    padding: 0;
    bottom: 0;
  }
  .ant-modal-root .ant-modal-wrap .ant-modal.full-height {
    top: 0;
  }
  .ant-modal-root .ant-modal-wrap .ant-modal.full-height .ant-modal-content {
    border-radius: 0;
    height: 100%;
  }
  .ant-modal-root .ant-modal-wrap .ant-modal.full-height .ant-modal-content .ant-modal-body {
    height: calc(100dvh - 144px);
  }
  .ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content {
    height: auto;
    border-radius: 24px 24px 0 0;
    padding: 0px;
    display: flex;
    flex-direction: column;
    bottom: 0;
    position: fixed;
    width: 100%;
  }
  .ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-close {
    margin-top: 16px;
  }
  .ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-header {
    top: 0;
    width: 100%;
    z-index: 100;
    padding-top: 24px;
  }
  .ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-header .ant-modal-title {
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
  }
  .ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-body {
    overflow-y: auto;
    padding-bottom: 84px;
    height: 100%;
  }
  .ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-footer {
    bottom: 0;
    position: fixed;
    width: 100%;
    left: 0;
    padding: 24px;
    background: #fff;
    z-index: 10;
    border-radius: 0;
  }
  .ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-footer .ant-btn {
    border-radius: 25px;
    padding: 8px 16px 8px 16px;
    height: 36px;
    font-size: 14px;
    line-height: 20px;
  }
  .ant-modal-root .ant-modal-wrap .ant-modal.ant-modal-confirm {
    height: inherit;
    position: fixed;
    bottom: 0;
    top: auto;
    display: block;
  }
  .ant-modal-root .ant-modal-wrap .ant-modal.ant-modal-confirm .ant-modal-content {
    border-radius: 24px 24px 0px 0px;
  }
  .ant-modal-root .ant-modal-wrap .ant-modal.ant-modal-confirm .ant-modal-content .ant-modal-body {
    padding: 0px;
  }
  .ant-modal-root .ant-modal-wrap .ant-modal.ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-btns .ant-btn {
    border-radius: 25px;
    padding: 8px 16px 8px 16px;
    height: 36px;
    font-size: 14px;
    line-height: 20px;
  }
  .ant-modal-root .ant-modal-wrap .ant-modal.ant-zoom-leave {
    animation-timing-function: ease-in-out;
    animation-duration: 300ms;
  }
  .ant-modal-root .ant-modal-wrap .ant-modal.ant-zoom-leave.ant-zoom-leave-active {
    animation-name: slide-down;
  }
  .ant-modal-root .ant-modal-wrap .ant-modal.ant-zoom-enter {
    animation-timing-function: ease-in-out;
    animation-duration: 300ms;
  }
  .ant-modal-root .ant-modal-wrap .ant-modal.ant-zoom-enter.ant-zoom-enter-active {
    animation-name: slide-up;
  }
  .ant-modal-root .ant-modal-wrap .ant-modal.ant-zoom-appear {
    animation-timing-function: ease-in-out;
    animation-duration: 300ms;
  }
  .ant-modal-root .ant-modal-wrap .ant-modal.ant-zoom-appear.ant-zoom-appear-active {
    animation-name: slide-up;
  }
}
@keyframes slide-up {
  0% {
    opacity: 0;
    transform: translate3d(0, 75%, 0);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
@keyframes slide-down {
  0% {
    opacity: 1;
    transform: none;
  }
  100% {
    opacity: 0;
    transform: translate3d(0, 75%, 0);
  }
}
#scrollableDiv {
  height: 300;
  overflow: hidden;
  display: flex;
}
#scrollableDiv .ant-list-header {
  font-weight: 600;
  font-size: 16px;
}
#scrollableDiv .notifications-list .ant-list-items .ant-list-item {
  display: flex;
  padding: 0px;
  font-size: 16px;
  flex-direction: column;
  align-items: flex-start;
}
#scrollableDiv .notifications-list .ant-list-items .ant-list-item .ant-list-item-meta-content {
  width: 100%;
}
#scrollableDiv .notifications-list .ant-list-items .ant-list-item .ant-list-item-meta-content .ant-list-item-meta-title {
  display: flex;
}
#scrollableDiv .notifications-list .ant-list-items .ant-list-item .ant-list-item-meta-content .ant-list-item-meta-description {
  color: #3F8CFF;
  font-weight: 600;
  font-size: 12px;
}
#scrollableDiv .notifications-list .ant-list-items .ant-list-item > div {
  margin-bottom: 10px;
}
#scrollableDiv .notifications-list .ant-list-items .ant-list-item > div > p {
  margin: 0;
}
#scrollableDiv .notifications-list .ant-list-items .ant-list-item.inactive > div,
#scrollableDiv .notifications-list .ant-list-items .ant-list-item.inactive > div > p,
#scrollableDiv .notifications-list .ant-list-items .ant-list-item.inactive > div > p > span {
  color: #727A88 !important;
  background-color: inherit !important;
}
#scrollableDiv .notifications-list .ant-list-items .ant-list-item.inactive .ant-list-item-meta-description {
  color: #727A88;
}
#scrollableDiv .notifications-list .ant-list-items > div {
  padding: 10px;
  margin: 0px 10px;
  display: flex;
  justify-content: space-between;
}
#scrollableDiv:hover {
  overflow: auto;
}
.nackle-chip {
  height: 50px;
  display: inline-flex;
  border: 1px solid #c9d1df;
  border-radius: 25px;
  justify-content: center;
  align-items: center;
  background-color: #f5f7fa;
}
.nackle-chip.with-image .chip-content {
  margin-left: 8px;
}
.nackle-chip.earned {
  background-color: #fff9db;
  border: 1px solid #fcc419;
}
.nackle-chip.earned .chip-image {
  opacity: 1;
}
.nackle-chip .chip-image {
  height: 46px;
  width: 46px;
  border-radius: 50%;
  margin-left: 2px;
  opacity: 0.54;
}
.nackle-chip .chip-content {
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #59606d;
  margin-left: 16px;
}
.nackle-chip .chip-suffix {
  color: #59606d;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-left: 4px;
  margin-right: 16px;
}
.nackle-status-badge {
  width: 50px;
  height: 50px;
}
.nackle-status-badge svg {
  box-shadow: 0px 7px 20px 0px #00000014;
  border-radius: 50%;
}
.nackle-notation {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.nackle-notation.emphasis .notation-text {
  font-weight: 600;
}
.nackle-notation.info .notation-icon {
  color: #1d5bbf;
}
.nackle-notation.info .notation-text {
  color: #1d5bbf;
}
.nackle-notation.error .notation-icon {
  color: #de1b1b;
}
.nackle-notation.error .notation-text {
  color: #de1b1b;
}
.nackle-notation.success .notation-icon {
  color: #038537;
}
.nackle-notation.success .notation-text {
  color: #038537;
}
.nackle-notation .notation-icon {
  display: flex;
  align-items: center;
  color: #59606d;
}
.nackle-notation .notation-text {
  color: #59606d;
  font-size: 16px;
  line-height: 24px;
  margin-left: 6px;
}
.nackle-item {
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  background-color: #ffffff;
  width: 100%;
  border-radius: 8px;
  cursor: pointer;
}
.nackle-item.large {
  padding: 14px;
}
.nackle-item.medium {
  padding: 10px 14px;
}
.nackle-item.small {
  padding: 8px 14px;
}
.nackle-item.description {
  align-items: flex-start;
}
.nackle-item.right-icon {
  justify-content: space-between;
}
.nackle-item.right-icon .item-icon {
  margin-right: 0;
}
.nackle-item.right-icon.left-icon .right {
  color: #59606d;
}
.nackle-item:hover:not(.disabled),
.nackle-item:active:not(.disabled) {
  background-color: #f5f7fa;
}
.nackle-item.disabled {
  color: #b1baca;
  cursor: not-allowed;
}
.nackle-item.disabled .item-icon {
  color: #b1baca;
}
.nackle-item.disabled .item-icon.right {
  color: #b1baca;
}
.nackle-item .left-container {
  display: flex;
  justify-content: flex-start;
}
.nackle-item.left-icon .item-text-container {
  margin-left: 14px;
}
.nackle-item .item-text-container {
  display: flex;
  flex-direction: column;
}
.nackle-item .item-icon {
  color: rgb(var(--color-primary-none, 89, 96, 109));
  display: flex;
}
.nackle-item.large .item-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
}
.nackle-item.large .item-description {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #59606d;
  margin-top: 2px;
}
.nackle-item.medium .item-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
}
.nackle-item.medium .item-description {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #59606d;
  margin-top: 2px;
}
.nackle-item.small .item-title {
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
}
.nackle-item.small .item-description {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #59606d;
  margin-top: 2px;
}
.nackle-tile {
  border-radius: 24px;
  box-shadow: 0px 8px 32px 0px #34383F14;
}
.nackle-tile-single {
  width: 320px;
  height: 320px;
  container-name: nackle-tile-single;
  container-type: size;
  margin-bottom: 32px;
  display: inline-block;
  overflow: hidden;
}
.nackle-tile-single-infinity {
  width: 320px;
  height: auto;
  container-name: nackle-tile-single-infinity;
  container-type: inline-size;
  margin-bottom: 32px;
  overflow: hidden;
}
.nackle-tile-double {
  width: 672px;
  height: 320px;
  container-name: nackle-tile-double;
  container-type: size;
  margin-right: 32px;
  margin-bottom: 32px;
  overflow: hidden;
}
.nackle-tile-double-infinity {
  width: 672px;
  height: auto;
  container-name: nackle-tile-double-infinity;
  container-type: inline-size;
  margin-right: 32px;
  margin-bottom: 32px;
}
.nackle-tile-triple {
  width: 1024px;
  height: 320px;
  container-name: nackle-tile-triple;
  container-type: size;
  margin-bottom: 32px;
  overflow: hidden;
}
.nackle-tile-triple-infinity {
  width: 1024px;
  height: auto;
  container-name: nackle-tile-triple-infinity;
  container-type: inline-size;
  margin-bottom: 32px;
}
@media screen and (max-width: 1087px) {
  .nackle-tile-double {
    width: 320px;
  }
  .nackle-tile-double-infinity {
    margin-right: 0;
  }
  .nackle-tile-triple {
    width: 672px;
  }
  .nackle-tile-triple-infinity {
    width: 672px;
  }
  .nackle-tile-single {
    display: block;
  }
}
@media screen and (max-width: 735px) {
  .nackle-tile-double-infinity {
    width: 320px;
    margin-right: 0;
  }
  .nackle-tile-triple {
    width: 320px;
    margin-right: 0;
  }
  .nackle-tile-triple-infinity {
    width: 320px;
    margin-right: 0;
  }
}
@media screen and (max-width: 636px) {
  .nackle-tile-double {
    margin-right: 0;
  }
  .nackle-tile-triple {
    margin-right: 0;
  }
  .nackle-tile-double-infinity {
    margin-right: 0;
  }
  .nackle-tile-triple-infinity {
    margin-right: 0;
  }
  .nackle-tile-single {
    margin-right: 0;
  }
}
.search-screen .search-select__placeholder {
  color: #c9d1df;
  font-size: 16px;
  line-height: 24px;
}
.search-screen .search-select__menu {
  z-index: 22;
  border-radius: 8px;
  box-shadow: 0px 2px 10px 0px #0000001A;
}
.search-screen .no-team-container {
  min-height: 400px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: white;
}
.search-screen .no-team-container .search-text-no-team {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #59606d;
  margin-top: 6px;
}
.search-screen .search-select__input-container {
  height: 24px;
  margin: 0;
}
@media only screen and (max-width: 735px) {
  .search-screen .search-select__input-container {
    padding: 0;
  }
}
.search-screen .search-select__input-container input {
  height: 24px;
}
.search-screen .search-limit {
  padding-left: 10px;
}
.search-screen .search-limit.top {
  margin-top: 24px;
}
.search-screen .search-limit .top-100 {
  font-weight: 600;
  color: #59606d;
  font-size: 12px;
  line-height: 18px;
}
.search-screen .search-limit .search-more {
  font-weight: 400;
  color: #59606d;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0px;
}
.search-screen .person-search {
  border-radius: 8px;
  margin-top: 1px;
}
@media only screen and (max-width: 735px) {
  .search-screen .person-search .value:not(.expanded) .search-chevron-container {
    right: 12px;
  }
}
.search-screen .person-search .empty-state-container {
  padding: 12px;
}
.search-screen .person-search .search-chevron-container {
  position: absolute;
  right: 22px;
  display: flex;
  height: calc(100% - 20px);
  justify-content: center;
  align-items: center;
}
@media only screen and (max-width: 735px) {
  .search-screen .person-search .search-chevron-container {
    height: 100%;
  }
}
.search-screen .person-search .search-chevron-container > div {
  position: absolute;
  padding: 14px 0 14px 14px;
}
.search-screen .person-search .search-chevron-container .chevron {
  cursor: pointer;
}
.search-screen .person-search .search-chevron-container .up,
.search-screen .person-search .search-chevron-container .down {
  margin-right: 10px;
  transition: 150ms transform linear;
}
.search-screen .person-search .search-chevron-container .up {
  transform: rotate(-180deg);
}
.search-screen .person-search .search-select__control--is-focused {
  box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);
}
.search-screen .person-search .search-select__multi-value {
  font-size: 16px;
  line-height: 24px;
  margin: 0;
}
.search-screen .person-search .search-select__multi-value__remove svg {
  height: 16px;
  width: 16px;
}
.search-screen .person-search .ant-input-prefix {
  margin-right: 10px;
}
.search-screen .person-search input.ant-input {
  padding: 0;
}
.search-screen .person-search .search-icon {
  width: 20px;
}
.search-screen .person-search input:focus {
  box-shadow: none;
}
.search-screen .person-search .icon-container {
  display: flex;
  align-items: center;
}
.search-screen .person-search .value {
  max-height: 103px;
  padding-right: 16px;
  transition: 150ms max-height linear;
  overflow-y: auto;
  cursor: text;
  padding-top: 10px;
  padding-bottom: 10px;
}
.search-screen .person-search .value.expanded {
  max-height: 219px;
}
.search-screen .person-search .value .ref-container {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  width: 100%;
}
.search-screen .cursor-not-allowed {
  cursor: not-allowed;
}
.search-screen .disabled-search-result-wrapper {
  pointer-events: none;
}
.search-screen .search-results .ant-popover-inner {
  max-height: 300px;
  overflow: auto;
  height: auto;
}
.search-screen .search-results .ant-popover-inner-content {
  padding: 0;
}
.search-screen .search-results .ant-spin-container {
  display: block;
}
.search-screen .search-results .ant-spin-spinning {
  padding: 12px;
}
.search-screen .search-results .ant-spin-nested-loading {
  position: static;
}
.search-screen .sub-description {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #59606d;
  padding-left: 0;
}
.search-screen .sub-description:not(.error-label) {
  margin-top: 10px;
}
.search-screen .search-error-container {
  display: flex;
  margin-right: 10px;
}
.search-screen .search-error-container .error-icon {
  color: #de1b1b;
}
.search-screen .team-container {
  background: white;
  overflow: auto;
}
.search-screen .error-label {
  margin-top: 16px;
}
.search-screen .error-label.nackle-caption {
  color: #de1b1b;
}
.search-screen .search-result {
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #eceff4;
  padding: 12px;
  cursor: pointer;
}
.search-screen .search-result .disabled-text-container {
  row-gap: 11px;
  display: flex;
  justify-content: space-between;
  flex: 2;
  flex-wrap: wrap;
}
.search-screen .search-result.disabled {
  background-color: #f5f7fa;
  cursor: not-allowed;
  flex-wrap: wrap;
}
.search-screen .search-result.disabled .ant-avatar {
  opacity: 0.54;
}
.search-screen .search-result.disabled .text-container .search-name {
  color: #b1baca;
  cursor: not-allowed;
}
.search-screen .search-result.disabled .text-container .person-details {
  color: #b1baca;
}
.search-screen .search-result.disabled .disabled-reason {
  color: #59606d;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
}
.search-screen .search-result .avatar-container {
  align-items: start;
}
.search-screen .search-result .avatar-container .ant-avatar {
  margin-right: 8px;
}
.search-screen .search-result:hover {
  background-color: #f5f7fa;
}
.search-screen .search-result .text-container {
  flex: 10;
}
.search-screen .search-result .text-container .search-name {
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}
.search-screen .search-result .text-container .person-details {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #59606d;
}
.search-screen .search-result .text-container .search-selected {
  flex: 2;
  text-align: right;
}
@media only screen and (max-width: 735px) {
  .search-screen .person-search .value {
    max-height: 86px;
  }
  .search-screen .person-search .value .ref-container {
    gap: 0;
    -moz-column-gap: 4px;
         column-gap: 4px;
    width: 100%;
  }
  .search-screen .person-search .search-select__value-container {
    padding: 0;
    padding-left: 0;
    gap: 0;
  }
  .search-screen .person-search .search-select__menu {
    z-index: 10000;
  }
  .search-screen .person-search .search-select__placeholder {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: #c9d1df;
    align-self: center;
    position: absolute;
    white-space: nowrap;
  }
  .search-screen .person-search .search-select__control {
    min-height: 24px;
  }
  .search-screen .person-search .search-select__control .icon-container svg {
    height: 16px;
    width: 16px;
  }
  .search-screen .person-search .search-select__multi-value {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    margin-top: 6px;
  }
  .search-screen .person-search .search-select__multi-value__remove svg {
    height: 12px;
    width: 12px;
  }
}
.nackle-caption {
  color: #59606d;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-top: 2px;
  padding-left: 10px;
}
.nackle-caption.error {
  color: #de1b1b;
}
.nackle-caption.large {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  padding-left: 12px;
}
.nackle-caption.small {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  padding-left: 8px;
}
.nackle-caption.disabled {
  color: #b1baca;
}
.disabled .nackle-caption {
  color: #b1baca;
}
.ant-pagination {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: rgb(var(--color-primary-none, 89, 96, 109));
  background-color: #fff;
  padding: 10px;
  border-radius: 40px;
}
.ant-pagination:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-prev,
.ant-pagination:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-next,
.ant-pagination:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-item {
  min-width: 26px;
}
.ant-pagination:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-prev:not(.ant-pagination-item-active, .ant-pagination-disabled):hover,
.ant-pagination:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-next:not(.ant-pagination-item-active, .ant-pagination-disabled):hover,
.ant-pagination:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-item:not(.ant-pagination-item-active, .ant-pagination-disabled):hover {
  background-color: #f5f7fa;
}
.ant-pagination:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-prev:not(.ant-pagination-item-active, .ant-pagination-disabled):hover a,
.ant-pagination:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-next:not(.ant-pagination-item-active, .ant-pagination-disabled):hover a,
.ant-pagination:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-item:not(.ant-pagination-item-active, .ant-pagination-disabled):hover a,
.ant-pagination:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-prev:not(.ant-pagination-item-active, .ant-pagination-disabled):hover button.ant-btn.ant-btn-circle.ant-btn-link.ant-btn-icon-only,
.ant-pagination:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-next:not(.ant-pagination-item-active, .ant-pagination-disabled):hover button.ant-btn.ant-btn-circle.ant-btn-link.ant-btn-icon-only,
.ant-pagination:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-item:not(.ant-pagination-item-active, .ant-pagination-disabled):hover button.ant-btn.ant-btn-circle.ant-btn-link.ant-btn-icon-only {
  color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);
}
.ant-pagination li.ant-pagination-prev,
.ant-pagination li.ant-pagination-next,
.ant-pagination li.ant-pagination-item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  width: 36px;
  border-radius: 25px;
}
.ant-pagination .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,
.ant-pagination .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {
  position: absolute;
  top: 16px;
  inset-inline-end: 0;
  bottom: 0;
  inset-inline-start: 0;
  color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-pagination .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon svg,
.ant-pagination .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon svg {
  width: 20px;
  height: 20px;
}
.ant-pagination .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-ellipsis,
.ant-pagination .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-ellipsis {
  color: #59606d;
}
.ant-pagination .ant-btn svg {
  width: 20px;
  height: 20px;
}
.ant-pagination .ant-btn:disabled {
  background-color: #f5f7fa;
  color: #b1baca;
  border: 1px #c9d1df solid;
  cursor: not-allowed;
}
.ant-pagination .ant-pagination-item {
  border: none;
}
.ant-pagination .ant-pagination-item a {
  font-weight: 600;
  color: rgb(var(--color-primary-none, rgb(var(--color-primary-none, 89, 96, 109))));
  padding: 0;
}
.ant-pagination .ant-pagination-item-active {
  background-color: #fff;
  border: 1px #c9d1df solid;
}
.ant-pagination .ant-pagination-item-active a {
  color: #59606d;
}
.ant-pagination .ant-pagination-item-active:hover {
  border: 1px #c9d1df solid;
}
.ant-pagination .ant-pagination-item-active:hover a {
  color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-pagination .ant-pagination-item-active {
  cursor: default;
}
.ant-pagination .ant-pagination-item-active a {
  cursor: default;
}
.ant-pagination .ant-pagination-item-active:hover {
  color: #59606d;
}
.ant-pagination .ant-pagination-item-active:hover a {
  color: #59606d;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-item > a {
  color: #b1baca;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-item-active {
  background-color: #f5f7fa;
  border: 1px #c9d1df solid;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-item-active:hover {
  background-color: #f5f7fa;
}
.ant-pagination.ant-pagination-disabled button.ant-btn {
  color: #b1baca;
  background-color: #f5f7fa;
  border: 1px #c9d1df solid;
  cursor: not-allowed;
}
.ant-pagination.ant-pagination-disabled button.ant-btn:hover {
  color: #b1baca;
}
.ant-pagination.ant-pagination-disabled button.ant-btn .ant-btn-icon svg {
  color: #b1baca;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-prev button,
.ant-pagination.ant-pagination-disabled .ant-pagination-next button {
  background-color: #f5f7fa;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-ellipsis,
.ant-pagination.ant-pagination-disabled .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-ellipsis {
  color: #b1baca;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-jump-prev:hover .ant-pagination-item-container .ant-pagination-item-ellipsis,
.ant-pagination.ant-pagination-disabled .ant-pagination-jump-next:hover .ant-pagination-item-container .ant-pagination-item-ellipsis {
  opacity: 1;
}
.ant-pagination.ant-pagination-disabled .ant-pagination-jump-prev:hover .ant-pagination-item-container .ant-pagination-item-link-icon,
.ant-pagination.ant-pagination-disabled .ant-pagination-jump-next:hover .ant-pagination-item-container .ant-pagination-item-link-icon {
  opacity: 0;
}
.ant-pagination.ant-pagination-large {
  height: 64px;
}
.ant-pagination.ant-pagination-large li.ant-pagination-prev,
.ant-pagination.ant-pagination-large li.ant-pagination-next,
.ant-pagination.ant-pagination-large li.ant-pagination-item {
  height: 44px;
  width: 44px;
  font-size: 16px;
}
.ant-pagination.ant-pagination-large li.ant-pagination-prev .ant-btn,
.ant-pagination.ant-pagination-large li.ant-pagination-next .ant-btn,
.ant-pagination.ant-pagination-large li.ant-pagination-item .ant-btn {
  width: 44px;
  height: 44px;
}
.ant-pagination.ant-pagination-large li.ant-pagination-prev .ant-btn svg,
.ant-pagination.ant-pagination-large li.ant-pagination-next .ant-btn svg,
.ant-pagination.ant-pagination-large li.ant-pagination-item .ant-btn svg {
  width: 24px;
  height: 24px;
}
.ant-pagination.ant-pagination-large .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,
.ant-pagination.ant-pagination-large .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {
  top: 16px;
  color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-pagination.ant-pagination-large .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon svg,
.ant-pagination.ant-pagination-large .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon svg {
  width: 24px;
  height: 24px;
}
.ant-pagination.ant-pagination-mini {
  height: 46px;
}
.ant-pagination.ant-pagination-mini li.ant-pagination-prev,
.ant-pagination.ant-pagination-mini li.ant-pagination-next,
.ant-pagination.ant-pagination-mini li.ant-pagination-item {
  height: 26px;
  width: 26px;
  font-size: 12px;
  margin-inline-end: 8px;
}
.ant-pagination.ant-pagination-mini li.ant-pagination-prev .ant-btn,
.ant-pagination.ant-pagination-mini li.ant-pagination-next .ant-btn,
.ant-pagination.ant-pagination-mini li.ant-pagination-item .ant-btn {
  min-width: 26px;
  width: 26px;
  height: 26px;
}
.ant-pagination.ant-pagination-mini li.ant-pagination-prev .ant-btn svg,
.ant-pagination.ant-pagination-mini li.ant-pagination-next .ant-btn svg,
.ant-pagination.ant-pagination-mini li.ant-pagination-item .ant-btn svg {
  width: 16px;
  height: 16px;
}
.ant-pagination.ant-pagination-mini .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,
.ant-pagination.ant-pagination-mini .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {
  top: 12px;
  color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-pagination.ant-pagination-mini .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon svg,
.ant-pagination.ant-pagination-mini .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon svg {
  width: 16px;
  height: 16px;
}
.ant-pagination.ant-pagination-simple {
  color: #59606d;
  background-color: transparent;
  height: 26px;
  padding: 0;
  border-radius: 0;
  border: 1px transparent solid;
}
.ant-pagination.ant-pagination-simple .ant-btn {
  min-width: 26px;
  width: 26px;
  height: 26px;
  padding: 0;
}
.ant-pagination.ant-pagination-simple .ant-btn svg {
  width: 16px;
  height: 16px;
}
.ant-pagination.ant-pagination-simple:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-prev,
.ant-pagination.ant-pagination-simple:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-next {
  width: 26px;
  height: 26px;
}
.ant-pagination.ant-pagination-simple:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-prev:not(.ant-pagination-item-active, .ant-pagination-disabled):hover,
.ant-pagination.ant-pagination-simple:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-next:not(.ant-pagination-item-active, .ant-pagination-disabled):hover {
  background-color: #f5f7fa;
}
.ant-pagination.ant-pagination-simple:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-prev:not(.ant-pagination-item-active, .ant-pagination-disabled):hover a,
.ant-pagination.ant-pagination-simple:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-next:not(.ant-pagination-item-active, .ant-pagination-disabled):hover a,
.ant-pagination.ant-pagination-simple:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-prev:not(.ant-pagination-item-active, .ant-pagination-disabled):hover button.ant-btn.ant-btn-link.ant-btn-icon-only,
.ant-pagination.ant-pagination-simple:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-next:not(.ant-pagination-item-active, .ant-pagination-disabled):hover button.ant-btn.ant-btn-link.ant-btn-icon-only {
  color: #59606d;
}
.ant-pagination.ant-pagination-simple .ant-pagination-prev,
.ant-pagination.ant-pagination-simple .ant-pagination-next {
  color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-pagination.ant-pagination-simple .ant-pagination-prev .ant-btn:focus,
.ant-pagination.ant-pagination-simple .ant-pagination-next .ant-btn:focus {
  outline: none;
}
.ant-pagination.ant-pagination-simple .ant-pagination-prev .ant-btn:disabled,
.ant-pagination.ant-pagination-simple .ant-pagination-next .ant-btn:disabled {
  background-color: transparent;
  border: none;
  color: #b1baca;
}
.ant-pagination.ant-pagination-simple .ant-pagination-simple-pager input {
  width: 48px;
  color: #59606d;
}
.ant-pagination.ant-pagination-simple .ant-pagination-simple-pager input:hover {
  border-color: #c9d1df;
}
.ant-pagination.ant-pagination-simple .ant-pagination-simple-pager input:focus {
  border-color: #c9d1df;
  outline: none;
  box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);
  -webkit-box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);
}
.ant-pagination.ant-pagination-simple .ant-pagination-simple-pager input:disabled {
  color: #b1baca;
  background-color: #f5f7fa;
  border-color: #c9d1df;
}
.ant-pagination.icon-only.icon-only {
  background-color: transparent;
}
.ant-pagination.icon-only.icon-only li {
  display: none;
}
.ant-pagination.icon-only.icon-only li:first-child {
  display: flex;
}
.ant-pagination.icon-only.icon-only li:last-child {
  display: flex;
}
.ant-pagination.icon-only.icon-only .ant-pagination-prev,
.ant-pagination.icon-only.icon-only .ant-pagination-next {
  background-color: white;
  border: 1px #c9d1df solid;
}
.ant-pagination.icon-only.icon-only .ant-pagination-prev.ant-pagination-disabled,
.ant-pagination.icon-only.icon-only .ant-pagination-next.ant-pagination-disabled {
  background-color: #f5f7fa;
}
.ant-pagination.icon-only.icon-only .ant-btn:disabled {
  border: none;
}
.ant-pagination.icon-only.icon-only.ant-pagination-mini li:first-child {
  margin-inline-end: 8px;
}
.ant-pagination-slash {
  position: relative;
  top: 1px;
}
.icon-only .ant-pagination-chevron.ant-btn.ant-btn.ant-btn-link:not(:disabled) {
  color: #59606d;
}
.ant-popconfirm .ant-popover-content .ant-popover-inner {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 12px;
  padding-bottom: 12px;
  border-radius: 8px;
}
.ant-popconfirm .ant-popover-content .ant-popover-inner .ant-popconfirm-inner-content .ant-popconfirm-message {
  margin-bottom: 12px;
  align-items: center;
}
.ant-popconfirm .ant-popover-content .ant-popover-inner .ant-popconfirm-inner-content .ant-popconfirm-message .ant-popconfirm-message-icon {
  display: flex;
  align-items: center;
  margin-right: 10px;
  align-self: start;
}
.ant-popconfirm .ant-popover-content .ant-popover-inner .ant-popconfirm-inner-content .ant-popconfirm-message .ant-popconfirm-message-icon svg {
  height: 16px;
  width: 16px;
  color: #fcc419;
}
.ant-popconfirm .ant-popover-content .ant-popover-inner .ant-popconfirm-inner-content .ant-popconfirm-message .ant-popconfirm-message-text .ant-popconfirm-title {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
.ant-popconfirm .ant-popover-content .ant-popover-inner .ant-popconfirm-inner-content .ant-popconfirm-buttons {
  display: flex;
  justify-content: space-between;
}
.ant-popconfirm .ant-popover-content .ant-popover-inner .ant-popconfirm-inner-content .ant-popconfirm-buttons button.ant-btn {
  margin-left: 0;
  border-radius: 25px;
}
.ant-popover.ant-popover {
  width: -moz-min-content;
  width: min-content;
}
.ant-popover-content {
  font-weight: 400;
  font-size: 14px;
  color: #59606d;
}
.ant-popover-content .ant-list-header {
  font-size: 12px;
  color: #59606d;
  font-weight: 600;
}
.ant-popover-content .ant-list .ant-list-item .ant-list-item-meta .ant-list-item-meta-title {
  font-size: 14px;
  font-weight: 600;
}
.ant-popover-content .ant-list .ant-list-item .ant-list-item-meta .ant-list-item-meta-description {
  color: #59606d;
  font-size: 12px;
}
.ant-popover-content .ant-popover-inner {
  border-radius: 16px;
  padding: 12px;
}
.ant-popover-content .ant-popover-inner .popover-shell-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
}
.ant-popover-content .ant-popover-inner .popover-shell-container .ant-image-img {
  border-radius: 10px;
}
.ant-popover-content .ant-popover-inner .ant-popover-inner-content {
  font-size: 14px;
  color: #000000;
  max-width: 444px;
}
.ant-popover-content .ant-popover-inner .ant-popover-inner-content .ant-menu {
  border: none;
}
.ant-popover-content .ant-popover-inner .ant-popover-inner-content .ant-menu.ant-menu-vertical:focus {
  box-shadow: none;
}
.ant-popover-content .ant-popover-inner .ant-popover-inner-content .ant-menu .ant-menu-item {
  color: #59606d;
}
.ant-popover-content .ant-popover-inner .ant-popover-inner-content .ant-menu .ant-menu-item:hover {
  background-color: #f5f7fa;
}
.ant-popover-content .ant-popover-inner .ant-popover-inner-content .popover-content {
  padding-top: 12px;
  padding-bottom: 12px;
}
.ant-popover-content .ant-popover-inner .ant-popover-inner-content .ant-divider {
  border: 0.5px solid #c9d1df;
  border-top: 0px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ant-popover-content .ant-popover-inner .ant-popover-title {
  font-size: 16px;
  margin: 0px;
  color: #000000;
}
.progress-with-steps-extended {
  width: 100%;
}
.progress-with-steps-extended .ant-progress-steps-outer .ant-progress-steps-item {
  flex-grow: 1;
  max-height: 10px;
  min-height: 10px;
}
.progress-with-steps-extended .ant-progress-steps-outer .ant-progress-steps-item:not(.ant-progress-steps-item-active) {
  background-color: #dee3ec;
}
.ant-progress-steps .ant-progress-steps-outer .ant-progress-steps-item {
  flex-grow: 1;
  max-height: 10px;
  min-height: 10px;
}
.ant-progress-steps .ant-progress-steps-outer .ant-progress-steps-item:not(.ant-progress-steps-item-active) {
  background-color: #dee3ec;
}
.vertical-align {
  align-items: top;
  justify-content: space-between;
  flex-wrap: nowrap;
  margin-top: 15px;
}
.ant-progress.ant-progress-line .ant-progress-outer .ant-progress-inner {
  background-color: #dee3ec;
}
.ant-progress.ant-progress-circle.ant-progress-small-percent.ant-progress-circle-large .ant-progress-inner .ant-progress-text::after {
  content: '%';
  font-size: 24px;
}
.ant-progress.ant-progress-circle.ant-progress-small-percent.ant-progress-circle-medium .ant-progress-inner .ant-progress-text::after {
  content: '%';
  font-size: 18px;
}
.ant-progress.ant-progress-circle.ant-progress-small-percent.ant-progress-circle-small .ant-progress-inner .ant-progress-text::after {
  font-size: 14px;
  content: '%';
}
.ant-progress.ant-progress-circle.ant-progress-small-percent .ant-progress-inner .ant-progress-text ::after {
  content: '%';
}
.ant-progress.ant-progress-large .ant-progress-outer .ant-progress-inner .ant-progress-bg {
  min-height: 10px;
}
.ant-progress.ant-progress-large .ant-progress-text svg {
  width: 16px;
  height: 16px;
}
.ant-progress.ant-progress-medium .ant-progress-text svg {
  width: 16px;
  height: 16px;
}
.ant-progress.ant-progress-small .ant-progress-text svg {
  width: 12px;
  height: 12px;
}
.ant-progress.primary .ant-progress-inner .ant-progress-circle .ant-progress-circle-path {
  stroke: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-progress.primary .ant-progress-inner .ant-progress-bg {
  background-color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-progress .ant-progress-inner .ant-progress-circle .ant-progress-circle-path {
  stroke: #1d5bbf;
}
.ant-progress .ant-progress-inner .ant-progress-bg {
  background-color: #1d5bbf;
}
.ant-progress.ant-progress-circle .ant-progress-circle-trail {
  stroke: #dee3ec;
}
.ant-progress.ant-progress-circle .ant-progress-inner .ant-progress-text {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 38px;
  font-weight: 600;
  color: #59606d;
}
.ant-progress.ant-progress-circle .ant-progress-inner .ant-progress-text svg {
  height: 32px;
  width: 32px;
}
.ant-progress.ant-progress-circle.ant-progress-circle-large .ant-progress-inner .ant-progress-text {
  font-size: 38px;
  color: #59606d;
}
.ant-progress.ant-progress-circle.ant-progress-circle-medium .ant-progress-inner .ant-progress-text {
  font-size: 28px;
  color: #59606d;
}
.ant-progress.ant-progress-circle.ant-progress-circle-small .ant-progress-inner .ant-progress-text {
  font-size: 18px;
  color: #59606d;
}
.ant-progress.ant-progress-steps .ant-progress-steps-outer .ant-progress-steps-item-active {
  background-color: #1d5bbf;
}
.ant-progress.ant-progress-status-success .ant-progress-inner .ant-progress-circle .ant-progress-circle-path {
  stroke: #038537;
}
.ant-progress.ant-progress-status-success .ant-progress-inner .ant-progress-text {
  color: #038537;
}
.ant-progress.ant-progress-status-success .ant-progress-inner .ant-progress-text svg {
  color: #038537;
}
.ant-progress.ant-progress-status-success .ant-progress-inner .ant-progress-bg {
  background-color: #038537;
}
.ant-progress.ant-progress-status-success .ant-progress-text {
  color: #038537;
}
.ant-progress.ant-progress-status-success .ant-progress-text span svg {
  color: #038537;
}
.ant-progress.ant-progress-status-success .ant-progress-steps-outer .ant-progress-steps-item-active {
  background-color: #038537;
}
.ant-progress.ant-progress-status-exception .ant-progress-inner .ant-progress-circle .ant-progress-circle-path {
  stroke: #de1b1b;
}
.ant-progress.ant-progress-status-exception .ant-progress-inner .ant-progress-text {
  color: #de1b1b;
}
.ant-progress.ant-progress-status-exception .ant-progress-inner .ant-progress-text svg {
  color: #de1b1b;
}
.ant-progress.ant-progress-status-exception .ant-progress-inner .ant-progress-bg {
  background-color: #de1b1b;
}
.ant-progress.ant-progress-status-exception .ant-progress-text {
  color: #de1b1b;
}
.ant-progress.ant-progress-status-exception .ant-progress-text span svg {
  color: #de1b1b;
}
.ant-progress.ant-progress-status-exception .ant-progress-steps-outer .ant-progress-steps-item-active {
  background-color: #de1b1b;
}
.ant-progress .ant-progress-text {
  color: #59606d;
  font-weight: 600;
}
.ant-progress-circle {
  position: relative;
}
.ant-progress-circle:not(.ant-progress-dashboard)::before {
  height: 5px;
  width: 5px;
  border-radius: 50%;
  background-color: white;
  position: absolute;
  content: ' ';
  left: 50%;
  top: 3px;
  z-index: 10000;
  transform: translateX(-50%);
}
.ant-result .ant-result-title {
  font-size: 28px;
  font-weight: 600;
  margin-block: 0;
}
.ant-result .ant-result-subtitle {
  font-size: 16px;
  color: #59606d;
  margin-top: 4px;
}
.ant-result .ant-result-icon {
  margin-bottom: 0;
}
.ant-result .ant-result-icon img {
  height: 300px;
  width: 300px;
}
.ant-result .ant-result-icon svg {
  width: 100px;
  height: 100px;
}
.ant-result.ant-result-info .ant-result-icon {
  color: #1d5bbf;
}
.ant-result.ant-result-warning .ant-result-icon {
  color: #fcc419;
}
.ant-result.ant-result-success .ant-result-icon {
  color: #038537;
}
.ant-result.ant-result-error .ant-result-icon {
  color: #de1b1b;
}
.ant-result .ant-result-extra {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 18px;
}
.ant-result .ant-result-extra button {
  margin-right: 20px;
}
.ant-result.result-small .ant-result-title {
  font-size: 18px;
}
.ant-result.result-small .ant-result-subtitle {
  font-size: 14px;
}
.ant-result.result-small .ant-result-extra {
  margin-top: 14px;
}
.ant-result.result-small .ant-result-icon img {
  height: 100px;
  width: 100px;
}
.ant-result.result-small .ant-result-icon svg {
  height: 48px;
  width: 48px;
}
.ant-skeleton .ant-skeleton-content .ant-skeleton-title {
  border-radius: 2px;
  background: #eceff4;
  margin-top: 0;
}
.ant-skeleton .ant-skeleton-content .ant-skeleton-paragraph {
  margin-bottom: 0;
}
.ant-skeleton .ant-skeleton-content .ant-skeleton-paragraph li {
  border-radius: 2px;
  background: #eceff4;
}
.ant-skeleton.ant-skeleton-active .ant-skeleton-content .ant-skeleton-title {
  background: linear-gradient(90deg, #eceff4 25%, #dee3ec 37%, #eceff4 63%);
  background-size: 400% 100%;
}
.ant-skeleton.ant-skeleton-active .ant-skeleton-content .ant-skeleton-paragraph li {
  background: linear-gradient(90deg, #eceff4 25%, #dee3ec 37%, #eceff4 63%);
  background-size: 400% 100%;
}
.ant-spin-nested-loading > div .ant-spin {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.ant-spin-nested-loading > div .ant-spin svg.ant-spin-dot {
  top: unset;
  inset-inline-start: unset;
}
.ant-spin-nested-loading > div .nackle-spin-small .ant-spin-text {
  padding-top: 16px;
  color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-spin-nested-loading > div .nackle-spin-default .ant-spin-text {
  padding-top: 40px;
  color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-spin-nested-loading > div .nackle-spin-large .ant-spin-text {
  padding-top: 64px;
  color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-spin-nested-loading > div .nackle-spin-extra-large .ant-spin-text {
  padding-top: 88px;
  color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-spin.nackle-spin-large svg {
  width: 150px;
  height: 150px;
}
.ant-spin.nackle-spin-extra-large svg {
  width: 200px;
  height: 200px;
}
.ant-spin.nackle-spin-default svg {
  width: 100px;
  height: 100px;
}
.ant-spin.nackle-spin-small svg {
  width: 50px;
  height: 50px;
}
.ant-tabs {
  width: 100%;
  display: flex;
  justify-content: center;
  box-shadow: none;
}
.ant-tabs .ant-tabs-nav .ant-tabs-nav-wrap {
  transform: unset;
}
.ant-tabs .ant-tabs-nav-operations .ant-tabs-nav-more {
  background-color: inherit;
}
.ant-tabs .ant-tabs-nav-operations .ant-tabs-nav-more svg {
  color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-tabs.ant-tabs-top .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-right::after {
  box-shadow: inset -10px 0 8px -8px rgba(0, 0, 0, 0.08);
}
.ant-tabs.ant-tabs-bottom .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-right::after {
  box-shadow: inset -10px 0 8px -8px rgba(0, 0, 0, 0.08);
}
.ant-tabs .ant-tabs-tab.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: rgb(var(--color-primary-none, 89, 96, 109));
  text-shadow: none;
}
.ant-tabs .ant-tabs-tab .ant-tabs-tab-btn {
  color: #59606d;
  font-weight: 600;
  box-shadow: none;
  text-shadow: none;
  display: flex;
}
.ant-tabs .ant-tabs-tab .ant-tabs-tab-btn:hover,
.ant-tabs .ant-tabs-tab .ant-tabs-tab-btn:active,
.ant-tabs .ant-tabs-tab .ant-tabs-tab-btn:focus {
  color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);
}
.ant-tabs .ant-tabs-tab .ant-tabs-tab-btn > span {
  display: flex;
  align-items: center;
}
.ant-tabs .ant-tabs-tab .ant-tabs-tab-btn > span > div {
  display: flex;
  align-items: center;
}
.ant-tabs .ant-tabs-tab .ant-tabs-tab-btn > span > div svg {
  margin-right: 6px;
}
.ant-tabs .ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-btn {
  color: #b1baca;
  text-shadow: none;
}
.ant-tabs .ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-btn:hover {
  color: #b1baca;
}
.ant-tabs.ant-tabs-large .ant-tabs-tab-btn {
  font-size: 16px;
}
.ant-tabs.ant-tabs-large .ant-tabs-tab-btn svg {
  width: 24px;
  height: 24px;
}
.ant-tabs.ant-tabs-large .ant-tabs-nav-add {
  padding: 11px 12px;
}
.ant-tabs.ant-tabs-middle .ant-tabs-tab-btn {
  font-size: 14px;
}
.ant-tabs.ant-tabs-middle .ant-tabs-tab-btn svg {
  width: 20px;
  height: 20px;
}
.ant-tabs.ant-tabs-middle .ant-tabs-nav-add {
  padding: 8px;
  border-radius: 6px 6px 0px 0px;
}
.ant-tabs.ant-tabs-left.ant-tabs-middle .ant-tabs-tab,
.ant-tabs.ant-tabs-right.ant-tabs-middle .ant-tabs-tab {
  padding: 12px 24px;
}
.ant-tabs.ant-tabs-small .ant-tabs-nav {
  height: 34.84px;
}
.ant-tabs.ant-tabs-small .ant-tabs-nav .ant-tabs-nav-operations .ant-tabs-nav-more {
  padding: 4px 5.5px;
}
.ant-tabs.ant-tabs-small .ant-tabs-tab-btn {
  font-size: 12px;
}
.ant-tabs.ant-tabs-small .ant-tabs-tab-btn svg {
  width: 16px;
  height: 16px;
}
.ant-tabs.ant-tabs-small .ant-tabs-nav-add {
  padding: 6px;
  border-radius: 4px 4px 0 0;
}
.ant-tabs.ant-tabs-left.ant-tabs-small .ant-tabs-tab,
.ant-tabs.ant-tabs-right.ant-tabs-small .ant-tabs-tab {
  padding: 8px 24px;
}
.ant-tabs > *.ant-tabs-nav .ant-tabs-ink-bar {
  height: 4px;
  width: 4px;
  background: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-tabs.ant-tabs-top .ant-tabs-nav .ant-tabs-nav-wrap::after,
.ant-tabs.ant-tabs-bottom .ant-tabs-nav .ant-tabs-nav-wrap::after {
  box-shadow: none;
}
.ant-tabs.ant-tabs-top > .ant-tabs-nav::before,
.ant-tabs.ant-tabs-bottom > .ant-tabs-nav::before {
  border: 1px solid #c9d1df;
  border-bottom: none;
}
.ant-tabs.ant-tabs-left > .ant-tabs-content-holder {
  border-left: 1px solid #c9d1df;
}
.ant-tabs.ant-tabs-right > .ant-tabs-content-holder {
  border-right: 1px solid #c9d1df;
}
.ant-tabs-card .ant-tabs-nav .ant-tabs-nav-add,
.ant-tabs-card .ant-tabs-nav .ant-tabs-tab {
  border: 1px solid #c9d1df;
  background-color: #ffffff;
  min-width: 0px;
}
.ant-tabs-card .ant-tabs-nav .ant-tabs-nav-add.ant-tabs-tab-disabled,
.ant-tabs-card .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-disabled {
  color: #b1baca;
  background-color: #f5f7fa;
}
.ant-tabs-card .ant-tabs-nav .ant-tabs-nav-add {
  color: #59606d;
}
.ant-tabs-card .ant-tabs-nav .ant-tabs-nav-add:hover {
  color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);
}
.ant-tabs-card.ant-tabs-large .ant-tabs-nav .ant-tabs-nav-add {
  background-color: #ffffff;
  border-radius: 8px 8px 0 0;
  padding: 7px 11px;
  height: 40px;
}
.ant-tabs-card.ant-tabs-middle .ant-tabs-nav .ant-tabs-nav-add {
  background-color: #ffffff;
  border-radius: 6px 6px 0 0;
  padding: 7px;
  height: 36px;
}
.ant-tabs-card.ant-tabs-middle .ant-tabs-nav .ant-tabs-nav-add svg {
  height: 20px;
  width: 20px;
}
.ant-tabs-card.ant-tabs-small {
  border-radius: 4px 4px 0 0;
}
.ant-tabs-card.ant-tabs-small .ant-tabs-nav .ant-tabs-nav-add {
  background-color: #ffffff;
  border-radius: 4px;
  padding: 4px;
  height: 28px;
}
.ant-tabs-card.ant-tabs-small .ant-tabs-nav .ant-tabs-nav-add svg {
  height: 16px;
  width: 16px;
}
.ant-tabs-card .ant-tabs-nav::before {
  border: none;
}
.ant-tabs-card .ant-tabs-tab-btn {
  margin-right: 10px;
}
.ant-tabs-card .ant-tabs-tab-remove {
  margin-left: 0;
  padding: 0;
}
.ant-tabs-card.ant-tabs-large > .ant-tabs-nav .ant-tabs-tab {
  border-radius: 8px 8px 0 0;
  padding: 8px 16px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  height: 40px;
}
.ant-tabs-card.ant-tabs-large > .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-remove {
  height: 24px;
}
.ant-tabs-card.ant-tabs-middle > .ant-tabs-nav .ant-tabs-tab {
  border-radius: 6px 6px 0 0;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  height: 36px;
}
.ant-tabs-card.ant-tabs-middle > .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-remove {
  height: 20px;
}
.ant-tabs-card.ant-tabs-small > .ant-tabs-nav .ant-tabs-tab {
  border-radius: 4px 4px 0 0;
  padding: 6px 16px;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  height: 28px;
}
.ant-tabs-card.ant-tabs-small > .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-remove {
  height: 16px;
}
.ant-tabs-dropdown {
  width: 178px;
  max-height: 218px;
  border-radius: 8px;
}
.ant-tabs-dropdown .ant-menu.more-tabs-menu {
  width: 100%;
  max-height: 218px;
  overflow: scroll;
  padding: 0px;
  border-radius: 8px;
  padding-top: 4px;
  padding-bottom: 4px;
}
.ant-tabs-dropdown .ant-menu.more-tabs-menu .ant-menu-item {
  height: 30px;
  border-radius: 4px;
  margin-block: 0px;
}
.ant-tabs-dropdown .ant-menu.more-tabs-menu .ant-menu-item .ant-menu-title-content {
  font-size: 14px;
  font-weight: 400;
}
.ant-tabs-dropdown .ant-menu.more-tabs-menu .ant-menu-item:hover {
  background-color: #f5f7fa;
}
.ant-tabs-dropdown .ant-menu.more-tabs-menu .ant-menu-item.ant-menu-item-selected {
  background-color: rgb(var(--color-primary-none, 89, 96, 109));
  color: white;
}
.ant-tabs-dropdown .ant-menu.more-tabs-menu .ant-menu-item.ant-menu-item-selected:hover {
  background-color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-tabs-dropdown .ant-menu.more-tabs-menu .ant-menu-item.ant-menu-item-disabled {
  background-color: #f5f7fa !important;
}
.ant-tabs-dropdown .ant-menu.more-tabs-menu .ant-menu-item.ant-menu-item-disabled .ant-menu-title-content {
  color: #b1baca;
}
.ant-tabs-dropdown .ant-menu-light:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover {
  background-color: #f5f7fa;
}
.ant-tag {
  font-family: var(--body-font-family-none, Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, color emoji, segoe ui emoji, noto color emoji, android emoji);
  background-color: #f5f7fa;
  border: 1px solid #c9d1df;
  border-radius: 6px;
  color: #59606d;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0px;
  line-height: 14px;
  padding: 1px 8px 1px 1px;
}
.ant-tag.ant-tag-borderless {
  border: none;
}
.ant-tag .ant-tag-close-icon {
  justify-content: center;
  align-items: center;
  display: flex;
  margin-left: 8px;
  color: #59606D;
  text-shadow: none;
  box-shadow: none;
}
.ant-tag.ant-tag-has-color {
  color: #f5f7fa;
}
.ant-tag.ant-tag-has-color.color-tag-medium {
  padding: 2px 10px 2px 10px;
}
.ant-tag.ant-tag-has-color.color-tag-large {
  padding: 2px 12px 2px 12px;
}
.ant-tag.error {
  border-radius: 5px;
  background-color: #faf0f0;
  border-color: #de1b1b;
  color: #59606d;
}
.ant-tag.warning {
  border-radius: 5px;
  background-color: #fff9db;
  border-color: #fcc419;
  color: #59606d;
}
.ant-tag.warning-tag {
  color: #000000;
}
.ant-tag.success {
  border-radius: 5px;
  background-color: #e1faeb;
  border-color: #038537;
  color: #59606d;
}
.ant-tag.processing {
  border-radius: 5px;
  background-color: #f0f5fc;
  border-color: #1d5bbf;
  color: #59606d;
}
.ant-tag.purple {
  border-radius: 5px;
  background-color: #f5f0fa;
  border-color: #7d3cbd;
  color: #59606d;
}
.ant-tag.default {
  border-radius: 5px;
  background-color: #59606d;
  border-color: #59606d;
  color: #59606d;
}
.ant-tag > span.anticon {
  margin-inline-start: 4px;
  margin: 2px;
  color: #59606d;
}
.ant-tag .ant-avatar {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  margin-right: 8px;
}
.ant-tag.square-tag,
.ant-tag.round-tag {
  background-color: white;
  border-radius: 5px;
  padding: 1px 16px 1px 1px;
}
.ant-tag.square-tag.round-tag,
.ant-tag.round-tag.round-tag {
  border-radius: 18px;
}
.ant-tag.square-tag.round-tag .ant-avatar,
.ant-tag.round-tag.round-tag .ant-avatar {
  border-radius: 96px;
}
.ant-tag.square-tag:hover,
.ant-tag.round-tag:hover {
  background-color: #f5f7fa;
}
.ant-tag.square-tag > span,
.ant-tag.round-tag > span {
  font-size: 16px;
  font-weight: 600;
  display: flex;
  justify-content: center;
}
.ant-tag.square-tag-close,
.ant-tag.round-tag-close {
  background-color: white;
  border-radius: 5px;
}
.ant-tag.square-tag-close.round-tag-close,
.ant-tag.round-tag-close.round-tag-close {
  border-radius: 18px;
}
.ant-tag.square-tag-close.round-tag-close .ant-avatar,
.ant-tag.round-tag-close.round-tag-close .ant-avatar {
  border-radius: 96px;
}
.ant-tag.square-tag-close:hover,
.ant-tag.round-tag-close:hover {
  background-color: #f5f7fa;
}
.ant-tag.square-tag-close > span,
.ant-tag.round-tag-close > span {
  font-size: 16px;
  font-weight: 600;
  display: flex;
  justify-content: center;
}
.ant-tag.generic-tag-mini.generic-tag-mini {
  padding: 2px 8px;
  font-size: 10px;
  line-height: 14px;
  border-radius: 4px;
  min-height: 18px;
  height: auto;
  text-wrap: wrap;
  white-space: normal;
}
.ant-tag.generic-tag-small.generic-tag-small {
  padding: 2px 8px;
  font-size: 12px;
  line-height: 16px;
  min-height: 20px;
  height: auto;
  text-wrap: wrap;
  white-space: normal;
}
.ant-tag.generic-tag-medium.generic-tag-medium {
  padding: 2px 10px;
  font-size: 14px;
  line-height: 20px;
  min-height: 24px;
  height: auto;
  text-wrap: wrap;
  white-space: normal;
}
.ant-tag.generic-tag-large.generic-tag-large {
  padding: 2px 12px;
  font-size: 16px;
  line-height: 24px;
  min-height: 28px;
  height: auto;
  text-wrap: wrap;
  white-space: normal;
}
.ant-tag.generic-close-tag-mini {
  padding: 2px 5px 2px 8px;
}
.ant-tag.generic-close-tag-small {
  padding: 2px 5px 2px 8px;
}
.ant-tag.generic-close-tag-medium {
  padding: 2px 6px 2px 10px;
}
.ant-tag.generic-close-tag-large {
  padding: 2px 8px 2px 12px;
}
.origami-time-picker-dropdown .ant-picker-time-panel-container {
  width: 100%;
  border-radius: 4px;
}
.origami-time-picker-dropdown .ant-picker-time-panel-container .ant-picker-panel-layout {
  width: 100%;
  display: block;
}
.origami-time-picker-dropdown .ant-picker-time-panel-container .ant-picker-panel-layout .ant-picker-panel {
  width: 100%;
  height: 208px;
}
.origami-time-picker-dropdown .ant-picker-time-panel-container .ant-picker-panel-layout .ant-picker-panel .ant-picker-time-panel {
  height: 100%;
  padding-top: 0px;
}
.origami-time-picker-dropdown .ant-picker-time-panel-container .ant-picker-panel-layout .ant-picker-panel .ant-picker-time-panel .ant-picker-content {
  height: 100%;
}
.origami-time-picker-dropdown .ant-picker-time-panel-container .ant-picker-panel-layout .ant-picker-panel .ant-picker-time-panel .ant-picker-content .ant-picker-time-panel-cell {
  display: flex;
  justify-content: center;
  height: 26px;
}
.origami-time-picker-dropdown .ant-picker-time-panel-container .ant-picker-panel-layout .ant-picker-panel .ant-picker-time-panel .ant-picker-content .ant-picker-time-panel-cell .ant-picker-time-panel-cell-inner {
  width: 100%;
}
.origami-time-picker-dropdown .ant-picker-time-panel-container .ant-picker-footer {
  height: 42px;
}
.origami-time-picker-dropdown .ant-picker-time-panel-container .ant-picker-footer .ant-picker-now {
  height: 26px;
  display: flex;
  align-items: center;
  border-radius: 25px;
}
.origami-time-picker-dropdown .ant-picker-time-panel-container .ant-picker-footer .ant-picker-now:hover {
  background-color: #f5f7fa;
}
.origami-time-picker-dropdown .ant-picker-time-panel-container .ant-picker-footer .ant-picker-now .ant-picker-now-btn:hover {
  background-color: none;
}
.origami-time-picker-dropdown.origami-time-picker-dropdown-HHmm .ant-picker-content,
.origami-time-picker-dropdown.origami-time-picker-dropdown-ha .ant-picker-content {
  width: 140px;
}
.origami-time-picker-dropdown.origami-time-picker-dropdown-HHmm .ant-picker-content .ant-picker-time-panel-cell,
.origami-time-picker-dropdown.origami-time-picker-dropdown-ha .ant-picker-content .ant-picker-time-panel-cell {
  width: 70px;
}
.origami-time-picker-dropdown.origami-time-picker-dropdown-HH .ant-picker-content {
  width: 70px;
}
.origami-time-picker-dropdown.origami-time-picker-dropdown-HH .ant-picker-content ul:nth-child(2) {
  display: none;
}
.origami-time-picker-dropdown.origami-time-picker-dropdown-HH .ant-picker-content .ant-picker-time-panel-cell {
  width: 70px;
}
.origami-time-picker-dropdown.origami-time-picker-dropdown-hhmma .ant-picker-content {
  width: 164px;
}
.origami-time-picker-dropdown.origami-time-picker-dropdown-hhmma .ant-picker-content .ant-picker-time-panel-column {
  width: 54.6px;
}
.origami-time-picker-dropdown.origami-time-picker-dropdown-hhmma .ant-picker-content .ant-picker-time-panel-column .ant-picker-time-panel-cell {
  width: 54.6px;
}
.ant-tooltip {
  background-color: #444a53;
  border-radius: 4px;
  --antd-arrow-background-color: #444a53;
}
.ant-tooltip .ant-tooltip-inner {
  background-color: transparent;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 400;
  border-radius: 4px;
}
.ant-transfer {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: var(--body-font-family-none, Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, color emoji, segoe ui emoji, noto color emoji, android emoji);
  width: 568px;
  min-height: 240px;
}
.ant-transfer .ant-transfer-list {
  width: 296px;
  height: -moz-fit-content;
  height: fit-content;
  border: 1px solid #DEE3EC;
  overflow: hidden;
}
.ant-transfer .ant-transfer-operation {
  display: flex;
  padding: 8px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  border-radius: 30px;
  border: 1px solid #DEE3EC;
  background: #FFFFFF;
}
.ant-transfer .ant-btn {
  width: 36px !important;
  height: 36px !important;
  border-radius: 25px !important;
  display: flex !important;
  padding: 8px;
  align-items: center;
  gap: 9px;
  border-radius: 25px;
  border: 1px solid #c9d1df;
}
.ant-transfer .ant-btn.ant-btn:disabled {
  background-color: #FFFFFF !important;
}
.ant-transfer .ant-btn-icon {
  margin-inline-end: 0px !important;
}
.ant-transfer .ant-transfer-list-header {
  padding: 10px 12px;
  justify-content: space-between;
  align-self: stretch;
  box-shadow: 0px -1px 0px 0px #eceff4 inset;
}
.ant-transfer .ant-transfer-list-content-item {
  height: 32px;
  padding: 6px 12px;
  justify-content: center;
  align-items: flex-start;
  flex-shrink: 0;
  align-self: stretch;
}
.ant-transfer .ant-transfer-list-content-item:hover {
  fill: #f5f7fa;
}
.ant-transfer .ant-transfer-list-content-item-checked {
  background-color: #FFFFFF;
}
.ant-transfer .ant-transfer-list-content {
  max-height: 192px;
  height: 192px;
  min-height: 192px;
  background-color: #FFFFFF;
  border-radius: 0px 0px 8px 8px;
}
.ant-transfer .ant-transfer-list-header-title {
  color: #59606d;
  text-align: right;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: 14px;
}
.ant-transfer .ant-transfer-list-header-selected {
  color: black;
  display: flex;
  align-items: center;
  gap: 8px;
}
.ant-transfer .ant-transfer-list-body-not-found {
  min-height: 192px;
  height: 192px;
}
.ant-transfer .ant-transfer-list-body {
  background-color: #FFFFFF;
  border-radius: 0px 0px 8px 8px;
}
.ant-transfer .ant-empty-small {
  margin: 25%;
}
.ant-transfer .ant-checkbox-input {
  border-color: #b1baca;
}
/* === Typography styles === */
h1.ant-typography,
h2.ant-typography,
h3.ant-typography,
h4.ant-typography,
h5.ant-typography,
h6.ant-typography,
p.ant-typography,
a.ant-typography,
span.ant-typography,
div.ant-typography {
  margin: 0;
  font-family: var(--body-font-family-none, Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, color emoji, segoe ui emoji, noto color emoji, android emoji);
  font-size: 16px;
  font-weight: 400;
}
h1.ant-typography + *.ant-typography,
h2.ant-typography + *.ant-typography,
h3.ant-typography + *.ant-typography,
h4.ant-typography + *.ant-typography,
h5.ant-typography + *.ant-typography,
h6.ant-typography + *.ant-typography,
p.ant-typography + *.ant-typography,
a.ant-typography + *.ant-typography,
span.ant-typography + *.ant-typography,
div.ant-typography + *.ant-typography {
  margin: 0;
}
h1.ant-typography.ant-typography-light,
h2.ant-typography.ant-typography-light,
h3.ant-typography.ant-typography-light,
h4.ant-typography.ant-typography-light,
h5.ant-typography.ant-typography-light,
h6.ant-typography.ant-typography-light,
p.ant-typography.ant-typography-light,
a.ant-typography.ant-typography-light,
span.ant-typography.ant-typography-light,
div.ant-typography.ant-typography-light {
  font-weight: 300;
}
h1.ant-typography.ant-typography-semibold,
h2.ant-typography.ant-typography-semibold,
h3.ant-typography.ant-typography-semibold,
h4.ant-typography.ant-typography-semibold,
h5.ant-typography.ant-typography-semibold,
h6.ant-typography.ant-typography-semibold,
p.ant-typography.ant-typography-semibold,
a.ant-typography.ant-typography-semibold,
span.ant-typography.ant-typography-semibold,
div.ant-typography.ant-typography-semibold {
  font-weight: 600;
}
h1.ant-typography.ant-typography-bold,
h2.ant-typography.ant-typography-bold,
h3.ant-typography.ant-typography-bold,
h4.ant-typography.ant-typography-bold,
h5.ant-typography.ant-typography-bold,
h6.ant-typography.ant-typography-bold,
p.ant-typography.ant-typography-bold,
a.ant-typography.ant-typography-bold,
span.ant-typography.ant-typography-bold,
div.ant-typography.ant-typography-bold {
  font-weight: 700;
}
h1.ant-typography.ant-typography-danger,
h2.ant-typography.ant-typography-danger,
h3.ant-typography.ant-typography-danger,
h4.ant-typography.ant-typography-danger,
h5.ant-typography.ant-typography-danger,
h6.ant-typography.ant-typography-danger,
p.ant-typography.ant-typography-danger,
a.ant-typography.ant-typography-danger,
span.ant-typography.ant-typography-danger,
div.ant-typography.ant-typography-danger {
  color: #de1b1b;
}
h1.ant-typography.ant-typography-secondary,
h2.ant-typography.ant-typography-secondary,
h3.ant-typography.ant-typography-secondary,
h4.ant-typography.ant-typography-secondary,
h5.ant-typography.ant-typography-secondary,
h6.ant-typography.ant-typography-secondary,
p.ant-typography.ant-typography-secondary,
a.ant-typography.ant-typography-secondary,
span.ant-typography.ant-typography-secondary,
div.ant-typography.ant-typography-secondary {
  color: #59606d;
}
h1.ant-typography.ant-typography-success,
h2.ant-typography.ant-typography-success,
h3.ant-typography.ant-typography-success,
h4.ant-typography.ant-typography-success,
h5.ant-typography.ant-typography-success,
h6.ant-typography.ant-typography-success,
p.ant-typography.ant-typography-success,
a.ant-typography.ant-typography-success,
span.ant-typography.ant-typography-success,
div.ant-typography.ant-typography-success {
  color: #038537;
}
h1.ant-typography.ant-typography-warning,
h2.ant-typography.ant-typography-warning,
h3.ant-typography.ant-typography-warning,
h4.ant-typography.ant-typography-warning,
h5.ant-typography.ant-typography-warning,
h6.ant-typography.ant-typography-warning,
p.ant-typography.ant-typography-warning,
a.ant-typography.ant-typography-warning,
span.ant-typography.ant-typography-warning,
div.ant-typography.ant-typography-warning {
  color: #fcc419;
}
a.ant-typography {
  color: rgb(var(--color-primary-none, 89, 96, 109));
  text-decoration: underline;
}
a.ant-typography.ant-typography-disabled {
  color: #b1baca;
}
a.ant-typography:visited {
  color: #59606d;
}
a.ant-typography:hover {
  color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);
  text-decoration: underline;
  opacity: 90%;
}
a.ant-typography:focus {
  color: rgb(var(--color-primary-none, 89, 96, 109));
  opacity: 90%;
  box-shadow: 0px 0px 4px 0px #3272d9;
  border-radius: 4px;
}
a.ant-typography:active {
  color: black;
  box-shadow: none;
  text-decoration: underline;
}
h1.ant-typography {
  font-size: 44px;
  line-height: 60px;
}
h2.ant-typography {
  font-size: 34px;
  line-height: 46px;
}
h3.ant-typography {
  font-size: 28px;
  line-height: 38px;
}
h4.ant-typography {
  font-size: 22px;
  line-height: 30px;
}
h5.ant-typography {
  font-size: 18px;
  line-height: 25px;
}
h6.ant-typography-heading-6 {
  font-size: 16px;
  line-height: 22px;
}
span.ant-typography-label-1 {
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 1px;
}
span.ant-typography-label-2 {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
}
span.ant-typography-label-3 {
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 1px;
  text-transform: uppercase;
}
span.ant-typography-size-8 {
  font-size: 8px;
  line-height: 12px;
}
span.ant-typography-size-10 {
  font-size: 10px;
  line-height: 14px;
}
span.ant-typography-size-12 {
  font-size: 12px;
  line-height: 16px;
}
span.ant-typography-size-14 {
  font-size: 14px;
  line-height: 20px;
}
span.ant-typography-size-16 {
  font-size: 16px;
  line-height: 24px;
}
span.ant-typography-size-18 {
  font-size: 18px;
  line-height: 28px;
}
span.ant-typography-size-24 {
  font-size: 24px;
  line-height: 32px;
}
span.ant-typography-size-30 {
  font-size: 30px;
  line-height: 40px;
}
span.ant-typography-size-38 {
  font-size: 38px;
  line-height: 52px;
}
span.ant-typography-size-44 {
  font-size: 44px;
  line-height: 60px;
}
span.ant-typography-size-52 {
  font-size: 52px;
  line-height: 68px;
}
span.ant-typography-size-60 {
  font-size: 60px;
  line-height: 80px;
}
span.ant-typography-size-68 {
  font-size: 68px;
  line-height: 93px;
}
span.ant-typography-size-84 {
  font-size: 84px;
  line-height: 114px;
}
.nackle-upload.nackle-upload-large {
  max-width: 566px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.nackle-upload.nackle-upload-large .upload-container {
  width: 100%;
}
.nackle-upload.nackle-upload-large .upload-container .upload-content .dropzone-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 211px;
  max-width: 566px;
  border: 1px dashed #c9d1df;
  border-radius: 12px;
  background-color: #ffffff;
  margin-bottom: 10px;
}
.nackle-upload.nackle-upload-large .upload-container .upload-content .dropzone-container .upload-icon-div .upload-icon {
  width: 48px;
  height: 48px;
  color: #c9d1df;
}
.nackle-upload.nackle-upload-large .upload-container .upload-content .dropzone-container .upload-icon-div .upload-icon.error {
  color: #de1b1b;
}
.nackle-upload.nackle-upload-large .upload-container .upload-content .dropzone-container .upload-instructions {
  max-width: 518px;
  margin: 0px 24px 5px 24px;
  display: flex;
  justify-content: center;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
}
.nackle-upload.nackle-upload-large .upload-container .upload-content .dropzone-container .upload-instructions .fake-link {
  color: rgb(var(--color-primary-none, 89, 96, 109));
  text-decoration: underline;
}
.nackle-upload.nackle-upload-large .upload-container .upload-content .dropzone-container .large-upload-parameters {
  max-width: 518px;
  margin: 0px 24px 0px 24px;
  display: flex;
  justify-content: center;
  text-align: center;
  color: #59606d;
  font-size: 14px;
}
.nackle-upload.nackle-upload-large .upload-container .upload-content .dropzone-container:hover {
  border: 1px dashed rgb(var(--color-primary-none, 89, 96, 109));
  background-color: #f5f7fa;
}
.nackle-upload.nackle-upload-large .upload-container .upload-content .dropzone-container.error {
  border: #de1b1b solid 1px;
  background-image: none;
  width: 100%;
}
.nackle-upload.nackle-upload-large .upload-container .upload-content .dropzone-container.error .upload-instructions {
  cursor: default;
}
.nackle-upload.nackle-upload-large .upload-container .upload-content .dropzone-container.error .error-buttons {
  display: flex;
  margin-top: 10px;
  justify-content: center;
}
.nackle-upload.nackle-upload-large .upload-container .upload-content .dropzone-container.error .error-buttons .cancel-button {
  margin-right: 10px;
}
.nackle-upload.nackle-upload-large .upload-container .upload-content .dropzone-container.error .error-buttons .new-upload-button {
  margin-left: 10px;
}
.nackle-upload.nackle-upload-medium {
  max-width: 566px;
}
.nackle-upload.nackle-upload-medium .upload-container {
  width: 100%;
}
.nackle-upload.nackle-upload-medium .upload-container .upload-content .dropzone-container {
  max-width: 566px;
  height: 67px;
  display: flex;
  align-items: center;
  border: 1px dashed #c9d1df;
  border-radius: 8px;
  background-color: #ffffff;
  margin-bottom: 10px;
}
.nackle-upload.nackle-upload-medium .upload-container .upload-content .dropzone-container .upload-instructions {
  width: 100%;
  display: flex;
  justify-content: center;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.nackle-upload.nackle-upload-medium .upload-container .upload-content .dropzone-container .upload-instructions .fake-link {
  color: rgb(var(--color-primary-none, 89, 96, 109));
  text-decoration: underline;
}
.nackle-upload.nackle-upload-medium .upload-container .upload-content .dropzone-container:hover {
  border: 1px dashed rgb(var(--color-primary-none, 89, 96, 109));
  background-color: #f5f7fa;
}
.nackle-upload.nackle-upload-medium .upload-container .upload-content .medium-upload-parameters {
  width: 566px;
  font-size: 12px;
  color: #59606d;
  text-align: center;
  margin-bottom: 10px;
}
.nackle-upload.nackle-upload-small {
  display: flex;
  flex-direction: column;
  max-width: 313px;
}
.nackle-upload.nackle-upload-small .upload-container {
  width: 100%;
  height: 128px;
}
.nackle-upload.nackle-upload-small .upload-container .upload-content {
  width: 100%;
  display: flex;
  justify-content: center;
}
.nackle-upload.nackle-upload-small .upload-container .upload-content .dropzone-container {
  height: 128px;
  width: 128px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  border: 1px dashed #c9d1df;
  border-radius: 8px;
  background-color: #ffffff;
  margin-bottom: 10px;
}
.nackle-upload.nackle-upload-small .upload-container .upload-content .dropzone-container .upload-icon-div .upload-icon {
  width: 32px;
  height: 32px;
  color: rgb(var(--color-primary-none, 89, 96, 109));
}
.nackle-upload.nackle-upload-small .upload-container .upload-content .dropzone-container .upload-instructions {
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
}
.nackle-upload.nackle-upload-small .upload-container .upload-content .dropzone-container:hover {
  border: 1px dashed rgb(var(--color-primary-none, 89, 96, 109));
  background-color: #f5f7fa;
}
.nackle-upload .uploaded-files-list-container {
  width: 566px;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list {
  width: 100%;
  list-style-type: none;
  padding-left: 0px;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file {
  height: 44px;
  width: 100%;
  background-color: #ffffff;
  border-radius: 4px;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file .uploaded-file-row {
  height: 44px;
  align-items: center;
  justify-content: start;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file .uploaded-file-row .icon-col {
  height: 100%;
  display: flex;
  align-items: center;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file .uploaded-file-row .icon-col svg {
  margin: 0px 6px 0px 6px;
  color: #59606d;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file .uploaded-file-row .path-col {
  align-items: center;
  font-size: 12px;
  width: 84%;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file .uploaded-file-row .path-col .file-path {
  display: flex;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  color: #000000;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file .uploaded-file-row .delete-button-col {
  display: flex;
  align-items: center;
  margin-left: 10px;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file .uploaded-file-row .delete-button-col .ant-btn {
  background-color: transparent;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file .uploaded-file-row .delete-button-col .ant-btn:hover {
  background-color: transparent;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file .uploaded-file-row:hover {
  background-color: #f5f7fa;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file .uploaded-file-row:hover .delete-button-col .delete-button {
  background-color: transparent;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file .uploaded-file-row:hover .delete-button-col .delete-button .ant-btn-icon path {
  color: rgb(var(--color-primary-none, 89, 96, 109));
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file.display-progress-bar {
  height: 52px;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file.display-progress-bar .uploaded-file-row {
  height: 100%;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file.display-progress-bar .uploaded-file-row .icon-col svg {
  margin: 0px 6px 12px 6px;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file.display-progress-bar .uploaded-file-row .path-col {
  height: 100%;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file.display-progress-bar .uploaded-file-row .path-col .file-path {
  margin-top: 13px;
  margin-bottom: -3px;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file.display-progress-bar .uploaded-file-row .path-col .progress-bar {
  width: 100%;
  height: 6px;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file.display-progress-bar .uploaded-file-row .path-col .progress-bar .ant-progress {
  height: 100%;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file.display-progress-bar .uploaded-file-row .path-col .progress-bar .ant-progress .ant-progress-bg {
  background-color: rgb(var(--color-primary-none, 89, 96, 109));
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file.rejected .uploaded-file-row .icon-col svg {
  color: #de1b1b;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file.rejected .uploaded-file-row .file-path {
  color: #de1b1b;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file.rejected .uploaded-file-row .delete-button-col .delete-button .ant-btn-icon path {
  color: #de1b1b;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file.rejected .uploaded-file-row .delete-button-col:hover .ant-btn-icon path {
  color: #f55353;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list.display-multiple-files li:first-child {
  border-radius: 8px 8px 0px 0px;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list.display-multiple-files li {
  border-radius: 0px;
}
.nackle-upload .uploaded-files-list-container .uploaded-file-list.display-multiple-files li:last-child {
  border-radius: 0px 0px 8px 8px;
}
.nackle-upload .uploaded-files-list-container.uploaded-files-list-container-small {
  max-width: 313px;
  align-self: center;
  margin-top: 0px;
}
.nackle-upload .uploaded-files-list-container.uploaded-files-list-container-small .uploaded-file-list {
  margin-top: 10px;
}
.nackle-upload .uploaded-files-list-container.uploaded-files-list-container-small .uploaded-file-list .uploaded-file .uploaded-file-row .path-col {
  align-items: center;
  font-size: 12px;
  width: 225px;
  margin-right: 6px;
}
.nackle-upload .uploaded-files-list-container.uploaded-files-list-container-small .uploaded-file-list .uploaded-file .uploaded-file-row .delete-button-col {
  margin-left: 0px;
}
.ant-select {
  font-size: 16px;
  font-weight: 400;
  display: block;
}
.ant-select.ant-select-focused .ant-select-selector {
  border-color: #9099a9;
  box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);
}
.ant-select .select-loading {
  transform: rotate(45deg);
  animation-name: Rotate;
  animation-duration: 1.2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
.ant-select .ant-select-selector {
  border: 1px solid #c9d1df;
  align-items: center;
}
.ant-select .ant-select-selector:hover {
  border-color: #9099a9;
}
.ant-select .ant-select-selector:focus {
  border-color: #9099a9;
  box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);
}
.ant-select .ant-select-selector .ant-select-selection-item .ant-checkbox-wrapper .ant-checkbox {
  display: none;
}
.ant-select .ant-select-selector .ant-select-selection-item .ant-checkbox-wrapper span {
  padding: 0;
}
.ant-select .ant-select-selector .ant-select-selection-item .ant-radio-wrapper .ant-radio {
  display: none;
}
.ant-select .ant-select-selector .ant-select-selection-item .ant-radio-wrapper span {
  padding: 0;
}
.ant-select .ant-select-selector .ant-select-selection-placeholder {
  color: #9099a9;
}
.ant-select .ant-select-arrow {
  color: #59606d;
}
.ant-select.ant-select-sm .ant-select-selector {
  font-size: 12px;
  padding: 5px 8px;
}
.ant-select.ant-select-sm .ant-select-selector.ant-select-arrow {
  margin-right: 8px;
}
.ant-select .ant-select-selector {
  font-size: 14px;
  padding: 8px 10px;
}
.ant-select .ant-select-selector.ant-select-arrow {
  margin-right: 10px;
}
.ant-select.ant-select-lg .ant-select-selector {
  font-size: 16px;
  padding: 10px 12px;
}
.ant-select.ant-select-lg .ant-select-selector.ant-select-arrow {
  margin-right: 12px;
}
.ant-select.ant-select-multiple .ant-select-selection-item,
.ant-select.ant-select-multiple.ant-select-sm .ant-select-selection-item,
.ant-select.ant-select-multiple.ant-select-lg .ant-select-selection-item {
  background-color: #f5f7fa;
  line-height: 24px;
  padding: 0px 8px;
}
.ant-select.ant-select-multiple.ant-select-selection-overflow-item.ant-select-selection-item {
  padding: 0px 8px;
  height: 20px;
  background-color: #f5f7fa;
  line-height: 24px;
}
.ant-select.ant-select-multiple.ant-select-lg .ant-select-selection-item {
  padding: 0px 10px;
  height: 24px;
  gap: 8px;
}
.ant-select.ant-select-multiple.ant-select-sm .ant-select-selection-item {
  padding: 0px 6px;
  height: 16px;
  gap: 4px;
}
.ant-select.ant-select-disabled.ant-select-outlined .ant-select-selector {
  background-color: #f5f7fa;
}
.ant-select.ant-select-disabled.ant-select-outlined .ant-select-selector:hover {
  border: 1px solid #c9d1df;
}
.ant-select.ant-select-disabled .ant-select-arrow {
  color: #b1baca;
}
.ant-select.ant-select-single {
  min-height: 36px;
  border-radius: 6px;
}
.ant-select.ant-select-single.ant-select-open {
  border-radius: 6px;
}
.ant-select.ant-select-single .ant-select-selector {
  border-radius: 6px;
}
.ant-select.ant-select-single .ant-select-selector {
  min-height: 36px;
}
.ant-select.ant-select-lg {
  min-height: 44px;
  border-radius: 8px;
}
.ant-select.ant-select-lg.ant-select-open {
  border-radius: 8px;
}
.ant-select.ant-select-lg .ant-select-selector {
  border-radius: 8px;
}
.ant-select.ant-select-lg.ant-select-single .ant-select-selector {
  min-height: 44px;
}
.ant-select.ant-select-sm {
  min-height: 26px;
  border-radius: 4px;
}
.ant-select.ant-select-sm.ant-select-open {
  border-radius: 4px;
}
.ant-select.ant-select-sm .ant-select-selector {
  border-radius: 4px;
}
.ant-select.ant-select-sm.ant-select-single .ant-select-selector {
  min-height: 26px;
}
.ant-select.ant-select-multiple {
  border-radius: 6px;
}
.ant-select.ant-select-multiple .ant-select-selection-overflow {
  padding: 8px 10px;
}
.ant-select.ant-select-multiple .ant-select-selection-overflow .ant-select-selection-overflow-item {
  max-height: 20px;
  align-items: center;
}
.ant-select.ant-select-multiple .ant-select-selection-overflow .ant-select-selection-overflow-item .ant-select-selection-item-remove {
  color: #59606d;
}
.ant-select.ant-select-multiple .ant-select-selection-overflow .ant-select-selection-overflow-item .ant-select-selection-item-remove:hover {
  color: black;
}
.ant-select.ant-select-multiple .ant-select-selection-overflow .ant-select-selection-overflow-item .ant-select-selection-item-remove svg {
  width: 14px;
  height: 14px;
}
.ant-select.ant-select-multiple .ant-select-selection-overflow .ant-select-selection-overflow-item .ant-select-selection-item-remove:hover {
  color: black;
}
.ant-select.ant-select-multiple.ant-select-sm {
  border-radius: 4px;
}
.ant-select.ant-select-multiple.ant-select-sm.ant-select-open {
  border-radius: 4px;
}
.ant-select.ant-select-multiple.ant-select-sm .ant-select-selector {
  border-radius: 4px;
}
.ant-select.ant-select-multiple.ant-select-sm .ant-select-selection-item .ant-select-selection-item-remove svg {
  width: 12px;
  height: 12px;
}
.ant-select.ant-select-multiple.ant-select-lg {
  border-radius: 8px;
}
.ant-select.ant-select-multiple.ant-select-lg.ant-select-open {
  border-radius: 8px;
}
.ant-select.ant-select-multiple.ant-select-lg .ant-select-selector {
  border-radius: 8px;
}
.ant-select.ant-select-multiple.ant-select-lg .ant-select-selection-item .ant-select-selection-item-remove svg {
  width: 16px;
  height: 16px;
}
.ant-select.ant-select-multiple {
  min-height: 36px;
}
.ant-select.ant-select-multiple .ant-select-selector {
  min-height: 36px;
  height: auto;
  padding: 0;
}
.ant-select.ant-select-multiple .ant-select-selection-overflow {
  padding: 8px 10px 0px 10px;
}
.ant-select.ant-select-multiple .ant-select-selection-overflow .ant-select-selection-overflow-item {
  max-height: 20px;
}
.ant-select.ant-select-multiple .ant-select-selection-overflow .ant-select-selection-overflow-item .ant-select-selection-item-remove {
  color: #59606d;
}
.ant-select.ant-select-multiple .ant-select-selection-overflow .ant-select-selection-overflow-item .ant-select-selection-item-remove:hover {
  color: black;
}
.ant-select.ant-select-multiple.ant-select-lg {
  min-height: 44px;
}
.ant-select.ant-select-multiple.ant-select-lg .ant-select-selection-overflow {
  padding: 10px 12px 6px 12px;
}
.ant-select.ant-select-multiple.ant-select-lg .ant-select-selection-overflow .ant-select-selection-overflow-item {
  max-height: 24px;
}
.ant-select.ant-select-multiple.ant-select-lg.ant-select-show-arrow,
.ant-select.ant-select-multiple.ant-select-lg.ant-select-allow-clear .ant-select-selector {
  min-height: 44px;
  height: auto;
  padding: 0;
}
.ant-select.ant-select-multiple.ant-select-sm {
  min-height: 26px;
}
.ant-select.ant-select-multiple.ant-select-sm .ant-select-selection-overflow {
  padding: 5px 8px 1px 8px;
}
.ant-select.ant-select-multiple.ant-select-sm .ant-select-selection-overflow .ant-select-selection-overflow-item {
  max-height: 16px;
}
.ant-select.ant-select-multiple.ant-select-sm .ant-select-selector {
  min-height: 26px;
  height: auto;
  padding: 0;
  border: 1px solid #c9d1df;
}
.ant-select-item .ant-select-item-option-state svg {
  width: 20px;
  height: 20px;
}
.ant-select-item.ant-select-item-group {
  padding: 6px 12px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  min-height: 0;
  color: #59606d;
}
.ant-select-item.ant-select-item-option {
  padding: 5px 12px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
}
.ant-select-item.ant-select-item-option.ant-select-item-option-disabled {
  color: #b1baca;
}
.ant-select-item.ant-select-item-option:hover {
  background-color: #f5f7fa;
}
.ant-select-item.ant-select-item-option.ant-select-item-option-active {
  background-color: #f5f7fa;
}
.ant-select-item.ant-select-item-option.ant-select-item-option-selected {
  background-color: rgb(var(--color-primary-none, 89, 96, 109));
  color: white;
  font-weight: 400;
}
.ant-select-item.ant-select-item-option.ant-select-item-option-selected .ant-select-item-option-state svg {
  color: white;
}
.ant-select-item.ant-select-item-option.ant-select-item-option-disabled {
  color: #b1baca;
}
.ant-select-item.ant-select-item-option .ant-select-item-option-state {
  color: white;
}
.ant-select-tree-treenode {
  transition: transform 0.3s;
}
.ant-select-tree-treenode .ant-select-tree-switcher svg {
  transition: transform 0.3s;
}
.ant-select-tree-treenode.ant-select-tree-treenode-switcher-close .ant-select-tree-switcher svg {
  transform: rotate(-90deg);
}
.ant-tree-select .ant-select-selector .ant-select-selection-overflow .ant-select-selection-overflow-item,
.ant-select-multiple .ant-select-selector .ant-select-selection-overflow .ant-select-selection-overflow-item {
  margin-bottom: 8px;
}
.ant-tree-select .ant-select-selector .ant-select-selection-overflow .ant-select-selection-overflow-item .ant-select-selection-item,
.ant-select-multiple .ant-select-selector .ant-select-selection-overflow .ant-select-selection-overflow-item .ant-select-selection-item {
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  gap: 6px;
}
.ant-tree-select.ant-select-lg .ant-select-selector .ant-select-selection-overflow-item,
.ant-select-multiple.ant-select-lg .ant-select-selector .ant-select-selection-overflow-item,
.ant-tree-select.ant-select-sm .ant-select-selector .ant-select-selection-overflow-item,
.ant-select-multiple.ant-select-sm .ant-select-selector .ant-select-selection-overflow-item {
  margin-bottom: 4px;
}
.ant-tree-select-dropdown .ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner {
  background-color: rgb(var(--color-primary-none, 89, 96, 109));
  border-color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-tree-select-dropdown .ant-select-tree .ant-select-tree-node-content-wrapper.ant-select-tree-node-selected,
.ant-tree-select-dropdown .ant-select-tree .ant-select-tree-checkbox + span.ant-select-tree-node-selected {
  background-color: rgb(var(--color-primary-none, 89, 96, 109));
  color: white;
}
.ant-tree-select-dropdown .ant-select-tree .ant-select-tree-switcher .ant-select-tree-switcher-icon {
  color: #59606d;
}
.ant-select-selection-search-input:focus {
  box-shadow: none;
}
.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer):hover .ant-select-selector {
  border-color: #9099a9;
}
.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer):focus-within .ant-select-selector {
  border-color: #9099a9;
}
.ant-select-disabled:where(.css-dev-only-do-not-override-nnuwmp).ant-select:not(.ant-select-customize-input) .ant-select-selector {
  background: #f5f7fa;
}
.ant-select-multiple.ant-select-disabled:where(.css-dev-only-do-not-override-nnuwmp).ant-select:not(.ant-select-customize-input) .ant-select-selector {
  background: #f5f7fa;
}
@keyframes Rotate {
  100% {
    transform: rotate(405deg);
  }
}
.ant-select-dropdown .ant-select-item-empty .ant-spin {
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.select-radio.ant-tree-select-dropdown .ant-select-tree-checkbox .ant-select-tree-checkbox-inner {
  border-radius: 50%;
}
.nkl-password-helper .nkl-password-helper-inner {
  transition: all 200ms ease-in-out;
}
.nkl-password-helper .nkl-password-helper-inner .ant-input-affix-wrapper {
  border: 1px solid #c9d1df;
}
.nkl-password-helper .nkl-password-helper-inner .ant-input-affix-wrapper:focus {
  border: 1px solid #9099a9;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules,
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm,
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg {
  border-radius: 8px;
  transition: all 300ms ease;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules .all-passwords,
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm .all-passwords,
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg .all-passwords {
  font-size: 12px;
  font-weight: 400;
  color: #59606d;
  margin-top: 0px;
  line-height: 16px;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules .all-passwords.top,
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm .all-passwords.top,
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg .all-passwords.top {
  margin-bottom: 6px;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules ul,
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm ul,
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg ul {
  margin: 0;
  padding: 0;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules ul .complexity li,
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm ul .complexity li,
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg ul .complexity li {
  display: inline-flex;
  align-items: start;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules ul .complexity .complex-requirement,
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm ul .complexity .complex-requirement,
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg ul .complexity .complex-requirement {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules ul .complexity .complex-requirement ul,
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm ul .complexity .complex-requirement ul,
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg ul .complexity .complex-requirement ul {
  padding-left: 16px;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules li,
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm li,
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg li {
  position: relative;
  list-style-type: none;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules li > ul,
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm li > ul,
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg li > ul {
  list-style-type: none;
  padding-left: 16px;
  line-height: 24px;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules li,
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm li,
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg li {
  gap: 4px;
  align-items: center;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules .length,
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm .length,
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg .length {
  display: inline-flex;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules .nkl-icon,
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm .nkl-icon,
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg .nkl-icon {
  top: 0;
  left: 0;
  transition: fill 200ms ease;
  width: 14px;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules {
  margin-top: 6px;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules ul {
  margin: 0;
  padding: 0;
  line-height: 10px;
  display: flex;
  flex-direction: column;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules ul .complexity li {
  display: inline-flex;
  align-items: start;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules ul .complexity .complex-requirement {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules ul .complexity .complex-requirement ul {
  padding-left: 16px;
  line-height: 24px;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm {
  font-size: 12px;
  line-height: 16px;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm .nkl-icon {
  width: 12px;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm ul {
  line-height: 8px;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg {
  font-size: 16px;
  line-height: 24px;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg .nkl-icon {
  width: 16px;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg ul {
  line-height: 12px;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper--passes {
  color: #038537;
  gap: 4px;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper--passes > .nkl-icon {
  fill: #038537;
  color: #038537;
  font-size: 18px;
  width: 14px;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper--passes .nackle-caption {
  color: #038537;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper--initial {
  color: #59606d;
  gap: 4px;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper--initial.nackle-caption {
  color: #59606d;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper--fails {
  color: #de1b1b;
  gap: 4px;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper--fails .nackle-caption {
  color: #de1b1b;
}
.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper--fails > .nkl-icon {
  fill: #de1b1b;
  color: #de1b1b;
  width: 14px;
}
.nkl-password-helper .nkl-password-helper-inner .nackle-caption {
  margin-top: 0px;
}
.nkl-password-helper .nkl-password-helper-inner .nackle-caption div {
  align-items: center;
  display: flex;
  gap: 4px;
}
.nkl-password-helper .nkl-password-helper-inner .nackle-caption.large .nkl-icon {
  width: 16px;
}
.nkl-password-helper .nkl-password-helper-inner .nackle-caption.large .nkl-password-helper-rules,
.nkl-password-helper .nkl-password-helper-inner .nackle-caption.large .confirm {
  margin-left: 12px;
}
.nkl-password-helper .nkl-password-helper-inner .nackle-caption.default .nkl-icon {
  width: 14px;
}
.nkl-password-helper .nkl-password-helper-inner .nackle-caption.default .nkl-password-helper-rules,
.nkl-password-helper .nkl-password-helper-inner .nackle-caption.default .confirm {
  margin-left: 10px;
}
.nkl-password-helper .nkl-password-helper-inner .nackle-caption.small .nkl-icon {
  width: 12px;
}
.nkl-password-helper .nkl-password-helper-inner .nackle-caption.small .nkl-password-helper-rules,
.nkl-password-helper .nkl-password-helper-inner .nackle-caption.small .confirm {
  margin-left: 8px;
}
.nkl-password-helper .nkl-password-helper-inner .nackle-caption .confirm {
  display: inline-flex;
  padding-top: 6px;
}
.nkl-password-helper .nkl-password-helper-inner .nackle-caption {
  padding-left: 0px;
  display: inline-flex;
}
.nkl-password-helper .nkl-password-helper-inner .ant-form.ant-form-small .ant-form-item-control .ant-form-item-explain {
  margin-left: 8px;
  padding-top: 2px;
}
.nkl-password-helper .nkl-password-helper-inner .ant-form .ant-form-item-control .ant-form-item-explain {
  margin-left: 10px;
}
.nkl-password-helper .nkl-password-helper-inner .ant-form .ant-form-item-control .ant-form-item-explain .ant-form-item-explain-success {
  color: #038537;
}
.nkl-password-helper .nkl-password-helper-inner .ant-form.ant-form-large .ant-form-item-control .ant-form-item-explain {
  margin-left: 12px;
  padding-top: 6px;
}
.nkl-password-helper input:focus::-moz-placeholder {
  color: transparent;
}
.nkl-password-helper input:focus::placeholder {
  color: transparent;
}
.nkl-password-helper .ant-form-item-explain-error {
  color: #de1b1b;
}
.nkl-password-helper .ant-form-item-explain-error .confirm-password-rule,
.nkl-password-helper .ant-form-item-explain-error div {
  display: flex;
  align-items: center;
  margin-left: 12px;
  gap: 4px;
}
.nkl-password-helper .ant-form-item-explain-error .confirm-password-rule svg,
.nkl-password-helper .ant-form-item-explain-error div svg {
  width: 14px;
  height: 14px;
  align-items: center;
}
.nkl-password-helper .ant-input-affix-wrapper:focus-within,
.nkl-password-helper .ant-input-affix-wrapper-focused {
  box-shadow: 0px 0px 4px 0px #3272D9BF;
  border: 1px solid #9099a9;
}
.nkl-password-helper .ant-input-affix-wrapper:focus-within .ant-input-suffix .ant-input-password-icon,
.nkl-password-helper .ant-input-affix-wrapper-focused .ant-input-suffix .ant-input-password-icon {
  color: #59606d;
}
/* Desktop */
.ant-mask {
  z-index: 1 !important;
}
.ant-modal-root .video-player-container-desktop.ant-modal.ant-modal {
  background-color: transparent;
  border: none;
  position: relative;
  border-radius: 24px;
  height: 475px;
  top: 200px;
  z-index: auto;
}
.ant-modal-root .video-player-container-desktop.ant-modal .vjs-has-started .vjs-control-bar {
  display: none;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content {
  background-color: transparent;
  border-radius: 24px;
  box-shadow: none;
  z-index: 2;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-header {
  border-bottom: none;
  background-color: transparent;
  display: none;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-close {
  border-radius: 25px;
  padding: 8px;
  background-color: #59606d;
  margin-bottom: -100px;
  margin-right: -26px;
  margin-top: -12px;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-close:hover {
  background-color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-close-x {
  color: #ffffff;
  justify-content: center;
  align-items: center;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body {
  padding: 0 !important;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  max-width: 845px;
  overflow: hidden;
  cursor: pointer;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .custom-content-wrapper {
  background-color: black;
  border-radius: 24px;
  width: calc(100% - 2px);
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .controls {
  position: absolute;
  background-color: transparent;
  align-items: center;
  margin: auto;
  left: 50%;
  right: 50%;
  top: 50%;
  bottom: 50%;
  z-index: 3;
  display: flex;
  opacity: 0;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .controls .controlsIcon-small {
  width: 100px;
  height: 100px;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .replay {
  position: absolute;
  background-color: transparent;
  align-items: center;
  margin: auto;
  left: 50%;
  right: 50%;
  top: 50%;
  bottom: 50%;
  z-index: 3;
  display: flex;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .replay .replay-icon {
  width: 100px;
  height: 100px;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .nackle-video-player {
  height: 475px;
  border-radius: 24px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: 0 !important;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-js {
  border-radius: 30px;
  width: calc(100% + 2px);
  background-color: unset;
  padding: 0px !important;
  height: 100%;
}
@media screen and (max-width: 845px) {
  .ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-js {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control {
  width: 845px;
  z-index: 3;
  padding: 24px;
  height: 130px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.9) 100%);
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  opacity: 0;
  right: 0;
  left: 0;
  position: absolute;
  bottom: 0;
  transition: all 0.2s ease;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel {
  width: 100%;
  display: flex;
  z-index: 4;
  justify-content: space-between;
  background-blend-mode: multiply;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  margin-top: 24px;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control {
  display: flex;
  gap: 24px;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .play-button {
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.1s ease-out 1s;
  -webkit-transition: 0.1s ease-out 1s;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .play-button:hover {
  transition: 0.1s ease-out;
  -webkit-transition: 0.1s ease-out;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .volume-control {
  display: flex;
  align-items: center;
  gap: 5px;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .volume-control .mute-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .volume-control .wrapper-input {
  color: transparent;
  max-width: 77px;
  width: 100%;
  height: 4px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: 15px;
  display: flex;
  cursor: pointer;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .volume-control .wrapper-input .range-input {
  -webkit-appearance: none;
  -moz-appearance: none;
       appearance: none;
  width: 100%;
  border-radius: 8px;
  outline: none;
  border-radius: 15px;
  height: 4px;
  background: #eceff4;
  margin: 0px;
  padding: 0px;
  box-shadow: none;
  border: none;
  pointer-events: bounding-box;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .volume-control .wrapper-input .range-input:hover {
  border: none;
  pointer-events: none;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .volume-control .wrapper-input .range-input::-webkit-slider-thumb {
  pointer-events: auto;
  -webkit-appearance: none;
  appearance: none;
  height: 6px;
  width: 6px;
  background-color: #ffffff;
  border-radius: 50%;
  border: none;
  -webkit-transition: 0.2s ease-in-out;
  transition: 0.2s ease-in-out;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .volume-control .wrapper-input .range-input::-moz-range-thumb {
  pointer-events: auto;
  height: 6px;
  width: 6px;
  background-color: #ffffff;
  border-radius: 50%;
  border: none;
  -moz-transition: 0.2s ease-in-out;
  transition: 0.2s ease-in-out;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .volume-control .wrapper-input .range-input::-webkit-progress-bar {
  border-radius: 8px;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .volume-control .wrapper-input {
  opacity: 0;
  transition: opacity 200ms;
  width: 0;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .volume-control:hover .wrapper-input {
  opacity: 1;
  transition: all 200ms;
  display: flex;
  width: 100%;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .video-timeline {
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
  display: inline-flex;
  align-items: center;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .caption-control {
  display: flex;
  gap: 24px;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .caption-control .screen-mobile-control {
  display: none;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress {
  margin-top: 24px;
  width: 797px;
  height: 4px;
  z-index: 5;
  display: flex;
  color: transparent;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress .seek {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  position: absolute;
  top: 0;
  width: 100%;
  cursor: pointer;
  margin: 0;
  background-color: transparent;
  height: 4px;
  padding: 0px;
  border: none;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress .seek:hover + .seek-tooltip {
  display: block;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress .seek-tooltip {
  display: none;
  position: absolute;
  top: -50px;
  margin-left: -20px;
  font-size: 12px;
  padding: 3px;
  content: attr(data-title);
  font-weight: 400;
  color: #ffffff;
  background-color: #444a53;
  border-radius: 4px;
  padding: 10px 20px;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress .seek:focus {
  outline: none;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress .seek::-webkit-slider-runnable-track {
  width: 100%;
  cursor: pointer;
  border-radius: 1.3px;
  -webkit-appearance: none;
  -webkit-transition: all 0.4s ease;
  transition: all 0.4s ease;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress .seek::-webkit-slider-thumb {
  height: 14px;
  width: 14px;
  border-radius: 16px;
  background: rgb(var(--color-primary-none, 89, 96, 109));
  cursor: pointer;
  -webkit-appearance: none;
  margin-left: -1px;
  opacity: 0;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress .seek::-moz-range-thumb {
  height: 14px;
  width: 14px;
  border-radius: 50px;
  border: 1px solid rgb(var(--color-primary-none, 89, 96, 109));
  background: rgb(var(--color-primary-none, 89, 96, 109));
  cursor: pointer;
  margin-top: 10px;
  opacity: 0;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress .seek:hover::-moz-range-thumb {
  position: absolute !important;
  margin-top: 0px;
  margin-left: 0px;
  align-items: center;
  width: 14px;
  height: 14px;
  opacity: 1;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress .seek:focus::-webkit-slider-runnable-track {
  background: transparent;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress .seek::-moz-range-track {
  width: 100%;
  height: 8.4px;
  cursor: pointer;
  border: 1px solid transparent;
  background: transparent;
  border-radius: 1.3px;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress .progress {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 8px;
  width: 100%;
  height: 4px;
  top: 0;
  border: none;
  pointer-events: none;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress:hover .progress {
  height: 10px;
  border-radius: 8px;
  border: none;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress:hover .progress::-webkit-progress-bar {
  height: 10px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.4);
  position: absolute;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress:hover .seek::-webkit-slider-thumb {
  opacity: 1;
  margin-top: 6px;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .progress::-webkit-progress-bar {
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 8px;
  position: absolute;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .progress::-webkit-progress-value {
  background-color: rgb(var(--color-primary-none, 89, 96, 109));
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  position: absolute;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .progress::-webkit-progress-inner-element {
  position: absolute;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .progress::-moz-progress-bar {
  border: 1px solid rgb(var(--color-primary-none, 89, 96, 109));
  background: rgb(var(--color-primary-none, 89, 96, 109));
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  position: relative;
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .progress::-moz-range-progress {
  position: relative;
  background-color: rgba(255, 255, 255, 0.4);
}
.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .full-screen-icon {
  position: absolute;
  right: 24px;
}
.vjs-modal-dialog-content {
  display: none;
}
.vjs-big-play-button {
  display: none;
}
.vjs-play-control {
  padding: 24px;
  background-color: transparent;
  border: none;
}
.vjs-control-bar {
  display: none;
}
.vjs-control-text {
  display: none;
}
.vjs-close-button {
  display: none;
}
/* Mobile */
@media screen and (max-width: 900px) {
  .ant-modal-root .ant-modal.video-player-container-desktop {
    height: auto;
    top: 10%;
    display: block !important;
    margin: 0;
    width: 100% !important;
    padding-bottom: 0;
  }
  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content {
    top: 50%;
    padding-left: 24px;
    padding-right: 24px;
    height: 100%;
    border-radius: 0;
    padding: 0px;
    display: flex;
    flex-direction: column;
  }
  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-close {
    margin-right: 0;
  }
  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .nackle-video-player {
    height: 100%;
  }
  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .nackle-video-player .video-js {
    justify-content: start;
    border-radius: 0;
    height: auto;
  }
  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .nackle-video-player .video-js .vjs-tech {
    position: static;
  }
  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .full-screen {
    padding: 0;
  }
  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .video-control {
    width: auto;
  }
  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .video-control .video-progress {
    width: 100%;
  }
  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .volume-control:hover .wrapper-input {
    display: none;
  }
  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .volume-control .wrapper-input {
    display: none;
  }
}
@media screen and (max-width: 900px) {
  .ant-modal-root .ant-modal.video-player-container-desktop {
    height: 100%;
    top: unset;
    visibility: visible !important;
  }
  .ant-modal-root .ant-modal.video-player-container-desktop.ant-modal.ant-modal {
    display: flex !important;
  }
  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content {
    top: unset;
    padding-left: 0;
    padding-right: 0;
  }
  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-close {
    display: none;
  }
  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body {
    height: 100%;
    border-radius: 0;
    width: 100%;
    max-width: 100% !important;
  }
  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .custom-content-wrapper {
    height: 100%;
    border-radius: 0;
    width: auto;
  }
  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .custom-content-wrapper .nackle-video-player {
    height: 100%;
  }
  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .custom-content-wrapper .nackle-video-player .video-js {
    width: 100%;
  }
  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .custom-content-wrapper .nackle-video-player .video-js .vjs-tech {
    border-radius: 0;
  }
  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .custom-content-wrapper .video-control {
    border-radius: 0;
  }
  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .custom-content-wrapper .video-control .screen-control {
    display: block;
  }
}
.video {
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 845px;
  height: 475px;
  -o-object-fit: cover !important;
     object-fit: cover !important;
  background-size: cover;
  border-radius: 24px;
}
.screen-mobile-control {
  display: flex;
}
.video-player-container-desktop video:state(webkit-media-controls-fullscreen-button) {
  background-image: url('https://api.biw.cloud/v1/images/arrow-expands-right.png');
}
.video-player-container-desktop video:state(webkit-scrollbar-track) {
  background-image: url('https://api.biw.cloud/v1/images/arrow-expands-right.png');
}
.video-player-container-desktop .video:state(webkit-media-controls-timelinev) {
  visibility: visible;
}
.video-player-container-desktop video:state(webkit-media-controls-overlay-play-button) {
  display: none;
}
.video-player-container-desktop *:state(webkit-media-controls-panel) {
  display: none !important;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none !important;
}
.video-player-container-desktop *::-moz-media-controls-panel {
  display: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none;
       appearance: none;
}
.video-player-container-desktop *:state(webkit-media-controls-play-button) {
  display: none !important;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.video-player-container-desktop *:state(webkit-media-controls-start-playback-button) {
  display: none !important;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
}
.secondVideoElement {
  display: none;
}
.full-progress {
  width: 100% !important;
  margin-bottom: 100px !important;
  opacity: 0;
  transition: all 0.2s ease;
  position: absolute;
  padding: 0px !important;
}
.full-control {
  width: 100% !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  margin-left: 0px !important;
  opacity: 0 !important;
}
.full-control:hover .full-progress {
  opacity: 1;
}
.full-control:hover .full-panel {
  opacity: 1;
}
.full-screen {
  width: 100% !important;
  height: 100% !important;
}
.full-panel {
  position: absolute !important;
  width: 100% !important;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 24px;
  opacity: 0;
  transition: all 0.2s ease;
}
.video-player-container-desktop .video-control:hover {
  opacity: 1 !important;
}
.hidden {
  visibility: hidden;
}
.visible {
  visibility: hidden;
}
.vjs-tech {
  height: auto;
  z-index: 1;
  width: 100%;
  border-radius: 24px;
  justify-content: center;
}
.vjs-control-bar {
  display: flex;
}
.vjs-big-play-centered {
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
}
.vjs-default-skin .vjs-progress-holder {
  height: 100%;
}
.vjs-default-skin .vjs-progress-holder .vjs-play-progress,
.vjs-default-skin .vjs-progress-holder .vjs-load-progress {
  position: absolute;
  display: block;
  height: 100%;
  margin: 0;
  padding: 0;
  /* Needed for IE6 */
  left: 0;
  top: 0;
}
.vjs-poster {
  display: none;
}
.video-full-screen {
  width: 100% !important;
  height: 100% !important;
}
.global-nav {
  display: flex;
  justify-content: space-between;
  border-style: none;
}
.global-nav .ant-select {
  border-style: none;
}
.global-nav .ant-select .ant-select-selector {
  width: 100%;
  padding: 0;
}
.global-nav .ant-select .ant-select-selector.ant-select-outlined {
  border: none;
}
.global-nav .ant-select .ant-select-selector .ant-select-selection-item {
  font-size: 24px;
  font-weight: 700;
}
.global-nav-header.ant-layout-header {
  display: flex;
  height: 50px;
  padding: 6px 18px;
  padding-inline: 18px;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  z-index: 10;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.05), inset 0px -1px 0px #f5f7fa;
}
.global-nav-header.ant-layout-header .ant-select {
  min-width: 219px;
}
.global-nav-header.ant-layout-header .global-nav {
  display: flex;
}
.image-container {
  background-color: #eceff4;
}
.image-container .preview-image {
  display: flex;
  align-items: center;
  gap: 6px;
}
.ant-image-preview-close {
  display: none;
}
.ant-image-preview-operations-wrapper {
  position: relative;
}
.image-preview {
  display: flex;
  justify-content: center;
  max-width: 80%;
  max-height: 80%;
}
.image-preview > img {
  max-width: 80%;
  max-height: 80vh;
  width: auto;
  height: auto;
  display: block;
}
.image-preview .ant-btn.ant-btn.ant-btn-default {
  padding: 8px;
  border-radius: 25px;
  right: 16px;
  bottom: 20px;
  border: none;
  background-color: #59606d;
}
.image-preview .ant-btn.ant-btn.ant-btn-default svg {
  color: #ffffff;
}
.image-preview .ant-btn.ant-btn.ant-btn-default:hover {
  background-color: rgb(var(--color-primary-none, 89, 96, 109));
}
.image-preview img {
  background-color: #eceff4;
}
.ant-image-preview-root .ant-image-preview-mask {
  background-color: rgba(201, 209, 223, 0.8);
}
.picker-popover .ant-popover-content .ant-popover-inner {
  background-color: inherit;
  border: none;
  padding: 0px;
  box-shadow: 0px 4px 16px 0px #34383F29;
}
.nackle-trigger-color-picker .ant-btn.ant-btn {
  border: none;
  box-shadow: 0px 2px 8px 0px #34383F29;
  padding: 8px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.nackle-trigger-color-picker .ant-btn.ant-btn .panel-color-picker {
  align-items: center;
}
.nackle-trigger-color-picker .ant-btn.ant-btn .panel-color-picker .ant-color-picker-trigger {
  min-width: 0px;
}
.nackle-trigger-color-picker .ant-btn.ant-btn .panel-color-picker .ant-color-picker-trigger .ant-color-picker-color-block {
  width: 16.67px;
  height: 16.67px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}
.nackle-trigger-color-picker .ant-btn.ant-btn .panel-color-picker .ant-color-picker-trigger .ant-color-picker-trigger-text {
  margin-inline-start: 0px;
  margin-right: 0px;
}
.nackle-trigger-color-picker .ant-btn.ant-btn.circle {
  border-radius: 25px;
  min-width: 36px;
  height: 36px;
  padding: 8px;
}
.nackle-trigger-color-picker .ant-btn.ant-btn.circle .ant-color-picker-trigger {
  min-width: 0px;
}
.nackle-trigger-color-picker .ant-btn.ant-btn.circle .ant-color-picker-color-block {
  border-radius: 25px !important;
}
.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-sm {
  padding: 5px;
  height: 26px;
  font-size: 12px;
  line-height: 16px;
  border-radius: 4px;
}
.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-sm .panel-color-picker .ant-color-picker-trigger {
  min-width: 0px;
}
.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-sm .panel-color-picker .ant-color-picker-trigger .ant-color-picker-color-block {
  width: 13.33px;
  height: 13.33px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-sm .panel-color-picker .ant-color-picker-trigger .color-name {
  font-size: 12px;
}
.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-sm.circle {
  padding: 5px;
  min-width: 26px;
  border-radius: 25px;
}
.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-sm.trigger-button-with-text {
  padding: 5px 12px 5px 12px;
}
.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-sm.trigger-circle-button-icon {
  padding: 8px 12px;
}
.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-lg {
  padding: 10px;
  height: 44px;
  font-size: 16px;
  line-height: 24px;
  border-radius: 8px;
  min-width: 44px;
}
.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-lg .panel-color-picker .ant-color-picker-trigger {
  min-width: 0px;
}
.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-lg .panel-color-picker .ant-color-picker-trigger .ant-color-picker-color-block {
  width: 20px;
  height: 20px;
}
.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-lg .panel-color-picker .ant-color-picker-trigger .color-name {
  font-size: 16px;
}
.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-lg.circle {
  border-radius: 25px;
  padding: 10px;
}
.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-lg.trigger-button-with-text {
  padding: 10px 20px 10px 20px;
}
.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-lg.trigger-circle-button-icon {
  padding: 8px 12px;
}
.nackle-trigger-color-picker .ant-btn.ant-btn .ant-color-picker-color-block {
  width: 16.67px;
  height: 16.67px;
}
.nackle-trigger-color-picker .ant-btn.ant-btn .panel-color-picker {
  display: flex;
}
.nackle-trigger-color-picker .ant-btn.ant-btn .panel-color-picker .color-name {
  color: #59606d;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-family: var(--body-font-family-none, Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, color emoji, segoe ui emoji, noto color emoji, android emoji);
  align-content: center;
  margin-left: 9px;
}
.nackle-trigger-color-picker .ant-btn.ant-btn .panel-color-picker .ant-color-picker-trigger,
.nackle-trigger-color-picker .ant-btn.ant-btn .panel-color-picker .ant-color-picker-trigger-active {
  background-color: transparent;
  box-shadow: none;
  border-inline-end-width: 0px;
  border-color: transparent;
  outline: 0;
  padding: 0px;
  border: none;
  justify-content: start;
  align-items: center;
  display: flex;
  flex-direction: row;
}
.nackle-trigger-color-picker .ant-btn.ant-btn.trigger-button-with-text {
  padding: 8px 16px 8px 16px;
}
.nackle-trigger-color-picker .ant-btn.ant-btn.trigger-circle-button-icon {
  padding: 8px 12px;
}
.nackle-trigger-color-picker .ant-btn.ant-btn .color-name {
  font-size: 14px;
}
.nackle-trigger-color-picker .gradient-panel .ant-popover {
  position: static;
}
/*swatch color picker panel style*/
.ant-color-picker {
  width: 292px;
}
.ant-color-picker .ant-color-picker-inner .ant-color-picker-presets-items {
  padding: 20px;
  justify-content: center;
}
.ant-color-picker .ant-color-picker-inner .ant-color-picker-presets-items .ant-color-picker-presets-color:hover {
  transform: scale(1.2);
}
.ant-color-picker .ant-color-picker-inner .ant-color-picker-presets-items .ant-color-picker-presets-color:before {
  display: none;
}
.ant-color-picker .ant-color-picker-inner .ant-color-picker-presets-items .ant-color-picker-presets-color-checked:after {
  display: none;
}
.ant-color-picker .ant-color-picker-inner .ant-color-picker-presets-items .ant-color-picker-presets-color-checked .ant-color-picker-color-block-inner {
  box-shadow: var(--currentColor) 0px 0px 0px 3px inset;
  background: #ffffff !important;
}
.ant-color-picker .ant-color-picker-inner .ant-color-picker-presets-items .ant-color-picker-presets-color {
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  margin: 3px;
  box-shadow: 0px 2px 8px 0px #34383F29;
}
.ant-color-picker .ant-color-picker-inner .ant-color-picker-presets-items .ant-color-picker-color-block .ant-color-picker-color-block-inner {
  width: 28px;
  height: 28px;
  border: none;
}
.ant-color-picker .ant-collapse-header {
  display: none !important;
}
.gradient-panel .ant-popover {
  position: static;
}
.ant-switch.origami-switch {
  background-color: #9099a9;
}
.ant-switch.origami-switch.ant-switch-checked {
  background-color: rgb(var(--color-primary-none, 89, 96, 109));
}
.ant-switch.origami-switch.ant-switch-checked:hover {
  background-color: rgb(var(--color-primary-none, 89, 96, 109));
  opacity: 0.9;
}
.ant-switch.origami-switch.ant-switch-checked.ant-switch-disabled {
  background-color: rgb(var(--color-primary-none, 89, 96, 109));
  opacity: 0.4;
}
.ant-switch.origami-switch.ant-switch-disabled {
  background-color: #b1baca;
  opacity: 0.4;
}
.ant-switch.origami-switch:hover {
  background-color: #b1baca;
}
.ant-switch.origami-switch.origami-switch-large {
  transform: scale(127.28%);
}
/* dropdown list */
.nackle-behavior {
  display: flex;
  align-items: center;
  height: 36px;
  width: 100%;
}
.nackle-behavior img {
  height: 36px;
  width: 36px;
  border-radius: 50%;
  margin-right: 10px;
}
.ant-select-item-option-disabled {
  background-color: #f5f7fa;
}
.ant-select-item-option-disabled .nackle-behavior img {
  opacity: 0.54;
}
/* selected option */
.ant-select .nackle-behavior {
  height: 20px;
}
.ant-select .nackle-behavior img {
  height: 20px;
  width: 20px;
}
.ant-select .nackle-behavior.nackle-behavior-large {
  height: 24px;
}
.ant-select .nackle-behavior.nackle-behavior-large img {
  height: 24px;
  width: 24px;
}
.ant-select .nackle-behavior.nackle-behavior-small {
  height: 16px;
}
.ant-select .nackle-behavior.nackle-behavior-small img {
  height: 16px;
  width: 16px;
}
.ant-select.ant-select-disabled .ant-select-selection-item .nackle-behavior img {
  opacity: 0.54;
}
.multi-button {
  display: flex;
}
.multi-button .ant-btn.ant-btn.left-button {
  border-right: none;
  border-radius: 25px 0px 0px 25px;
}
.multi-button .ant-btn.ant-btn.left-button span {
  display: flex;
  align-items: center;
}
.multi-button .ant-btn.ant-btn.left-button svg {
  width: 20px;
  height: 20px;
}
.multi-button .ant-btn.ant-btn.left-button.ant-btn-lg svg {
  width: 24px;
  height: 24px;
}
.multi-button .ant-btn.ant-btn.left-button.ant-btn-sm svg {
  width: 16px;
  height: 16px;
}
.multi-button .ant-btn.ant-btn.right-button {
  border-left: none;
}
.multi-button .ant-btn.ant-btn.right-button {
  border-left: none;
  border-radius: 0px 25px 25px 0px;
}
.multi-button .ant-btn.ant-btn.right-button:before {
  height: 50%;
  position: absolute;
  inset-inline-start: -1px;
  display: inline-block;
  background-color: #59606d;
  width: 1px;
  content: "";
}
.multi-button .ant-btn.ant-btn.right-button svg {
  width: 20px;
  height: 20px;
}
.multi-button .ant-btn.ant-btn.right-button.ant-btn-lg svg {
  width: 24px;
  height: 24px;
}
.multi-button .ant-btn.ant-btn.right-button.ant-btn-sm svg {
  width: 16px;
  height: 16px;
}
.multi-button .ant-btn.ant-btn.right-button span {
  display: flex;
}
.multi-button .ant-btn.ant-btn.right-button .left-button-icon {
  border-radius: 8px 0px 0px 8px;
}
.multi-button .ant-btn.ant-btn.ant-btn-secondary {
  background-color: #ffffff;
  border: 1px solid #c9d1df;
}
.multi-button .ant-btn.ant-btn.ant-btn-secondary.right-button {
  border-left: none;
}
.multi-button .ant-btn.ant-btn.ant-btn-secondary.left-button {
  border-right: none;
}
.multi-button .ant-btn.ant-btn.ant-btn-secondary:hover {
  border-color: #c9d1df;
  color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);
}
.multi-button .ant-btn.ant-btn.ant-btn-secondary.ant-btn-dangerous {
  color: #de1b1b;
}
.multi-button .ant-btn.ant-btn.ant-btn-secondary.ant-btn-dangerous:hover {
  color: #f55353;
}
.multi-button .ant-btn.ant-btn.ant-btn-primary:before {
  background-color: #ffffff;
}
.multi-button .ant-btn.ant-btn:disabled:before {
  background-color: #c9d1df;
}
.multi-button .ant-btn .ant-btn:not(.ant-btn-round, .ant-btn-circle).left-button {
  border-right: none;
  border-radius: 6px 0px 0px 6px;
}
.multi-button .ant-btn .ant-btn:not(.ant-btn-round, .ant-btn-circle).left-button.ant-btn-lg {
  border-radius: 8px 0px 0px 8px;
}
.multi-button .ant-btn .ant-btn:not(.ant-btn-round, .ant-btn-circle).left-button.ant-btn-sm {
  border-radius: 4px 0px 0px 4px;
}
.multi-button .ant-btn .ant-btn:not(.ant-btn-round, .ant-btn-circle).right-button {
  border-left: none;
  border-radius: 0px 6px 6px 0px;
}
.multi-button .ant-btn .ant-btn:not(.ant-btn-round, .ant-btn-circle).right-button.ant-btn-lg {
  border-radius: 0px 8px 8px 0px;
}
.multi-button .ant-btn .ant-btn:not(.ant-btn-round, .ant-btn-circle).right-button.ant-btn-sm {
  border-radius: 0px 4px 4px 0px;
}
.ant-popover.popover-menu.multi-menu {
  width: auto;
}
@media only screen and (max-width: 735px) {
  .ant-popover.popover-menu.multi-menu {
    max-width: 300px;
  }
}
.origami-redeem-section {
  max-width: 400px;
}
.origami-redeem-section .redeem-menu {
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  list-style-type: none;
  width: 100%;
}
.origami-redeem-section .redeem-menu .redeem-option {
  flex-basis: auto;
  padding: 0;
  width: 100%;
  text-align: left;
  display: flex;
  flex-direction: row;
  margin-bottom: 8px;
}
.origami-redeem-section .redeem-menu .market-link {
  display: block;
  cursor: pointer;
  width: 100%;
}
.origami-redeem-section .redeem-menu .market-link:hover,
.origami-redeem-section .redeem-menu .market-link:focus {
  text-decoration: none;
}
.origami-redeem-section .redeem-menu .market-link:hover .link-label,
.origami-redeem-section .redeem-menu .market-link:focus .link-label {
  background-color: #F5F7FA;
  border-radius: 8px;
}
.origami-redeem-section .redeem-menu .market-link.is-disabled {
  cursor: not-allowed;
}
.origami-redeem-section .redeem-menu .icon {
  position: relative;
  width: 18px;
  height: 18px;
  margin: 0 8px 0 4px;
}
.origami-redeem-section .redeem-menu svg {
  position: absolute;
  top: 0;
  width: 100%;
}
@media screen and (max-width: 735px) {
  .origami-redeem-section .redeem-menu svg {
    width: auto;
  }
}
.origami-redeem-section .redeem-menu .link-label {
  display: flex;
  align-items: center;
  flex-basis: auto;
  width: 100%;
  height: 100%;
  margin-top: 10px / 2;
  padding: 14px;
  color: #000;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  pointer-events: none;
}
@media screen and (max-width: 735px) {
  .origami-redeem-section .redeem-menu .link-label {
    padding: 0;
    padding-left: 8px;
    padding-right: 8px;
  }
}
.origami-redeem-section .redeem-menu .link-label .rewards-store-description {
  display: flex;
  flex-direction: column;
  align-self: start;
  max-width: 265px;
}
.origami-redeem-section .redeem-menu .link-label img {
  height: 44px;
  margin-right: 10px;
  align-self: start;
}
.origami-redeem-section .redeem-menu .link-label .link-text {
  font-size: 16px;
  font-weight: 600;
  color: black;
  margin-bottom: 2px;
  line-height: 24px;
}
@media screen and (max-width: 735px) {
  .origami-redeem-section .redeem-menu .link-label .link-text {
    font-size: 14px;
    line-height: 20px;
  }
}
.origami-redeem-section .redeem-menu .link-label .sub-text {
  font-size: 14px;
  font-weight: 400;
  color: #59606D;
  line-height: 20px;
}
@media screen and (max-width: 735px) {
  .origami-redeem-section .redeem-menu .link-label .sub-text {
    font-size: 12px;
    line-height: 16px;
  }
}
.origami-redeem-section .redeem-menu .origami-external-link-icon {
  position: relative;
  width: 24px;
  height: 24px;
  margin-left: auto;
  color: #59606D;
}
@media screen and (max-width: 735px) {
  .origami-redeem-section .redeem-menu .origami-external-link-icon {
    height: 100%;
    top: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/.pnpm/@nackle+origami@2.25.12_@types+react@19.0.3_emoji-mart@5.6.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@nackle/origami/dist/css/origami.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,sBAAsB;AACxB;AACA;;;EAGE,mBAAmB;AACrB;AACA;EACE,6OAA6O;AAC/O;AACA;EACE,6OAA6O;AAC/O;AACA;EACE,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,kDAAkD;AACpD;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kEAAkE;AACpE;AACA;EACE,oEAAoE;AACtE;AACA;EACE,8EAA8E;AAChF;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,wEAAwE;AAC1E;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,mHAAmH;AACrH;AACA;EACE,oEAAoE;AACtE;AACA;EACE,0EAA0E;AAC5E;AACA;EACE,mEAAmE;AACrE;AACA;EACE,+EAA+E;AACjF;AACA;EACE,+EAA+E;AACjF;AACA;EACE,+EAA+E;AACjF;AACA;EACE,+EAA+E;AACjF;AACA;EACE,oCAAoC;AACtC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oEAAoE;AACtE;AACA;EACE,oEAAoE;AACtE;AACA;EACE,oEAAoE;AACtE;AACA;EACE,0EAA0E;AAC5E;AACA;EACE,sEAAsE;AACxE;AACA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,iEAAiE;AACnE;AACA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,6MAA6M;EAC7M,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,6DAA6D;EAC7D,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,YAAY;AACd;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;AACrB;AACA;;;;EAIE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;;;;EAIE,gBAAgB;AAClB;AACA;;;;EAIE,cAAc;AAChB;AACA;;EAEE,6BAA6B;EAC7B,kDAAkD;AACpD;AACA;;;;;;;;EAQE,kDAAkD;EAClD,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,6OAA6O;EAC7O,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,QAAQ;AACV;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;EACE,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,6DAA6D;AAC/D;AACA;EACE,mEAAmE;AACrE;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kDAAkD;EAClD,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,wDAAwD;AAC1D;AACA;;;EAGE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;;;EAGE,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;;;EAGE,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;;;EAGE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;;;EAGE,wDAAwD;AAC1D;AACA;;;EAGE,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kDAAkD;AACpD;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,aAAa;EACb,8CAA8C;EAC9C,sDAAsD;AACxD;AACA;EACE,oBAAoB;AACtB;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,MAAM;EACN,oBAAoB;EACpB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kCAAkC;EAClC,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,oBAAiB;KAAjB,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,2EAA2E;EAC3E,YAAY;EACZ,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,qCAAqC;EACrC,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EAEE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,YAAY;IACZ,SAAS;IACT,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,mEAAmE;AACrE;AACA;EACE,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,8CAA8C;EAC9C,sDAAsD;AACxD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6DAA6D;EAC7D,yDAAyD;AAC3D;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AAFA;EACE,cAAc;AAChB;AACA;;;EAGE,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;AACA;;;EAGE,YAAY;AACd;AACA;;;EAGE,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;;;;EAIE,oBAAoB;AACtB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,6DAA6D;EAC7D,mBAAmB;AACrB;AACA;;EAEE,WAAW;AACb;AACA;EACE;IACE,8BAA8B;IAC9B,YAAY;EACd;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kDAAkD;EACpD;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;;IAEE,8BAA8B;EAChC;AACF;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kDAAkD;EAClD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kDAAkD;EAClD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kDAAkD;AACpD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,kDAAkD;AACpD;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,cAAc;EACd,uDAAuD;EACvD,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;;;;;;EAME,yBAAyB;AAC3B;AACA;;EAEE,mBAAmB;AACrB;AACA;;;;EAIE,mBAAmB;AACrB;AACA;;;;;;;EAOE,YAAY;EACZ,kEAAkE;EAClE,qEAAqE;AACvE;AACA;;;;;EAKE,uBAAuB;EACvB,2EAA2E;EAC3E,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA;;;;;EAKE,qBAAqB;EACrB,yEAAyE;EACzE,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yDAAyD;AAC3D;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,uDAAuD;EACvD,gBAAgB;AAClB;AACA;EACE,6DAA6D;AAC/D;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,+CAA+C;AACjD;AACA;;EAEE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,6BAA6B;AAC/B;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;AACA;;EAEE,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,YAAY;AACd;AACA;;;;EAIE,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,YAAY;AACd;AACA;;;;EAIE,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;;;EAGE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,6OAA6O;EAC7O,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EAGE,cAAc;AAChB;AAJA;;;EAGE,cAAc;AAChB;AACA;EAGE,cAAc;AAChB;AAJA;;;EAGE,cAAc;AAChB;AACA;;;EAGE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;;;EAGE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;;;;;;EAME,qBAAqB;AACvB;AACA;;;;;;EAME,qBAAqB;EACrB,8CAA8C;AAChD;AACA;;;;;;EAME,qBAAqB;AACvB;AACA;;;;;;EAME,qBAAqB;AACvB;AACA;;;;;;;;;;;;EAYE,qBAAqB;EACrB,4CAA4C;AAC9C;AACA;;;;;;EAME,qBAAqB;AACvB;AACA;;;;;;EAME,qBAAqB;AACvB;AACA;;;;;;;;;;;;EAYE,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,cAAc;AAChB;AACA;;;;EAIE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;;;;EAIE,cAAc;AAChB;AACA;;EAEE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;AACA;;;;EAIE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;;;EAGE,qBAAqB;AACvB;AACA;;;;;;EAME,cAAc;AAChB;AACA;;;;;;EAME,cAAc;AAChB;AACA;EACE,6OAA6O;AAC/O;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,6OAA6O;AAC/O;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,6OAA6O;EAC7O,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AAFA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,8BAA8B;AAChC;AACA;;;EAGE,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,8BAA8B;AAChC;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;;;;EAIE,8BAA8B;AAChC;AACA;;;EAGE,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;;;EAGE,8BAA8B;AAChC;AACA;;;EAGE,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,yBAAyB;AAC3B;AACA;;;EAGE,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,8BAA8B;AAChC;AACA;;;EAGE,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;AACA;;;EAGE,qBAAqB;AACvB;AACA;;;EAGE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;;;EAGE,qBAAqB;AACvB;AACA;;;EAGE,qBAAqB;AACvB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,qBAAqB;AACvB;AACA;;;EAGE,qBAAqB;AACvB;AACA;;;EAGE,qBAAqB;AACvB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;;;;EAIE,aAAa;EACb,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,yDAAyD;EACzD,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,6DAA6D;AAC/D;AACA;EACE,+DAA+D;AACjE;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;AACpB;AACA,qEAAqE;AACrE;;;EAGE,oBAAoB;EACpB,WAAW;EACX,WAAW;AACb;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;EAGE,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;EAGE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;;EAGE,WAAW;EACX,qBAAqB;AACvB;AACA;;;EAGE,yDAAyD;EACzD,aAAa;EACb,8CAA8C;EAC9C,sDAAsD;AACxD;AACA;;;EAGE,aAAa;AACf;AACA;;;EAGE,WAAW;EACX,yDAAyD;AAC3D;AACA;;;EAGE,cAAc;EACd,yBAAyB;AAC3B;AACA;;;;;;EAME,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;;EAEE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,8BAA8B;EAC9B,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,yDAAyD;EACzD,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,6DAA6D;AAC/D;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yDAAyD;AAC3D;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;EACd,kDAAkD;AACpD;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,qCAAqC;AACvC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,qBAAqB;AACvB;AACA;;;;EAIE,qBAAqB;AACvB;AACA;;;;EAIE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,qBAAqB;AACvB;AACA;;;;EAIE,qBAAqB;AACvB;AACA;;;;EAIE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,aAAa;AACf;AACA;EACE,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;EACpB,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kDAAkD;AACpD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;;EAEE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kDAAkD;EAClD,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;;;EAGE,kBAAkB;AACpB;AACA;;EAGE,8CAA8C;AAChD;AACA;;EAGE,8CAA8C;AAChD;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,oCAAoC;AACtC;AACA;EACE,aAAa;AACf;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,kDAAkD;AACpD;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,kDAAkD;AACpD;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,mCAAmC;EACnC,iCAAiC;EACjC,oBAAoB;AACtB;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,4BAA4B;EAC5B,eAAe;EACf,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,aAAa;EACb,eAAe;EACf,SAAS;AACX;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;;EAEE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE;IACE,sBAAsB;IACtB,eAAe;IACf,SAAS;IACT,SAAS;IACT,YAAY;IACZ,UAAU;IACV,SAAS;EACX;EACA;IACE,MAAM;EACR;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,YAAY;IACZ,4BAA4B;IAC5B,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,eAAe;IACf,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,MAAM;IACN,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;EACd;EACA;IACE,SAAS;IACT,eAAe;IACf,WAAW;IACX,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,0BAA0B;IAC1B,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,eAAe;IACf,SAAS;IACT,SAAS;IACT,cAAc;EAChB;EACA;IACE,gCAAgC;EAClC;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,0BAA0B;IAC1B,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,sCAAsC;IACtC,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sCAAsC;IACtC,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sCAAsC;IACtC,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;AACA;EACE;IACE,UAAU;IACV,eAAe;EACjB;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;;;EAGE,yBAAyB;EACzB,oCAAoC;AACtC;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kDAAkD;EAClD,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,2CAA2C;EAC3C,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,2CAA2C;EAC3C,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,aAAa;EACb,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,2CAA2C;EAC3C,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;EACZ,SAAS;AACX;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,8CAA8C;AAChD;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,OAAO;EACP,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,QAAQ;AACV;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,OAAO;EACP,iBAAiB;AACnB;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,MAAM;IACN,oBAAe;SAAf,eAAe;IACf,WAAW;EACb;EACA;IACE,UAAU;IACV,eAAe;IACf,MAAM;EACR;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,eAAe;EACjB;EACA;IACE,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kDAAkD;EAClD,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;AACA;;;EAGE,eAAe;AACjB;AACA;;;EAGE,yBAAyB;AAC3B;AACA;;;;;;EAME,wDAAwD;AAC1D;AACA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,kDAAkD;AACpD;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,kFAAkF;EAClF,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kDAAkD;AACpD;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;;;EAGE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;AACA;;;EAGE,WAAW;EACX,YAAY;AACd;AACA;;;EAGE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,SAAS;EACT,kDAAkD;AACpD;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;;;EAGE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;AACA;;;EAGE,eAAe;EACf,WAAW;EACX,YAAY;AACd;AACA;;;EAGE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,SAAS;EACT,kDAAkD;AACpD;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,yBAAyB;AAC3B;AACA;;;;EAIE,cAAc;AAChB;AACA;;EAEE,kDAAkD;AACpD;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,6BAA6B;EAC7B,YAAY;EACZ,cAAc;AAChB;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,8CAA8C;EAC9C,sDAAsD;AACxD;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;;EAEE,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,uBAAkB;EAAlB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,mDAAmD;AACrD;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,cAAc;EACd,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,yEAAyE;EACzE,0BAA0B;AAC5B;AACA;EACE,yEAAyE;EACzE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,kDAAkD;AACpD;AACA;EACE,iBAAiB;EACjB,kDAAkD;AACpD;AACA;EACE,iBAAiB;EACjB,kDAAkD;AACpD;AACA;EACE,iBAAiB;EACjB,kDAAkD;AACpD;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kDAAkD;AACpD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,kDAAkD;EAClD,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;AACA;;;EAGE,wDAAwD;AAC1D;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,8BAA8B;AAChC;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,0BAA0B;AAC5B;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,UAAU;EACV,uDAAuD;AACzD;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6DAA6D;EAC7D,YAAY;AACd;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,oCAAoC;AACtC;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6OAA6O;EAC7O,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,WAAW;EACX,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;AACA;;EAEE,uBAAuB;EACvB,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6OAA6O;EAC7O,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,wBAAmB;EAAnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,0CAA0C;AAC5C;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;AACA,8BAA8B;AAC9B;;;;;;;;;;EAUE,SAAS;EACT,6OAA6O;EAC7O,eAAe;EACf,gBAAgB;AAClB;AACA;;;;;;;;;;EAUE,SAAS;AACX;AACA;;;;;;;;;;EAUE,gBAAgB;AAClB;AACA;;;;;;;;;;EAUE,gBAAgB;AAClB;AACA;;;;;;;;;;EAUE,gBAAgB;AAClB;AACA;;;;;;;;;;EAUE,cAAc;AAChB;AACA;;;;;;;;;;EAUE,cAAc;AAChB;AACA;;;;;;;;;;EAUE,cAAc;AAChB;AACA;;;;;;;;;;EAUE,cAAc;AAChB;AACA;EACE,kDAAkD;EAClD,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,wDAAwD;EACxD,0BAA0B;EAC1B,YAAY;AACd;AACA;EACE,kDAAkD;EAClD,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kDAAkD;EAClD,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,8DAA8D;EAC9D,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kDAAkD;EAClD,0BAA0B;AAC5B;AACA;EACE,8DAA8D;EAC9D,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kDAAkD;AACpD;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;EACE,8DAA8D;EAC9D,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,UAAU;AACZ;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kDAAkD;AACpD;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;EACxB,mCAAmC;EACnC,iCAAiC;AACnC;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;;;EAGE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,QAAQ;AACV;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;AACV;AACA;;;;EAIE,kBAAkB;AACpB;AACA;EACE,6DAA6D;EAC7D,yDAAyD;AAC3D;AACA;;EAEE,6DAA6D;EAC7D,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;;;EAGE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;;;EAGE,kBAAkB;AACpB;AACA;;;EAGE,SAAS;EACT,UAAU;AACZ;AACA;;;EAGE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;;;EAGE,kBAAkB;AACpB;AACA;;;EAGE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;;;EAGE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;;EAGE,QAAQ;EACR,mBAAmB;AACrB;AACA;;;EAGE,oBAAoB;AACtB;AACA;;;EAGE,MAAM;EACN,OAAO;EACP,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,QAAQ;AACV;AACA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,QAAQ;AACV;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,QAAQ;AACV;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,cAAc;EACd,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;AACV;AACA;EACE,WAAW;AACb;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AAFA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;AACV;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;;EAEE,qCAAqC;EACrC,yBAAyB;AAC3B;AACA;;EAEE,cAAc;AAChB;AACA,YAAY;AACZ;EACE,qBAAqB;AACvB;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,QAAQ;EACR,WAAW;EACX,UAAU;EACV,aAAa;EACb,UAAU;AACZ;AACA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,QAAQ;EACR,WAAW;EACX,UAAU;EACV,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;AACF;AACA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,aAAa;EACb,iFAAiF;EACjF,+BAA+B;EAC/B,gCAAgC;EAChC,UAAU;EACV,QAAQ;EACR,OAAO;EACP,kBAAkB;EAClB,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,aAAa;EACb,UAAU;EACV,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;EAC5B,oCAAoC;AACtC;AACA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,qBAAgB;OAAhB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,oCAA4B;EAA5B,4BAA4B;AAC9B;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,iCAA4B;EAA5B,4BAA4B;AAC9B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,UAAU;EACV,qBAAqB;EACrB,aAAa;EACb,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,eAAe;EACf,SAAS;EACT,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,wBAAwB;EACxB,iCAAyB;EAAzB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uDAAuD;EACvD,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,6DAA6D;EAC7D,uDAAuD;EACvD,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,MAAM;EACN,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,6DAA6D;EAC7D,uDAAuD;EACvD,2BAA2B;EAC3B,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA,WAAW;AACX;EACE;IACE,YAAY;IACZ,QAAQ;IACR,yBAAyB;IACzB,SAAS;IACT,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,YAAY;IACZ,UAAU;IACV,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,0BAA0B;EAC5B;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE,2DAA+L;EAC/L,mDAAuL;EACvL,YAAY;EACZ,aAAa;EACb,+BAA4B;KAA5B,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,gFAAgF;AAClF;AACA;EACE,gFAAgF;AAClF;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,qBAAgB;OAAhB,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,qBAAgB;OAAhB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,qBAAgB;OAAhB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,OAAO;EACP,MAAM;AACR;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;EACX,uEAAuE;AACzE;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,6OAA6O;EAC7O,qBAAqB;EACrB,gBAAgB;AAClB;AACA;;EAEE,6BAA6B;EAC7B,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA,kCAAkC;AAClC;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,qDAAqD;EACrD,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,6DAA6D;EAC7D,YAAY;AACd;AACA;EACE,6DAA6D;EAC7D,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA,oBAAoB;AACpB;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;EACrB,yBAAyB;EACzB,UAAU;EACV,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,8BAA8B;AAChC;AACA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,wDAAwD;AAC1D;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE;IACE,UAAU;IACV,iBAAiB;IACjB,kBAAkB;EACpB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE;IACE,YAAY;IACZ,QAAQ;EACV;AACF","sourcesContent":["/* === Base Styles & Variables === */\nhtml {\n  box-sizing: border-box;\n}\n*,\n*::before,\n*::after {\n  box-sizing: inherit;\n}\nbody * {\n  font-family: var(--body-font-family-none, Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, color emoji, segoe ui emoji, noto color emoji, android emoji);\n}\nbody * .ant-typography {\n  font-family: var(--body-font-family-none, Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, color emoji, segoe ui emoji, noto color emoji, android emoji);\n}\nbody {\n  margin: 0;\n  background-color: #f5f7fa;\n}\nbody a {\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n}\nbody a:hover {\n  color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);\n}\n.nkl-deck-app-root .nkl-content-root .ant-layout-content .main-layout {\n  padding-top: 24px;\n}\n.primary-background:not(:disabled) {\n  background: rgb(var(--color-primary-none, 89, 96, 109)) !important;\n}\n.primary-background:not(:disabled).ant-btn.primary-background:not(:disabled):not(:disabled) {\n  border-color: rgb(var(--color-primary-none, 89, 96, 109)) !important;\n}\n.primary-background:not(:disabled).ant-btn.primary-background:not(:disabled):not(:disabled):hover {\n  background-color: rgba(var(--color-primary-none, 89, 96, 109), 0.9) !important;\n}\n.primary-color {\n  color: rgb(var(--color-primary-none, 89, 96, 109)) !important;\n}\n.primary-background-avatar {\n  background-color: rgb(var(--color-primary-none, 89, 96, 109)) !important;\n}\n.primary-fill {\n  fill: rgb(var(--color-primary-none, 89, 96, 109)) !important;\n}\n.primary-gradient {\n  background: linear-gradient(180deg, #ffffff 0%, rgba(var(--color-primary-none, 89, 96, 109), 0.07) 100%) !important;\n}\n.primary-border {\n  border-color: rgb(var(--color-primary-none, 89, 96, 109)) !important;\n}\n.primary-border:hover {\n  border-color: rgba(var(--color-primary-none, 89, 96, 109), 0.9) !important;\n}\n.primary-hover:hover {\n  color: rgba(var(--color-primary-none, 89, 96, 109), 0.9) !important;\n}\n.primary-highlight.highlighted {\n  background-color: rgba(var(--color-primary-none, 30, 112, 235), 0.1) !important;\n}\n.primary-highlight.ant-menu-item-selected {\n  background-color: rgba(var(--color-primary-none, 30, 112, 235), 0.1) !important;\n}\n.primary-highlight:active {\n  background-color: rgba(var(--color-primary-none, 30, 112, 235), 0.1) !important;\n}\n.primary-highlight-hover:hover {\n  background-color: rgba(var(--color-primary-none, 30, 112, 235), 0.1) !important;\n}\n.primary-error-background {\n  background-color: #de1b1b !important;\n}\n.primary-error-background.ant-btn {\n  border-color: #de1b1b !important;\n}\n.primary-error {\n  color: #de1b1b !important;\n}\n.primary-info-background {\n  background-color: #1d5bbf !important;\n}\n.primary-info-background.ant-btn {\n  border-color: #1d5bbf !important;\n}\n.primary-info {\n  color: #1d5bbf !important;\n}\n.primary-warning-background {\n  background-color: #fcc419 !important;\n}\n.primary-warning-background.ant-btn {\n  border-color: #fcc419 !important;\n}\n.primary-warning {\n  color: #fcc419 !important;\n}\n.primary-success-background {\n  background-color: #038537 !important;\n}\n.primary-success-background.ant-btn {\n  border-color: #038537 !important;\n}\n.primary-success {\n  color: #038537 !important;\n}\n.react-calendar .react-calender__tile--now {\n  border-color: rgb(var(--color-primary-none, 89, 96, 109)) !important;\n}\n.ant-btn.nkl-deck-site-content:not(:disabled) {\n  border-color: rgb(var(--color-primary-none, 89, 96, 109)) !important;\n}\n.ant-btn.nkl-deck-site-content:not(:disabled):focus {\n  border-color: rgb(var(--color-primary-none, 89, 96, 109)) !important;\n}\n.ant-btn.nkl-deck-site-content:not(:disabled):hover {\n  border-color: rgba(var(--color-primary-none, 89, 96, 109), 0.9) !important;\n}\n.secondary-background {\n  background: rgb(var(--color-secondary-none, 255, 255, 255)) !important;\n}\n.secondary-background.ant-btn {\n  color: #000 !important;\n  border-color: #fff !important;\n}\n.secondary-color {\n  color: rgb(var(--color-secondary-none, 255, 255, 255)) !important;\n}\n.ant-alert {\n  padding: 16px;\n  display: flex;\n  border-radius: 12px;\n}\n.ant-alert .ant-alert-content .ant-alert-message {\n  font-weight: 600;\n  margin-bottom: 0px;\n}\n.ant-alert .ant-alert-content .ant-alert-description {\n  font-size: 14px;\n  font-weight: 400;\n  color: #59606d;\n}\n.ant-alert .ant-alert-content .ant-alert-description .ant-alert-description-inner {\n  margin-bottom: 8px;\n}\n.ant-alert .ant-alert-close-icon svg {\n  height: 16px;\n  width: 16px;\n  color: #59606d;\n}\n.ant-alert.ant-alert-info {\n  background-color: #f0f5fc;\n  border: 1px solid #1d5bbf;\n}\n.ant-alert.ant-alert-info .ant-alert-icon {\n  color: #1d5bbf;\n}\n.ant-alert.ant-alert-success {\n  background-color: #e1faeb;\n  border: 1px solid #038537;\n}\n.ant-alert.ant-alert-success .ant-alert-icon {\n  color: #038537;\n}\n.ant-alert.ant-alert-warning {\n  background-color: #fff9db;\n  border: 1px solid #fcc419;\n}\n.ant-alert.ant-alert-warning .ant-alert-icon {\n  color: #fcc419;\n}\n.ant-alert.ant-alert-error {\n  background-color: #faf0f0;\n  border: 1px solid #de1b1b;\n}\n.ant-alert.ant-alert-error .ant-alert-icon {\n  color: #de1b1b;\n}\n.ant-alert.ant-alert-neutral {\n  background-color: white;\n  border: 1px solid #59606d;\n}\n.ant-alert.ant-alert-neutral .ant-alert-icon {\n  color: #59606d;\n}\n.ant-alert.no-description {\n  align-items: center;\n}\n.ant-alert.no-description .ant-alert-content {\n  display: flex;\n  align-items: center;\n}\n.ant-avatar {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  font-size: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, color emoji, segoe ui emoji, noto color emoji, android emoji;\n  background-color: #c9d1df;\n  color: #ffffff;\n  border: none;\n}\n.ant-avatar.ant-avatar-image {\n  border: none;\n}\n.ant-avatar.jumbo-avatar .ant-avatar-string {\n  font-size: 30px;\n}\n.ant-avatar.large-avatar .ant-avatar-string {\n  font-size: 18px;\n}\n.ant-avatar.medium-avatar {\n  margin-inline-start: -10px;\n  margin: 0px;\n}\n.ant-avatar.medium-avatar .ant-avatar-string {\n  font-size: 16px;\n}\n.ant-avatar.small-avatar .ant-avatar-string {\n  font-size: 12px;\n}\n.ant-avatar.mini-avatar .ant-avatar-string {\n  font-size: 10px;\n}\n.ant-avatar-group {\n  display: inline-flex;\n}\n.ant-avatar-group.large-avatar .ant-avatar {\n  margin-inline-start: -14px;\n}\n.ant-avatar-group.large-avatar .ant-avatar .ant-avatar-string {\n  font-size: 18px;\n}\n.ant-avatar-group.medium-avatar .ant-avatar {\n  margin-inline-start: -10px;\n}\n.ant-avatar-group.medium-avatar .ant-avatar .ant-avatar-string {\n  font-size: 16px;\n}\n.ant-avatar-group.small-avatar .ant-avatar {\n  margin-inline-start: -8px;\n}\n.ant-avatar-group.small-avatar .ant-avatar .ant-avatar-string {\n  font-size: 12px;\n}\n.ant-avatar-group.mini-avatar .ant-avatar {\n  margin-inline-start: -4px;\n}\n.ant-avatar-group.mini-avatar .ant-avatar .ant-avatar-string {\n  font-size: 10px;\n}\n.ant-avatar-group .ant-avatar {\n  background-color: rgb(var(--color-primary-none, 89, 96, 109));\n  border: 1px solid #ffffff;\n}\n.avatar-container {\n  display: inline-flex;\n  align-items: center;\n}\n.avatar-container .avatar-info-container {\n  display: flex;\n  flex-direction: column;\n  padding: 8px;\n}\n.avatar-container .avatar-info-container .avatar-info-name {\n  font-size: 16px;\n  display: inline-flex;\n  font-weight: 600;\n  align-items: center;\n}\n.avatar-container .avatar-info-container .avatar-info-name .avatar-info-pronouns {\n  font-size: 14px;\n  flex-direction: row;\n  color: #59606d;\n  display: inline-flex;\n  font-weight: 400;\n  align-items: center;\n}\n.avatar-container .avatar-info-container .avatar-info-name-mini {\n  font-size: 14px;\n  display: flex;\n  font-weight: 600;\n  align-items: center;\n}\n.avatar-container .avatar-info-container .avatar-info-name-mini .avatar-info-pronouns {\n  font-size: 12px;\n  flex-direction: row;\n  color: #59606d;\n  display: flex;\n  font-weight: 400;\n  align-items: center;\n}\n.avatar-container .avatar-info-content {\n  font-size: 14px;\n  font-weight: 600;\n  color: #59606d;\n  display: flex;\n  align-items: center;\n}\n.ant-avatar-group-popover .ant-popover-content .ant-popover-inner-content {\n  text-align: center;\n}\n.ant-badge .ant-badge-count {\n  height: 21px;\n  padding: 1px 8px 0 8px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  border-radius: 16px;\n}\n.ant-badge.ant-badge-status .ant-badge-status-text {\n  color: #59606d;\n}\n.default .ant-badge-count,\n.neutral .ant-badge-count,\n.warning .ant-badge-count {\n  color: black;\n}\n.ant-badge.badge-size-large .ant-badge-count {\n  height: 26px;\n  padding: 2px 10px;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  border-radius: 20px;\n}\n.ant-badge.badge-size-medium .ant-badge-count {\n  height: 21px;\n  padding: 1px 8px 0 8px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  border-radius: 16px;\n}\n.ant-badge.badge-size-small .ant-badge-count {\n  height: 16px;\n  min-width: 16px;\n  padding: 2px 6px;\n  font-weight: 600;\n  font-size: 10px;\n  line-height: 14px;\n  border-radius: 10px;\n}\n.ant-breadcrumb ol li:not(:last-child) {\n  color: #59606d;\n}\n.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-link,\n.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-overlay-link {\n  display: inline-flex;\n  align-items: center;\n}\n.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-link .anticon,\n.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-overlay-link .anticon,\n.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-link svg,\n.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-overlay-link svg {\n  color: #59606d;\n  width: 16px;\n  height: 16px;\n}\n.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-link .anticon + span,\n.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-overlay-link .anticon + span,\n.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-link svg + span,\n.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-overlay-link svg + span {\n  margin-left: 4px;\n}\n.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-link a,\n.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-overlay-link a,\n.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-link span,\n.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-overlay-link span {\n  color: #59606d;\n}\n.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-link:hover,\n.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-overlay-link:hover {\n  background-color: transparent;\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-link:hover .anticon,\n.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-overlay-link:hover .anticon,\n.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-link:hover svg,\n.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-overlay-link:hover svg,\n.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-link:hover a,\n.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-overlay-link:hover a,\n.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-link:hover span,\n.ant-breadcrumb ol li:not(:last-child) .ant-breadcrumb-overlay-link:hover span {\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n  background-color: transparent;\n}\n.ant-dropdown-trigger .anticon {\n  display: none;\n}\n.ant-dropdown-trigger .breadcrumbDropdown {\n  display: flex;\n  align-items: center;\n}\n.ant-dropdown-trigger .breadcrumbDropdown svg {\n  margin-left: 2px;\n}\n.dropdown-icon {\n  margin-left: 8px;\n  display: flex;\n  align-items: center;\n}\n.ant-btn.ant-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: var(--body-font-family-none, Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, color emoji, segoe ui emoji, noto color emoji, android emoji);\n  line-height: 20px;\n  box-shadow: none;\n  color: #59606d;\n}\n.ant-btn.ant-btn .ant-btn-icon > svg {\n  width: 20px;\n  height: 20px;\n}\n.ant-btn.ant-btn > svg {\n  width: 20px;\n  height: 20px;\n}\n.ant-btn.ant-btn.ant-btn {\n  gap: 9px;\n}\n.ant-btn.ant-btn.ant-btn-circle:not(.ant-btn-icon-only) {\n  padding: 8px 12px;\n}\n.ant-btn.ant-btn.ant-btn.ant-btn.success {\n  background-color: #038537;\n}\n.ant-btn.ant-btn.ant-btn-icon-only {\n  padding: 8px;\n  width: 36px;\n  height: 36px;\n}\n.ant-btn.ant-btn:not(.ant-btn-lg, .ant-btn-sm) {\n  min-width: 36px;\n  height: 36px;\n}\n.ant-btn.ant-btn.ant-btn-sm {\n  padding: 5px 12px 5px 12px;\n  height: 26px;\n  font-size: 12px;\n  line-height: 16px;\n  border-radius: 25px;\n}\n.ant-btn.ant-btn.ant-btn-sm .ant-btn-icon > svg {\n  width: 16px;\n  height: 16px;\n}\n.ant-btn.ant-btn.ant-btn-sm > svg {\n  width: 16px;\n  height: 16px;\n}\n.ant-btn.ant-btn.ant-btn-sm.ant-btn-icon-only {\n  padding: 5px;\n  width: 26px;\n  height: 26px;\n}\n.ant-btn.ant-btn.ant-btn-lg {\n  padding: 10px 20px 10px 20px;\n  height: 44px;\n  font-size: 16px;\n  line-height: 24px;\n}\n.ant-btn.ant-btn.ant-btn-lg .ant-btn-icon {\n  height: 24px;\n  width: 24px;\n}\n.ant-btn.ant-btn.ant-btn-lg .ant-btn-icon > svg {\n  width: 24px;\n  height: 24px;\n}\n.ant-btn.ant-btn.ant-btn-lg.ant-btn-icon-only {\n  padding: 10px;\n  width: 44px;\n  height: 44px;\n}\n.ant-btn.ant-btn.ant-btn-lg.ant-btn-icon-only .ant-btn-icon {\n  height: 24px;\n  width: 24px;\n}\n.ant-btn.ant-btn:not(.ant-btn-round, .ant-btn-circle) {\n  border-radius: 6px;\n}\n.ant-btn.ant-btn:not(.ant-btn-round, .ant-btn-circle).ant-btn-sm {\n  border-radius: 4px;\n}\n.ant-btn.ant-btn:not(.ant-btn-round, .ant-btn-circle).ant-btn-lg {\n  border-radius: 8px;\n}\n.ant-btn.ant-btn.ant-btn-default {\n  box-shadow: none;\n}\n.ant-btn.ant-btn:disabled {\n  color: #b1baca;\n  background-color: #f5f7fa;\n  border-color: #c9d1df;\n}\n.ant-btn.ant-btn:disabled.ant-btn-link,\n.ant-btn.ant-btn:disabled.ant-btn-background-ghost {\n  background-color: transparent;\n}\n.ant-btn.ant-btn:disabled.ant-btn-text,\n.ant-btn.ant-btn:disabled.ant-btn-link {\n  border: none;\n}\n.ant-btn.ant-btn:disabled.ant-btn-text {\n  background-color: #f5f7fa;\n}\n.ant-btn.ant-btn:disabled.ant-btn-link {\n  background-color: transparent;\n}\n.ant-btn.ant-btn:not(.ant-btn-icon-only) .ant-btn-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.ant-btn.ant-btn.ant-btn-primary:not(:disabled) {\n  color: #fff;\n  background-color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-btn.ant-btn.ant-btn-primary:not(:disabled):hover {\n  background-color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);\n}\n.ant-btn.ant-btn.ant-btn-primary:not(:disabled).ant-btn-dangerous {\n  background-color: #de1b1b;\n}\n.ant-btn.ant-btn.ant-btn-primary:not(:disabled).ant-btn-dangerous:hover {\n  background-color: #f55353;\n}\n.ant-btn.ant-btn.ant-btn-primary:not(:disabled).ant-btn-background-ghost {\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n  background-color: transparent;\n  border-color: #c9d1df;\n}\n.ant-btn.ant-btn.ant-btn-primary:not(:disabled).ant-btn-background-ghost:hover {\n  color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);\n}\n.ant-btn.ant-btn.ant-btn-default:not(:disabled),\n.ant-btn.ant-btn.ant-btn-dashed:not(:disabled),\n.ant-btn.ant-btn.ant-btn-text:not(:disabled) {\n  background-color: #fff;\n  border-color: #c9d1df;\n}\n.ant-btn.ant-btn.ant-btn-default:not(:disabled):hover,\n.ant-btn.ant-btn.ant-btn-dashed:not(:disabled):hover,\n.ant-btn.ant-btn.ant-btn-text:not(:disabled):hover {\n  border-color: #c9d1df;\n  color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);\n}\n.ant-btn.ant-btn.ant-btn-default:not(:disabled).ant-btn-dangerous,\n.ant-btn.ant-btn.ant-btn-dashed:not(:disabled).ant-btn-dangerous,\n.ant-btn.ant-btn.ant-btn-text:not(:disabled).ant-btn-dangerous {\n  color: #de1b1b;\n}\n.ant-btn.ant-btn.ant-btn-default:not(:disabled).ant-btn-dangerous:hover,\n.ant-btn.ant-btn.ant-btn-dashed:not(:disabled).ant-btn-dangerous:hover,\n.ant-btn.ant-btn.ant-btn-text:not(:disabled).ant-btn-dangerous:hover {\n  color: #f55353;\n}\n.ant-btn.ant-btn.ant-btn-default:not(:disabled).ant-btn-background-ghost,\n.ant-btn.ant-btn.ant-btn-dashed:not(:disabled).ant-btn-background-ghost,\n.ant-btn.ant-btn.ant-btn-text:not(:disabled).ant-btn-background-ghost {\n  color: #59606d;\n  background-color: transparent;\n  border-color: #c9d1df;\n}\n.ant-btn.ant-btn.ant-btn-default:not(:disabled).ant-btn-background-ghost:hover,\n.ant-btn.ant-btn.ant-btn-dashed:not(:disabled).ant-btn-background-ghost:hover,\n.ant-btn.ant-btn.ant-btn-text:not(:disabled).ant-btn-background-ghost:hover {\n  color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);\n}\n.ant-btn.ant-btn.ant-btn-default:not(:disabled).ant-btn-background-ghost.ant-btn-dangerous,\n.ant-btn.ant-btn.ant-btn-dashed:not(:disabled).ant-btn-background-ghost.ant-btn-dangerous,\n.ant-btn.ant-btn.ant-btn-text:not(:disabled).ant-btn-background-ghost.ant-btn-dangerous {\n  color: #de1b1b;\n}\n.ant-btn.ant-btn.ant-btn-default:not(:disabled).ant-btn-background-ghost.ant-btn-dangerous:hover,\n.ant-btn.ant-btn.ant-btn-dashed:not(:disabled).ant-btn-background-ghost.ant-btn-dangerous:hover,\n.ant-btn.ant-btn.ant-btn-text:not(:disabled).ant-btn-background-ghost.ant-btn-dangerous:hover {\n  color: #f55353;\n}\n.ant-btn.ant-btn.ant-btn-text:not(:disabled) {\n  border: none;\n}\n.ant-btn.ant-btn.ant-btn-text:not(:disabled):hover {\n  background-color: #f5f7fa;\n}\n.ant-btn.ant-btn.ant-btn-link:not(:disabled) {\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-btn.ant-btn.ant-btn-link:not(:disabled):hover {\n  color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);\n}\n.ant-btn.ant-btn.ant-btn-link:not(:disabled).ant-btn-dangerous {\n  color: #de1b1b;\n}\n.ant-btn.ant-btn.ant-btn-link:not(:disabled).ant-btn-dangerous:hover {\n  color: #f55353;\n}\n.ant-btn:not(:disabled):focus,\n.ant-btn:not(:disabled):focus-visible {\n  outline: none;\n  box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);\n  -webkit-box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);\n}\n.ant-btn span {\n  pointer-events: none;\n}\n.carousel {\n  width: 100%;\n}\n.carousel .ant-card {\n  padding: 0;\n  border-radius: 24px;\n  position: relative;\n}\n.carousel .bottom-container {\n  bottom: 24px;\n  position: absolute;\n  right: 24px;\n  width: 100%;\n  z-index: 10;\n  width: auto;\n}\n.carousel .carousel-content-container.disabled .news-content-container {\n  cursor: not-allowed;\n}\n.carousel .news-content-container {\n  height: 100%;\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  cursor: pointer;\n  outline-offset: -1px;\n  display: flex;\n}\n.carousel .news-content-container.no-link {\n  cursor: default;\n}\n.carousel .clickable {\n  cursor: pointer;\n}\n.carousel .content-box {\n  display: block;\n  position: absolute;\n  height: 33%;\n  bottom: 0;\n}\n.carousel .content-box .text-container {\n  color: #FFFFFF;\n  width: 300px;\n  position: absolute;\n  left: 30px;\n  max-height: 100%;\n  top: 0;\n  padding-bottom: 20px;\n  font-size: 16px;\n  pointer-events: none;\n}\n.carousel .img-container {\n  width: 100%;\n  min-height: 320px;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  border-radius: 24px;\n}\n.carousel .img-container .image {\n  height: 320px;\n  object-fit: cover;\n  width: 100%;\n}\n.carousel .img-container .scrim {\n  background-image: linear-gradient(rgba(0, 0, 0, 0.54), rgba(0, 0, 0, 0.54));\n  height: 100%;\n  width: 100%;\n  display: block;\n  position: absolute;\n}\n.carousel .video-modal {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n.carousel .video-modal .play-control {\n  display: flex;\n  width: 100%;\n  position: absolute;\n  justify-content: center;\n  align-items: center;\n  z-index: 100;\n}\n.carousel .video-modal .play-control .video-player-button {\n  display: flex;\n  justify-content: center;\n  position: absolute;\n}\n.carousel .direction-arrow {\n  background-color: rgba(0, 0, 0, 0.54);\n  color: #FFFFFF;\n  margin-right: 10px;\n  border-radius: 30px;\n  height: 44px;\n  width: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n.carousel .count-container {\n  background-color: rgba(0, 0, 0, 0.54);\n  color: #FFFFFF;\n  border-radius: 30px;\n  height: 44px;\n  line-height: 35px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 20px;\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n}\n.carousel .controls {\n  justify-content: flex-end;\n  display: flex;\n}\n.carousel .nav-button-container {\n  display: flex;\n  flex-direction: row;\n}\n.carousel .link-container {\n  border-radius: 16px;\n}\n.carousel .link-container:focus {\n  -webkit-box-shadow: 0 0 0 1px #1f75cb;\n  box-shadow: 0 0 0 1px #1f75cb;\n  border-color: #1f75cb;\n}\n@container (max-width: 320px) {\n  .carousel .content-box {\n    height: 50%;\n  }\n  .carousel .content-box .text-container {\n    width: 200px;\n    left: 5px;\n    font-size: 14px;\n  }\n  .carousel .controls {\n    margin-right: 0;\n  }\n  .carousel .bottom-container {\n    bottom: 20px;\n  }\n}\n.ant-card.ant-card {\n  border-radius: 24px;\n}\n.ant-checkbox-wrapper {\n  color: #000;\n}\n.ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner {\n  background-color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);\n}\n.ant-checkbox-wrapper .ant-checkbox {\n  align-self: flex-start;\n  margin-top: 2px;\n}\n.ant-checkbox-wrapper .ant-checkbox > span.ant-checkbox-inner {\n  border-radius: 2px;\n}\n.ant-checkbox-wrapper .ant-checkbox.ant-checkbox-disabled > span.ant-checkbox-inner {\n  background: #f5f7fa;\n  border: 1px #c9d1df solid;\n}\n.ant-checkbox-wrapper .ant-checkbox.ant-checkbox-disabled > span.ant-checkbox-inner::after {\n  border-color: #c9d1df;\n}\n.ant-checkbox-wrapper .ant-checkbox.ant-checkbox-disabled.ant-checkbox-indeterminate > span.ant-checkbox-inner::after {\n  background-color: #c9d1df;\n}\n.ant-checkbox-wrapper.ant-checkbox-wrapper-disabled :nth-child(2) {\n  color: #b1baca;\n}\n.ant-checkbox-wrapper .ant-checkbox:not(.ant-checkbox-disabled) .ant-checkbox-input:focus-visible + .ant-checkbox-inner {\n  outline: none;\n  box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);\n  -webkit-box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);\n}\n.ant-checkbox-wrapper .ant-checkbox:not(.ant-checkbox-disabled) > span.ant-checkbox-inner {\n  border: 1px #b1baca solid;\n}\n.ant-checkbox-wrapper .ant-checkbox:not(.ant-checkbox-disabled).ant-checkbox-checked > span.ant-checkbox-inner {\n  background-color: rgb(var(--color-primary-none, 89, 96, 109));\n  border-color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-checkbox-wrapper .ant-checkbox:not(.ant-checkbox-disabled).ant-checkbox-indeterminate ::after {\n  background-color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-checkbox-wrapper .ant-checkbox:not(.ant-checkbox-disabled):hover span.ant-checkbox-inner {\n  border: 1px #9099a9 solid;\n}\n.ant-picker {\n  padding: 10px 12px;\n  min-width: 136px;\n  height: 44px;\n  border: 1px #c9d1df solid;\n  border-radius: 8px;\n}\n.ant-picker.ant-picker-outlined.ant-picker-status-error:not(.ant-picker-disabled) {\n  color: #de1b1b;\n}\n.ant-picker.ant-picker-outlined.ant-picker-status-error:not(.ant-picker-disabled) .ant-picker-suffix {\n  color: #de1b1b;\n}\n.ant-picker:hover:not(.ant-picker-disabled) {\n  border-color: #9099a9;\n}\n.ant-picker.ant-picker-disabled {\n  background-color: #f5f7fa;\n}\n.ant-picker.ant-picker-disabled.ant-picker-range:hover,\n.ant-picker.ant-picker-disabled.ant-picker-outlined:hover {\n  background-color: #f5f7fa;\n  border-color: #c9d1df;\n}\n.ant-picker.ant-picker-focused {\n  border-color: #9099a9;\n  box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);\n}\n.ant-picker .ant-picker-input input {\n  color: #000;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n}\n.ant-picker .ant-picker-input input::placeholder {\n  color: #c9d1df;\n}\n.ant-picker .ant-picker-suffix,\n.ant-picker .ant-picker-separator,\n.ant-picker .ant-picker-clear {\n  display: flex;\n  flex: none;\n  align-self: center;\n  width: 20px;\n  height: 20px;\n  color: #b1baca;\n  line-height: 20px;\n}\n.ant-picker .ant-picker-suffix .anticon,\n.ant-picker .ant-picker-separator .anticon,\n.ant-picker .ant-picker-clear .anticon {\n  height: 20px;\n}\n.ant-picker .ant-picker-suffix svg,\n.ant-picker .ant-picker-separator svg,\n.ant-picker .ant-picker-clear svg {\n  width: 20px;\n  height: 20px;\n}\n.ant-picker .ant-picker-clear:hover {\n  color: #b1baca;\n}\n.ant-picker.ant-picker-range .ant-picker-input > input {\n  text-align: center;\n}\n.ant-picker.ant-picker-range .ant-picker-active-bar {\n  background-color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-picker.ant-picker-range .ant-picker-range-separator {\n  display: flex;\n}\n.ant-picker-dropdown {\n  color: #59606d;\n}\n.ant-picker-dropdown .ant-picker-panel {\n  border-color: #eceff4;\n}\n.ant-picker-dropdown .ant-picker-panel .ant-picker-date-panel {\n  width: 280px;\n}\n.ant-picker-dropdown .ant-picker-panel .ant-picker-date-panel .ant-picker-header .ant-picker-month-btn {\n  pointer-events: none;\n}\n.ant-picker-dropdown .ant-picker-panel .ant-picker-date-panel .ant-picker-header .ant-picker-year-btn {\n  pointer-events: none;\n}\n.ant-picker-dropdown .ant-picker-panel .ant-picker-date-panel .ant-picker-body {\n  padding: 8px 14px;\n}\n.ant-picker-dropdown .ant-picker-panel .ant-picker-month-panel .ant-picker-header .ant-picker-year-btn,\n.ant-picker-dropdown .ant-picker-panel .ant-picker-year-panel .ant-picker-header .ant-picker-year-btn,\n.ant-picker-dropdown .ant-picker-panel .ant-picker-month-panel .ant-picker-header .ant-picker-decade-btn,\n.ant-picker-dropdown .ant-picker-panel .ant-picker-year-panel .ant-picker-header .ant-picker-decade-btn {\n  pointer-events: none;\n}\n.ant-picker-dropdown .ant-picker-panel .ant-picker-month-panel .ant-picker-cell,\n.ant-picker-dropdown .ant-picker-panel .ant-picker-year-panel .ant-picker-cell {\n  padding: 3px 8px;\n}\n.ant-picker-dropdown .ant-picker-panel .ant-picker-month-panel .ant-picker-cell .current,\n.ant-picker-dropdown .ant-picker-panel .ant-picker-year-panel .ant-picker-cell .current {\n  border: rgb(var(--color-primary-none, 89, 96, 109)) 1px solid;\n  border-radius: 16px;\n}\n.ant-picker-dropdown .ant-picker-panel .ant-picker-month-panel .ant-picker-cell .ant-picker-cell-inner,\n.ant-picker-dropdown .ant-picker-panel .ant-picker-year-panel .ant-picker-cell .ant-picker-cell-inner {\n  width: 100%;\n}\n@media screen and (max-width: 1087px) {\n  .ant-picker-dropdown .ant-picker-panel-container .ant-picker-panel-layout {\n    flex-direction: column-reverse;\n    height: auto;\n  }\n  .ant-picker-dropdown .ant-picker-panel-container .ant-picker-panel-layout .ant-picker-presets {\n    height: 80px;\n    width: 100%;\n  }\n  .ant-picker-dropdown .ant-picker-panel-container .ant-picker-panel-layout .ant-picker-presets ul {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    width: 280px;\n    min-width: none;\n    max-width: none;\n  }\n  .ant-picker-dropdown .ant-picker-panel-container .ant-picker-panel-layout .ant-picker-presets ul li {\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 16px;\n    color: rgb(var(--color-primary-none, 89, 96, 109));\n  }\n  .ant-picker-dropdown .ant-picker-panel-container .ant-picker-panel-layout .ant-picker-presets ul li + li {\n    margin-top: 0;\n  }\n  .ant-picker-dropdown .ant-picker-panel-container .ant-picker-panel-layout .ant-picker-panels .ant-picker-panel:nth-child(2) {\n    display: none;\n  }\n  .ant-picker-dropdown .ant-picker-panel-container .ant-picker-panel-layout .ant-picker-panels .ant-picker-panel:first-child .ant-picker-header-next-btn,\n  .ant-picker-dropdown .ant-picker-panel-container .ant-picker-panel-layout .ant-picker-panels .ant-picker-panel:first-child .ant-picker-header-super-next-btn {\n    visibility: visible !important;\n  }\n}\n.ant-picker-dropdown .ant-picker-footer {\n  min-height: 40px;\n  border-color: #eceff4;\n}\n.ant-picker-dropdown .ant-picker-footer .ant-picker-ranges {\n  align-items: center;\n  margin: 0;\n  min-height: 42px;\n}\n.ant-picker-dropdown .ant-picker-footer .ant-picker-today-btn {\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n  padding: 0px 12px;\n  border-radius: 16px;\n}\n.ant-picker-dropdown .ant-picker-footer .ant-picker-today-btn:hover {\n  background: #f5f7fa;\n}\n.ant-picker-dropdown .ant-picker-footer .ant-picker-now-btn {\n  padding: 0 12px;\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n  border-radius: 16px;\n}\n.ant-picker-dropdown .ant-picker-footer .ant-picker-now-btn:hover {\n  background: #f5f7fa;\n}\n.ant-picker-dropdown .ant-picker-footer .ant-picker-ok button.ant-btn.ant-btn-primary.ant-btn-sm {\n  height: 26px;\n  padding: 5px 12px;\n  font-size: 12px;\n  line-height: 16px;\n  border-radius: 25px;\n}\n.ant-picker-dropdown .ant-picker-panel-container {\n  box-shadow: 0 4px 16px rgba(52, 56, 63, 0.16);\n}\n.ant-picker-dropdown .ant-picker-panel-container .ant-picker-presets {\n  min-width: 128px;\n}\n.ant-picker-dropdown .ant-picker-panel-container .ant-picker-presets ul {\n  border-inline-end: 1px solid #eceff4;\n}\n.ant-picker-dropdown .ant-picker-panel-container .ant-picker-presets ul li {\n  display: flex;\n  align-items: center;\n  height: 24px;\n  border-radius: 16px;\n  padding: 0 12px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-picker-dropdown .ant-picker-panel-container .ant-picker-presets ul li:hover {\n  background: #f5f7fa;\n}\n.ant-picker-dropdown .ant-picker-header {\n  padding: 0 8px;\n  color: #59606d;\n  border-bottom: 1px #eceff4 solid;\n}\n.ant-picker-dropdown .ant-picker-header button {\n  min-width: 16px;\n  color: #59606d;\n  line-height: 37px;\n}\n.ant-picker-dropdown .ant-picker-header button span[class^=\"origami-picker-\"] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.ant-picker-dropdown .ant-picker-header button span[class^=\"origami-picker-\"] svg {\n  width: 16px;\n  height: 16px;\n}\n.ant-picker-dropdown .ant-picker-header button:hover {\n  color: #b1baca;\n}\n.ant-picker-dropdown .ant-picker-header .ant-picker-header-view {\n  line-height: 37px;\n}\n.ant-picker-dropdown .ant-picker-header .ant-picker-header-view button {\n  color: #000;\n}\n.ant-picker-dropdown .ant-picker-header .ant-picker-header-view button:hover {\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-picker-dropdown .ant-picker-content tr {\n  height: 30px;\n}\n.ant-picker-dropdown .ant-picker-content th {\n  color: #59606d;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell {\n  height: 28px;\n  padding: 3px 6px;\n  color: #c9d1df;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view:not(.ant-picker-cell-disabled) {\n  color: #59606d;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-disabled {\n  cursor: not-allowed;\n  color: #c9d1df;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-disabled::before {\n  background-color: #f5f7fa;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {\n  color: #f5f7fa;\n  background: rgb(var(--color-primary-none, 89, 96, 109));\n  font-weight: 600;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-in-range::before {\n  background: #f5f7fa;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover::before,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start::before,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end::before,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover .ant-picker-cell-inner::after,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start .ant-picker-cell-inner::after,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner::after {\n  background-color: #dee3ec;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single)::before,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single)::before {\n  background: #f5f7fa;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-start.ant-picker-cell-range-hover::before,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-end.ant-picker-cell-range-hover::before,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single).ant-picker-cell-range-hover-start::before,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-range-end-single).ant-picker-cell-range-hover-end::before {\n  background: #dee3ec;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover-start:not(.ant-picker-cell-in-range):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end)::after,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-in-view.ant-picker-cell-range-hover-end:not(.ant-picker-cell-in-range):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end)::after,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover-start.ant-picker-cell-range-start-single::after,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover-start.ant-picker-cell-range-start.ant-picker-cell-range-end.ant-picker-cell-range-end-near-hover::after,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover-end.ant-picker-cell-range-start.ant-picker-cell-range-end.ant-picker-cell-range-start-near-hover::after,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover-end.ant-picker-cell-range-end-single::after,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover:not(.ant-picker-cell-in-range)::after {\n  height: 28px;\n  border-top: 1px dashed rgb(var(--color-primary-none, 89, 96, 109));\n  border-bottom: 1px dashed rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover:first-child::after,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover-end:first-child::after,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-start.ant-picker-cell-range-hover-edge-start.ant-picker-cell-range-hover-edge-start-near-range::after,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover-edge-start:not(.ant-picker-cell-range-hover-edge-start-near-range)::after,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover-start::after {\n  inset-inline-start: 3px;\n  border-inline-start: 1px dashed rgb(var(--color-primary-none, 89, 96, 109));\n  border-start-start-radius: 20px;\n  border-end-start-radius: 20px;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover:last-child::after,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover-start:last-child::after,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-end.ant-picker-cell-range-hover-edge-end.ant-picker-cell-range-hover-edge-end-near-range::after,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover-edge-end:not(.ant-picker-cell-range-hover-edge-end-near-range)::after,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-hover-end::after {\n  inset-inline-end: 3px;\n  border-inline-end: 1px dashed rgb(var(--color-primary-none, 89, 96, 109));\n  border-start-end-radius: 20px;\n  border-end-end-radius: 20px;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single):not(.ant-picker-cell-range-end)::before {\n  inset-inline-start: 4px;\n  border-start-start-radius: 16px;\n  border-end-start-radius: 16px;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-start:not(.ant-picker-cell-range-start-single):not(.ant-picker-cell-range-end) .ant-picker-cell-inner {\n  border-radius: 16px;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-end::before {\n  inset-inline-end: 4px;\n  border-start-end-radius: 16px;\n  border-end-end-radius: 16px;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {\n  border-radius: 16px;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-disabled {\n  cursor: not-allowed;\n  color: #c9d1df;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-disabled::before {\n  background-color: #f5f7fa;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell.ant-picker-cell-today {\n  font-weight: 600;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell::before {\n  height: 28px;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell .ant-picker-cell-inner {\n  border-radius: 16px;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell .ant-picker-cell-inner::before {\n  border-radius: 16px;\n  border-color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell:hover:not(.ant-picker-cell-in-view) .ant-picker-cell-inner,\n.ant-picker-dropdown .ant-picker-content .ant-picker-cell:hover:not(.ant-picker-cell-selected):not(.ant-picker-cell-range-start):not(.ant-picker-cell-range-end):not(.ant-picker-cell-range-hover-start):not(.ant-picker-cell-range-hover-end) .ant-picker-cell-inner {\n  background: #f5f7fa;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-time-panel-column {\n  margin: 0;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-time-panel-column li.ant-picker-time-panel-cell {\n  margin-inline: 0;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-time-panel-column li.ant-picker-time-panel-cell .ant-picker-time-panel-cell-inner {\n  width: 56px;\n  padding-inline: 0;\n  color: #59606d;\n  text-align: center;\n  border-radius: 0;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-time-panel-column li.ant-picker-time-panel-cell .ant-picker-time-panel-cell-inner:hover {\n  background: #f5f7fa;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-time-panel-column li.ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner {\n  color: #fff;\n  font-weight: 600;\n  background: rgb(var(--color-primary-none, 89, 96, 109));\n  border-radius: 0;\n}\n.ant-picker-dropdown .ant-picker-content .ant-picker-time-panel-column li.ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner:hover {\n  background: rgba(var(--color-primary-none, 89, 96, 109), 0.9);\n}\n.mobile-view-only .ant-picker-panel .ant-picker-header-next-btn,\n.mobile-view-only .ant-picker-panel .ant-picker-header-super-next-btn {\n  visibility: visible !important;\n}\n.mobile-view-only .ant-picker-panel:nth-child(2) {\n  display: none;\n}\n.ant-divider.ant-divider-horizontal {\n  border-color: #c9d1df;\n}\n.ant-divider.ant-divider-horizontal.ant-divider-with-text {\n  font-weight: 600;\n  border-color: #c9d1df;\n}\n.ant-divider.divider-hidden-left.ant-divider-horizontal.ant-divider-with-text::before {\n  border: none;\n}\n.ant-divider.divider-hidden-right.ant-divider-horizontal.ant-divider-with-text::after {\n  border: none;\n}\na.ant-dropdown-trigger {\n  display: inline-flex;\n  align-items: center;\n  font-weight: 600;\n}\na.ant-dropdown-trigger svg {\n  color: #59606d;\n  width: 20px;\n  height: 20px;\n  margin-inline-start: 6px;\n}\n.ant-dropdown .ant-dropdown-menu {\n  padding: 6px;\n  color: #59606d;\n  background-color: #fff;\n  border-radius: 10px;\n  box-shadow: 0px 4px 16px rgba(52, 56, 63, 0.16);\n}\n.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item,\n.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-submenu {\n  padding: 6px 10px;\n  font-size: 14px;\n  line-height: 20px;\n  color: #59606d;\n  border-radius: 6px;\n}\n.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item:hover,\n.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-submenu:hover {\n  background-color: #f5f7fa;\n}\n.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item.ant-dropdown-menu-item-disabled,\n.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-submenu.ant-dropdown-menu-item-disabled {\n  color: #b1baca;\n}\n.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item.ant-dropdown-menu-item-disabled:hover,\n.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-submenu.ant-dropdown-menu-item-disabled:hover {\n  background-color: transparent;\n}\n.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item.ant-dropdown-menu-item-danger:not(.ant-dropdown-menu-item.disabled),\n.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-submenu.ant-dropdown-menu-item-danger:not(.ant-dropdown-menu-item.disabled) {\n  color: #de1b1b;\n}\n.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item.ant-dropdown-menu-item-danger:not(.ant-dropdown-menu-item.disabled):hover,\n.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-submenu.ant-dropdown-menu-item-danger:not(.ant-dropdown-menu-item.disabled):hover {\n  color: #fff;\n  background-color: #de1b1b;\n}\n.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item svg.ant-dropdown-menu-item-icon,\n.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-submenu svg.ant-dropdown-menu-item-icon {\n  width: 20px;\n  height: 20px;\n}\n.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-submenu .ant-dropdown-menu-submenu-title {\n  padding: 0;\n  color: #59606d;\n}\n.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-submenu .ant-dropdown-menu-submenu-title:hover {\n  background-color: #f5f7fa;\n}\n.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-submenu .ant-dropdown-menu-submenu-title svg.ant-dropdown-menu-submenu-expand-icon {\n  width: 20px;\n  height: 20px;\n}\n.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-submenu .ant-dropdown-menu-sub .ant-dropdown-menu-item {\n  color: #59606d;\n}\n.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-submenu .ant-dropdown-menu-sub .ant-dropdown-menu-item .ant-dropdown-menu-title-content {\n  color: #59606d;\n}\n.ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item-divider {\n  background-color: #c9d1df;\n}\n.ant-dropdown-menu-submenu .ant-dropdown-menu-sub .ant-dropdown-menu-item {\n  color: #59606d;\n}\n.ant-dropdown-menu-submenu .ant-dropdown-menu-sub .ant-dropdown-menu-item:hover {\n  background-color: #f5f7fa;\n}\n.ant-dropdown-menu-submenu .ant-dropdown-menu-sub .ant-dropdown-menu-item .ant-dropdown-menu-title-content {\n  color: #59606d;\n}\n.ant-dropdown-menu-submenu-open {\n  background-color: #f5f7fa;\n}\n.ant-dropdown-menu.ant-dropdown-menu-sub.ant-dropdown-menu-vertical {\n  position: relative;\n  left: 12px;\n  top: -8px;\n}\n.ant-dropdown-large,\n.submenu-item-large {\n  font-size: 16px;\n  line-height: 24px;\n}\n.ant-dropdown-large .ant-dropdown-menu,\n.submenu-item-large .ant-dropdown-menu {\n  padding: 8px;\n}\n.ant-dropdown-large .ant-dropdown-menu .ant-dropdown-menu-item,\n.submenu-item-large .ant-dropdown-menu .ant-dropdown-menu-item,\n.ant-dropdown-large .ant-dropdown-menu .ant-dropdown-menu-submenu .ant-dropdown-menu-submenu-title,\n.submenu-item-large .ant-dropdown-menu .ant-dropdown-menu-submenu .ant-dropdown-menu-submenu-title {\n  font-size: 16px;\n  line-height: 24px;\n}\n.ant-dropdown-large.ant-dropdown-trigger svg,\n.submenu-item-large.ant-dropdown-trigger svg {\n  width: 24px;\n  height: 24px;\n}\n.ant-dropdown-small,\n.submenu-item-small {\n  font-size: 12px;\n  line-height: 16px;\n}\n.ant-dropdown-small .ant-dropdown-menu,\n.submenu-item-small .ant-dropdown-menu {\n  padding: 4px;\n}\n.ant-dropdown-small .ant-dropdown-menu .ant-dropdown-menu-item,\n.submenu-item-small .ant-dropdown-menu .ant-dropdown-menu-item,\n.ant-dropdown-small .ant-dropdown-menu .ant-dropdown-menu-submenu .ant-dropdown-menu-submenu-title,\n.submenu-item-small .ant-dropdown-menu .ant-dropdown-menu-submenu .ant-dropdown-menu-submenu-title {\n  font-size: 12px;\n  line-height: 16px;\n}\n.ant-dropdown-small.ant-dropdown-trigger svg,\n.submenu-item-small.ant-dropdown-trigger svg {\n  width: 16px;\n  height: 16px;\n}\n.no-arrow {\n  margin: 6px 0;\n}\n.ant-dropdown-button .ant-btn-default.ant-btn-compact-item.ant-btn-compact-first-item {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.ant-dropdown-button .ant-btn-default.ant-btn-compact-item.ant-btn-compact-last-item {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.ant-drawer.ant-drawer-open .ant-drawer-mask {\n  background: rgba(201, 209, 223, 0.8);\n}\n.ant-drawer .ant-drawer-mask {\n  background: rgba(201, 209, 223, 0.8);\n}\ninput,\n.ant-input,\n.ant-input-affix-wrapper {\n  color: #000;\n  font-weight: normal;\n  padding: 8px 10px;\n  height: 36px;\n  font-family: var(--body-font-family-none, Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, color emoji, segoe ui emoji, noto color emoji, android emoji);\n  font-size: 14px;\n  line-height: 20px;\n  border: 1px #c9d1df solid;\n}\ninput:placeholder-shown,\n.ant-input:placeholder-shown,\n.ant-input-affix-wrapper:placeholder-shown {\n  color: #c9d1df;\n}\ninput::placeholder,\n.ant-input::placeholder,\n.ant-input-affix-wrapper::placeholder {\n  color: #c9d1df;\n}\ninput.ant-input-lg,\n.ant-input.ant-input-lg,\n.ant-input-affix-wrapper.ant-input-lg {\n  padding: 10px 12px;\n  height: 44px;\n  font-size: 16px;\n  line-height: 24px;\n}\ninput.ant-input-sm,\n.ant-input.ant-input-sm,\n.ant-input-affix-wrapper.ant-input-sm {\n  padding: 5px 8px;\n  height: 26px;\n  font-size: 12px;\n  line-height: 16px;\n}\ninput:hover,\n.ant-input:hover,\n.ant-input-affix-wrapper:hover,\ninput:not(.ant-input-affix-wrapper-disabled):hover,\n.ant-input:not(.ant-input-affix-wrapper-disabled):hover,\n.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {\n  border-color: #9099a9;\n}\ninput:focus,\n.ant-input:focus,\n.ant-input-affix-wrapper:focus,\ninput.ant-input-affix-wrapper-focused,\n.ant-input.ant-input-affix-wrapper-focused,\n.ant-input-affix-wrapper.ant-input-affix-wrapper-focused {\n  border-color: #9099a9;\n  box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);\n}\ninput.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless),\n.ant-input.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless),\n.ant-input-affix-wrapper.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless),\ninput.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless),\n.ant-input.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless),\n.ant-input-affix-wrapper.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless) {\n  border-color: #de1b1b;\n}\ninput.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless):hover,\n.ant-input.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless):hover,\n.ant-input-affix-wrapper.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless):hover,\ninput.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless):hover,\n.ant-input.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless):hover,\n.ant-input-affix-wrapper.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless):hover {\n  border-color: #f55353;\n}\ninput.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless):focus,\n.ant-input.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless):focus,\n.ant-input-affix-wrapper.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless):focus,\ninput.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless):focus,\n.ant-input.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless):focus,\n.ant-input-affix-wrapper.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless):focus,\ninput.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input-affix-wrapper-focused,\n.ant-input.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input-affix-wrapper-focused,\n.ant-input-affix-wrapper.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input-affix-wrapper-focused,\ninput.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper-focused,\n.ant-input.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper-focused,\n.ant-input-affix-wrapper.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper-focused {\n  border-color: #f55353;\n  box-shadow: 0 0 4px 0 rgba(222, 27, 27, 0.5);\n}\ninput.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless),\n.ant-input.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless),\n.ant-input-affix-wrapper.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless),\ninput.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless),\n.ant-input.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless),\n.ant-input-affix-wrapper.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless) {\n  border-color: #fcc419;\n}\ninput.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless):hover,\n.ant-input.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless):hover,\n.ant-input-affix-wrapper.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless):hover,\ninput.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless):hover,\n.ant-input.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless):hover,\n.ant-input-affix-wrapper.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless):hover {\n  border-color: #ffd43b;\n}\ninput.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless):focus,\n.ant-input.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless):focus,\n.ant-input-affix-wrapper.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless):focus,\ninput.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless):focus,\n.ant-input.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless):focus,\n.ant-input-affix-wrapper.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless):focus,\ninput.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless).ant-input-affix-wrapper-focused,\n.ant-input.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless).ant-input-affix-wrapper-focused,\n.ant-input-affix-wrapper.ant-input-status-warning:not(.ant-input-disabled):not(.ant-input-borderless).ant-input-affix-wrapper-focused,\ninput.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper-focused,\n.ant-input.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper-focused,\n.ant-input-affix-wrapper.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper-focused {\n  border-color: #ffd43b;\n  box-shadow: 0 0 4px 0 rgba(255, 212, 59, 0.75);\n}\n.ant-input-affix-wrapper input.ant-input {\n  height: 20px;\n  font-size: 14px;\n  line-height: 20px;\n}\n.ant-input-affix-wrapper .ant-input-prefix,\n.ant-input-affix-wrapper .ant-input-suffix {\n  color: #59606d;\n}\n.ant-input-affix-wrapper .ant-input-prefix .ant-input-clear-icon,\n.ant-input-affix-wrapper .ant-input-suffix .ant-input-clear-icon,\n.ant-input-affix-wrapper .ant-input-prefix .ant-input-password-icon,\n.ant-input-affix-wrapper .ant-input-suffix .ant-input-password-icon {\n  color: #b1baca;\n  display: flex;\n  align-items: center;\n}\n.ant-input-affix-wrapper .ant-input-prefix .ant-input-clear-icon:hover,\n.ant-input-affix-wrapper .ant-input-suffix .ant-input-clear-icon:hover,\n.ant-input-affix-wrapper .ant-input-prefix .ant-input-password-icon:hover,\n.ant-input-affix-wrapper .ant-input-suffix .ant-input-password-icon:hover {\n  color: #59606d;\n}\n.ant-input-affix-wrapper .ant-input-prefix .ant-btn.ant-input-search-icon,\n.ant-input-affix-wrapper .ant-input-suffix .ant-btn.ant-input-search-icon {\n  min-width: 20px;\n  width: 20px;\n  background: none;\n  border: none;\n}\n.ant-input-affix-wrapper .ant-input-prefix .ant-btn.ant-input-search-icon:focus,\n.ant-input-affix-wrapper .ant-input-suffix .ant-btn.ant-input-search-icon:focus,\n.ant-input-affix-wrapper .ant-input-prefix .ant-btn.ant-input-search-icon:focus-visible,\n.ant-input-affix-wrapper .ant-input-suffix .ant-btn.ant-input-search-icon:focus-visible {\n  box-shadow: none;\n  -webkit-box-shadow: none;\n}\n.ant-input-affix-wrapper .ant-input-prefix svg,\n.ant-input-affix-wrapper .ant-input-suffix svg {\n  width: 20px;\n  height: 20px;\n}\n.ant-input-affix-wrapper .ant-input-prefix {\n  margin-inline-end: 10px;\n  margin-top: 1px;\n}\n.ant-input-affix-wrapper .ant-input-prefix:has(svg) {\n  margin-inline-end: 4px;\n}\n.ant-input-affix-wrapper .ant-input-prefix .ant-btn.ant-input-search-icon {\n  margin-inline-end: 6px;\n}\n.ant-input-affix-wrapper .ant-input-suffix {\n  margin-inline-start: 10px;\n  margin-top: 2px;\n}\n.ant-input-affix-wrapper .ant-input-suffix:has(svg) {\n  margin-inline-start: 4px;\n}\n.ant-input-affix-wrapper .ant-input-suffix .ant-btn.ant-input-search-icon {\n  margin-inline-start: 6px;\n}\n.ant-input-affix-wrapper.ant-input-affix-wrapper-lg {\n  padding: 10px 12px;\n  height: 44px;\n}\n.ant-input-affix-wrapper.ant-input-affix-wrapper-lg input.ant-input {\n  height: 24px;\n  font-size: 16px;\n  line-height: 24px;\n}\n.ant-input-affix-wrapper.ant-input-affix-wrapper-lg .ant-input-prefix,\n.ant-input-affix-wrapper.ant-input-affix-wrapper-lg .ant-input-suffix {\n  font-size: 16px;\n}\n.ant-input-affix-wrapper.ant-input-affix-wrapper-lg .ant-input-prefix svg,\n.ant-input-affix-wrapper.ant-input-affix-wrapper-lg .ant-input-suffix svg {\n  width: 24px;\n  height: 24px;\n}\n.ant-input-affix-wrapper.ant-input-affix-wrapper-lg.ant-input-search .ant-input-prefix button {\n  margin-left: -13px;\n  padding: 10px 20px 10px 20px;\n}\n.ant-input-affix-wrapper.ant-input-affix-wrapper-lg.ant-input-search .ant-input-suffix button {\n  margin-right: -13px;\n}\n.ant-input-affix-wrapper.ant-input-affix-wrapper-sm {\n  padding: 5px 8px;\n  height: 26px;\n}\n.ant-input-affix-wrapper.ant-input-affix-wrapper-sm input.ant-input {\n  height: 16px;\n  font-size: 12px;\n  line-height: 16px;\n}\n.ant-input-affix-wrapper.ant-input-affix-wrapper-sm .ant-input-prefix,\n.ant-input-affix-wrapper.ant-input-affix-wrapper-sm .ant-input-suffix {\n  font-size: 12px;\n}\n.ant-input-affix-wrapper.ant-input-affix-wrapper-sm .ant-input-prefix svg,\n.ant-input-affix-wrapper.ant-input-affix-wrapper-sm .ant-input-suffix svg {\n  width: 16px;\n  height: 16px;\n}\n.ant-input-affix-wrapper .anticon.ant-input-password-icon {\n  color: #59606d;\n}\n.ant-input-affix-wrapper.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled) .ant-input-suffix > svg {\n  color: #59606d;\n}\n.ant-input-affix-wrapper.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled) .ant-input-suffix > svg:last-of-type {\n  color: #de1b1b;\n}\n.ant-input-affix-wrapper.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled) .ant-input-suffix > svg {\n  color: #59606d;\n}\n.ant-input-affix-wrapper.ant-input-affix-wrapper-status-warning:not(.ant-input-affix-wrapper-disabled) .ant-input-suffix > svg:last-of-type {\n  color: #fcc419;\n}\n.ant-input-disabled,\n.ant-input[disabled],\n.ant-input-affix-wrapper.ant-input-affix-wrapper-disabled {\n  color: #b1baca;\n  background-color: #f5f7fa;\n  border-color: #c9d1df;\n}\n.ant-input-disabled:hover,\n.ant-input[disabled]:hover,\n.ant-input-affix-wrapper.ant-input-affix-wrapper-disabled:hover {\n  border-color: #c9d1df;\n}\n.ant-input-disabled .ant-input-prefix,\n.ant-input[disabled] .ant-input-prefix,\n.ant-input-affix-wrapper.ant-input-affix-wrapper-disabled .ant-input-prefix,\n.ant-input-disabled .ant-input-suffix,\n.ant-input[disabled] .ant-input-suffix,\n.ant-input-affix-wrapper.ant-input-affix-wrapper-disabled .ant-input-suffix {\n  color: #c9d1df;\n}\n.ant-input-disabled .ant-input-prefix svg,\n.ant-input[disabled] .ant-input-prefix svg,\n.ant-input-affix-wrapper.ant-input-affix-wrapper-disabled .ant-input-prefix svg,\n.ant-input-disabled .ant-input-suffix svg,\n.ant-input[disabled] .ant-input-suffix svg,\n.ant-input-affix-wrapper.ant-input-affix-wrapper-disabled .ant-input-suffix svg {\n  color: #b1baca;\n}\n.ant-input-group-wrapper {\n  font-family: var(--body-font-family-none, Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, color emoji, segoe ui emoji, noto color emoji, android emoji);\n}\n.ant-input-group-wrapper .ant-input-group {\n  color: #000;\n}\n.ant-input-group-wrapper .ant-input-group .ant-input-group-addon {\n  color: #59606d;\n  padding: 0 11px;\n  font-size: 14px;\n  line-height: 0;\n  background-color: #eceff4;\n  border-color: #c9d1df;\n}\n.ant-input-group-wrapper .ant-input-group .ant-input-group-addon svg {\n  width: 20px;\n  height: 20px;\n}\n.ant-input-group-wrapper .ant-input-group .ant-input-group-addon .ant-btn {\n  width: auto;\n  height: auto;\n  padding: 8px 16px;\n  font-size: 14px;\n  line-height: 20px;\n  border: none;\n  border-start-start-radius: 0;\n  border-end-start-radius: 0;\n  box-shadow: none;\n}\n.ant-input-group-wrapper .ant-input-group .ant-input-group-addon .ant-btn svg {\n  width: 20px;\n  height: 20px;\n}\n.ant-input-group-wrapper .ant-input-group .ant-input-group-addon .ant-btn.ant-btn-lg {\n  padding: 10px 20px;\n  font-size: 16px;\n  line-height: 24px;\n  border-radius: 8px;\n  border-start-start-radius: 0;\n  border-end-start-radius: 0;\n}\n.ant-input-group-wrapper .ant-input-group .ant-input-group-addon .ant-btn.ant-btn-lg svg {\n  width: 24px;\n  height: 24px;\n}\n.ant-input-group-wrapper .ant-input-group .ant-input-group-addon .ant-btn.ant-btn-sm {\n  padding: 5px 12px;\n  font-size: 12px;\n  line-height: 16px;\n  border-radius: 4px;\n  border-start-start-radius: 0;\n  border-end-start-radius: 0;\n}\n.ant-input-group-wrapper .ant-input-group .ant-input-group-addon .ant-btn.ant-btn-sm svg {\n  width: 16px;\n  height: 16px;\n}\n.ant-input-group-wrapper.ant-input-group-wrapper-disabled .ant-input-group-addon {\n  background-color: #f5f7fa;\n  color: #b1baca;\n}\n.ant-input-group-wrapper.ant-input-group-wrapper-lg .ant-input-group-addon {\n  font-size: 16px;\n}\n.ant-input-group-wrapper.ant-input-group-wrapper-lg .ant-input-group-addon svg {\n  width: 24px;\n  height: 24px;\n}\n.ant-input-group-wrapper.ant-input-group-wrapper-sm .ant-input-group-addon {\n  font-size: 12px;\n}\n.ant-input-group-wrapper.ant-input-group-wrapper-sm .ant-input-group-addon svg {\n  width: 16px;\n  height: 16px;\n}\n.origami-input-number {\n  border: 1px solid #c9d1df;\n  display: flex;\n  justify-content: space-between;\n  width: 320px;\n  height: 36px;\n  border-radius: 6px;\n  font-family: var(--body-font-family-none, Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, color emoji, segoe ui emoji, noto color emoji, android emoji);\n}\n.origami-input-number .ant-input-number {\n  border-radius: 0px;\n  border: none;\n  border-left: none;\n  border-right: none;\n  width: 100%;\n}\n.origami-input-number .ant-input-number:focus {\n  box-shadow: none;\n}\n.origami-input-number .ant-input-number:focus-within {\n  box-shadow: none;\n}\n.origami-input-number .ant-input-number .ant-input-number-input-wrap {\n  height: 100%;\n}\n.origami-input-number .ant-input-number .ant-input-number-input-wrap:focus {\n  box-shadow: none;\n}\n.origami-input-number .ant-input-number .ant-input-number-input-wrap input {\n  height: 100%;\n  text-align: center;\n  border: none;\n  color: black;\n  font-family: var(--body-font-family-none, Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, color emoji, segoe ui emoji, noto color emoji, android emoji);\n  font-size: 14px;\n  font-weight: 400;\n}\n.origami-input-number .ant-input-number .ant-input-number-input-wrap input:focus {\n  box-shadow: none;\n}\n.origami-input-number .ant-input-number .ant-input-number-input-wrap input::placeholder {\n  color: #c9d1df;\n}\n.origami-input-number .ant-input-number.ant-input-number-disabled input {\n  color: #b1baca;\n}\n.origami-input-number .ant-btn-square {\n  border-radius: 0px 8px 8px 0px;\n}\n.origami-input-number .add-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled),\n.origami-input-number .ant-btn.ant-btn.ant-btn-dashed:not(:disabled),\n.origami-input-number .ant-btn.ant-btn.ant-btn-text:not(:disabled) {\n  height: 100%;\n  border: none;\n  border-left: 1px solid #c9d1df;\n  border-radius: 0px 6px 6px 0px;\n}\n.origami-input-number .add-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled):focus,\n.origami-input-number .ant-btn.ant-btn.ant-btn-dashed:not(:disabled):focus,\n.origami-input-number .ant-btn.ant-btn.ant-btn-text:not(:disabled):focus {\n  box-shadow: none;\n}\n.origami-input-number .subtract-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled),\n.origami-input-number .ant-btn.ant-btn.ant-btn-dashed:not(:disabled),\n.ant-btn.ant-btn.ant-btn-text:not(:disabled) .origami-input-number.ant-btn-square {\n  height: 100%;\n  border: none;\n  border-right: 1px solid #c9d1df;\n  border-radius: 6px 0px 0px 6px;\n}\n.origami-input-number .subtract-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled):focus,\n.origami-input-number .ant-btn.ant-btn.ant-btn-dashed:not(:disabled):focus,\n.ant-btn.ant-btn.ant-btn-text:not(:disabled) .origami-input-number.ant-btn-square:focus {\n  box-shadow: none;\n}\n.origami-input-number.origami-input-number-large {\n  height: 44px;\n  border-radius: 8px;\n}\n.origami-input-number.origami-input-number-large .add-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled),\n.origami-input-number.origami-input-number-large .ant-btn.ant-btn.ant-btn-dashed:not(:disabled),\n.origami-input-number.origami-input-number-large .ant-btn.ant-btn.ant-btn-text:not(:disabled),\n.origami-input-number.origami-input-number-large .ant-btn-square {\n  border-radius: 0px 8px 8px 0px;\n}\n.origami-input-number.origami-input-number-large .subtract-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled),\n.origami-input-number.origami-input-number-large .ant-btn.ant-btn.ant-btn-dashed:not(:disabled),\n.origami-input-number.origami-input-number-large .ant-btn.ant-btn.ant-btn-text:not(:disabled) {\n  border-radius: 8px 0px 0px 8px;\n}\n.origami-input-number.origami-input-number-large .ant-input-number .ant-input-number-input-wrap input {\n  font-size: 16px;\n}\n.origami-input-number.origami-input-number-small {\n  border-radius: 4px;\n  height: 26px;\n}\n.origami-input-number.origami-input-number-small .add-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled),\n.origami-input-number.origami-input-number-small .ant-btn.ant-btn.ant-btn-dashed:not(:disabled),\n.origami-input-number.origami-input-number-small .ant-btn.ant-btn.ant-btn-text:not(:disabled) {\n  border-radius: 0px 4px 4px 0px;\n}\n.origami-input-number.origami-input-number-small .subtract-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled),\n.origami-input-number.origami-input-number-small .ant-btn.ant-btn.ant-btn-dashed:not(:disabled),\n.origami-input-number.origami-input-number-small .ant-btn.ant-btn.ant-btn-text:not(:disabled) {\n  border-radius: 4px 0px 0px 4px;\n}\n.origami-input-number.origami-input-number-small .ant-input-number .ant-input-number-input-wrap input {\n  font-size: 12px;\n}\n.origami-input-number.origami-input-number-disabled {\n  border-color: #c9d1df;\n}\n.origami-input-number.origami-input-number-disabled .ant-input-number,\n.origami-input-number.origami-input-number-disabled :hover {\n  background-color: #f5f7fa;\n}\n.origami-input-number.origami-input-number-disabled .add-btn.ant-btn.ant-btn.ant-btn-default,\n.origami-input-number.origami-input-number-disabled .ant-btn.ant-btn.ant-btn-dashed,\n.origami-input-number.origami-input-number-disabled .ant-btn.ant-btn.ant-btn-text {\n  height: 100%;\n  border: none;\n  border-left: 1px solid #c9d1df;\n  border-radius: 0px 8px 8px 0px;\n}\n.origami-input-number.origami-input-number-disabled .subtract-btn.ant-btn.ant-btn.ant-btn-default,\n.origami-input-number.origami-input-number-disabled .ant-btn.ant-btn.ant-btn-dashed,\n.origami-input-number.origami-input-number-disabled .ant-btn.ant-btn.ant-btn-text {\n  height: 100%;\n  border: none;\n  border-right: 1px solid #c9d1df;\n  border-radius: 8px 0px 0px 8px;\n}\n.origami-input-number.origami-input-number-disabled:hover {\n  border-color: #c9d1df;\n}\n.origami-input-number.origami-input-number-error {\n  border: 1px solid #de1b1b;\n}\n.origami-input-number.origami-input-number-error .ant-input-number-group-wrapper {\n  height: 100%;\n  width: 100%;\n}\n.origami-input-number.origami-input-number-error .ant-input-number-group-wrapper .ant-input-number-wrapper {\n  height: 100%;\n}\n.origami-input-number.origami-input-number-error .ant-input-number-group-wrapper .ant-input-number-wrapper .ant-input-number-group-addon {\n  height: 100%;\n  background-color: #ffffff;\n  border: none;\n  border-radius: 0px;\n}\n.origami-input-number.origami-input-number-error .ant-input-number-group-wrapper .ant-input-number-wrapper .ant-input-number-group-addon svg {\n  margin-top: 4px;\n  color: #de1b1b;\n  height: 20px;\n  width: 20px;\n}\n.origami-input-number.origami-input-number-error.origami-input-number-large .ant-input-number-input-wrap input {\n  font-size: 16px;\n}\n.origami-input-number.origami-input-number-error.origami-input-number-large .ant-input-number-group-wrapper .ant-input-number-wrapper .ant-input-number-group-addon svg {\n  height: 24px;\n  width: 24px;\n}\n.origami-input-number.origami-input-number-error.origami-input-number-small .ant-input-number-input-wrap input {\n  font-size: 12px;\n}\n.origami-input-number.origami-input-number-error.origami-input-number-small .ant-input-number-group-wrapper .ant-input-number-wrapper .ant-input-number .ant-input-number-input-wrap input {\n  padding: 0px 11px;\n  font-size: 12px;\n}\n.origami-input-number.origami-input-number-error.origami-input-number-small .ant-input-number-group-wrapper .ant-input-number-wrapper .ant-input-number-group-addon svg {\n  margin-top: 3px;\n  height: 16px;\n  width: 16px;\n}\n.origami-input-number.origami-input-number-error .add-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled),\n.origami-input-number.origami-input-number-error .ant-btn.ant-btn.ant-btn-dashed:not(:disabled),\n.origami-input-number.origami-input-number-error .ant-btn.ant-btn.ant-btn-text:not(:disabled) {\n  border-color: #de1b1b;\n}\n.origami-input-number.origami-input-number-error .subtract-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled),\n.origami-input-number.origami-input-number-error .ant-btn.ant-btn.ant-btn-dashed:not(:disabled),\n.origami-input-number.origami-input-number-error .ant-btn.ant-btn.ant-btn-text:not(:disabled) {\n  border-color: #de1b1b;\n}\n.origami-input-number.origami-input-number-error:hover {\n  border-color: #de1b1b;\n}\n.origami-input-number.origami-input-number-error:hover .add-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled),\n.origami-input-number.origami-input-number-error:hover .ant-btn.ant-btn.ant-btn-dashed:not(:disabled),\n.origami-input-number.origami-input-number-error:hover .ant-btn.ant-btn.ant-btn-text:not(:disabled) {\n  border-color: #de1b1b;\n}\n.origami-input-number.origami-input-number-error:hover .subtract-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled),\n.origami-input-number.origami-input-number-error:hover .ant-btn.ant-btn.ant-btn-dashed:not(:disabled),\n.origami-input-number.origami-input-number-error:hover .ant-btn.ant-btn.ant-btn-text:not(:disabled) {\n  border-color: #de1b1b;\n}\n.origami-input-number.origami-input-number-error:focus {\n  box-shadow: 0px 0px 4px 0px #de1b1b;\n}\n.origami-input-number.origami-input-number-error:focus-within {\n  box-shadow: 0px 0px 4px 0px #de1b1b;\n}\n.origami-input-number:hover {\n  border-color: #9099a9;\n}\n.origami-input-number:hover .add-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled),\n.origami-input-number:hover .ant-btn.ant-btn.ant-btn-dashed:not(:disabled),\n.origami-input-number:hover .ant-btn.ant-btn.ant-btn-text:not(:disabled) {\n  border-color: #9099a9;\n}\n.origami-input-number:hover .subtract-btn.ant-btn.ant-btn.ant-btn-default:not(:disabled),\n.origami-input-number:hover .ant-btn.ant-btn.ant-btn-dashed:not(:disabled),\n.origami-input-number:hover .ant-btn.ant-btn.ant-btn-text:not(:disabled) {\n  border-color: #9099a9;\n}\n.origami-input-number:focus {\n  box-shadow: 0px 0px 4px 0px #3272D9BF;\n}\n.origami-input-number:focus-within {\n  box-shadow: 0px 0px 4px 0px #3272D9BF;\n}\n.ant-radio-wrapper {\n  color: #000;\n  margin-inline-end: 12px;\n  display: flex;\n}\n.ant-radio-wrapper .ant-radio {\n  align-self: flex-start;\n  margin-top: 2px;\n}\n.ant-radio-wrapper .ant-radio .ant-radio-inner {\n  border-color: #b1baca;\n  align-self: flex-start;\n}\n.ant-radio-wrapper .ant-radio:hover .ant-radio-inner {\n  border-color: #9099a9;\n}\n.ant-radio-wrapper input[type='radio']:focus,\n.ant-radio-wrapper .ant-radio-input:focus,\n.ant-radio-wrapper input[type='radio']:focus-visible + .ant-radio-inner,\n.ant-radio-wrapper .ant-radio-input:focus-visible + .ant-radio-inner {\n  outline: none;\n  box-shadow: none;\n  -webkit-box-shadow: none;\n}\n.ant-radio-wrapper .ant-radio-checked .ant-radio-inner {\n  border-color: rgb(var(--color-primary-none, 89, 96, 109));\n  background-color: #fff;\n}\n.ant-radio-wrapper .ant-radio-checked .ant-radio-inner::after {\n  width: 20px;\n  height: 20px;\n  margin-block-start: -10px;\n  margin-inline-start: -10px;\n  background-color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-radio-wrapper .ant-radio-checked::after {\n  border-color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);\n}\n.ant-radio-wrapper.origami-radio-error .ant-radio-inner {\n  border-color: #de1b1b;\n}\n.ant-radio-wrapper.origami-radio-error:hover .ant-radio-inner {\n  border-color: #f55353;\n}\n.ant-radio-wrapper.origami-radio-error .ant-radio-checked .ant-radio-inner {\n  border-color: #de1b1b;\n  background-color: #fff;\n}\n.ant-radio-wrapper.origami-radio-error .ant-radio-checked .ant-radio-inner::after {\n  width: 20px;\n  height: 20px;\n  margin-block-start: -10px;\n  margin-inline-start: -10px;\n  background-color: #de1b1b;\n}\n.ant-radio-wrapper.origami-radio-error .ant-radio-checked::after {\n  border-color: #f55353;\n}\n.ant-radio-wrapper.ant-radio-wrapper-disabled {\n  color: #b1baca;\n}\n.ant-radio-wrapper.ant-radio-wrapper-disabled:active {\n  box-shadow: none;\n}\n.ant-radio-wrapper.ant-radio-wrapper-disabled .ant-radio-disabled .ant-radio-inner {\n  background-color: #f5f7fa;\n  border-color: #c9d1df;\n}\n.ant-radio-wrapper.ant-radio-wrapper-disabled .ant-radio-disabled .ant-radio-inner::after {\n  background-color: #c9d1df;\n}\n.ant-radio-wrapper.ant-radio-wrapper-disabled .ant-radio-disabled.ant-radio-checked .ant-radio-inner::after {\n  transform: scale(0.375);\n}\n.ant-radio-wrapper.large {\n  font-size: 16px;\n}\n.ant-radio-wrapper.large .ant-radio-inner {\n  height: 24px;\n  width: 24px;\n}\n.ant-radio-wrapper.large .ant-radio-inner::after {\n  height: 37px;\n  width: 37px;\n  margin-block-start: -18.5px;\n  margin-inline-start: -18.5px;\n  border-radius: 50%;\n}\n/* === Styles for custom Radio.Button and Radio.Card components === */\n.origami-radio-group,\n.origami-radio-group-button,\n.origami-radio-group-card {\n  display: inline-flex;\n  width: 100%;\n  color: #000;\n}\n.origami-radio-group .tall .ant-radio-button-wrapper,\n.origami-radio-group-button .tall .ant-radio-button-wrapper,\n.origami-radio-group-card .tall .ant-radio-button-wrapper {\n  min-height: 74px;\n}\n.origami-radio-group .ant-radio-button-wrapper,\n.origami-radio-group-button .ant-radio-button-wrapper,\n.origami-radio-group-card .ant-radio-button-wrapper {\n  display: inline-flex;\n  justify-content: center;\n  flex: 1 0 auto;\n  height: auto;\n  min-height: 52px;\n  margin-inline-end: 12px;\n  padding-inline: 14px;\n  padding-block: 14px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  border-block: unset;\n  border-inline: unset;\n  border: 1px solid #c9d1df;\n  border-radius: 12px;\n}\n.origami-radio-group .ant-radio-button-wrapper span:not([class^='origami-radio-']):last-child,\n.origami-radio-group-button .ant-radio-button-wrapper span:not([class^='origami-radio-']):last-child,\n.origami-radio-group-card .ant-radio-button-wrapper span:not([class^='origami-radio-']):last-child {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.origami-radio-group .ant-radio-button-wrapper span:not([class^='origami-radio-']):last-child .origami-radio-button-description,\n.origami-radio-group-button .ant-radio-button-wrapper span:not([class^='origami-radio-']):last-child .origami-radio-button-description,\n.origami-radio-group-card .ant-radio-button-wrapper span:not([class^='origami-radio-']):last-child .origami-radio-button-description {\n  color: #59606d;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n}\n.origami-radio-group .ant-radio-button-wrapper:not(.ant-radio-button-wrapper-disabled):hover,\n.origami-radio-group-button .ant-radio-button-wrapper:not(.ant-radio-button-wrapper-disabled):hover,\n.origami-radio-group-card .ant-radio-button-wrapper:not(.ant-radio-button-wrapper-disabled):hover {\n  color: #000;\n  border-color: #9099a9;\n}\n.origami-radio-group .ant-radio-button-wrapper:has(:focus-visible),\n.origami-radio-group-button .ant-radio-button-wrapper:has(:focus-visible),\n.origami-radio-group-card .ant-radio-button-wrapper:has(:focus-visible) {\n  border-color: rgb(var(--color-primary-none, 89, 96, 109));\n  outline: none;\n  box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);\n  -webkit-box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);\n}\n.origami-radio-group .ant-radio-button-wrapper::before,\n.origami-radio-group-button .ant-radio-button-wrapper::before,\n.origami-radio-group-card .ant-radio-button-wrapper::before {\n  display: none;\n}\n.origami-radio-group .ant-radio-button-wrapper.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled),\n.origami-radio-group-button .ant-radio-button-wrapper.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled),\n.origami-radio-group-card .ant-radio-button-wrapper.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n  color: #000;\n  border-color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.origami-radio-group .ant-radio-button-wrapper.ant-radio-button-wrapper-disabled,\n.origami-radio-group-button .ant-radio-button-wrapper.ant-radio-button-wrapper-disabled,\n.origami-radio-group-card .ant-radio-button-wrapper.ant-radio-button-wrapper-disabled {\n  color: #b1baca;\n  background-color: #f5f7fa;\n}\n.origami-radio-group .ant-radio-button-wrapper.ant-radio-button-wrapper-disabled span:last-child .origami-radio-lock-icon,\n.origami-radio-group-button .ant-radio-button-wrapper.ant-radio-button-wrapper-disabled span:last-child .origami-radio-lock-icon,\n.origami-radio-group-card .ant-radio-button-wrapper.ant-radio-button-wrapper-disabled span:last-child .origami-radio-lock-icon,\n.origami-radio-group .ant-radio-button-wrapper.ant-radio-button-wrapper-disabled span:last-child .origami-radio-button-description,\n.origami-radio-group-button .ant-radio-button-wrapper.ant-radio-button-wrapper-disabled span:last-child .origami-radio-button-description,\n.origami-radio-group-card .ant-radio-button-wrapper.ant-radio-button-wrapper-disabled span:last-child .origami-radio-button-description {\n  color: #b1baca;\n}\n.origami-radio-lock-icon {\n  width: 24px;\n  height: 24px;\n  color: #59606d;\n}\n.tall .origami-radio-card-wrapper {\n  min-height: 74px;\n}\n.origami-radio-card-wrapper {\n  display: inline-flex;\n  justify-content: flex-start;\n  flex: 1 0 auto;\n  background-color: #fff;\n  padding-inline: 14px;\n  padding-block: 14px;\n  height: auto;\n  min-height: 52px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  border: 1px solid #c9d1df;\n  border-radius: 12px;\n  margin-inline-end: 0;\n  align-items: center;\n  /* === State styels === */\n}\n.origami-radio-card-wrapper.no-description.ant-radio-wrapper .ant-radio,\n.origami-radio-card-wrapper.no-description.ant-radio-wrapper .ant-checkbox {\n  margin-top: 2px;\n}\n.origami-radio-card-wrapper.ant-checkbox-wrapper .ant-checkbox {\n  align-self: center;\n}\n.origami-radio-card-wrapper.ant-checkbox-wrapper:not(.no-description) .ant-checkbox {\n  margin-top: 14px;\n}\n@media only screen and (max-width: 735px) {\n  .origami-radio-card-wrapper.ant-checkbox-wrapper:not(.no-description) .ant-checkbox {\n    margin-top: 12px;\n  }\n}\n.origami-radio-card-wrapper:not(.no-description) .ant-radio,\n.origami-radio-card-wrapper:not(.no-description) .ant-checkbox {\n  align-self: start;\n}\n.origami-radio-card-wrapper .ant-radio {\n  height: 24px;\n  align-self: center;\n}\n.origami-radio-card-wrapper .ant-radio .ant-radio-inner {\n  width: 24px;\n  height: 24px;\n}\n.origami-radio-card-wrapper:not(.reversed):not(.show-check-icon) span:not([class^='origami-radio-']):last-child {\n  padding-inline-start: 14px;\n}\n.origami-radio-card-wrapper:not(.reversed).show-check-icon .origami-radio-card-info-wrapper {\n  padding-left: 14px;\n}\n.origami-radio-card-wrapper:not(.reversed).show-check-icon span:not([class^='origami-radio-']):last-child {\n  padding-inline-start: 0;\n}\n.origami-radio-card-wrapper span:not([class^='origami-radio-']):last-child {\n  display: inline-flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex: auto;\n  padding-inline-end: 0;\n}\n.origami-radio-card-wrapper span:not([class^='origami-radio-']):last-child .origami-radio-card-description {\n  color: #59606d;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n}\n.origami-radio-card-wrapper .ant-radio-checked .ant-radio-inner {\n  border-color: rgb(var(--color-primary-none, 89, 96, 109));\n  background-color: #fff;\n}\n.origami-radio-card-wrapper .ant-radio-checked .ant-radio-inner::after {\n  width: 36px;\n  height: 36px;\n  margin-block-start: -18px;\n  margin-inline-start: -18px;\n  background-color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.origami-radio-card-wrapper:hover:not(.ant-checkbox-wrapper-disabled) {\n  border-color: #9099a9;\n}\n.origami-radio-card-wrapper:hover:not(.ant-checkbox-wrapper-disabled) .ant-radio-inner {\n  border-color: #b1baca;\n}\n.origami-radio-card-wrapper.ant-radio-wrapper-checked {\n  border-color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.origami-radio-card-wrapper.ant-radio-wrapper-disabled {\n  background-color: #f5f7fa;\n  border-color: #c9d1df;\n}\n.origami-radio-card-wrapper.ant-radio-wrapper-disabled:hover {\n  border-color: #c9d1df;\n}\n.origami-radio-card-wrapper.ant-radio-wrapper-disabled span:not([class^='origami-radio-']):last-child .origami-radio-card-description {\n  color: #b1baca;\n}\n.origami-radio-card-wrapper.ant-radio-wrapper-disabled span:not([class^='origami-radio-']):last-child .origami-radio-lock-icon {\n  color: #b1baca;\n}\n.ant-radio-wrapper.animation-container.collapsed:not(.ant-radio-wrapper-checked) {\n  position: relative;\n  top: -100px;\n}\n.origami-radio-card-wrapper.is-checkbox-variant:not(.reversed) .ant-checkbox {\n  padding-left: 8px;\n}\n.origami-radio-card-wrapper.is-checkbox-variant .ant-checkbox .ant-checkbox-input {\n  transform: scale(1.5);\n}\n.origami-radio-card-wrapper.is-checkbox-variant .ant-checkbox .ant-checkbox-inner {\n  transform: scale(1.5);\n}\n.origami-radio-card-wrapper.is-checkbox-variant .ant-checkbox .ant-checkbox-inner::after {\n  inset-inline-start: 20%;\n  top: 45%;\n  border-width: 1px;\n  width: 4.7px;\n}\n.origami-radio-card-wrapper.is-checkbox-variant.ant-checkbox-wrapper-disabled {\n  color: #b1baca;\n}\n.origami-radio-card-wrapper.is-checkbox-variant.ant-checkbox-wrapper-disabled .ant-checkbox-disabled .ant-checkbox-inner {\n  background-color: #f5f7fa;\n  border-color: #c9d1df;\n}\n.origami-radio-card-wrapper.is-checkbox-variant.ant-checkbox-wrapper-disabled .ant-checkbox-disabled .ant-checkbox-inner::checkbox {\n  background-color: #c9d1df;\n}\n.origami-radio-card-wrapper.is-checkbox-variant.ant-checkbox-wrapper-disabled .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {\n  transform: scale(0.375);\n}\n.origami-radio-card-wrapper.is-checkbox-variant.ant-checkbox-wrapper-disabled .origami-radio-card-info-wrapper .origami-radio-card-text-wrapper .origami-radio-card-description {\n  color: #b1baca;\n}\n.origami-radio-card-wrapper.is-checkbox-variant.ant-checkbox-wrapper-disabled .origami-radio-card-info-wrapper .origami-radio-card-text-wrapper .origami-radio-lock-icon {\n  color: #b1baca;\n}\n.origami-radio-card-wrapper.is-checkbox-variant.ant-checkbox-wrapper-disabled {\n  color: #b1baca;\n  background-color: #f5f7fa;\n}\n.origami-radio-card-wrapper.is-checkbox-variant.ant-checkbox-wrapper-disabled span:last-child .origami-radio-lock-icon,\n.origami-radio-card-wrapper.is-checkbox-variant.ant-checkbox-wrapper-disabled span:last-child .origami-radio-button-description {\n  color: #b1baca;\n}\n.origami-radio-card-wrapper.ant-radio-wrapper-checked.show-check-icon .circle-check {\n  display: block;\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.origami-radio-card-wrapper.ant-radio-wrapper-checked.show-check-icon .ant-radio {\n  display: none;\n}\n.origami-radio-card-wrapper .circle {\n  display: none;\n}\n.origami-radio-card-wrapper .circle-check {\n  display: none;\n}\n.origami-radio-card-wrapper .error-circle {\n  color: #de1b1b;\n  display: block;\n}\n.origami-radio-card-wrapper.show-check-icon:not(.ant-radio-wrapper-checked) .circle {\n  color: #b1baca;\n  display: block;\n}\n.origami-radio-card-wrapper.show-check-icon .ant-radio {\n  display: none;\n}\n.origami-radio-card-wrapper .radio-card-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n}\n.origami-radio-card-wrapper.full-width {\n  width: 100%;\n}\n.origami-radio-card-wrapper:active {\n  box-shadow: 0px 0px 4px 0px #3272D9BF;\n}\n.origami-radio-card-wrapper .radio-card-container .origami-radio-card-info-wrapper .origami-radio-card-button .ant-btn {\n  margin-left: -12px;\n}\n.origami-radio-card-wrapper .radio-card-container .origami-radio-card-info-wrapper .origami-radio-card-button .ant-btn > span {\n  padding-inline-start: 0;\n}\n.origami-radio-card-wrapper.no-description .ant-checkbox,\n.origami-radio-card-wrapper.no-description .ant-radio {\n  margin-top: 2px;\n}\n.origami-radio-card-wrapper.no-description.has-button .ant-checkbox {\n  margin-top: 4px;\n}\n.origami-radio-card-wrapper.no-description.has-button .ant-btn {\n  margin-left: -12px;\n}\n.ant-radio-wrapper.has-error,\n.ant-checkbox-wrapper.has-error {\n  border-color: #de1b1b;\n}\n.ant-radio-wrapper.has-error.origami-radio-card-wrapper .ant-radio-checked > .ant-radio-inner,\n.ant-checkbox-wrapper.has-error.origami-radio-card-wrapper .ant-radio-checked > .ant-radio-inner,\n.ant-radio-wrapper.has-error.origami-radio-card-wrapper .ant-checkbox-checked > .ant-radio-inner,\n.ant-checkbox-wrapper.has-error.origami-radio-card-wrapper .ant-checkbox-checked > .ant-radio-inner {\n  border-color: #de1b1b;\n}\n.ant-radio-wrapper.has-error.origami-radio-card-wrapper .ant-radio-checked > span.ant-checkbox-inner,\n.ant-checkbox-wrapper.has-error.origami-radio-card-wrapper .ant-radio-checked > span.ant-checkbox-inner,\n.ant-radio-wrapper.has-error.origami-radio-card-wrapper .ant-checkbox-checked > span.ant-checkbox-inner,\n.ant-checkbox-wrapper.has-error.origami-radio-card-wrapper .ant-checkbox-checked > span.ant-checkbox-inner {\n  border-color: #de1b1b;\n  background-color: #de1b1b;\n}\n.ant-radio-wrapper.has-error.origami-radio-card-wrapper .ant-radio-checked .ant-radio-inner::after,\n.ant-checkbox-wrapper.has-error.origami-radio-card-wrapper .ant-radio-checked .ant-radio-inner::after,\n.ant-radio-wrapper.has-error.origami-radio-card-wrapper .ant-checkbox-checked .ant-radio-inner::after,\n.ant-checkbox-wrapper.has-error.origami-radio-card-wrapper .ant-checkbox-checked .ant-radio-inner::after {\n  background-color: #de1b1b;\n}\n.ant-radio-wrapper.origami-radio-card-wrapper .ant-radio,\n.ant-checkbox-wrapper.origami-radio-card-wrapper .ant-radio {\n  margin-top: 12px;\n}\n.ant-radio-wrapper:hover.has-error,\n.ant-checkbox-wrapper:hover.has-error {\n  border-color: #de1b1b;\n}\n.ant-radio-wrapper:hover.has-error.origami-radio-card-wrapper .ant-radio-checked > .ant-radio-inner,\n.ant-checkbox-wrapper:hover.has-error.origami-radio-card-wrapper .ant-radio-checked > .ant-radio-inner,\n.ant-radio-wrapper:hover.has-error.origami-radio-card-wrapper .ant-checkbox-checked > .ant-radio-inner,\n.ant-checkbox-wrapper:hover.has-error.origami-radio-card-wrapper .ant-checkbox-checked > .ant-radio-inner {\n  border-color: #de1b1b;\n}\n.ant-radio-wrapper:hover.has-error.origami-radio-card-wrapper .ant-radio-checked > span.ant-checkbox-inner,\n.ant-checkbox-wrapper:hover.has-error.origami-radio-card-wrapper .ant-radio-checked > span.ant-checkbox-inner,\n.ant-radio-wrapper:hover.has-error.origami-radio-card-wrapper .ant-checkbox-checked > span.ant-checkbox-inner,\n.ant-checkbox-wrapper:hover.has-error.origami-radio-card-wrapper .ant-checkbox-checked > span.ant-checkbox-inner {\n  border-color: #de1b1b;\n  background-color: #de1b1b;\n}\n.ant-radio-wrapper:hover.has-error.origami-radio-card-wrapper .ant-radio-checked .ant-radio-inner::after,\n.ant-checkbox-wrapper:hover.has-error.origami-radio-card-wrapper .ant-radio-checked .ant-radio-inner::after,\n.ant-radio-wrapper:hover.has-error.origami-radio-card-wrapper .ant-checkbox-checked .ant-radio-inner::after,\n.ant-checkbox-wrapper:hover.has-error.origami-radio-card-wrapper .ant-checkbox-checked .ant-radio-inner::after {\n  background-color: #de1b1b;\n}\n.disabled-reason {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  color: #59606d !important;\n}\n.card-group-selector {\n  flex-direction: column;\n  gap: 12px;\n  height: 100%;\n  display: inline-flex;\n}\n.card-group-selector.collapsed .ant-radio-wrapper {\n  position: absolute;\n  z-index: 0;\n  top: 0;\n  display: none;\n}\n.card-group-selector.collapsed .ant-radio-wrapper.ant-radio-wrapper-checked {\n  z-index: 29;\n  display: inline-flex;\n}\n.card-group-selector.collapsed .empty-1 {\n  top: 32px;\n  z-index: 28;\n  width: calc(100% - 24px);\n  margin-left: 10px;\n  pointer-events: none;\n  display: inline-flex;\n  color: #fff;\n}\n.card-group-selector.collapsed .empty-1 .ant-radio {\n  display: none;\n}\n.card-group-selector.collapsed .empty-1:hover {\n  border: 1px solid #c9d1df;\n}\n.card-group-selector.collapsed .empty-2 {\n  top: 44px;\n  z-index: 27;\n  margin-left: 20px;\n  width: calc(100% - 44px);\n  pointer-events: none;\n  display: inline-flex;\n  color: #fff;\n}\n.card-group-selector.collapsed .empty-2 .ant-radio {\n  display: none;\n}\n.card-group-selector.collapsed .empty-2:hover {\n  border: 1px solid #c9d1df;\n}\n.card-group-selector .card-hidden {\n  display: none;\n  visibility: hidden;\n  height: 0;\n}\n.reversed {\n  flex-direction: row-reverse;\n  justify-content: space-between;\n}\n.reversed .radio-card-container {\n  flex-direction: row-reverse;\n}\n.reversed .origami-radio-card-info-wrapper {\n  flex-direction: row-reverse;\n  width: 100%;\n  justify-content: start;\n}\n.reversed .ant-checkbox {\n  margin-left: 14px;\n  margin-right: 14px;\n}\n.origami-radio-card-info-wrapper {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: space-between;\n  text-align: left;\n  gap: 14px;\n  align-items: center;\n  flex-wrap: nowrap;\n}\n@media only screen and (max-width: 735px) {\n  .origami-radio-card-info-wrapper {\n    flex-wrap: wrap;\n  }\n}\n.origami-radio-card-info-wrapper.has-icon:not(.has-reason, .has-button) {\n  flex-wrap: nowrap;\n}\n.ant-radio-wrapper-disabled .origami-radio-icon,\n.ant-checkbox-wrapper-disabled .origami-radio-icon {\n  color: #b1baca;\n}\n.origami-radio-icon {\n  width: 24px;\n  height: 24px;\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-form .ant-form-item .ant-form-item-control-input {\n  min-height: 26px;\n}\n.ant-form .ant-form-item .ant-form-item-label {\n  padding-bottom: 0;\n}\n.ant-form .ant-form-item .ant-form-item-label > label.ant-form-item-no-colon::after {\n  content: \"\";\n}\n.ant-form .ant-form-item .ant-form-item-label > label::after {\n  margin-inline-start: 0;\n}\n.ant-form .ant-form-item .ant-form-item-label .large .label-content-wrapper {\n  margin-bottom: 10px;\n}\n.ant-form .ant-form-item .ant-form-item-label .small .label-content-wrapper {\n  margin-bottom: 6px;\n}\n.ant-form .ant-form-item .ant-form-item-label .label-content-wrapper {\n  margin-bottom: 8px;\n}\n.ant-form .ant-form-item .nackle-caption {\n  margin-top: 2px;\n}\n.nackle-label.horizontal {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n.nackle-label.horizontal .label-content-wrapper {\n  display: inline-flex;\n  margin-bottom: 0;\n  padding-right: 4px;\n}\n.nackle-label.horizontal .ant-input {\n  width: 100%;\n}\n.nackle-label.horizontal .ant-input-search .ant-input,\n.nackle-label.horizontal .ant-input-password .ant-input {\n  width: 100%;\n}\n.nackle-label .ant-input {\n  width: 100%;\n}\n.nackle-label .input-caption-wrapper {\n  display: inline-block;\n  width: 100%;\n}\n.nackle-label .ant-input-search .ant-input {\n  width: 100%;\n}\n.nackle-label .label-content-wrapper {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-bottom: 8px;\n}\n.nackle-label .label-text {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  color: #59606d;\n  text-wrap: nowrap;\n  white-space: nowrap;\n}\n.nackle-label .label-text .required {\n  color: #de1b1b;\n  margin-left: 4px;\n}\n.nackle-label .label-text .optional-text {\n  margin-left: 4px;\n  font-weight: 400;\n}\n.nackle-label .label-icon {\n  margin-left: 4px;\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n  display: flex;\n  align-items: center;\n}\n.nackle-label .label-icon svg {\n  width: 20px;\n  height: 20px;\n}\n.nackle-label.small .label-content-wrapper {\n  margin-bottom: 6px;\n}\n.nackle-label.small .label-text {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n  color: #59606d;\n}\n.nackle-label.small .label-icon svg {\n  width: 16px;\n  height: 16px;\n}\n.nackle-label.large .label-content-wrapper {\n  margin-bottom: 10px;\n}\n.nackle-label.large .label-text {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  color: #59606d;\n}\n.nackle-label.large .label-icon svg {\n  width: 24px;\n  height: 24px;\n}\n.ant-menu {\n  border-radius: 30px;\n  padding: 15px;\n}\n.ant-menu .ant-menu-item {\n  font-weight: 600;\n  font-size: 16px;\n  padding: 14px;\n  color: #444A53;\n}\n.ant-menu .ant-menu-item .anticon {\n  color: #3F8CFF;\n}\n.ant-menu .ant-menu-item-group .ant-menu-item-group-list .ant-menu-title-content {\n  font-size: 14px;\n}\n.ant-menu-inline,\n.ant-menu-vertical,\n.ant-menu-vertical-left {\n  border-right: none;\n}\n.ant-menu.ant-menu-root.ant-menu-vertical:focus,\n.ant-menu.ant-menu-root.ant-menu-horizontal:focus {\n  -webkit-box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);\n  box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);\n}\n.ant-menu.ant-menu-root.ant-menu-vertical:focus-visible,\n.ant-menu.ant-menu-root.ant-menu-horizontal:focus-visible {\n  -webkit-box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);\n  box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);\n}\n.ant-menu.ant-menu-root .ant-menu-item {\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n}\n.ant-menu.ant-menu-root.menu-popover {\n  border-radius: 10px;\n}\n.ant-menu.ant-menu-root.menu-popover .ant-menu-item {\n  border-radius: 6px;\n  font-weight: 400;\n  color: #59606d;\n}\n.ant-menu.ant-menu-root.menu-popover .ant-menu-item-selected {\n  background-color: #f5f7fa;\n}\n.ant-menu.ant-menu-root.menu-popover.menu-lg {\n  padding: 8px;\n}\n.ant-menu.ant-menu-root.menu-popover.menu-lg .ant-menu-item {\n  font-size: 16px;\n}\n.ant-menu.ant-menu-root.menu-popover.menu-md {\n  padding: 6px;\n}\n.ant-menu.ant-menu-root.menu-popover.menu-md .ant-menu-item {\n  font-size: 14px;\n}\n.ant-menu.ant-menu-root.menu-popover.menu-sm {\n  padding: 4px;\n}\n.ant-menu.ant-menu-root.menu-popover.menu-sm .ant-menu-item {\n  font-size: 12px;\n}\n.ant-menu .ant-menu-submenu-title {\n  font-size: 16px;\n  font-weight: 600;\n}\n.ant-menu .ant-menu-sub .ant-menu-item .ant-menu-title-content {\n  font-weight: 400;\n}\n.ant-menu .ant-menu-sub .ant-menu-item::after {\n  border-right: none;\n}\n.ant-menu .ant-menu-sub .ant-menu-item-selected::after {\n  border-right: none;\n}\n.ant-menu + div + .ant-menu {\n  padding-top: 0;\n}\n.ant-message .ant-message-notice .ant-message-notice-content {\n  border-radius: 6px;\n  padding: 8px 10px 8px 10px;\n}\n.ant-message .ant-message-notice .ant-message-notice-content .ant-message-custom-content {\n  display: flex;\n  font-size: 12px;\n  line-height: 16px;\n}\n.ant-message .ant-message-notice .ant-message-notice-content .ant-message-custom-content .ant-message-icon {\n  height: 16px;\n  width: 16px;\n  margin-right: 8px;\n}\n.ant-message .ant-message-notice .ant-message-notice-content .ant-message-custom-content .ant-message-close-icon {\n  height: 12px;\n  width: 12px;\n  color: #59606d;\n}\n.ant-message .ant-message-notice .ant-message-notice-content .ant-message-custom-content span {\n  display: flex;\n  color: #59606d;\n}\n.ant-message .ant-message-notice .ant-message-notice-content .ant-message-custom-content span button {\n  height: 16px;\n  width: 16px;\n  padding-left: 0px;\n  padding-right: 0px;\n  margin-left: 8px;\n}\n.ant-message .ant-message-notice .ant-message-notice-content .ant-message-info-icon {\n  color: #1d5bbf;\n}\n.ant-message .ant-message-notice .ant-message-notice-content .ant-message-success-icon {\n  color: #038537;\n}\n.ant-message .ant-message-notice .ant-message-notice-content .ant-message-warning-icon {\n  color: #fcc419;\n}\n.ant-message .ant-message-notice .ant-message-notice-content .ant-message-error-icon {\n  color: #de1b1b;\n}\n.ant-message .ant-message-notice .ant-message-notice-content .ant-message-tip-icon {\n  color: #7d3cbd;\n}\n.ant-message .ant-message-notice .ant-message-notice-content .ant-message-loading-icon {\n  color: #1d5bbf;\n  animation: rotate 1s linear infinite;\n}\n.ant-message .ant-message-notice .ant-message-close-x {\n  display: none;\n}\n.ant-message .ant-message-notice.ant-message-large .ant-message-notice-content {\n  padding: 10px 12px 10px 12px;\n}\n.ant-message .ant-message-notice.ant-message-large .ant-message-notice-content .ant-message-custom-content {\n  display: flex;\n  font-size: 14px;\n  line-height: 20px;\n}\n.ant-message .ant-message-notice.ant-message-large .ant-message-notice-content .ant-message-custom-content .ant-message-icon {\n  height: 20px;\n  width: 20px;\n  margin-right: 10px;\n}\n.ant-message .ant-message-notice.ant-message-large .ant-message-notice-content .ant-message-custom-content .ant-message-close-icon {\n  height: 14px;\n  width: 14px;\n}\n.ant-message .ant-message-notice.ant-message-large .ant-message-notice-content .ant-message-custom-content span button {\n  height: 20px;\n  width: 20px;\n  padding-left: 0px;\n  padding-right: 0px;\n  margin-left: 10px;\n}\n@keyframes rotate {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.ant-notification.ant-notification-stack.ant-notification-stack-expanded .ant-notification-notice-wrapper {\n  width: auto;\n  border-radius: 16px;\n}\n.ant-notification .ant-notification-notice-wrapper {\n  width: auto;\n  border-radius: 16px;\n}\n.ant-notification .ant-notification-notice {\n  border-radius: 16px;\n  padding: 24px;\n  margin-bottom: 0;\n}\n.ant-notification .ant-notification-notice:not(.ant-notification-large) {\n  width: 300px;\n}\n.ant-notification .ant-notification-notice:not(.ant-notification-large) .ant-notification-notice-message {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  margin-bottom: 6px;\n  padding-top: 3px;\n}\n.ant-notification .ant-notification-notice:not(.ant-notification-large) .ant-notification-notice-description {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  color: #59606d;\n}\n.ant-notification .ant-notification-notice:not(.ant-notification-large) .ant-notification-notice-close svg {\n  width: 16px;\n  height: 16px;\n  color: #59606d;\n}\n.ant-notification .ant-notification-notice:not(.ant-notification-large) .ant-notification-notice-close:hover svg {\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-notification .ant-notification-notice:not(.ant-notification-large) .ant-notification-notice-icon {\n  height: 26px;\n  width: 26px;\n}\n.ant-notification .ant-notification-notice:not(.ant-notification-large) .ant-notification-icon {\n  color: white;\n  height: 26px;\n  width: 26px;\n  padding: 5px;\n  border-radius: 50%;\n}\n.ant-notification .ant-notification-notice.ant-notification-large {\n  border-radius: 16px;\n  width: 350px;\n}\n.ant-notification .ant-notification-notice.ant-notification-large .ant-notification-notice-message {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  margin-bottom: 6px;\n  padding-top: 5px;\n}\n.ant-notification .ant-notification-notice.ant-notification-large .ant-notification-notice-description {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  color: #59606d;\n}\n.ant-notification .ant-notification-notice.ant-notification-large .ant-notification-notice-with-icon .ant-notification-notice-message,\n.ant-notification .ant-notification-notice.ant-notification-large .ant-notification-notice-with-icon .ant-notification-notice-description {\n  margin-inline-start: 46px;\n}\n.ant-notification .ant-notification-notice.ant-notification-large .ant-notification-notice-close svg {\n  width: 16px;\n  height: 16px;\n  color: #59606d;\n}\n.ant-notification .ant-notification-notice.ant-notification-large .ant-notification-notice-close:hover svg {\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-notification .ant-notification-notice.ant-notification-large .ant-notification-notice-icon {\n  height: 36px;\n  width: 36px;\n}\n.ant-notification .ant-notification-notice.ant-notification-large .ant-notification-icon {\n  color: white;\n  height: 36px;\n  width: 36px;\n  padding: 8px;\n  border-radius: 50%;\n}\n.ant-notification .ant-notification-notice .ant-notification-info-icon {\n  background: #1d5bbf;\n}\n.ant-notification .ant-notification-notice .ant-notification-warning-icon {\n  background: #fcc419;\n}\n.ant-notification .ant-notification-notice .ant-notification-success-icon {\n  background: #038537;\n}\n.ant-notification .ant-notification-notice .ant-notification-error-icon {\n  background: #de1b1b;\n}\n.ant-notification .ant-notification-notice .ant-notification-tip-icon {\n  background: #7d3cbd;\n}\n.ant-notification .ant-notification-notice .ant-notification-loading-icon {\n  background: #1d5bbf;\n  animation-duration: 1200ms;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n  animation-name: spin;\n}\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.ant-modal-root .ant-modal-mask {\n  background-color: rgba(201, 209, 223, 0.8);\n}\n.ant-modal-root .ant-modal-wrap .ant-modal {\n  max-width: 100%;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content {\n  border-radius: 24px;\n  padding: 0px;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-close {\n  margin-top: 24px;\n  background-color: #fff;\n  min-width: 36px;\n  height: 36px;\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  box-shadow: none;\n  color: #59606d;\n  padding-inline-start: 0;\n  padding-inline-end: 0;\n  border-radius: 50%;\n  width: 32px;\n  border: none;\n  top: auto;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-close:hover {\n  background-color: #f5f7fa;\n  border-color: #c9d1df;\n  color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);\n}\n.ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-close .ant-modal-close-x {\n  height: 20px;\n  width: 20px;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-title {\n  color: #000000;\n  font-size: 24px;\n  font-weight: 600;\n  margin-right: 32px;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-title .ant-modal-subtitle {\n  font-size: 14px;\n  font-weight: 400;\n  color: #59606d;\n  margin-top: 8px;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-header {\n  border-bottom: 1px solid #eceff4;\n  margin-bottom: 0px;\n  padding: 24px;\n  border-radius: 24px 24px 0px 0px;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-body {\n  padding: 16px 24px 16px 24px;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-footer {\n  display: flex;\n  justify-content: space-between;\n  padding: 24px 24px 24px 24px;\n  margin-top: 0px;\n  flex-wrap: wrap;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-footer .ant-btn {\n  border-radius: 50px;\n  padding: 10px 20px 10px 20px;\n  height: 44px;\n  font-size: 16px;\n  line-height: 24px;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-confirm-paragraph {\n  max-width: 100%;\n  row-gap: 0px;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content {\n  padding: 0px;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body {\n  padding: 0px;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .confirm-modal-header {\n  display: flex;\n  padding: 24px;\n  border-bottom: 1px solid #eceff4;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .confirm-modal-header .ant-modal-icon {\n  color: white;\n  height: 36px;\n  width: 36px;\n  padding: 8px;\n  border-radius: 50%;\n  margin-right: 8px;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .confirm-modal-header .warning {\n  background: #fcc419;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .confirm-modal-header .success {\n  background: #038537;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .confirm-modal-header .error {\n  background: #de1b1b;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .confirm-modal-header .info {\n  background: #1d5bbf;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .confirm-modal-header .confirm-modal-title {\n  display: flex;\n  align-items: center;\n  font-size: 18px;\n  margin-right: 8px;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .confirm-modal-header .confirm-modal-header-close {\n  margin-right: 0;\n  margin-left: auto;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-content {\n  padding: 16px 24px 16px 24px;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-body-has-title {\n  max-width: 100%;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-btns {\n  padding: 24px;\n  display: flex;\n  margin-top: 0px;\n  gap: 14px;\n}\n@media only screen and (max-width: 735px) {\n  .ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-btns {\n    flex-wrap: wrap;\n  }\n}\n.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-btns .ant-btn:not(:disabled):focus,\n.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-btns .ant-btn:not(:disabled):focus-visible {\n  box-shadow: none;\n  -webkit-box-shadow: none;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-btns .ant-btn:first-child {\n  margin-left: 0px;\n  margin-right: auto;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-btns .ant-btn:last-child {\n  margin-right: 0px;\n  margin-left: auto;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-btns .ant-btn:only-child {\n  margin-right: 0px;\n  margin-left: auto;\n}\n.ant-modal-root .ant-modal-wrap .ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-btns .ant-btn {\n  border-radius: 50px;\n  padding: 10px 20px 10px 20px;\n  height: 44px;\n  font-size: 16px;\n  line-height: 24px;\n}\n@media only screen and (max-width: 735px) {\n  .ant-modal-root .ant-modal-wrap .ant-modal {\n    width: 100% !important;\n    max-width: 100%;\n    margin: 0;\n    top: auto;\n    height: 100%;\n    padding: 0;\n    bottom: 0;\n  }\n  .ant-modal-root .ant-modal-wrap .ant-modal.full-height {\n    top: 0;\n  }\n  .ant-modal-root .ant-modal-wrap .ant-modal.full-height .ant-modal-content {\n    border-radius: 0;\n    height: 100%;\n  }\n  .ant-modal-root .ant-modal-wrap .ant-modal.full-height .ant-modal-content .ant-modal-body {\n    height: calc(100dvh - 144px);\n  }\n  .ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content {\n    height: auto;\n    border-radius: 24px 24px 0 0;\n    padding: 0px;\n    display: flex;\n    flex-direction: column;\n    bottom: 0;\n    position: fixed;\n    width: 100%;\n  }\n  .ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-close {\n    margin-top: 16px;\n  }\n  .ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-header {\n    top: 0;\n    width: 100%;\n    z-index: 100;\n    padding-top: 24px;\n  }\n  .ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-header .ant-modal-title {\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 28px;\n  }\n  .ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-body {\n    overflow-y: auto;\n    padding-bottom: 84px;\n    height: 100%;\n  }\n  .ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-footer {\n    bottom: 0;\n    position: fixed;\n    width: 100%;\n    left: 0;\n    padding: 24px;\n    background: #fff;\n    z-index: 10;\n    border-radius: 0;\n  }\n  .ant-modal-root .ant-modal-wrap .ant-modal .ant-modal-content .ant-modal-footer .ant-btn {\n    border-radius: 25px;\n    padding: 8px 16px 8px 16px;\n    height: 36px;\n    font-size: 14px;\n    line-height: 20px;\n  }\n  .ant-modal-root .ant-modal-wrap .ant-modal.ant-modal-confirm {\n    height: inherit;\n    position: fixed;\n    bottom: 0;\n    top: auto;\n    display: block;\n  }\n  .ant-modal-root .ant-modal-wrap .ant-modal.ant-modal-confirm .ant-modal-content {\n    border-radius: 24px 24px 0px 0px;\n  }\n  .ant-modal-root .ant-modal-wrap .ant-modal.ant-modal-confirm .ant-modal-content .ant-modal-body {\n    padding: 0px;\n  }\n  .ant-modal-root .ant-modal-wrap .ant-modal.ant-modal-confirm .ant-modal-content .ant-modal-body .ant-modal-confirm-btns .ant-btn {\n    border-radius: 25px;\n    padding: 8px 16px 8px 16px;\n    height: 36px;\n    font-size: 14px;\n    line-height: 20px;\n  }\n  .ant-modal-root .ant-modal-wrap .ant-modal.ant-zoom-leave {\n    animation-timing-function: ease-in-out;\n    animation-duration: 300ms;\n  }\n  .ant-modal-root .ant-modal-wrap .ant-modal.ant-zoom-leave.ant-zoom-leave-active {\n    animation-name: slide-down;\n  }\n  .ant-modal-root .ant-modal-wrap .ant-modal.ant-zoom-enter {\n    animation-timing-function: ease-in-out;\n    animation-duration: 300ms;\n  }\n  .ant-modal-root .ant-modal-wrap .ant-modal.ant-zoom-enter.ant-zoom-enter-active {\n    animation-name: slide-up;\n  }\n  .ant-modal-root .ant-modal-wrap .ant-modal.ant-zoom-appear {\n    animation-timing-function: ease-in-out;\n    animation-duration: 300ms;\n  }\n  .ant-modal-root .ant-modal-wrap .ant-modal.ant-zoom-appear.ant-zoom-appear-active {\n    animation-name: slide-up;\n  }\n}\n@keyframes slide-up {\n  0% {\n    opacity: 0;\n    transform: translate3d(0, 75%, 0);\n  }\n  100% {\n    opacity: 1;\n    transform: none;\n  }\n}\n@keyframes slide-down {\n  0% {\n    opacity: 1;\n    transform: none;\n  }\n  100% {\n    opacity: 0;\n    transform: translate3d(0, 75%, 0);\n  }\n}\n#scrollableDiv {\n  height: 300;\n  overflow: hidden;\n  display: flex;\n}\n#scrollableDiv .ant-list-header {\n  font-weight: 600;\n  font-size: 16px;\n}\n#scrollableDiv .notifications-list .ant-list-items .ant-list-item {\n  display: flex;\n  padding: 0px;\n  font-size: 16px;\n  flex-direction: column;\n  align-items: flex-start;\n}\n#scrollableDiv .notifications-list .ant-list-items .ant-list-item .ant-list-item-meta-content {\n  width: 100%;\n}\n#scrollableDiv .notifications-list .ant-list-items .ant-list-item .ant-list-item-meta-content .ant-list-item-meta-title {\n  display: flex;\n}\n#scrollableDiv .notifications-list .ant-list-items .ant-list-item .ant-list-item-meta-content .ant-list-item-meta-description {\n  color: #3F8CFF;\n  font-weight: 600;\n  font-size: 12px;\n}\n#scrollableDiv .notifications-list .ant-list-items .ant-list-item > div {\n  margin-bottom: 10px;\n}\n#scrollableDiv .notifications-list .ant-list-items .ant-list-item > div > p {\n  margin: 0;\n}\n#scrollableDiv .notifications-list .ant-list-items .ant-list-item.inactive > div,\n#scrollableDiv .notifications-list .ant-list-items .ant-list-item.inactive > div > p,\n#scrollableDiv .notifications-list .ant-list-items .ant-list-item.inactive > div > p > span {\n  color: #727A88 !important;\n  background-color: inherit !important;\n}\n#scrollableDiv .notifications-list .ant-list-items .ant-list-item.inactive .ant-list-item-meta-description {\n  color: #727A88;\n}\n#scrollableDiv .notifications-list .ant-list-items > div {\n  padding: 10px;\n  margin: 0px 10px;\n  display: flex;\n  justify-content: space-between;\n}\n#scrollableDiv:hover {\n  overflow: auto;\n}\n.nackle-chip {\n  height: 50px;\n  display: inline-flex;\n  border: 1px solid #c9d1df;\n  border-radius: 25px;\n  justify-content: center;\n  align-items: center;\n  background-color: #f5f7fa;\n}\n.nackle-chip.with-image .chip-content {\n  margin-left: 8px;\n}\n.nackle-chip.earned {\n  background-color: #fff9db;\n  border: 1px solid #fcc419;\n}\n.nackle-chip.earned .chip-image {\n  opacity: 1;\n}\n.nackle-chip .chip-image {\n  height: 46px;\n  width: 46px;\n  border-radius: 50%;\n  margin-left: 2px;\n  opacity: 0.54;\n}\n.nackle-chip .chip-content {\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 20px;\n  color: #59606d;\n  margin-left: 16px;\n}\n.nackle-chip .chip-suffix {\n  color: #59606d;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  margin-left: 4px;\n  margin-right: 16px;\n}\n.nackle-status-badge {\n  width: 50px;\n  height: 50px;\n}\n.nackle-status-badge svg {\n  box-shadow: 0px 7px 20px 0px #00000014;\n  border-radius: 50%;\n}\n.nackle-notation {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n.nackle-notation.emphasis .notation-text {\n  font-weight: 600;\n}\n.nackle-notation.info .notation-icon {\n  color: #1d5bbf;\n}\n.nackle-notation.info .notation-text {\n  color: #1d5bbf;\n}\n.nackle-notation.error .notation-icon {\n  color: #de1b1b;\n}\n.nackle-notation.error .notation-text {\n  color: #de1b1b;\n}\n.nackle-notation.success .notation-icon {\n  color: #038537;\n}\n.nackle-notation.success .notation-text {\n  color: #038537;\n}\n.nackle-notation .notation-icon {\n  display: flex;\n  align-items: center;\n  color: #59606d;\n}\n.nackle-notation .notation-text {\n  color: #59606d;\n  font-size: 16px;\n  line-height: 24px;\n  margin-left: 6px;\n}\n.nackle-item {\n  display: inline-flex;\n  justify-content: flex-start;\n  align-items: center;\n  background-color: #ffffff;\n  width: 100%;\n  border-radius: 8px;\n  cursor: pointer;\n}\n.nackle-item.large {\n  padding: 14px;\n}\n.nackle-item.medium {\n  padding: 10px 14px;\n}\n.nackle-item.small {\n  padding: 8px 14px;\n}\n.nackle-item.description {\n  align-items: flex-start;\n}\n.nackle-item.right-icon {\n  justify-content: space-between;\n}\n.nackle-item.right-icon .item-icon {\n  margin-right: 0;\n}\n.nackle-item.right-icon.left-icon .right {\n  color: #59606d;\n}\n.nackle-item:hover:not(.disabled),\n.nackle-item:active:not(.disabled) {\n  background-color: #f5f7fa;\n}\n.nackle-item.disabled {\n  color: #b1baca;\n  cursor: not-allowed;\n}\n.nackle-item.disabled .item-icon {\n  color: #b1baca;\n}\n.nackle-item.disabled .item-icon.right {\n  color: #b1baca;\n}\n.nackle-item .left-container {\n  display: flex;\n  justify-content: flex-start;\n}\n.nackle-item.left-icon .item-text-container {\n  margin-left: 14px;\n}\n.nackle-item .item-text-container {\n  display: flex;\n  flex-direction: column;\n}\n.nackle-item .item-icon {\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n  display: flex;\n}\n.nackle-item.large .item-title {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n.nackle-item.large .item-description {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #59606d;\n  margin-top: 2px;\n}\n.nackle-item.medium .item-title {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n.nackle-item.medium .item-description {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #59606d;\n  margin-top: 2px;\n}\n.nackle-item.small .item-title {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n}\n.nackle-item.small .item-description {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #59606d;\n  margin-top: 2px;\n}\n.nackle-tile {\n  border-radius: 24px;\n  box-shadow: 0px 8px 32px 0px #34383F14;\n}\n.nackle-tile-single {\n  width: 320px;\n  height: 320px;\n  container-name: nackle-tile-single;\n  container-type: size;\n  margin-bottom: 32px;\n  display: inline-block;\n  overflow: hidden;\n}\n.nackle-tile-single-infinity {\n  width: 320px;\n  height: auto;\n  container-name: nackle-tile-single-infinity;\n  container-type: inline-size;\n  margin-bottom: 32px;\n  overflow: hidden;\n}\n.nackle-tile-double {\n  width: 672px;\n  height: 320px;\n  container-name: nackle-tile-double;\n  container-type: size;\n  margin-right: 32px;\n  margin-bottom: 32px;\n  overflow: hidden;\n}\n.nackle-tile-double-infinity {\n  width: 672px;\n  height: auto;\n  container-name: nackle-tile-double-infinity;\n  container-type: inline-size;\n  margin-right: 32px;\n  margin-bottom: 32px;\n}\n.nackle-tile-triple {\n  width: 1024px;\n  height: 320px;\n  container-name: nackle-tile-triple;\n  container-type: size;\n  margin-bottom: 32px;\n  overflow: hidden;\n}\n.nackle-tile-triple-infinity {\n  width: 1024px;\n  height: auto;\n  container-name: nackle-tile-triple-infinity;\n  container-type: inline-size;\n  margin-bottom: 32px;\n}\n@media screen and (max-width: 1087px) {\n  .nackle-tile-double {\n    width: 320px;\n  }\n  .nackle-tile-double-infinity {\n    margin-right: 0;\n  }\n  .nackle-tile-triple {\n    width: 672px;\n  }\n  .nackle-tile-triple-infinity {\n    width: 672px;\n  }\n  .nackle-tile-single {\n    display: block;\n  }\n}\n@media screen and (max-width: 735px) {\n  .nackle-tile-double-infinity {\n    width: 320px;\n    margin-right: 0;\n  }\n  .nackle-tile-triple {\n    width: 320px;\n    margin-right: 0;\n  }\n  .nackle-tile-triple-infinity {\n    width: 320px;\n    margin-right: 0;\n  }\n}\n@media screen and (max-width: 636px) {\n  .nackle-tile-double {\n    margin-right: 0;\n  }\n  .nackle-tile-triple {\n    margin-right: 0;\n  }\n  .nackle-tile-double-infinity {\n    margin-right: 0;\n  }\n  .nackle-tile-triple-infinity {\n    margin-right: 0;\n  }\n  .nackle-tile-single {\n    margin-right: 0;\n  }\n}\n.search-screen .search-select__placeholder {\n  color: #c9d1df;\n  font-size: 16px;\n  line-height: 24px;\n}\n.search-screen .search-select__menu {\n  z-index: 22;\n  border-radius: 8px;\n  box-shadow: 0px 2px 10px 0px #0000001A;\n}\n.search-screen .no-team-container {\n  min-height: 400px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  background-color: white;\n}\n.search-screen .no-team-container .search-text-no-team {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  color: #59606d;\n  margin-top: 6px;\n}\n.search-screen .search-select__input-container {\n  height: 24px;\n  margin: 0;\n}\n@media only screen and (max-width: 735px) {\n  .search-screen .search-select__input-container {\n    padding: 0;\n  }\n}\n.search-screen .search-select__input-container input {\n  height: 24px;\n}\n.search-screen .search-limit {\n  padding-left: 10px;\n}\n.search-screen .search-limit.top {\n  margin-top: 24px;\n}\n.search-screen .search-limit .top-100 {\n  font-weight: 600;\n  color: #59606d;\n  font-size: 12px;\n  line-height: 18px;\n}\n.search-screen .search-limit .search-more {\n  font-weight: 400;\n  color: #59606d;\n  font-size: 12px;\n  line-height: 18px;\n  letter-spacing: 0px;\n}\n.search-screen .person-search {\n  border-radius: 8px;\n  margin-top: 1px;\n}\n@media only screen and (max-width: 735px) {\n  .search-screen .person-search .value:not(.expanded) .search-chevron-container {\n    right: 12px;\n  }\n}\n.search-screen .person-search .empty-state-container {\n  padding: 12px;\n}\n.search-screen .person-search .search-chevron-container {\n  position: absolute;\n  right: 22px;\n  display: flex;\n  height: calc(100% - 20px);\n  justify-content: center;\n  align-items: center;\n}\n@media only screen and (max-width: 735px) {\n  .search-screen .person-search .search-chevron-container {\n    height: 100%;\n  }\n}\n.search-screen .person-search .search-chevron-container > div {\n  position: absolute;\n  padding: 14px 0 14px 14px;\n}\n.search-screen .person-search .search-chevron-container .chevron {\n  cursor: pointer;\n}\n.search-screen .person-search .search-chevron-container .up,\n.search-screen .person-search .search-chevron-container .down {\n  margin-right: 10px;\n  transition: 150ms transform linear;\n}\n.search-screen .person-search .search-chevron-container .up {\n  transform: rotate(-180deg);\n}\n.search-screen .person-search .search-select__control--is-focused {\n  box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);\n}\n.search-screen .person-search .search-select__multi-value {\n  font-size: 16px;\n  line-height: 24px;\n  margin: 0;\n}\n.search-screen .person-search .search-select__multi-value__remove svg {\n  height: 16px;\n  width: 16px;\n}\n.search-screen .person-search .ant-input-prefix {\n  margin-right: 10px;\n}\n.search-screen .person-search input.ant-input {\n  padding: 0;\n}\n.search-screen .person-search .search-icon {\n  width: 20px;\n}\n.search-screen .person-search input:focus {\n  box-shadow: none;\n}\n.search-screen .person-search .icon-container {\n  display: flex;\n  align-items: center;\n}\n.search-screen .person-search .value {\n  max-height: 103px;\n  padding-right: 16px;\n  transition: 150ms max-height linear;\n  overflow-y: auto;\n  cursor: text;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n.search-screen .person-search .value.expanded {\n  max-height: 219px;\n}\n.search-screen .person-search .value .ref-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  width: 100%;\n}\n.search-screen .cursor-not-allowed {\n  cursor: not-allowed;\n}\n.search-screen .disabled-search-result-wrapper {\n  pointer-events: none;\n}\n.search-screen .search-results .ant-popover-inner {\n  max-height: 300px;\n  overflow: auto;\n  height: auto;\n}\n.search-screen .search-results .ant-popover-inner-content {\n  padding: 0;\n}\n.search-screen .search-results .ant-spin-container {\n  display: block;\n}\n.search-screen .search-results .ant-spin-spinning {\n  padding: 12px;\n}\n.search-screen .search-results .ant-spin-nested-loading {\n  position: static;\n}\n.search-screen .sub-description {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: #59606d;\n  padding-left: 0;\n}\n.search-screen .sub-description:not(.error-label) {\n  margin-top: 10px;\n}\n.search-screen .search-error-container {\n  display: flex;\n  margin-right: 10px;\n}\n.search-screen .search-error-container .error-icon {\n  color: #de1b1b;\n}\n.search-screen .team-container {\n  background: white;\n  overflow: auto;\n}\n.search-screen .error-label {\n  margin-top: 16px;\n}\n.search-screen .error-label.nackle-caption {\n  color: #de1b1b;\n}\n.search-screen .search-result {\n  display: flex;\n  flex-direction: row;\n  border-bottom: 1px solid #eceff4;\n  padding: 12px;\n  cursor: pointer;\n}\n.search-screen .search-result .disabled-text-container {\n  row-gap: 11px;\n  display: flex;\n  justify-content: space-between;\n  flex: 2;\n  flex-wrap: wrap;\n}\n.search-screen .search-result.disabled {\n  background-color: #f5f7fa;\n  cursor: not-allowed;\n  flex-wrap: wrap;\n}\n.search-screen .search-result.disabled .ant-avatar {\n  opacity: 0.54;\n}\n.search-screen .search-result.disabled .text-container .search-name {\n  color: #b1baca;\n  cursor: not-allowed;\n}\n.search-screen .search-result.disabled .text-container .person-details {\n  color: #b1baca;\n}\n.search-screen .search-result.disabled .disabled-reason {\n  color: #59606d;\n  font-size: 14px;\n  line-height: 20px;\n  display: flex;\n  align-items: center;\n}\n.search-screen .search-result .avatar-container {\n  align-items: start;\n}\n.search-screen .search-result .avatar-container .ant-avatar {\n  margin-right: 8px;\n}\n.search-screen .search-result:hover {\n  background-color: #f5f7fa;\n}\n.search-screen .search-result .text-container {\n  flex: 10;\n}\n.search-screen .search-result .text-container .search-name {\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n}\n.search-screen .search-result .text-container .person-details {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  color: #59606d;\n}\n.search-screen .search-result .text-container .search-selected {\n  flex: 2;\n  text-align: right;\n}\n@media only screen and (max-width: 735px) {\n  .search-screen .person-search .value {\n    max-height: 86px;\n  }\n  .search-screen .person-search .value .ref-container {\n    gap: 0;\n    column-gap: 4px;\n    width: 100%;\n  }\n  .search-screen .person-search .search-select__value-container {\n    padding: 0;\n    padding-left: 0;\n    gap: 0;\n  }\n  .search-screen .person-search .search-select__menu {\n    z-index: 10000;\n  }\n  .search-screen .person-search .search-select__placeholder {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n    color: #c9d1df;\n    align-self: center;\n    position: absolute;\n    white-space: nowrap;\n  }\n  .search-screen .person-search .search-select__control {\n    min-height: 24px;\n  }\n  .search-screen .person-search .search-select__control .icon-container svg {\n    height: 16px;\n    width: 16px;\n  }\n  .search-screen .person-search .search-select__multi-value {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n    height: 16px;\n    margin-top: 6px;\n  }\n  .search-screen .person-search .search-select__multi-value__remove svg {\n    height: 12px;\n    width: 12px;\n  }\n}\n.nackle-caption {\n  color: #59606d;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  margin-top: 2px;\n  padding-left: 10px;\n}\n.nackle-caption.error {\n  color: #de1b1b;\n}\n.nackle-caption.large {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  padding-left: 12px;\n}\n.nackle-caption.small {\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n  padding-left: 8px;\n}\n.nackle-caption.disabled {\n  color: #b1baca;\n}\n.disabled .nackle-caption {\n  color: #b1baca;\n}\n.ant-pagination {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n  background-color: #fff;\n  padding: 10px;\n  border-radius: 40px;\n}\n.ant-pagination:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-prev,\n.ant-pagination:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-next,\n.ant-pagination:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-item {\n  min-width: 26px;\n}\n.ant-pagination:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-prev:not(.ant-pagination-item-active, .ant-pagination-disabled):hover,\n.ant-pagination:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-next:not(.ant-pagination-item-active, .ant-pagination-disabled):hover,\n.ant-pagination:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-item:not(.ant-pagination-item-active, .ant-pagination-disabled):hover {\n  background-color: #f5f7fa;\n}\n.ant-pagination:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-prev:not(.ant-pagination-item-active, .ant-pagination-disabled):hover a,\n.ant-pagination:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-next:not(.ant-pagination-item-active, .ant-pagination-disabled):hover a,\n.ant-pagination:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-item:not(.ant-pagination-item-active, .ant-pagination-disabled):hover a,\n.ant-pagination:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-prev:not(.ant-pagination-item-active, .ant-pagination-disabled):hover button.ant-btn.ant-btn-circle.ant-btn-link.ant-btn-icon-only,\n.ant-pagination:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-next:not(.ant-pagination-item-active, .ant-pagination-disabled):hover button.ant-btn.ant-btn-circle.ant-btn-link.ant-btn-icon-only,\n.ant-pagination:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-item:not(.ant-pagination-item-active, .ant-pagination-disabled):hover button.ant-btn.ant-btn-circle.ant-btn-link.ant-btn-icon-only {\n  color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);\n}\n.ant-pagination li.ant-pagination-prev,\n.ant-pagination li.ant-pagination-next,\n.ant-pagination li.ant-pagination-item {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 36px;\n  width: 36px;\n  border-radius: 25px;\n}\n.ant-pagination .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,\n.ant-pagination .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {\n  position: absolute;\n  top: 16px;\n  inset-inline-end: 0;\n  bottom: 0;\n  inset-inline-start: 0;\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-pagination .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon svg,\n.ant-pagination .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon svg {\n  width: 20px;\n  height: 20px;\n}\n.ant-pagination .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-ellipsis,\n.ant-pagination .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-ellipsis {\n  color: #59606d;\n}\n.ant-pagination .ant-btn svg {\n  width: 20px;\n  height: 20px;\n}\n.ant-pagination .ant-btn:disabled {\n  background-color: #f5f7fa;\n  color: #b1baca;\n  border: 1px #c9d1df solid;\n  cursor: not-allowed;\n}\n.ant-pagination .ant-pagination-item {\n  border: none;\n}\n.ant-pagination .ant-pagination-item a {\n  font-weight: 600;\n  color: rgb(var(--color-primary-none, rgb(var(--color-primary-none, 89, 96, 109))));\n  padding: 0;\n}\n.ant-pagination .ant-pagination-item-active {\n  background-color: #fff;\n  border: 1px #c9d1df solid;\n}\n.ant-pagination .ant-pagination-item-active a {\n  color: #59606d;\n}\n.ant-pagination .ant-pagination-item-active:hover {\n  border: 1px #c9d1df solid;\n}\n.ant-pagination .ant-pagination-item-active:hover a {\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-pagination .ant-pagination-item-active {\n  cursor: default;\n}\n.ant-pagination .ant-pagination-item-active a {\n  cursor: default;\n}\n.ant-pagination .ant-pagination-item-active:hover {\n  color: #59606d;\n}\n.ant-pagination .ant-pagination-item-active:hover a {\n  color: #59606d;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-item > a {\n  color: #b1baca;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-item-active {\n  background-color: #f5f7fa;\n  border: 1px #c9d1df solid;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-item-active:hover {\n  background-color: #f5f7fa;\n}\n.ant-pagination.ant-pagination-disabled button.ant-btn {\n  color: #b1baca;\n  background-color: #f5f7fa;\n  border: 1px #c9d1df solid;\n  cursor: not-allowed;\n}\n.ant-pagination.ant-pagination-disabled button.ant-btn:hover {\n  color: #b1baca;\n}\n.ant-pagination.ant-pagination-disabled button.ant-btn .ant-btn-icon svg {\n  color: #b1baca;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-prev button,\n.ant-pagination.ant-pagination-disabled .ant-pagination-next button {\n  background-color: #f5f7fa;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-ellipsis,\n.ant-pagination.ant-pagination-disabled .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-ellipsis {\n  color: #b1baca;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-jump-prev:hover .ant-pagination-item-container .ant-pagination-item-ellipsis,\n.ant-pagination.ant-pagination-disabled .ant-pagination-jump-next:hover .ant-pagination-item-container .ant-pagination-item-ellipsis {\n  opacity: 1;\n}\n.ant-pagination.ant-pagination-disabled .ant-pagination-jump-prev:hover .ant-pagination-item-container .ant-pagination-item-link-icon,\n.ant-pagination.ant-pagination-disabled .ant-pagination-jump-next:hover .ant-pagination-item-container .ant-pagination-item-link-icon {\n  opacity: 0;\n}\n.ant-pagination.ant-pagination-large {\n  height: 64px;\n}\n.ant-pagination.ant-pagination-large li.ant-pagination-prev,\n.ant-pagination.ant-pagination-large li.ant-pagination-next,\n.ant-pagination.ant-pagination-large li.ant-pagination-item {\n  height: 44px;\n  width: 44px;\n  font-size: 16px;\n}\n.ant-pagination.ant-pagination-large li.ant-pagination-prev .ant-btn,\n.ant-pagination.ant-pagination-large li.ant-pagination-next .ant-btn,\n.ant-pagination.ant-pagination-large li.ant-pagination-item .ant-btn {\n  width: 44px;\n  height: 44px;\n}\n.ant-pagination.ant-pagination-large li.ant-pagination-prev .ant-btn svg,\n.ant-pagination.ant-pagination-large li.ant-pagination-next .ant-btn svg,\n.ant-pagination.ant-pagination-large li.ant-pagination-item .ant-btn svg {\n  width: 24px;\n  height: 24px;\n}\n.ant-pagination.ant-pagination-large .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,\n.ant-pagination.ant-pagination-large .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {\n  top: 16px;\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-pagination.ant-pagination-large .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon svg,\n.ant-pagination.ant-pagination-large .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon svg {\n  width: 24px;\n  height: 24px;\n}\n.ant-pagination.ant-pagination-mini {\n  height: 46px;\n}\n.ant-pagination.ant-pagination-mini li.ant-pagination-prev,\n.ant-pagination.ant-pagination-mini li.ant-pagination-next,\n.ant-pagination.ant-pagination-mini li.ant-pagination-item {\n  height: 26px;\n  width: 26px;\n  font-size: 12px;\n  margin-inline-end: 8px;\n}\n.ant-pagination.ant-pagination-mini li.ant-pagination-prev .ant-btn,\n.ant-pagination.ant-pagination-mini li.ant-pagination-next .ant-btn,\n.ant-pagination.ant-pagination-mini li.ant-pagination-item .ant-btn {\n  min-width: 26px;\n  width: 26px;\n  height: 26px;\n}\n.ant-pagination.ant-pagination-mini li.ant-pagination-prev .ant-btn svg,\n.ant-pagination.ant-pagination-mini li.ant-pagination-next .ant-btn svg,\n.ant-pagination.ant-pagination-mini li.ant-pagination-item .ant-btn svg {\n  width: 16px;\n  height: 16px;\n}\n.ant-pagination.ant-pagination-mini .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,\n.ant-pagination.ant-pagination-mini .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {\n  top: 12px;\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-pagination.ant-pagination-mini .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon svg,\n.ant-pagination.ant-pagination-mini .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon svg {\n  width: 16px;\n  height: 16px;\n}\n.ant-pagination.ant-pagination-simple {\n  color: #59606d;\n  background-color: transparent;\n  height: 26px;\n  padding: 0;\n  border-radius: 0;\n  border: 1px transparent solid;\n}\n.ant-pagination.ant-pagination-simple .ant-btn {\n  min-width: 26px;\n  width: 26px;\n  height: 26px;\n  padding: 0;\n}\n.ant-pagination.ant-pagination-simple .ant-btn svg {\n  width: 16px;\n  height: 16px;\n}\n.ant-pagination.ant-pagination-simple:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-prev,\n.ant-pagination.ant-pagination-simple:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-next {\n  width: 26px;\n  height: 26px;\n}\n.ant-pagination.ant-pagination-simple:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-prev:not(.ant-pagination-item-active, .ant-pagination-disabled):hover,\n.ant-pagination.ant-pagination-simple:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-next:not(.ant-pagination-item-active, .ant-pagination-disabled):hover {\n  background-color: #f5f7fa;\n}\n.ant-pagination.ant-pagination-simple:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-prev:not(.ant-pagination-item-active, .ant-pagination-disabled):hover a,\n.ant-pagination.ant-pagination-simple:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-next:not(.ant-pagination-item-active, .ant-pagination-disabled):hover a,\n.ant-pagination.ant-pagination-simple:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-prev:not(.ant-pagination-item-active, .ant-pagination-disabled):hover button.ant-btn.ant-btn-link.ant-btn-icon-only,\n.ant-pagination.ant-pagination-simple:not(.ant-pagination.ant-pagination-disabled) li.ant-pagination-next:not(.ant-pagination-item-active, .ant-pagination-disabled):hover button.ant-btn.ant-btn-link.ant-btn-icon-only {\n  color: #59606d;\n}\n.ant-pagination.ant-pagination-simple .ant-pagination-prev,\n.ant-pagination.ant-pagination-simple .ant-pagination-next {\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-pagination.ant-pagination-simple .ant-pagination-prev .ant-btn:focus,\n.ant-pagination.ant-pagination-simple .ant-pagination-next .ant-btn:focus {\n  outline: none;\n}\n.ant-pagination.ant-pagination-simple .ant-pagination-prev .ant-btn:disabled,\n.ant-pagination.ant-pagination-simple .ant-pagination-next .ant-btn:disabled {\n  background-color: transparent;\n  border: none;\n  color: #b1baca;\n}\n.ant-pagination.ant-pagination-simple .ant-pagination-simple-pager input {\n  width: 48px;\n  color: #59606d;\n}\n.ant-pagination.ant-pagination-simple .ant-pagination-simple-pager input:hover {\n  border-color: #c9d1df;\n}\n.ant-pagination.ant-pagination-simple .ant-pagination-simple-pager input:focus {\n  border-color: #c9d1df;\n  outline: none;\n  box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);\n  -webkit-box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);\n}\n.ant-pagination.ant-pagination-simple .ant-pagination-simple-pager input:disabled {\n  color: #b1baca;\n  background-color: #f5f7fa;\n  border-color: #c9d1df;\n}\n.ant-pagination.icon-only.icon-only {\n  background-color: transparent;\n}\n.ant-pagination.icon-only.icon-only li {\n  display: none;\n}\n.ant-pagination.icon-only.icon-only li:first-child {\n  display: flex;\n}\n.ant-pagination.icon-only.icon-only li:last-child {\n  display: flex;\n}\n.ant-pagination.icon-only.icon-only .ant-pagination-prev,\n.ant-pagination.icon-only.icon-only .ant-pagination-next {\n  background-color: white;\n  border: 1px #c9d1df solid;\n}\n.ant-pagination.icon-only.icon-only .ant-pagination-prev.ant-pagination-disabled,\n.ant-pagination.icon-only.icon-only .ant-pagination-next.ant-pagination-disabled {\n  background-color: #f5f7fa;\n}\n.ant-pagination.icon-only.icon-only .ant-btn:disabled {\n  border: none;\n}\n.ant-pagination.icon-only.icon-only.ant-pagination-mini li:first-child {\n  margin-inline-end: 8px;\n}\n.ant-pagination-slash {\n  position: relative;\n  top: 1px;\n}\n.icon-only .ant-pagination-chevron.ant-btn.ant-btn.ant-btn-link:not(:disabled) {\n  color: #59606d;\n}\n.ant-popconfirm .ant-popover-content .ant-popover-inner {\n  padding-left: 16px;\n  padding-right: 16px;\n  padding-top: 12px;\n  padding-bottom: 12px;\n  border-radius: 8px;\n}\n.ant-popconfirm .ant-popover-content .ant-popover-inner .ant-popconfirm-inner-content .ant-popconfirm-message {\n  margin-bottom: 12px;\n  align-items: center;\n}\n.ant-popconfirm .ant-popover-content .ant-popover-inner .ant-popconfirm-inner-content .ant-popconfirm-message .ant-popconfirm-message-icon {\n  display: flex;\n  align-items: center;\n  margin-right: 10px;\n  align-self: start;\n}\n.ant-popconfirm .ant-popover-content .ant-popover-inner .ant-popconfirm-inner-content .ant-popconfirm-message .ant-popconfirm-message-icon svg {\n  height: 16px;\n  width: 16px;\n  color: #fcc419;\n}\n.ant-popconfirm .ant-popover-content .ant-popover-inner .ant-popconfirm-inner-content .ant-popconfirm-message .ant-popconfirm-message-text .ant-popconfirm-title {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n}\n.ant-popconfirm .ant-popover-content .ant-popover-inner .ant-popconfirm-inner-content .ant-popconfirm-buttons {\n  display: flex;\n  justify-content: space-between;\n}\n.ant-popconfirm .ant-popover-content .ant-popover-inner .ant-popconfirm-inner-content .ant-popconfirm-buttons button.ant-btn {\n  margin-left: 0;\n  border-radius: 25px;\n}\n.ant-popover.ant-popover {\n  width: min-content;\n}\n.ant-popover-content {\n  font-weight: 400;\n  font-size: 14px;\n  color: #59606d;\n}\n.ant-popover-content .ant-list-header {\n  font-size: 12px;\n  color: #59606d;\n  font-weight: 600;\n}\n.ant-popover-content .ant-list .ant-list-item .ant-list-item-meta .ant-list-item-meta-title {\n  font-size: 14px;\n  font-weight: 600;\n}\n.ant-popover-content .ant-list .ant-list-item .ant-list-item-meta .ant-list-item-meta-description {\n  color: #59606d;\n  font-size: 12px;\n}\n.ant-popover-content .ant-popover-inner {\n  border-radius: 16px;\n  padding: 12px;\n}\n.ant-popover-content .ant-popover-inner .popover-shell-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px;\n}\n.ant-popover-content .ant-popover-inner .popover-shell-container .ant-image-img {\n  border-radius: 10px;\n}\n.ant-popover-content .ant-popover-inner .ant-popover-inner-content {\n  font-size: 14px;\n  color: #000000;\n  max-width: 444px;\n}\n.ant-popover-content .ant-popover-inner .ant-popover-inner-content .ant-menu {\n  border: none;\n}\n.ant-popover-content .ant-popover-inner .ant-popover-inner-content .ant-menu.ant-menu-vertical:focus {\n  box-shadow: none;\n}\n.ant-popover-content .ant-popover-inner .ant-popover-inner-content .ant-menu .ant-menu-item {\n  color: #59606d;\n}\n.ant-popover-content .ant-popover-inner .ant-popover-inner-content .ant-menu .ant-menu-item:hover {\n  background-color: #f5f7fa;\n}\n.ant-popover-content .ant-popover-inner .ant-popover-inner-content .popover-content {\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n.ant-popover-content .ant-popover-inner .ant-popover-inner-content .ant-divider {\n  border: 0.5px solid #c9d1df;\n  border-top: 0px;\n  margin: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.ant-popover-content .ant-popover-inner .ant-popover-title {\n  font-size: 16px;\n  margin: 0px;\n  color: #000000;\n}\n.progress-with-steps-extended {\n  width: 100%;\n}\n.progress-with-steps-extended .ant-progress-steps-outer .ant-progress-steps-item {\n  flex-grow: 1;\n  max-height: 10px;\n  min-height: 10px;\n}\n.progress-with-steps-extended .ant-progress-steps-outer .ant-progress-steps-item:not(.ant-progress-steps-item-active) {\n  background-color: #dee3ec;\n}\n.ant-progress-steps .ant-progress-steps-outer .ant-progress-steps-item {\n  flex-grow: 1;\n  max-height: 10px;\n  min-height: 10px;\n}\n.ant-progress-steps .ant-progress-steps-outer .ant-progress-steps-item:not(.ant-progress-steps-item-active) {\n  background-color: #dee3ec;\n}\n.vertical-align {\n  align-items: top;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  margin-top: 15px;\n}\n.ant-progress.ant-progress-line .ant-progress-outer .ant-progress-inner {\n  background-color: #dee3ec;\n}\n.ant-progress.ant-progress-circle.ant-progress-small-percent.ant-progress-circle-large .ant-progress-inner .ant-progress-text::after {\n  content: '%';\n  font-size: 24px;\n}\n.ant-progress.ant-progress-circle.ant-progress-small-percent.ant-progress-circle-medium .ant-progress-inner .ant-progress-text::after {\n  content: '%';\n  font-size: 18px;\n}\n.ant-progress.ant-progress-circle.ant-progress-small-percent.ant-progress-circle-small .ant-progress-inner .ant-progress-text::after {\n  font-size: 14px;\n  content: '%';\n}\n.ant-progress.ant-progress-circle.ant-progress-small-percent .ant-progress-inner .ant-progress-text ::after {\n  content: '%';\n}\n.ant-progress.ant-progress-large .ant-progress-outer .ant-progress-inner .ant-progress-bg {\n  min-height: 10px;\n}\n.ant-progress.ant-progress-large .ant-progress-text svg {\n  width: 16px;\n  height: 16px;\n}\n.ant-progress.ant-progress-medium .ant-progress-text svg {\n  width: 16px;\n  height: 16px;\n}\n.ant-progress.ant-progress-small .ant-progress-text svg {\n  width: 12px;\n  height: 12px;\n}\n.ant-progress.primary .ant-progress-inner .ant-progress-circle .ant-progress-circle-path {\n  stroke: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-progress.primary .ant-progress-inner .ant-progress-bg {\n  background-color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-progress .ant-progress-inner .ant-progress-circle .ant-progress-circle-path {\n  stroke: #1d5bbf;\n}\n.ant-progress .ant-progress-inner .ant-progress-bg {\n  background-color: #1d5bbf;\n}\n.ant-progress.ant-progress-circle .ant-progress-circle-trail {\n  stroke: #dee3ec;\n}\n.ant-progress.ant-progress-circle .ant-progress-inner .ant-progress-text {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 38px;\n  font-weight: 600;\n  color: #59606d;\n}\n.ant-progress.ant-progress-circle .ant-progress-inner .ant-progress-text svg {\n  height: 32px;\n  width: 32px;\n}\n.ant-progress.ant-progress-circle.ant-progress-circle-large .ant-progress-inner .ant-progress-text {\n  font-size: 38px;\n  color: #59606d;\n}\n.ant-progress.ant-progress-circle.ant-progress-circle-medium .ant-progress-inner .ant-progress-text {\n  font-size: 28px;\n  color: #59606d;\n}\n.ant-progress.ant-progress-circle.ant-progress-circle-small .ant-progress-inner .ant-progress-text {\n  font-size: 18px;\n  color: #59606d;\n}\n.ant-progress.ant-progress-steps .ant-progress-steps-outer .ant-progress-steps-item-active {\n  background-color: #1d5bbf;\n}\n.ant-progress.ant-progress-status-success .ant-progress-inner .ant-progress-circle .ant-progress-circle-path {\n  stroke: #038537;\n}\n.ant-progress.ant-progress-status-success .ant-progress-inner .ant-progress-text {\n  color: #038537;\n}\n.ant-progress.ant-progress-status-success .ant-progress-inner .ant-progress-text svg {\n  color: #038537;\n}\n.ant-progress.ant-progress-status-success .ant-progress-inner .ant-progress-bg {\n  background-color: #038537;\n}\n.ant-progress.ant-progress-status-success .ant-progress-text {\n  color: #038537;\n}\n.ant-progress.ant-progress-status-success .ant-progress-text span svg {\n  color: #038537;\n}\n.ant-progress.ant-progress-status-success .ant-progress-steps-outer .ant-progress-steps-item-active {\n  background-color: #038537;\n}\n.ant-progress.ant-progress-status-exception .ant-progress-inner .ant-progress-circle .ant-progress-circle-path {\n  stroke: #de1b1b;\n}\n.ant-progress.ant-progress-status-exception .ant-progress-inner .ant-progress-text {\n  color: #de1b1b;\n}\n.ant-progress.ant-progress-status-exception .ant-progress-inner .ant-progress-text svg {\n  color: #de1b1b;\n}\n.ant-progress.ant-progress-status-exception .ant-progress-inner .ant-progress-bg {\n  background-color: #de1b1b;\n}\n.ant-progress.ant-progress-status-exception .ant-progress-text {\n  color: #de1b1b;\n}\n.ant-progress.ant-progress-status-exception .ant-progress-text span svg {\n  color: #de1b1b;\n}\n.ant-progress.ant-progress-status-exception .ant-progress-steps-outer .ant-progress-steps-item-active {\n  background-color: #de1b1b;\n}\n.ant-progress .ant-progress-text {\n  color: #59606d;\n  font-weight: 600;\n}\n.ant-progress-circle {\n  position: relative;\n}\n.ant-progress-circle:not(.ant-progress-dashboard)::before {\n  height: 5px;\n  width: 5px;\n  border-radius: 50%;\n  background-color: white;\n  position: absolute;\n  content: ' ';\n  left: 50%;\n  top: 3px;\n  z-index: 10000;\n  transform: translateX(-50%);\n}\n.ant-result .ant-result-title {\n  font-size: 28px;\n  font-weight: 600;\n  margin-block: 0;\n}\n.ant-result .ant-result-subtitle {\n  font-size: 16px;\n  color: #59606d;\n  margin-top: 4px;\n}\n.ant-result .ant-result-icon {\n  margin-bottom: 0;\n}\n.ant-result .ant-result-icon img {\n  height: 300px;\n  width: 300px;\n}\n.ant-result .ant-result-icon svg {\n  width: 100px;\n  height: 100px;\n}\n.ant-result.ant-result-info .ant-result-icon {\n  color: #1d5bbf;\n}\n.ant-result.ant-result-warning .ant-result-icon {\n  color: #fcc419;\n}\n.ant-result.ant-result-success .ant-result-icon {\n  color: #038537;\n}\n.ant-result.ant-result-error .ant-result-icon {\n  color: #de1b1b;\n}\n.ant-result .ant-result-extra {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 18px;\n}\n.ant-result .ant-result-extra button {\n  margin-right: 20px;\n}\n.ant-result.result-small .ant-result-title {\n  font-size: 18px;\n}\n.ant-result.result-small .ant-result-subtitle {\n  font-size: 14px;\n}\n.ant-result.result-small .ant-result-extra {\n  margin-top: 14px;\n}\n.ant-result.result-small .ant-result-icon img {\n  height: 100px;\n  width: 100px;\n}\n.ant-result.result-small .ant-result-icon svg {\n  height: 48px;\n  width: 48px;\n}\n.ant-skeleton .ant-skeleton-content .ant-skeleton-title {\n  border-radius: 2px;\n  background: #eceff4;\n  margin-top: 0;\n}\n.ant-skeleton .ant-skeleton-content .ant-skeleton-paragraph {\n  margin-bottom: 0;\n}\n.ant-skeleton .ant-skeleton-content .ant-skeleton-paragraph li {\n  border-radius: 2px;\n  background: #eceff4;\n}\n.ant-skeleton.ant-skeleton-active .ant-skeleton-content .ant-skeleton-title {\n  background: linear-gradient(90deg, #eceff4 25%, #dee3ec 37%, #eceff4 63%);\n  background-size: 400% 100%;\n}\n.ant-skeleton.ant-skeleton-active .ant-skeleton-content .ant-skeleton-paragraph li {\n  background: linear-gradient(90deg, #eceff4 25%, #dee3ec 37%, #eceff4 63%);\n  background-size: 400% 100%;\n}\n.ant-spin-nested-loading > div .ant-spin {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n.ant-spin-nested-loading > div .ant-spin svg.ant-spin-dot {\n  top: unset;\n  inset-inline-start: unset;\n}\n.ant-spin-nested-loading > div .nackle-spin-small .ant-spin-text {\n  padding-top: 16px;\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-spin-nested-loading > div .nackle-spin-default .ant-spin-text {\n  padding-top: 40px;\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-spin-nested-loading > div .nackle-spin-large .ant-spin-text {\n  padding-top: 64px;\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-spin-nested-loading > div .nackle-spin-extra-large .ant-spin-text {\n  padding-top: 88px;\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-spin.nackle-spin-large svg {\n  width: 150px;\n  height: 150px;\n}\n.ant-spin.nackle-spin-extra-large svg {\n  width: 200px;\n  height: 200px;\n}\n.ant-spin.nackle-spin-default svg {\n  width: 100px;\n  height: 100px;\n}\n.ant-spin.nackle-spin-small svg {\n  width: 50px;\n  height: 50px;\n}\n.ant-tabs {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  box-shadow: none;\n}\n.ant-tabs .ant-tabs-nav .ant-tabs-nav-wrap {\n  transform: unset;\n}\n.ant-tabs .ant-tabs-nav-operations .ant-tabs-nav-more {\n  background-color: inherit;\n}\n.ant-tabs .ant-tabs-nav-operations .ant-tabs-nav-more svg {\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-tabs.ant-tabs-top .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-right::after {\n  box-shadow: inset -10px 0 8px -8px rgba(0, 0, 0, 0.08);\n}\n.ant-tabs.ant-tabs-bottom .ant-tabs-nav .ant-tabs-nav-wrap.ant-tabs-nav-wrap-ping-right::after {\n  box-shadow: inset -10px 0 8px -8px rgba(0, 0, 0, 0.08);\n}\n.ant-tabs .ant-tabs-tab.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n  text-shadow: none;\n}\n.ant-tabs .ant-tabs-tab .ant-tabs-tab-btn {\n  color: #59606d;\n  font-weight: 600;\n  box-shadow: none;\n  text-shadow: none;\n  display: flex;\n}\n.ant-tabs .ant-tabs-tab .ant-tabs-tab-btn:hover,\n.ant-tabs .ant-tabs-tab .ant-tabs-tab-btn:active,\n.ant-tabs .ant-tabs-tab .ant-tabs-tab-btn:focus {\n  color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);\n}\n.ant-tabs .ant-tabs-tab .ant-tabs-tab-btn > span {\n  display: flex;\n  align-items: center;\n}\n.ant-tabs .ant-tabs-tab .ant-tabs-tab-btn > span > div {\n  display: flex;\n  align-items: center;\n}\n.ant-tabs .ant-tabs-tab .ant-tabs-tab-btn > span > div svg {\n  margin-right: 6px;\n}\n.ant-tabs .ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-btn {\n  color: #b1baca;\n  text-shadow: none;\n}\n.ant-tabs .ant-tabs-tab.ant-tabs-tab-disabled .ant-tabs-tab-btn:hover {\n  color: #b1baca;\n}\n.ant-tabs.ant-tabs-large .ant-tabs-tab-btn {\n  font-size: 16px;\n}\n.ant-tabs.ant-tabs-large .ant-tabs-tab-btn svg {\n  width: 24px;\n  height: 24px;\n}\n.ant-tabs.ant-tabs-large .ant-tabs-nav-add {\n  padding: 11px 12px;\n}\n.ant-tabs.ant-tabs-middle .ant-tabs-tab-btn {\n  font-size: 14px;\n}\n.ant-tabs.ant-tabs-middle .ant-tabs-tab-btn svg {\n  width: 20px;\n  height: 20px;\n}\n.ant-tabs.ant-tabs-middle .ant-tabs-nav-add {\n  padding: 8px;\n  border-radius: 6px 6px 0px 0px;\n}\n.ant-tabs.ant-tabs-left.ant-tabs-middle .ant-tabs-tab,\n.ant-tabs.ant-tabs-right.ant-tabs-middle .ant-tabs-tab {\n  padding: 12px 24px;\n}\n.ant-tabs.ant-tabs-small .ant-tabs-nav {\n  height: 34.84px;\n}\n.ant-tabs.ant-tabs-small .ant-tabs-nav .ant-tabs-nav-operations .ant-tabs-nav-more {\n  padding: 4px 5.5px;\n}\n.ant-tabs.ant-tabs-small .ant-tabs-tab-btn {\n  font-size: 12px;\n}\n.ant-tabs.ant-tabs-small .ant-tabs-tab-btn svg {\n  width: 16px;\n  height: 16px;\n}\n.ant-tabs.ant-tabs-small .ant-tabs-nav-add {\n  padding: 6px;\n  border-radius: 4px 4px 0 0;\n}\n.ant-tabs.ant-tabs-left.ant-tabs-small .ant-tabs-tab,\n.ant-tabs.ant-tabs-right.ant-tabs-small .ant-tabs-tab {\n  padding: 8px 24px;\n}\n.ant-tabs > *.ant-tabs-nav .ant-tabs-ink-bar {\n  height: 4px;\n  width: 4px;\n  background: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-tabs.ant-tabs-top .ant-tabs-nav .ant-tabs-nav-wrap::after,\n.ant-tabs.ant-tabs-bottom .ant-tabs-nav .ant-tabs-nav-wrap::after {\n  box-shadow: none;\n}\n.ant-tabs.ant-tabs-top > .ant-tabs-nav::before,\n.ant-tabs.ant-tabs-bottom > .ant-tabs-nav::before {\n  border: 1px solid #c9d1df;\n  border-bottom: none;\n}\n.ant-tabs.ant-tabs-left > .ant-tabs-content-holder {\n  border-left: 1px solid #c9d1df;\n}\n.ant-tabs.ant-tabs-right > .ant-tabs-content-holder {\n  border-right: 1px solid #c9d1df;\n}\n.ant-tabs-card .ant-tabs-nav .ant-tabs-nav-add,\n.ant-tabs-card .ant-tabs-nav .ant-tabs-tab {\n  border: 1px solid #c9d1df;\n  background-color: #ffffff;\n  min-width: 0px;\n}\n.ant-tabs-card .ant-tabs-nav .ant-tabs-nav-add.ant-tabs-tab-disabled,\n.ant-tabs-card .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-disabled {\n  color: #b1baca;\n  background-color: #f5f7fa;\n}\n.ant-tabs-card .ant-tabs-nav .ant-tabs-nav-add {\n  color: #59606d;\n}\n.ant-tabs-card .ant-tabs-nav .ant-tabs-nav-add:hover {\n  color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);\n}\n.ant-tabs-card.ant-tabs-large .ant-tabs-nav .ant-tabs-nav-add {\n  background-color: #ffffff;\n  border-radius: 8px 8px 0 0;\n  padding: 7px 11px;\n  height: 40px;\n}\n.ant-tabs-card.ant-tabs-middle .ant-tabs-nav .ant-tabs-nav-add {\n  background-color: #ffffff;\n  border-radius: 6px 6px 0 0;\n  padding: 7px;\n  height: 36px;\n}\n.ant-tabs-card.ant-tabs-middle .ant-tabs-nav .ant-tabs-nav-add svg {\n  height: 20px;\n  width: 20px;\n}\n.ant-tabs-card.ant-tabs-small {\n  border-radius: 4px 4px 0 0;\n}\n.ant-tabs-card.ant-tabs-small .ant-tabs-nav .ant-tabs-nav-add {\n  background-color: #ffffff;\n  border-radius: 4px;\n  padding: 4px;\n  height: 28px;\n}\n.ant-tabs-card.ant-tabs-small .ant-tabs-nav .ant-tabs-nav-add svg {\n  height: 16px;\n  width: 16px;\n}\n.ant-tabs-card .ant-tabs-nav::before {\n  border: none;\n}\n.ant-tabs-card .ant-tabs-tab-btn {\n  margin-right: 10px;\n}\n.ant-tabs-card .ant-tabs-tab-remove {\n  margin-left: 0;\n  padding: 0;\n}\n.ant-tabs-card.ant-tabs-large > .ant-tabs-nav .ant-tabs-tab {\n  border-radius: 8px 8px 0 0;\n  padding: 8px 16px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 24px;\n  height: 40px;\n}\n.ant-tabs-card.ant-tabs-large > .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-remove {\n  height: 24px;\n}\n.ant-tabs-card.ant-tabs-middle > .ant-tabs-nav .ant-tabs-tab {\n  border-radius: 6px 6px 0 0;\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  text-align: left;\n  height: 36px;\n}\n.ant-tabs-card.ant-tabs-middle > .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-remove {\n  height: 20px;\n}\n.ant-tabs-card.ant-tabs-small > .ant-tabs-nav .ant-tabs-tab {\n  border-radius: 4px 4px 0 0;\n  padding: 6px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n  height: 28px;\n}\n.ant-tabs-card.ant-tabs-small > .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-remove {\n  height: 16px;\n}\n.ant-tabs-dropdown {\n  width: 178px;\n  max-height: 218px;\n  border-radius: 8px;\n}\n.ant-tabs-dropdown .ant-menu.more-tabs-menu {\n  width: 100%;\n  max-height: 218px;\n  overflow: scroll;\n  padding: 0px;\n  border-radius: 8px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n.ant-tabs-dropdown .ant-menu.more-tabs-menu .ant-menu-item {\n  height: 30px;\n  border-radius: 4px;\n  margin-block: 0px;\n}\n.ant-tabs-dropdown .ant-menu.more-tabs-menu .ant-menu-item .ant-menu-title-content {\n  font-size: 14px;\n  font-weight: 400;\n}\n.ant-tabs-dropdown .ant-menu.more-tabs-menu .ant-menu-item:hover {\n  background-color: #f5f7fa;\n}\n.ant-tabs-dropdown .ant-menu.more-tabs-menu .ant-menu-item.ant-menu-item-selected {\n  background-color: rgb(var(--color-primary-none, 89, 96, 109));\n  color: white;\n}\n.ant-tabs-dropdown .ant-menu.more-tabs-menu .ant-menu-item.ant-menu-item-selected:hover {\n  background-color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-tabs-dropdown .ant-menu.more-tabs-menu .ant-menu-item.ant-menu-item-disabled {\n  background-color: #f5f7fa !important;\n}\n.ant-tabs-dropdown .ant-menu.more-tabs-menu .ant-menu-item.ant-menu-item-disabled .ant-menu-title-content {\n  color: #b1baca;\n}\n.ant-tabs-dropdown .ant-menu-light:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover {\n  background-color: #f5f7fa;\n}\n.ant-tag {\n  font-family: var(--body-font-family-none, Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, color emoji, segoe ui emoji, noto color emoji, android emoji);\n  background-color: #f5f7fa;\n  border: 1px solid #c9d1df;\n  border-radius: 6px;\n  color: #59606d;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0px;\n  line-height: 14px;\n  padding: 1px 8px 1px 1px;\n}\n.ant-tag.ant-tag-borderless {\n  border: none;\n}\n.ant-tag .ant-tag-close-icon {\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  margin-left: 8px;\n  color: #59606D;\n  text-shadow: none;\n  box-shadow: none;\n}\n.ant-tag.ant-tag-has-color {\n  color: #f5f7fa;\n}\n.ant-tag.ant-tag-has-color.color-tag-medium {\n  padding: 2px 10px 2px 10px;\n}\n.ant-tag.ant-tag-has-color.color-tag-large {\n  padding: 2px 12px 2px 12px;\n}\n.ant-tag.error {\n  border-radius: 5px;\n  background-color: #faf0f0;\n  border-color: #de1b1b;\n  color: #59606d;\n}\n.ant-tag.warning {\n  border-radius: 5px;\n  background-color: #fff9db;\n  border-color: #fcc419;\n  color: #59606d;\n}\n.ant-tag.warning-tag {\n  color: #000000;\n}\n.ant-tag.success {\n  border-radius: 5px;\n  background-color: #e1faeb;\n  border-color: #038537;\n  color: #59606d;\n}\n.ant-tag.processing {\n  border-radius: 5px;\n  background-color: #f0f5fc;\n  border-color: #1d5bbf;\n  color: #59606d;\n}\n.ant-tag.purple {\n  border-radius: 5px;\n  background-color: #f5f0fa;\n  border-color: #7d3cbd;\n  color: #59606d;\n}\n.ant-tag.default {\n  border-radius: 5px;\n  background-color: #59606d;\n  border-color: #59606d;\n  color: #59606d;\n}\n.ant-tag > span.anticon {\n  margin-inline-start: 4px;\n  margin: 2px;\n  color: #59606d;\n}\n.ant-tag .ant-avatar {\n  width: 24px;\n  height: 24px;\n  border-radius: 4px;\n  margin-right: 8px;\n}\n.ant-tag.square-tag,\n.ant-tag.round-tag {\n  background-color: white;\n  border-radius: 5px;\n  padding: 1px 16px 1px 1px;\n}\n.ant-tag.square-tag.round-tag,\n.ant-tag.round-tag.round-tag {\n  border-radius: 18px;\n}\n.ant-tag.square-tag.round-tag .ant-avatar,\n.ant-tag.round-tag.round-tag .ant-avatar {\n  border-radius: 96px;\n}\n.ant-tag.square-tag:hover,\n.ant-tag.round-tag:hover {\n  background-color: #f5f7fa;\n}\n.ant-tag.square-tag > span,\n.ant-tag.round-tag > span {\n  font-size: 16px;\n  font-weight: 600;\n  display: flex;\n  justify-content: center;\n}\n.ant-tag.square-tag-close,\n.ant-tag.round-tag-close {\n  background-color: white;\n  border-radius: 5px;\n}\n.ant-tag.square-tag-close.round-tag-close,\n.ant-tag.round-tag-close.round-tag-close {\n  border-radius: 18px;\n}\n.ant-tag.square-tag-close.round-tag-close .ant-avatar,\n.ant-tag.round-tag-close.round-tag-close .ant-avatar {\n  border-radius: 96px;\n}\n.ant-tag.square-tag-close:hover,\n.ant-tag.round-tag-close:hover {\n  background-color: #f5f7fa;\n}\n.ant-tag.square-tag-close > span,\n.ant-tag.round-tag-close > span {\n  font-size: 16px;\n  font-weight: 600;\n  display: flex;\n  justify-content: center;\n}\n.ant-tag.generic-tag-mini.generic-tag-mini {\n  padding: 2px 8px;\n  font-size: 10px;\n  line-height: 14px;\n  border-radius: 4px;\n  min-height: 18px;\n  height: auto;\n  text-wrap: wrap;\n  white-space: normal;\n}\n.ant-tag.generic-tag-small.generic-tag-small {\n  padding: 2px 8px;\n  font-size: 12px;\n  line-height: 16px;\n  min-height: 20px;\n  height: auto;\n  text-wrap: wrap;\n  white-space: normal;\n}\n.ant-tag.generic-tag-medium.generic-tag-medium {\n  padding: 2px 10px;\n  font-size: 14px;\n  line-height: 20px;\n  min-height: 24px;\n  height: auto;\n  text-wrap: wrap;\n  white-space: normal;\n}\n.ant-tag.generic-tag-large.generic-tag-large {\n  padding: 2px 12px;\n  font-size: 16px;\n  line-height: 24px;\n  min-height: 28px;\n  height: auto;\n  text-wrap: wrap;\n  white-space: normal;\n}\n.ant-tag.generic-close-tag-mini {\n  padding: 2px 5px 2px 8px;\n}\n.ant-tag.generic-close-tag-small {\n  padding: 2px 5px 2px 8px;\n}\n.ant-tag.generic-close-tag-medium {\n  padding: 2px 6px 2px 10px;\n}\n.ant-tag.generic-close-tag-large {\n  padding: 2px 8px 2px 12px;\n}\n.origami-time-picker-dropdown .ant-picker-time-panel-container {\n  width: 100%;\n  border-radius: 4px;\n}\n.origami-time-picker-dropdown .ant-picker-time-panel-container .ant-picker-panel-layout {\n  width: 100%;\n  display: block;\n}\n.origami-time-picker-dropdown .ant-picker-time-panel-container .ant-picker-panel-layout .ant-picker-panel {\n  width: 100%;\n  height: 208px;\n}\n.origami-time-picker-dropdown .ant-picker-time-panel-container .ant-picker-panel-layout .ant-picker-panel .ant-picker-time-panel {\n  height: 100%;\n  padding-top: 0px;\n}\n.origami-time-picker-dropdown .ant-picker-time-panel-container .ant-picker-panel-layout .ant-picker-panel .ant-picker-time-panel .ant-picker-content {\n  height: 100%;\n}\n.origami-time-picker-dropdown .ant-picker-time-panel-container .ant-picker-panel-layout .ant-picker-panel .ant-picker-time-panel .ant-picker-content .ant-picker-time-panel-cell {\n  display: flex;\n  justify-content: center;\n  height: 26px;\n}\n.origami-time-picker-dropdown .ant-picker-time-panel-container .ant-picker-panel-layout .ant-picker-panel .ant-picker-time-panel .ant-picker-content .ant-picker-time-panel-cell .ant-picker-time-panel-cell-inner {\n  width: 100%;\n}\n.origami-time-picker-dropdown .ant-picker-time-panel-container .ant-picker-footer {\n  height: 42px;\n}\n.origami-time-picker-dropdown .ant-picker-time-panel-container .ant-picker-footer .ant-picker-now {\n  height: 26px;\n  display: flex;\n  align-items: center;\n  border-radius: 25px;\n}\n.origami-time-picker-dropdown .ant-picker-time-panel-container .ant-picker-footer .ant-picker-now:hover {\n  background-color: #f5f7fa;\n}\n.origami-time-picker-dropdown .ant-picker-time-panel-container .ant-picker-footer .ant-picker-now .ant-picker-now-btn:hover {\n  background-color: none;\n}\n.origami-time-picker-dropdown.origami-time-picker-dropdown-HHmm .ant-picker-content,\n.origami-time-picker-dropdown.origami-time-picker-dropdown-ha .ant-picker-content {\n  width: 140px;\n}\n.origami-time-picker-dropdown.origami-time-picker-dropdown-HHmm .ant-picker-content .ant-picker-time-panel-cell,\n.origami-time-picker-dropdown.origami-time-picker-dropdown-ha .ant-picker-content .ant-picker-time-panel-cell {\n  width: 70px;\n}\n.origami-time-picker-dropdown.origami-time-picker-dropdown-HH .ant-picker-content {\n  width: 70px;\n}\n.origami-time-picker-dropdown.origami-time-picker-dropdown-HH .ant-picker-content ul:nth-child(2) {\n  display: none;\n}\n.origami-time-picker-dropdown.origami-time-picker-dropdown-HH .ant-picker-content .ant-picker-time-panel-cell {\n  width: 70px;\n}\n.origami-time-picker-dropdown.origami-time-picker-dropdown-hhmma .ant-picker-content {\n  width: 164px;\n}\n.origami-time-picker-dropdown.origami-time-picker-dropdown-hhmma .ant-picker-content .ant-picker-time-panel-column {\n  width: 54.6px;\n}\n.origami-time-picker-dropdown.origami-time-picker-dropdown-hhmma .ant-picker-content .ant-picker-time-panel-column .ant-picker-time-panel-cell {\n  width: 54.6px;\n}\n.ant-tooltip {\n  background-color: #444a53;\n  border-radius: 4px;\n  --antd-arrow-background-color: #444a53;\n}\n.ant-tooltip .ant-tooltip-inner {\n  background-color: transparent;\n  padding: 12px 16px;\n  font-size: 14px;\n  font-weight: 400;\n  border-radius: 4px;\n}\n.ant-transfer {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-family: var(--body-font-family-none, Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, color emoji, segoe ui emoji, noto color emoji, android emoji);\n  width: 568px;\n  min-height: 240px;\n}\n.ant-transfer .ant-transfer-list {\n  width: 296px;\n  height: fit-content;\n  border: 1px solid #DEE3EC;\n  overflow: hidden;\n}\n.ant-transfer .ant-transfer-operation {\n  display: flex;\n  padding: 8px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  border-radius: 30px;\n  border: 1px solid #DEE3EC;\n  background: #FFFFFF;\n}\n.ant-transfer .ant-btn {\n  width: 36px !important;\n  height: 36px !important;\n  border-radius: 25px !important;\n  display: flex !important;\n  padding: 8px;\n  align-items: center;\n  gap: 9px;\n  border-radius: 25px;\n  border: 1px solid #c9d1df;\n}\n.ant-transfer .ant-btn.ant-btn:disabled {\n  background-color: #FFFFFF !important;\n}\n.ant-transfer .ant-btn-icon {\n  margin-inline-end: 0px !important;\n}\n.ant-transfer .ant-transfer-list-header {\n  padding: 10px 12px;\n  justify-content: space-between;\n  align-self: stretch;\n  box-shadow: 0px -1px 0px 0px #eceff4 inset;\n}\n.ant-transfer .ant-transfer-list-content-item {\n  height: 32px;\n  padding: 6px 12px;\n  justify-content: center;\n  align-items: flex-start;\n  flex-shrink: 0;\n  align-self: stretch;\n}\n.ant-transfer .ant-transfer-list-content-item:hover {\n  fill: #f5f7fa;\n}\n.ant-transfer .ant-transfer-list-content-item-checked {\n  background-color: #FFFFFF;\n}\n.ant-transfer .ant-transfer-list-content {\n  max-height: 192px;\n  height: 192px;\n  min-height: 192px;\n  background-color: #FFFFFF;\n  border-radius: 0px 0px 8px 8px;\n}\n.ant-transfer .ant-transfer-list-header-title {\n  color: #59606d;\n  text-align: right;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 14px;\n}\n.ant-transfer .ant-transfer-list-header-selected {\n  color: black;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.ant-transfer .ant-transfer-list-body-not-found {\n  min-height: 192px;\n  height: 192px;\n}\n.ant-transfer .ant-transfer-list-body {\n  background-color: #FFFFFF;\n  border-radius: 0px 0px 8px 8px;\n}\n.ant-transfer .ant-empty-small {\n  margin: 25%;\n}\n.ant-transfer .ant-checkbox-input {\n  border-color: #b1baca;\n}\n/* === Typography styles === */\nh1.ant-typography,\nh2.ant-typography,\nh3.ant-typography,\nh4.ant-typography,\nh5.ant-typography,\nh6.ant-typography,\np.ant-typography,\na.ant-typography,\nspan.ant-typography,\ndiv.ant-typography {\n  margin: 0;\n  font-family: var(--body-font-family-none, Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, color emoji, segoe ui emoji, noto color emoji, android emoji);\n  font-size: 16px;\n  font-weight: 400;\n}\nh1.ant-typography + *.ant-typography,\nh2.ant-typography + *.ant-typography,\nh3.ant-typography + *.ant-typography,\nh4.ant-typography + *.ant-typography,\nh5.ant-typography + *.ant-typography,\nh6.ant-typography + *.ant-typography,\np.ant-typography + *.ant-typography,\na.ant-typography + *.ant-typography,\nspan.ant-typography + *.ant-typography,\ndiv.ant-typography + *.ant-typography {\n  margin: 0;\n}\nh1.ant-typography.ant-typography-light,\nh2.ant-typography.ant-typography-light,\nh3.ant-typography.ant-typography-light,\nh4.ant-typography.ant-typography-light,\nh5.ant-typography.ant-typography-light,\nh6.ant-typography.ant-typography-light,\np.ant-typography.ant-typography-light,\na.ant-typography.ant-typography-light,\nspan.ant-typography.ant-typography-light,\ndiv.ant-typography.ant-typography-light {\n  font-weight: 300;\n}\nh1.ant-typography.ant-typography-semibold,\nh2.ant-typography.ant-typography-semibold,\nh3.ant-typography.ant-typography-semibold,\nh4.ant-typography.ant-typography-semibold,\nh5.ant-typography.ant-typography-semibold,\nh6.ant-typography.ant-typography-semibold,\np.ant-typography.ant-typography-semibold,\na.ant-typography.ant-typography-semibold,\nspan.ant-typography.ant-typography-semibold,\ndiv.ant-typography.ant-typography-semibold {\n  font-weight: 600;\n}\nh1.ant-typography.ant-typography-bold,\nh2.ant-typography.ant-typography-bold,\nh3.ant-typography.ant-typography-bold,\nh4.ant-typography.ant-typography-bold,\nh5.ant-typography.ant-typography-bold,\nh6.ant-typography.ant-typography-bold,\np.ant-typography.ant-typography-bold,\na.ant-typography.ant-typography-bold,\nspan.ant-typography.ant-typography-bold,\ndiv.ant-typography.ant-typography-bold {\n  font-weight: 700;\n}\nh1.ant-typography.ant-typography-danger,\nh2.ant-typography.ant-typography-danger,\nh3.ant-typography.ant-typography-danger,\nh4.ant-typography.ant-typography-danger,\nh5.ant-typography.ant-typography-danger,\nh6.ant-typography.ant-typography-danger,\np.ant-typography.ant-typography-danger,\na.ant-typography.ant-typography-danger,\nspan.ant-typography.ant-typography-danger,\ndiv.ant-typography.ant-typography-danger {\n  color: #de1b1b;\n}\nh1.ant-typography.ant-typography-secondary,\nh2.ant-typography.ant-typography-secondary,\nh3.ant-typography.ant-typography-secondary,\nh4.ant-typography.ant-typography-secondary,\nh5.ant-typography.ant-typography-secondary,\nh6.ant-typography.ant-typography-secondary,\np.ant-typography.ant-typography-secondary,\na.ant-typography.ant-typography-secondary,\nspan.ant-typography.ant-typography-secondary,\ndiv.ant-typography.ant-typography-secondary {\n  color: #59606d;\n}\nh1.ant-typography.ant-typography-success,\nh2.ant-typography.ant-typography-success,\nh3.ant-typography.ant-typography-success,\nh4.ant-typography.ant-typography-success,\nh5.ant-typography.ant-typography-success,\nh6.ant-typography.ant-typography-success,\np.ant-typography.ant-typography-success,\na.ant-typography.ant-typography-success,\nspan.ant-typography.ant-typography-success,\ndiv.ant-typography.ant-typography-success {\n  color: #038537;\n}\nh1.ant-typography.ant-typography-warning,\nh2.ant-typography.ant-typography-warning,\nh3.ant-typography.ant-typography-warning,\nh4.ant-typography.ant-typography-warning,\nh5.ant-typography.ant-typography-warning,\nh6.ant-typography.ant-typography-warning,\np.ant-typography.ant-typography-warning,\na.ant-typography.ant-typography-warning,\nspan.ant-typography.ant-typography-warning,\ndiv.ant-typography.ant-typography-warning {\n  color: #fcc419;\n}\na.ant-typography {\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n  text-decoration: underline;\n}\na.ant-typography.ant-typography-disabled {\n  color: #b1baca;\n}\na.ant-typography:visited {\n  color: #59606d;\n}\na.ant-typography:hover {\n  color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);\n  text-decoration: underline;\n  opacity: 90%;\n}\na.ant-typography:focus {\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n  opacity: 90%;\n  box-shadow: 0px 0px 4px 0px #3272d9;\n  border-radius: 4px;\n}\na.ant-typography:active {\n  color: black;\n  box-shadow: none;\n  text-decoration: underline;\n}\nh1.ant-typography {\n  font-size: 44px;\n  line-height: 60px;\n}\nh2.ant-typography {\n  font-size: 34px;\n  line-height: 46px;\n}\nh3.ant-typography {\n  font-size: 28px;\n  line-height: 38px;\n}\nh4.ant-typography {\n  font-size: 22px;\n  line-height: 30px;\n}\nh5.ant-typography {\n  font-size: 18px;\n  line-height: 25px;\n}\nh6.ant-typography-heading-6 {\n  font-size: 16px;\n  line-height: 22px;\n}\nspan.ant-typography-label-1 {\n  font-size: 16px;\n  line-height: 22px;\n  letter-spacing: 1px;\n}\nspan.ant-typography-label-2 {\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\nspan.ant-typography-label-3 {\n  font-size: 18px;\n  line-height: 28px;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\nspan.ant-typography-size-8 {\n  font-size: 8px;\n  line-height: 12px;\n}\nspan.ant-typography-size-10 {\n  font-size: 10px;\n  line-height: 14px;\n}\nspan.ant-typography-size-12 {\n  font-size: 12px;\n  line-height: 16px;\n}\nspan.ant-typography-size-14 {\n  font-size: 14px;\n  line-height: 20px;\n}\nspan.ant-typography-size-16 {\n  font-size: 16px;\n  line-height: 24px;\n}\nspan.ant-typography-size-18 {\n  font-size: 18px;\n  line-height: 28px;\n}\nspan.ant-typography-size-24 {\n  font-size: 24px;\n  line-height: 32px;\n}\nspan.ant-typography-size-30 {\n  font-size: 30px;\n  line-height: 40px;\n}\nspan.ant-typography-size-38 {\n  font-size: 38px;\n  line-height: 52px;\n}\nspan.ant-typography-size-44 {\n  font-size: 44px;\n  line-height: 60px;\n}\nspan.ant-typography-size-52 {\n  font-size: 52px;\n  line-height: 68px;\n}\nspan.ant-typography-size-60 {\n  font-size: 60px;\n  line-height: 80px;\n}\nspan.ant-typography-size-68 {\n  font-size: 68px;\n  line-height: 93px;\n}\nspan.ant-typography-size-84 {\n  font-size: 84px;\n  line-height: 114px;\n}\n.nackle-upload.nackle-upload-large {\n  max-width: 566px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.nackle-upload.nackle-upload-large .upload-container {\n  width: 100%;\n}\n.nackle-upload.nackle-upload-large .upload-container .upload-content .dropzone-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 211px;\n  max-width: 566px;\n  border: 1px dashed #c9d1df;\n  border-radius: 12px;\n  background-color: #ffffff;\n  margin-bottom: 10px;\n}\n.nackle-upload.nackle-upload-large .upload-container .upload-content .dropzone-container .upload-icon-div .upload-icon {\n  width: 48px;\n  height: 48px;\n  color: #c9d1df;\n}\n.nackle-upload.nackle-upload-large .upload-container .upload-content .dropzone-container .upload-icon-div .upload-icon.error {\n  color: #de1b1b;\n}\n.nackle-upload.nackle-upload-large .upload-container .upload-content .dropzone-container .upload-instructions {\n  max-width: 518px;\n  margin: 0px 24px 5px 24px;\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  font-size: 18px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.nackle-upload.nackle-upload-large .upload-container .upload-content .dropzone-container .upload-instructions .fake-link {\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n  text-decoration: underline;\n}\n.nackle-upload.nackle-upload-large .upload-container .upload-content .dropzone-container .large-upload-parameters {\n  max-width: 518px;\n  margin: 0px 24px 0px 24px;\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  color: #59606d;\n  font-size: 14px;\n}\n.nackle-upload.nackle-upload-large .upload-container .upload-content .dropzone-container:hover {\n  border: 1px dashed rgb(var(--color-primary-none, 89, 96, 109));\n  background-color: #f5f7fa;\n}\n.nackle-upload.nackle-upload-large .upload-container .upload-content .dropzone-container.error {\n  border: #de1b1b solid 1px;\n  background-image: none;\n  width: 100%;\n}\n.nackle-upload.nackle-upload-large .upload-container .upload-content .dropzone-container.error .upload-instructions {\n  cursor: default;\n}\n.nackle-upload.nackle-upload-large .upload-container .upload-content .dropzone-container.error .error-buttons {\n  display: flex;\n  margin-top: 10px;\n  justify-content: center;\n}\n.nackle-upload.nackle-upload-large .upload-container .upload-content .dropzone-container.error .error-buttons .cancel-button {\n  margin-right: 10px;\n}\n.nackle-upload.nackle-upload-large .upload-container .upload-content .dropzone-container.error .error-buttons .new-upload-button {\n  margin-left: 10px;\n}\n.nackle-upload.nackle-upload-medium {\n  max-width: 566px;\n}\n.nackle-upload.nackle-upload-medium .upload-container {\n  width: 100%;\n}\n.nackle-upload.nackle-upload-medium .upload-container .upload-content .dropzone-container {\n  max-width: 566px;\n  height: 67px;\n  display: flex;\n  align-items: center;\n  border: 1px dashed #c9d1df;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-bottom: 10px;\n}\n.nackle-upload.nackle-upload-medium .upload-container .upload-content .dropzone-container .upload-instructions {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.nackle-upload.nackle-upload-medium .upload-container .upload-content .dropzone-container .upload-instructions .fake-link {\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n  text-decoration: underline;\n}\n.nackle-upload.nackle-upload-medium .upload-container .upload-content .dropzone-container:hover {\n  border: 1px dashed rgb(var(--color-primary-none, 89, 96, 109));\n  background-color: #f5f7fa;\n}\n.nackle-upload.nackle-upload-medium .upload-container .upload-content .medium-upload-parameters {\n  width: 566px;\n  font-size: 12px;\n  color: #59606d;\n  text-align: center;\n  margin-bottom: 10px;\n}\n.nackle-upload.nackle-upload-small {\n  display: flex;\n  flex-direction: column;\n  max-width: 313px;\n}\n.nackle-upload.nackle-upload-small .upload-container {\n  width: 100%;\n  height: 128px;\n}\n.nackle-upload.nackle-upload-small .upload-container .upload-content {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n.nackle-upload.nackle-upload-small .upload-container .upload-content .dropzone-container {\n  height: 128px;\n  width: 128px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  border: 1px dashed #c9d1df;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-bottom: 10px;\n}\n.nackle-upload.nackle-upload-small .upload-container .upload-content .dropzone-container .upload-icon-div .upload-icon {\n  width: 32px;\n  height: 32px;\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.nackle-upload.nackle-upload-small .upload-container .upload-content .dropzone-container .upload-instructions {\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n}\n.nackle-upload.nackle-upload-small .upload-container .upload-content .dropzone-container:hover {\n  border: 1px dashed rgb(var(--color-primary-none, 89, 96, 109));\n  background-color: #f5f7fa;\n}\n.nackle-upload .uploaded-files-list-container {\n  width: 566px;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list {\n  width: 100%;\n  list-style-type: none;\n  padding-left: 0px;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file {\n  height: 44px;\n  width: 100%;\n  background-color: #ffffff;\n  border-radius: 4px;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file .uploaded-file-row {\n  height: 44px;\n  align-items: center;\n  justify-content: start;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file .uploaded-file-row .icon-col {\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file .uploaded-file-row .icon-col svg {\n  margin: 0px 6px 0px 6px;\n  color: #59606d;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file .uploaded-file-row .path-col {\n  align-items: center;\n  font-size: 12px;\n  width: 84%;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file .uploaded-file-row .path-col .file-path {\n  display: flex;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  width: 100%;\n  color: #000000;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file .uploaded-file-row .delete-button-col {\n  display: flex;\n  align-items: center;\n  margin-left: 10px;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file .uploaded-file-row .delete-button-col .ant-btn {\n  background-color: transparent;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file .uploaded-file-row .delete-button-col .ant-btn:hover {\n  background-color: transparent;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file .uploaded-file-row:hover {\n  background-color: #f5f7fa;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file .uploaded-file-row:hover .delete-button-col .delete-button {\n  background-color: transparent;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file .uploaded-file-row:hover .delete-button-col .delete-button .ant-btn-icon path {\n  color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file.display-progress-bar {\n  height: 52px;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file.display-progress-bar .uploaded-file-row {\n  height: 100%;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file.display-progress-bar .uploaded-file-row .icon-col svg {\n  margin: 0px 6px 12px 6px;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file.display-progress-bar .uploaded-file-row .path-col {\n  height: 100%;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file.display-progress-bar .uploaded-file-row .path-col .file-path {\n  margin-top: 13px;\n  margin-bottom: -3px;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file.display-progress-bar .uploaded-file-row .path-col .progress-bar {\n  width: 100%;\n  height: 6px;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file.display-progress-bar .uploaded-file-row .path-col .progress-bar .ant-progress {\n  height: 100%;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file.display-progress-bar .uploaded-file-row .path-col .progress-bar .ant-progress .ant-progress-bg {\n  background-color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file.rejected .uploaded-file-row .icon-col svg {\n  color: #de1b1b;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file.rejected .uploaded-file-row .file-path {\n  color: #de1b1b;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file.rejected .uploaded-file-row .delete-button-col .delete-button .ant-btn-icon path {\n  color: #de1b1b;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list .uploaded-file.rejected .uploaded-file-row .delete-button-col:hover .ant-btn-icon path {\n  color: #f55353;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list.display-multiple-files li:first-child {\n  border-radius: 8px 8px 0px 0px;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list.display-multiple-files li {\n  border-radius: 0px;\n}\n.nackle-upload .uploaded-files-list-container .uploaded-file-list.display-multiple-files li:last-child {\n  border-radius: 0px 0px 8px 8px;\n}\n.nackle-upload .uploaded-files-list-container.uploaded-files-list-container-small {\n  max-width: 313px;\n  align-self: center;\n  margin-top: 0px;\n}\n.nackle-upload .uploaded-files-list-container.uploaded-files-list-container-small .uploaded-file-list {\n  margin-top: 10px;\n}\n.nackle-upload .uploaded-files-list-container.uploaded-files-list-container-small .uploaded-file-list .uploaded-file .uploaded-file-row .path-col {\n  align-items: center;\n  font-size: 12px;\n  width: 225px;\n  margin-right: 6px;\n}\n.nackle-upload .uploaded-files-list-container.uploaded-files-list-container-small .uploaded-file-list .uploaded-file .uploaded-file-row .delete-button-col {\n  margin-left: 0px;\n}\n.ant-select {\n  font-size: 16px;\n  font-weight: 400;\n  display: block;\n}\n.ant-select.ant-select-focused .ant-select-selector {\n  border-color: #9099a9;\n  box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);\n}\n.ant-select .select-loading {\n  transform: rotate(45deg);\n  animation-name: Rotate;\n  animation-duration: 1.2s;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n}\n.ant-select .ant-select-selector {\n  border: 1px solid #c9d1df;\n  align-items: center;\n}\n.ant-select .ant-select-selector:hover {\n  border-color: #9099a9;\n}\n.ant-select .ant-select-selector:focus {\n  border-color: #9099a9;\n  box-shadow: 0 0 4px 0 rgba(50, 114, 217, 0.75);\n}\n.ant-select .ant-select-selector .ant-select-selection-item .ant-checkbox-wrapper .ant-checkbox {\n  display: none;\n}\n.ant-select .ant-select-selector .ant-select-selection-item .ant-checkbox-wrapper span {\n  padding: 0;\n}\n.ant-select .ant-select-selector .ant-select-selection-item .ant-radio-wrapper .ant-radio {\n  display: none;\n}\n.ant-select .ant-select-selector .ant-select-selection-item .ant-radio-wrapper span {\n  padding: 0;\n}\n.ant-select .ant-select-selector .ant-select-selection-placeholder {\n  color: #9099a9;\n}\n.ant-select .ant-select-arrow {\n  color: #59606d;\n}\n.ant-select.ant-select-sm .ant-select-selector {\n  font-size: 12px;\n  padding: 5px 8px;\n}\n.ant-select.ant-select-sm .ant-select-selector.ant-select-arrow {\n  margin-right: 8px;\n}\n.ant-select .ant-select-selector {\n  font-size: 14px;\n  padding: 8px 10px;\n}\n.ant-select .ant-select-selector.ant-select-arrow {\n  margin-right: 10px;\n}\n.ant-select.ant-select-lg .ant-select-selector {\n  font-size: 16px;\n  padding: 10px 12px;\n}\n.ant-select.ant-select-lg .ant-select-selector.ant-select-arrow {\n  margin-right: 12px;\n}\n.ant-select.ant-select-multiple .ant-select-selection-item,\n.ant-select.ant-select-multiple.ant-select-sm .ant-select-selection-item,\n.ant-select.ant-select-multiple.ant-select-lg .ant-select-selection-item {\n  background-color: #f5f7fa;\n  line-height: 24px;\n  padding: 0px 8px;\n}\n.ant-select.ant-select-multiple.ant-select-selection-overflow-item.ant-select-selection-item {\n  padding: 0px 8px;\n  height: 20px;\n  background-color: #f5f7fa;\n  line-height: 24px;\n}\n.ant-select.ant-select-multiple.ant-select-lg .ant-select-selection-item {\n  padding: 0px 10px;\n  height: 24px;\n  gap: 8px;\n}\n.ant-select.ant-select-multiple.ant-select-sm .ant-select-selection-item {\n  padding: 0px 6px;\n  height: 16px;\n  gap: 4px;\n}\n.ant-select.ant-select-disabled.ant-select-outlined .ant-select-selector {\n  background-color: #f5f7fa;\n}\n.ant-select.ant-select-disabled.ant-select-outlined .ant-select-selector:hover {\n  border: 1px solid #c9d1df;\n}\n.ant-select.ant-select-disabled .ant-select-arrow {\n  color: #b1baca;\n}\n.ant-select.ant-select-single {\n  min-height: 36px;\n  border-radius: 6px;\n}\n.ant-select.ant-select-single.ant-select-open {\n  border-radius: 6px;\n}\n.ant-select.ant-select-single .ant-select-selector {\n  border-radius: 6px;\n}\n.ant-select.ant-select-single .ant-select-selector {\n  min-height: 36px;\n}\n.ant-select.ant-select-lg {\n  min-height: 44px;\n  border-radius: 8px;\n}\n.ant-select.ant-select-lg.ant-select-open {\n  border-radius: 8px;\n}\n.ant-select.ant-select-lg .ant-select-selector {\n  border-radius: 8px;\n}\n.ant-select.ant-select-lg.ant-select-single .ant-select-selector {\n  min-height: 44px;\n}\n.ant-select.ant-select-sm {\n  min-height: 26px;\n  border-radius: 4px;\n}\n.ant-select.ant-select-sm.ant-select-open {\n  border-radius: 4px;\n}\n.ant-select.ant-select-sm .ant-select-selector {\n  border-radius: 4px;\n}\n.ant-select.ant-select-sm.ant-select-single .ant-select-selector {\n  min-height: 26px;\n}\n.ant-select.ant-select-multiple {\n  border-radius: 6px;\n}\n.ant-select.ant-select-multiple .ant-select-selection-overflow {\n  padding: 8px 10px;\n}\n.ant-select.ant-select-multiple .ant-select-selection-overflow .ant-select-selection-overflow-item {\n  max-height: 20px;\n  align-items: center;\n}\n.ant-select.ant-select-multiple .ant-select-selection-overflow .ant-select-selection-overflow-item .ant-select-selection-item-remove {\n  color: #59606d;\n}\n.ant-select.ant-select-multiple .ant-select-selection-overflow .ant-select-selection-overflow-item .ant-select-selection-item-remove:hover {\n  color: black;\n}\n.ant-select.ant-select-multiple .ant-select-selection-overflow .ant-select-selection-overflow-item .ant-select-selection-item-remove svg {\n  width: 14px;\n  height: 14px;\n}\n.ant-select.ant-select-multiple .ant-select-selection-overflow .ant-select-selection-overflow-item .ant-select-selection-item-remove:hover {\n  color: black;\n}\n.ant-select.ant-select-multiple.ant-select-sm {\n  border-radius: 4px;\n}\n.ant-select.ant-select-multiple.ant-select-sm.ant-select-open {\n  border-radius: 4px;\n}\n.ant-select.ant-select-multiple.ant-select-sm .ant-select-selector {\n  border-radius: 4px;\n}\n.ant-select.ant-select-multiple.ant-select-sm .ant-select-selection-item .ant-select-selection-item-remove svg {\n  width: 12px;\n  height: 12px;\n}\n.ant-select.ant-select-multiple.ant-select-lg {\n  border-radius: 8px;\n}\n.ant-select.ant-select-multiple.ant-select-lg.ant-select-open {\n  border-radius: 8px;\n}\n.ant-select.ant-select-multiple.ant-select-lg .ant-select-selector {\n  border-radius: 8px;\n}\n.ant-select.ant-select-multiple.ant-select-lg .ant-select-selection-item .ant-select-selection-item-remove svg {\n  width: 16px;\n  height: 16px;\n}\n.ant-select.ant-select-multiple {\n  min-height: 36px;\n}\n.ant-select.ant-select-multiple .ant-select-selector {\n  min-height: 36px;\n  height: auto;\n  padding: 0;\n}\n.ant-select.ant-select-multiple .ant-select-selection-overflow {\n  padding: 8px 10px 0px 10px;\n}\n.ant-select.ant-select-multiple .ant-select-selection-overflow .ant-select-selection-overflow-item {\n  max-height: 20px;\n}\n.ant-select.ant-select-multiple .ant-select-selection-overflow .ant-select-selection-overflow-item .ant-select-selection-item-remove {\n  color: #59606d;\n}\n.ant-select.ant-select-multiple .ant-select-selection-overflow .ant-select-selection-overflow-item .ant-select-selection-item-remove:hover {\n  color: black;\n}\n.ant-select.ant-select-multiple.ant-select-lg {\n  min-height: 44px;\n}\n.ant-select.ant-select-multiple.ant-select-lg .ant-select-selection-overflow {\n  padding: 10px 12px 6px 12px;\n}\n.ant-select.ant-select-multiple.ant-select-lg .ant-select-selection-overflow .ant-select-selection-overflow-item {\n  max-height: 24px;\n}\n.ant-select.ant-select-multiple.ant-select-lg.ant-select-show-arrow,\n.ant-select.ant-select-multiple.ant-select-lg.ant-select-allow-clear .ant-select-selector {\n  min-height: 44px;\n  height: auto;\n  padding: 0;\n}\n.ant-select.ant-select-multiple.ant-select-sm {\n  min-height: 26px;\n}\n.ant-select.ant-select-multiple.ant-select-sm .ant-select-selection-overflow {\n  padding: 5px 8px 1px 8px;\n}\n.ant-select.ant-select-multiple.ant-select-sm .ant-select-selection-overflow .ant-select-selection-overflow-item {\n  max-height: 16px;\n}\n.ant-select.ant-select-multiple.ant-select-sm .ant-select-selector {\n  min-height: 26px;\n  height: auto;\n  padding: 0;\n  border: 1px solid #c9d1df;\n}\n.ant-select-item .ant-select-item-option-state svg {\n  width: 20px;\n  height: 20px;\n}\n.ant-select-item.ant-select-item-group {\n  padding: 6px 12px;\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 600;\n  min-height: 0;\n  color: #59606d;\n}\n.ant-select-item.ant-select-item-option {\n  padding: 5px 12px;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 400;\n}\n.ant-select-item.ant-select-item-option.ant-select-item-option-disabled {\n  color: #b1baca;\n}\n.ant-select-item.ant-select-item-option:hover {\n  background-color: #f5f7fa;\n}\n.ant-select-item.ant-select-item-option.ant-select-item-option-active {\n  background-color: #f5f7fa;\n}\n.ant-select-item.ant-select-item-option.ant-select-item-option-selected {\n  background-color: rgb(var(--color-primary-none, 89, 96, 109));\n  color: white;\n  font-weight: 400;\n}\n.ant-select-item.ant-select-item-option.ant-select-item-option-selected .ant-select-item-option-state svg {\n  color: white;\n}\n.ant-select-item.ant-select-item-option.ant-select-item-option-disabled {\n  color: #b1baca;\n}\n.ant-select-item.ant-select-item-option .ant-select-item-option-state {\n  color: white;\n}\n.ant-select-tree-treenode {\n  transition: transform 0.3s;\n}\n.ant-select-tree-treenode .ant-select-tree-switcher svg {\n  transition: transform 0.3s;\n}\n.ant-select-tree-treenode.ant-select-tree-treenode-switcher-close .ant-select-tree-switcher svg {\n  transform: rotate(-90deg);\n}\n.ant-tree-select .ant-select-selector .ant-select-selection-overflow .ant-select-selection-overflow-item,\n.ant-select-multiple .ant-select-selector .ant-select-selection-overflow .ant-select-selection-overflow-item {\n  margin-bottom: 8px;\n}\n.ant-tree-select .ant-select-selector .ant-select-selection-overflow .ant-select-selection-overflow-item .ant-select-selection-item,\n.ant-select-multiple .ant-select-selector .ant-select-selection-overflow .ant-select-selection-overflow-item .ant-select-selection-item {\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  gap: 6px;\n}\n.ant-tree-select.ant-select-lg .ant-select-selector .ant-select-selection-overflow-item,\n.ant-select-multiple.ant-select-lg .ant-select-selector .ant-select-selection-overflow-item,\n.ant-tree-select.ant-select-sm .ant-select-selector .ant-select-selection-overflow-item,\n.ant-select-multiple.ant-select-sm .ant-select-selector .ant-select-selection-overflow-item {\n  margin-bottom: 4px;\n}\n.ant-tree-select-dropdown .ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner {\n  background-color: rgb(var(--color-primary-none, 89, 96, 109));\n  border-color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-tree-select-dropdown .ant-select-tree .ant-select-tree-node-content-wrapper.ant-select-tree-node-selected,\n.ant-tree-select-dropdown .ant-select-tree .ant-select-tree-checkbox + span.ant-select-tree-node-selected {\n  background-color: rgb(var(--color-primary-none, 89, 96, 109));\n  color: white;\n}\n.ant-tree-select-dropdown .ant-select-tree .ant-select-tree-switcher .ant-select-tree-switcher-icon {\n  color: #59606d;\n}\n.ant-select-selection-search-input:focus {\n  box-shadow: none;\n}\n.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer):hover .ant-select-selector {\n  border-color: #9099a9;\n}\n.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer):focus-within .ant-select-selector {\n  border-color: #9099a9;\n}\n.ant-select-disabled:where(.css-dev-only-do-not-override-nnuwmp).ant-select:not(.ant-select-customize-input) .ant-select-selector {\n  background: #f5f7fa;\n}\n.ant-select-multiple.ant-select-disabled:where(.css-dev-only-do-not-override-nnuwmp).ant-select:not(.ant-select-customize-input) .ant-select-selector {\n  background: #f5f7fa;\n}\n@keyframes Rotate {\n  100% {\n    transform: rotate(405deg);\n  }\n}\n.ant-select-dropdown .ant-select-item-empty .ant-spin {\n  min-height: 200px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.select-radio.ant-tree-select-dropdown .ant-select-tree-checkbox .ant-select-tree-checkbox-inner {\n  border-radius: 50%;\n}\n.nkl-password-helper .nkl-password-helper-inner {\n  transition: all 200ms ease-in-out;\n}\n.nkl-password-helper .nkl-password-helper-inner .ant-input-affix-wrapper {\n  border: 1px solid #c9d1df;\n}\n.nkl-password-helper .nkl-password-helper-inner .ant-input-affix-wrapper:focus {\n  border: 1px solid #9099a9;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules,\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm,\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg {\n  border-radius: 8px;\n  transition: all 300ms ease;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules .all-passwords,\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm .all-passwords,\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg .all-passwords {\n  font-size: 12px;\n  font-weight: 400;\n  color: #59606d;\n  margin-top: 0px;\n  line-height: 16px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules .all-passwords.top,\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm .all-passwords.top,\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg .all-passwords.top {\n  margin-bottom: 6px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules ul,\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm ul,\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg ul {\n  margin: 0;\n  padding: 0;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules ul .complexity li,\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm ul .complexity li,\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg ul .complexity li {\n  display: inline-flex;\n  align-items: start;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules ul .complexity .complex-requirement,\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm ul .complexity .complex-requirement,\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg ul .complexity .complex-requirement {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules ul .complexity .complex-requirement ul,\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm ul .complexity .complex-requirement ul,\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg ul .complexity .complex-requirement ul {\n  padding-left: 16px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules li,\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm li,\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg li {\n  position: relative;\n  list-style-type: none;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules li > ul,\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm li > ul,\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg li > ul {\n  list-style-type: none;\n  padding-left: 16px;\n  line-height: 24px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules li,\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm li,\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg li {\n  gap: 4px;\n  align-items: center;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules .length,\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm .length,\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg .length {\n  display: inline-flex;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules .nkl-icon,\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm .nkl-icon,\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg .nkl-icon {\n  top: 0;\n  left: 0;\n  transition: fill 200ms ease;\n  width: 14px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules {\n  margin-top: 6px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules ul {\n  margin: 0;\n  padding: 0;\n  line-height: 10px;\n  display: flex;\n  flex-direction: column;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules ul .complexity li {\n  display: inline-flex;\n  align-items: start;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules ul .complexity .complex-requirement {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules ul .complexity .complex-requirement ul {\n  padding-left: 16px;\n  line-height: 24px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm {\n  font-size: 12px;\n  line-height: 16px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm .nkl-icon {\n  width: 12px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--sm ul {\n  line-height: 8px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg {\n  font-size: 16px;\n  line-height: 24px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg .nkl-icon {\n  width: 16px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper-rules--lg ul {\n  line-height: 12px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper--passes {\n  color: #038537;\n  gap: 4px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper--passes > .nkl-icon {\n  fill: #038537;\n  color: #038537;\n  font-size: 18px;\n  width: 14px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper--passes .nackle-caption {\n  color: #038537;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper--initial {\n  color: #59606d;\n  gap: 4px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper--initial.nackle-caption {\n  color: #59606d;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper--fails {\n  color: #de1b1b;\n  gap: 4px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper--fails .nackle-caption {\n  color: #de1b1b;\n}\n.nkl-password-helper .nkl-password-helper-inner .nkl-password-helper--fails > .nkl-icon {\n  fill: #de1b1b;\n  color: #de1b1b;\n  width: 14px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nackle-caption {\n  margin-top: 0px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nackle-caption div {\n  align-items: center;\n  display: flex;\n  gap: 4px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nackle-caption.large .nkl-icon {\n  width: 16px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nackle-caption.large .nkl-password-helper-rules,\n.nkl-password-helper .nkl-password-helper-inner .nackle-caption.large .confirm {\n  margin-left: 12px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nackle-caption.default .nkl-icon {\n  width: 14px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nackle-caption.default .nkl-password-helper-rules,\n.nkl-password-helper .nkl-password-helper-inner .nackle-caption.default .confirm {\n  margin-left: 10px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nackle-caption.small .nkl-icon {\n  width: 12px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nackle-caption.small .nkl-password-helper-rules,\n.nkl-password-helper .nkl-password-helper-inner .nackle-caption.small .confirm {\n  margin-left: 8px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nackle-caption .confirm {\n  display: inline-flex;\n  padding-top: 6px;\n}\n.nkl-password-helper .nkl-password-helper-inner .nackle-caption {\n  padding-left: 0px;\n  display: inline-flex;\n}\n.nkl-password-helper .nkl-password-helper-inner .ant-form.ant-form-small .ant-form-item-control .ant-form-item-explain {\n  margin-left: 8px;\n  padding-top: 2px;\n}\n.nkl-password-helper .nkl-password-helper-inner .ant-form .ant-form-item-control .ant-form-item-explain {\n  margin-left: 10px;\n}\n.nkl-password-helper .nkl-password-helper-inner .ant-form .ant-form-item-control .ant-form-item-explain .ant-form-item-explain-success {\n  color: #038537;\n}\n.nkl-password-helper .nkl-password-helper-inner .ant-form.ant-form-large .ant-form-item-control .ant-form-item-explain {\n  margin-left: 12px;\n  padding-top: 6px;\n}\n.nkl-password-helper input:focus::placeholder {\n  color: transparent;\n}\n.nkl-password-helper .ant-form-item-explain-error {\n  color: #de1b1b;\n}\n.nkl-password-helper .ant-form-item-explain-error .confirm-password-rule,\n.nkl-password-helper .ant-form-item-explain-error div {\n  display: flex;\n  align-items: center;\n  margin-left: 12px;\n  gap: 4px;\n}\n.nkl-password-helper .ant-form-item-explain-error .confirm-password-rule svg,\n.nkl-password-helper .ant-form-item-explain-error div svg {\n  width: 14px;\n  height: 14px;\n  align-items: center;\n}\n.nkl-password-helper .ant-input-affix-wrapper:focus-within,\n.nkl-password-helper .ant-input-affix-wrapper-focused {\n  box-shadow: 0px 0px 4px 0px #3272D9BF;\n  border: 1px solid #9099a9;\n}\n.nkl-password-helper .ant-input-affix-wrapper:focus-within .ant-input-suffix .ant-input-password-icon,\n.nkl-password-helper .ant-input-affix-wrapper-focused .ant-input-suffix .ant-input-password-icon {\n  color: #59606d;\n}\n/* Desktop */\n.ant-mask {\n  z-index: 1 !important;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal.ant-modal {\n  background-color: transparent;\n  border: none;\n  position: relative;\n  border-radius: 24px;\n  height: 475px;\n  top: 200px;\n  z-index: auto;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .vjs-has-started .vjs-control-bar {\n  display: none;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content {\n  background-color: transparent;\n  border-radius: 24px;\n  box-shadow: none;\n  z-index: 2;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-header {\n  border-bottom: none;\n  background-color: transparent;\n  display: none;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-close {\n  border-radius: 25px;\n  padding: 8px;\n  background-color: #59606d;\n  margin-bottom: -100px;\n  margin-right: -26px;\n  margin-top: -12px;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-close:hover {\n  background-color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-close-x {\n  color: #ffffff;\n  justify-content: center;\n  align-items: center;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body {\n  padding: 0 !important;\n  border-bottom-left-radius: 24px;\n  border-bottom-right-radius: 24px;\n  max-width: 845px;\n  overflow: hidden;\n  cursor: pointer;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .custom-content-wrapper {\n  background-color: black;\n  border-radius: 24px;\n  width: calc(100% - 2px);\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .controls {\n  position: absolute;\n  background-color: transparent;\n  align-items: center;\n  margin: auto;\n  left: 50%;\n  right: 50%;\n  top: 50%;\n  bottom: 50%;\n  z-index: 3;\n  display: flex;\n  opacity: 0;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .controls .controlsIcon-small {\n  width: 100px;\n  height: 100px;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .replay {\n  position: absolute;\n  background-color: transparent;\n  align-items: center;\n  margin: auto;\n  left: 50%;\n  right: 50%;\n  top: 50%;\n  bottom: 50%;\n  z-index: 3;\n  display: flex;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .replay .replay-icon {\n  width: 100px;\n  height: 100px;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  cursor: pointer;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .nackle-video-player {\n  height: 475px;\n  border-radius: 24px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-left: 0 !important;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-js {\n  border-radius: 30px;\n  width: calc(100% + 2px);\n  background-color: unset;\n  padding: 0px !important;\n  height: 100%;\n}\n@media screen and (max-width: 845px) {\n  .ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-js {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control {\n  width: 845px;\n  z-index: 3;\n  padding: 24px;\n  height: 130px;\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.9) 100%);\n  border-bottom-left-radius: 24px;\n  border-bottom-right-radius: 24px;\n  opacity: 0;\n  right: 0;\n  left: 0;\n  position: absolute;\n  bottom: 0;\n  transition: all 0.2s ease;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel {\n  width: 100%;\n  display: flex;\n  z-index: 4;\n  justify-content: space-between;\n  background-blend-mode: multiply;\n  border-bottom-left-radius: 24px;\n  border-bottom-right-radius: 24px;\n  margin-top: 24px;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control {\n  display: flex;\n  gap: 24px;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .play-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: 0.1s ease-out 1s;\n  -webkit-transition: 0.1s ease-out 1s;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .play-button:hover {\n  transition: 0.1s ease-out;\n  -webkit-transition: 0.1s ease-out;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .volume-control {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .volume-control .mute-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .volume-control .wrapper-input {\n  color: transparent;\n  max-width: 77px;\n  width: 100%;\n  height: 4px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  border-radius: 15px;\n  display: flex;\n  cursor: pointer;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .volume-control .wrapper-input .range-input {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 100%;\n  border-radius: 8px;\n  outline: none;\n  border-radius: 15px;\n  height: 4px;\n  background: #eceff4;\n  margin: 0px;\n  padding: 0px;\n  box-shadow: none;\n  border: none;\n  pointer-events: bounding-box;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .volume-control .wrapper-input .range-input:hover {\n  border: none;\n  pointer-events: none;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .volume-control .wrapper-input .range-input::-webkit-slider-thumb {\n  pointer-events: auto;\n  -webkit-appearance: none;\n  appearance: none;\n  height: 6px;\n  width: 6px;\n  background-color: #ffffff;\n  border-radius: 50%;\n  border: none;\n  transition: 0.2s ease-in-out;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .volume-control .wrapper-input .range-input::-moz-range-thumb {\n  pointer-events: auto;\n  height: 6px;\n  width: 6px;\n  background-color: #ffffff;\n  border-radius: 50%;\n  border: none;\n  transition: 0.2s ease-in-out;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .volume-control .wrapper-input .range-input::-webkit-progress-bar {\n  border-radius: 8px;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .volume-control .wrapper-input {\n  opacity: 0;\n  transition: opacity 200ms;\n  width: 0;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .volume-control:hover .wrapper-input {\n  opacity: 1;\n  transition: all 200ms;\n  display: flex;\n  width: 100%;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .video-timeline {\n  font-size: 16px;\n  font-weight: 400;\n  color: #ffffff;\n  display: inline-flex;\n  align-items: center;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .caption-control {\n  display: flex;\n  gap: 24px;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .control-panel .caption-control .screen-mobile-control {\n  display: none;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress {\n  margin-top: 24px;\n  width: 797px;\n  height: 4px;\n  z-index: 5;\n  display: flex;\n  color: transparent;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress .seek {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  cursor: pointer;\n  margin: 0;\n  background-color: transparent;\n  height: 4px;\n  padding: 0px;\n  border: none;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress .seek:hover + .seek-tooltip {\n  display: block;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress .seek-tooltip {\n  display: none;\n  position: absolute;\n  top: -50px;\n  margin-left: -20px;\n  font-size: 12px;\n  padding: 3px;\n  content: attr(data-title);\n  font-weight: 400;\n  color: #ffffff;\n  background-color: #444a53;\n  border-radius: 4px;\n  padding: 10px 20px;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress .seek:focus {\n  outline: none;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress .seek::-webkit-slider-runnable-track {\n  width: 100%;\n  cursor: pointer;\n  border-radius: 1.3px;\n  -webkit-appearance: none;\n  transition: all 0.4s ease;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress .seek::-webkit-slider-thumb {\n  height: 14px;\n  width: 14px;\n  border-radius: 16px;\n  background: rgb(var(--color-primary-none, 89, 96, 109));\n  cursor: pointer;\n  -webkit-appearance: none;\n  margin-left: -1px;\n  opacity: 0;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress .seek::-moz-range-thumb {\n  height: 14px;\n  width: 14px;\n  border-radius: 50px;\n  border: 1px solid rgb(var(--color-primary-none, 89, 96, 109));\n  background: rgb(var(--color-primary-none, 89, 96, 109));\n  cursor: pointer;\n  margin-top: 10px;\n  opacity: 0;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress .seek:hover::-moz-range-thumb {\n  position: absolute !important;\n  margin-top: 0px;\n  margin-left: 0px;\n  align-items: center;\n  width: 14px;\n  height: 14px;\n  opacity: 1;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress .seek:focus::-webkit-slider-runnable-track {\n  background: transparent;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress .seek::-moz-range-track {\n  width: 100%;\n  height: 8.4px;\n  cursor: pointer;\n  border: 1px solid transparent;\n  background: transparent;\n  border-radius: 1.3px;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress .progress {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border-radius: 8px;\n  width: 100%;\n  height: 4px;\n  top: 0;\n  border: none;\n  pointer-events: none;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress:hover .progress {\n  height: 10px;\n  border-radius: 8px;\n  border: none;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress:hover .progress::-webkit-progress-bar {\n  height: 10px;\n  border-radius: 8px;\n  background-color: rgba(255, 255, 255, 0.4);\n  position: absolute;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .video-progress:hover .seek::-webkit-slider-thumb {\n  opacity: 1;\n  margin-top: 6px;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .progress::-webkit-progress-bar {\n  background-color: rgba(255, 255, 255, 0.4);\n  border-radius: 8px;\n  position: absolute;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .progress::-webkit-progress-value {\n  background-color: rgb(var(--color-primary-none, 89, 96, 109));\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n  position: absolute;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .progress::-webkit-progress-inner-element {\n  position: absolute;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .progress::-moz-progress-bar {\n  border: 1px solid rgb(var(--color-primary-none, 89, 96, 109));\n  background: rgb(var(--color-primary-none, 89, 96, 109));\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n  position: relative;\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .progress::-moz-range-progress {\n  position: relative;\n  background-color: rgba(255, 255, 255, 0.4);\n}\n.ant-modal-root .video-player-container-desktop.ant-modal .ant-modal-content .ant-modal-body .video-control .full-screen-icon {\n  position: absolute;\n  right: 24px;\n}\n.vjs-modal-dialog-content {\n  display: none;\n}\n.vjs-big-play-button {\n  display: none;\n}\n.vjs-play-control {\n  padding: 24px;\n  background-color: transparent;\n  border: none;\n}\n.vjs-control-bar {\n  display: none;\n}\n.vjs-control-text {\n  display: none;\n}\n.vjs-close-button {\n  display: none;\n}\n/* Mobile */\n@media screen and (max-width: 900px) {\n  .ant-modal-root .ant-modal.video-player-container-desktop {\n    height: auto;\n    top: 10%;\n    display: block !important;\n    margin: 0;\n    width: 100% !important;\n    padding-bottom: 0;\n  }\n  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content {\n    top: 50%;\n    padding-left: 24px;\n    padding-right: 24px;\n    height: 100%;\n    border-radius: 0;\n    padding: 0px;\n    display: flex;\n    flex-direction: column;\n  }\n  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-close {\n    margin-right: 0;\n  }\n  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .nackle-video-player {\n    height: 100%;\n  }\n  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .nackle-video-player .video-js {\n    justify-content: start;\n    border-radius: 0;\n    height: auto;\n  }\n  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .nackle-video-player .video-js .vjs-tech {\n    position: static;\n  }\n  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .full-screen {\n    padding: 0;\n  }\n  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .video-control {\n    width: auto;\n  }\n  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .video-control .video-progress {\n    width: 100%;\n  }\n  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .volume-control:hover .wrapper-input {\n    display: none;\n  }\n  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .video-control .control-panel .audio-control .volume-control .wrapper-input {\n    display: none;\n  }\n}\n@media screen and (max-width: 900px) {\n  .ant-modal-root .ant-modal.video-player-container-desktop {\n    height: 100%;\n    top: unset;\n    visibility: visible !important;\n  }\n  .ant-modal-root .ant-modal.video-player-container-desktop.ant-modal.ant-modal {\n    display: flex !important;\n  }\n  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content {\n    top: unset;\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-close {\n    display: none;\n  }\n  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body {\n    height: 100%;\n    border-radius: 0;\n    width: 100%;\n    max-width: 100% !important;\n  }\n  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .custom-content-wrapper {\n    height: 100%;\n    border-radius: 0;\n    width: auto;\n  }\n  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .custom-content-wrapper .nackle-video-player {\n    height: 100%;\n  }\n  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .custom-content-wrapper .nackle-video-player .video-js {\n    width: 100%;\n  }\n  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .custom-content-wrapper .nackle-video-player .video-js .vjs-tech {\n    border-radius: 0;\n  }\n  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .custom-content-wrapper .video-control {\n    border-radius: 0;\n  }\n  .ant-modal-root .ant-modal.video-player-container-desktop .ant-modal-content .ant-modal-body .custom-content-wrapper .video-control .screen-control {\n    display: block;\n  }\n}\n.video {\n  -webkit-mask-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAA5JREFUeNpiYGBgAAgwAAAEAAGbA+oJAAAAAElFTkSuQmCC);\n  mask-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAA5JREFUeNpiYGBgAAgwAAAEAAGbA+oJAAAAAElFTkSuQmCC);\n  width: 845px;\n  height: 475px;\n  object-fit: cover !important;\n  background-size: cover;\n  border-radius: 24px;\n}\n.screen-mobile-control {\n  display: flex;\n}\n.video-player-container-desktop video:state(webkit-media-controls-fullscreen-button) {\n  background-image: url('https://api.biw.cloud/v1/images/arrow-expands-right.png');\n}\n.video-player-container-desktop video:state(webkit-scrollbar-track) {\n  background-image: url('https://api.biw.cloud/v1/images/arrow-expands-right.png');\n}\n.video-player-container-desktop .video:state(webkit-media-controls-timelinev) {\n  visibility: visible;\n}\n.video-player-container-desktop video:state(webkit-media-controls-overlay-play-button) {\n  display: none;\n}\n.video-player-container-desktop *:state(webkit-media-controls-panel) {\n  display: none !important;\n  appearance: none;\n  -webkit-appearance: none !important;\n}\n.video-player-container-desktop *::-moz-media-controls-panel {\n  display: none !important;\n  -webkit-appearance: none !important;\n  appearance: none;\n}\n.video-player-container-desktop *:state(webkit-media-controls-play-button) {\n  display: none !important;\n  appearance: none;\n}\n.video-player-container-desktop *:state(webkit-media-controls-start-playback-button) {\n  display: none !important;\n  appearance: none;\n  -webkit-appearance: none;\n}\n.secondVideoElement {\n  display: none;\n}\n.full-progress {\n  width: 100% !important;\n  margin-bottom: 100px !important;\n  opacity: 0;\n  transition: all 0.2s ease;\n  position: absolute;\n  padding: 0px !important;\n}\n.full-control {\n  width: 100% !important;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px;\n  margin-left: 0px !important;\n  opacity: 0 !important;\n}\n.full-control:hover .full-progress {\n  opacity: 1;\n}\n.full-control:hover .full-panel {\n  opacity: 1;\n}\n.full-screen {\n  width: 100% !important;\n  height: 100% !important;\n}\n.full-panel {\n  position: absolute !important;\n  width: 100% !important;\n  padding-left: 24px;\n  padding-right: 24px;\n  padding-top: 24px;\n  opacity: 0;\n  transition: all 0.2s ease;\n}\n.video-player-container-desktop .video-control:hover {\n  opacity: 1 !important;\n}\n.hidden {\n  visibility: hidden;\n}\n.visible {\n  visibility: hidden;\n}\n.vjs-tech {\n  height: auto;\n  z-index: 1;\n  width: 100%;\n  border-radius: 24px;\n  justify-content: center;\n}\n.vjs-control-bar {\n  display: flex;\n}\n.vjs-big-play-centered {\n  border-bottom-left-radius: 24px;\n  border-bottom-right-radius: 24px;\n}\n.vjs-default-skin .vjs-progress-holder {\n  height: 100%;\n}\n.vjs-default-skin .vjs-progress-holder .vjs-play-progress,\n.vjs-default-skin .vjs-progress-holder .vjs-load-progress {\n  position: absolute;\n  display: block;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  /* Needed for IE6 */\n  left: 0;\n  top: 0;\n}\n.vjs-poster {\n  display: none;\n}\n.video-full-screen {\n  width: 100% !important;\n  height: 100% !important;\n}\n.global-nav {\n  display: flex;\n  justify-content: space-between;\n  border-style: none;\n}\n.global-nav .ant-select {\n  border-style: none;\n}\n.global-nav .ant-select .ant-select-selector {\n  width: 100%;\n  padding: 0;\n}\n.global-nav .ant-select .ant-select-selector.ant-select-outlined {\n  border: none;\n}\n.global-nav .ant-select .ant-select-selector .ant-select-selection-item {\n  font-size: 24px;\n  font-weight: 700;\n}\n.global-nav-header.ant-layout-header {\n  display: flex;\n  height: 50px;\n  padding: 6px 18px;\n  padding-inline: 18px;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #fff;\n  z-index: 10;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.05), inset 0px -1px 0px #f5f7fa;\n}\n.global-nav-header.ant-layout-header .ant-select {\n  min-width: 219px;\n}\n.global-nav-header.ant-layout-header .global-nav {\n  display: flex;\n}\n.image-container {\n  background-color: #eceff4;\n}\n.image-container .preview-image {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.ant-image-preview-close {\n  display: none;\n}\n.ant-image-preview-operations-wrapper {\n  position: relative;\n}\n.image-preview {\n  display: flex;\n  justify-content: center;\n  max-width: 80%;\n  max-height: 80%;\n}\n.image-preview > img {\n  max-width: 80%;\n  max-height: 80vh;\n  width: auto;\n  height: auto;\n  display: block;\n}\n.image-preview .ant-btn.ant-btn.ant-btn-default {\n  padding: 8px;\n  border-radius: 25px;\n  right: 16px;\n  bottom: 20px;\n  border: none;\n  background-color: #59606d;\n}\n.image-preview .ant-btn.ant-btn.ant-btn-default svg {\n  color: #ffffff;\n}\n.image-preview .ant-btn.ant-btn.ant-btn-default:hover {\n  background-color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.image-preview img {\n  background-color: #eceff4;\n}\n.ant-image-preview-root .ant-image-preview-mask {\n  background-color: rgba(201, 209, 223, 0.8);\n}\n.picker-popover .ant-popover-content .ant-popover-inner {\n  background-color: inherit;\n  border: none;\n  padding: 0px;\n  box-shadow: 0px 4px 16px 0px #34383F29;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn {\n  border: none;\n  box-shadow: 0px 2px 8px 0px #34383F29;\n  padding: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn .panel-color-picker {\n  align-items: center;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn .panel-color-picker .ant-color-picker-trigger {\n  min-width: 0px;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn .panel-color-picker .ant-color-picker-trigger .ant-color-picker-color-block {\n  width: 16.67px;\n  height: 16.67px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 4px;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn .panel-color-picker .ant-color-picker-trigger .ant-color-picker-trigger-text {\n  margin-inline-start: 0px;\n  margin-right: 0px;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn.circle {\n  border-radius: 25px;\n  min-width: 36px;\n  height: 36px;\n  padding: 8px;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn.circle .ant-color-picker-trigger {\n  min-width: 0px;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn.circle .ant-color-picker-color-block {\n  border-radius: 25px !important;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-sm {\n  padding: 5px;\n  height: 26px;\n  font-size: 12px;\n  line-height: 16px;\n  border-radius: 4px;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-sm .panel-color-picker .ant-color-picker-trigger {\n  min-width: 0px;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-sm .panel-color-picker .ant-color-picker-trigger .ant-color-picker-color-block {\n  width: 13.33px;\n  height: 13.33px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-sm .panel-color-picker .ant-color-picker-trigger .color-name {\n  font-size: 12px;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-sm.circle {\n  padding: 5px;\n  min-width: 26px;\n  border-radius: 25px;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-sm.trigger-button-with-text {\n  padding: 5px 12px 5px 12px;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-sm.trigger-circle-button-icon {\n  padding: 8px 12px;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-lg {\n  padding: 10px;\n  height: 44px;\n  font-size: 16px;\n  line-height: 24px;\n  border-radius: 8px;\n  min-width: 44px;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-lg .panel-color-picker .ant-color-picker-trigger {\n  min-width: 0px;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-lg .panel-color-picker .ant-color-picker-trigger .ant-color-picker-color-block {\n  width: 20px;\n  height: 20px;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-lg .panel-color-picker .ant-color-picker-trigger .color-name {\n  font-size: 16px;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-lg.circle {\n  border-radius: 25px;\n  padding: 10px;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-lg.trigger-button-with-text {\n  padding: 10px 20px 10px 20px;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn.ant-btn-lg.trigger-circle-button-icon {\n  padding: 8px 12px;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn .ant-color-picker-color-block {\n  width: 16.67px;\n  height: 16.67px;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn .panel-color-picker {\n  display: flex;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn .panel-color-picker .color-name {\n  color: #59606d;\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  font-family: var(--body-font-family-none, Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif, color emoji, segoe ui emoji, noto color emoji, android emoji);\n  align-content: center;\n  margin-left: 9px;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn .panel-color-picker .ant-color-picker-trigger,\n.nackle-trigger-color-picker .ant-btn.ant-btn .panel-color-picker .ant-color-picker-trigger-active {\n  background-color: transparent;\n  box-shadow: none;\n  border-inline-end-width: 0px;\n  border-color: transparent;\n  outline: 0;\n  padding: 0px;\n  border: none;\n  justify-content: start;\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn.trigger-button-with-text {\n  padding: 8px 16px 8px 16px;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn.trigger-circle-button-icon {\n  padding: 8px 12px;\n}\n.nackle-trigger-color-picker .ant-btn.ant-btn .color-name {\n  font-size: 14px;\n}\n.nackle-trigger-color-picker .gradient-panel .ant-popover {\n  position: static;\n}\n/*swatch color picker panel style*/\n.ant-color-picker {\n  width: 292px;\n}\n.ant-color-picker .ant-color-picker-inner .ant-color-picker-presets-items {\n  padding: 20px;\n  justify-content: center;\n}\n.ant-color-picker .ant-color-picker-inner .ant-color-picker-presets-items .ant-color-picker-presets-color:hover {\n  transform: scale(1.2);\n}\n.ant-color-picker .ant-color-picker-inner .ant-color-picker-presets-items .ant-color-picker-presets-color:before {\n  display: none;\n}\n.ant-color-picker .ant-color-picker-inner .ant-color-picker-presets-items .ant-color-picker-presets-color-checked:after {\n  display: none;\n}\n.ant-color-picker .ant-color-picker-inner .ant-color-picker-presets-items .ant-color-picker-presets-color-checked .ant-color-picker-color-block-inner {\n  box-shadow: var(--currentColor) 0px 0px 0px 3px inset;\n  background: #ffffff !important;\n}\n.ant-color-picker .ant-color-picker-inner .ant-color-picker-presets-items .ant-color-picker-presets-color {\n  border: none;\n  border-radius: 50%;\n  width: 28px;\n  height: 28px;\n  margin: 3px;\n  box-shadow: 0px 2px 8px 0px #34383F29;\n}\n.ant-color-picker .ant-color-picker-inner .ant-color-picker-presets-items .ant-color-picker-color-block .ant-color-picker-color-block-inner {\n  width: 28px;\n  height: 28px;\n  border: none;\n}\n.ant-color-picker .ant-collapse-header {\n  display: none !important;\n}\n.gradient-panel .ant-popover {\n  position: static;\n}\n.ant-switch.origami-switch {\n  background-color: #9099a9;\n}\n.ant-switch.origami-switch.ant-switch-checked {\n  background-color: rgb(var(--color-primary-none, 89, 96, 109));\n}\n.ant-switch.origami-switch.ant-switch-checked:hover {\n  background-color: rgb(var(--color-primary-none, 89, 96, 109));\n  opacity: 0.9;\n}\n.ant-switch.origami-switch.ant-switch-checked.ant-switch-disabled {\n  background-color: rgb(var(--color-primary-none, 89, 96, 109));\n  opacity: 0.4;\n}\n.ant-switch.origami-switch.ant-switch-disabled {\n  background-color: #b1baca;\n  opacity: 0.4;\n}\n.ant-switch.origami-switch:hover {\n  background-color: #b1baca;\n}\n.ant-switch.origami-switch.origami-switch-large {\n  transform: scale(127.28%);\n}\n/* dropdown list */\n.nackle-behavior {\n  display: flex;\n  align-items: center;\n  height: 36px;\n  width: 100%;\n}\n.nackle-behavior img {\n  height: 36px;\n  width: 36px;\n  border-radius: 50%;\n  margin-right: 10px;\n}\n.ant-select-item-option-disabled {\n  background-color: #f5f7fa;\n}\n.ant-select-item-option-disabled .nackle-behavior img {\n  opacity: 0.54;\n}\n/* selected option */\n.ant-select .nackle-behavior {\n  height: 20px;\n}\n.ant-select .nackle-behavior img {\n  height: 20px;\n  width: 20px;\n}\n.ant-select .nackle-behavior.nackle-behavior-large {\n  height: 24px;\n}\n.ant-select .nackle-behavior.nackle-behavior-large img {\n  height: 24px;\n  width: 24px;\n}\n.ant-select .nackle-behavior.nackle-behavior-small {\n  height: 16px;\n}\n.ant-select .nackle-behavior.nackle-behavior-small img {\n  height: 16px;\n  width: 16px;\n}\n.ant-select.ant-select-disabled .ant-select-selection-item .nackle-behavior img {\n  opacity: 0.54;\n}\n.multi-button {\n  display: flex;\n}\n.multi-button .ant-btn.ant-btn.left-button {\n  border-right: none;\n  border-radius: 25px 0px 0px 25px;\n}\n.multi-button .ant-btn.ant-btn.left-button span {\n  display: flex;\n  align-items: center;\n}\n.multi-button .ant-btn.ant-btn.left-button svg {\n  width: 20px;\n  height: 20px;\n}\n.multi-button .ant-btn.ant-btn.left-button.ant-btn-lg svg {\n  width: 24px;\n  height: 24px;\n}\n.multi-button .ant-btn.ant-btn.left-button.ant-btn-sm svg {\n  width: 16px;\n  height: 16px;\n}\n.multi-button .ant-btn.ant-btn.right-button {\n  border-left: none;\n}\n.multi-button .ant-btn.ant-btn.right-button {\n  border-left: none;\n  border-radius: 0px 25px 25px 0px;\n}\n.multi-button .ant-btn.ant-btn.right-button:before {\n  height: 50%;\n  position: absolute;\n  inset-inline-start: -1px;\n  display: inline-block;\n  background-color: #59606d;\n  width: 1px;\n  content: \"\";\n}\n.multi-button .ant-btn.ant-btn.right-button svg {\n  width: 20px;\n  height: 20px;\n}\n.multi-button .ant-btn.ant-btn.right-button.ant-btn-lg svg {\n  width: 24px;\n  height: 24px;\n}\n.multi-button .ant-btn.ant-btn.right-button.ant-btn-sm svg {\n  width: 16px;\n  height: 16px;\n}\n.multi-button .ant-btn.ant-btn.right-button span {\n  display: flex;\n}\n.multi-button .ant-btn.ant-btn.right-button .left-button-icon {\n  border-radius: 8px 0px 0px 8px;\n}\n.multi-button .ant-btn.ant-btn.ant-btn-secondary {\n  background-color: #ffffff;\n  border: 1px solid #c9d1df;\n}\n.multi-button .ant-btn.ant-btn.ant-btn-secondary.right-button {\n  border-left: none;\n}\n.multi-button .ant-btn.ant-btn.ant-btn-secondary.left-button {\n  border-right: none;\n}\n.multi-button .ant-btn.ant-btn.ant-btn-secondary:hover {\n  border-color: #c9d1df;\n  color: rgba(var(--color-primary-none, 89, 96, 109), 0.9);\n}\n.multi-button .ant-btn.ant-btn.ant-btn-secondary.ant-btn-dangerous {\n  color: #de1b1b;\n}\n.multi-button .ant-btn.ant-btn.ant-btn-secondary.ant-btn-dangerous:hover {\n  color: #f55353;\n}\n.multi-button .ant-btn.ant-btn.ant-btn-primary:before {\n  background-color: #ffffff;\n}\n.multi-button .ant-btn.ant-btn:disabled:before {\n  background-color: #c9d1df;\n}\n.multi-button .ant-btn .ant-btn:not(.ant-btn-round, .ant-btn-circle).left-button {\n  border-right: none;\n  border-radius: 6px 0px 0px 6px;\n}\n.multi-button .ant-btn .ant-btn:not(.ant-btn-round, .ant-btn-circle).left-button.ant-btn-lg {\n  border-radius: 8px 0px 0px 8px;\n}\n.multi-button .ant-btn .ant-btn:not(.ant-btn-round, .ant-btn-circle).left-button.ant-btn-sm {\n  border-radius: 4px 0px 0px 4px;\n}\n.multi-button .ant-btn .ant-btn:not(.ant-btn-round, .ant-btn-circle).right-button {\n  border-left: none;\n  border-radius: 0px 6px 6px 0px;\n}\n.multi-button .ant-btn .ant-btn:not(.ant-btn-round, .ant-btn-circle).right-button.ant-btn-lg {\n  border-radius: 0px 8px 8px 0px;\n}\n.multi-button .ant-btn .ant-btn:not(.ant-btn-round, .ant-btn-circle).right-button.ant-btn-sm {\n  border-radius: 0px 4px 4px 0px;\n}\n.ant-popover.popover-menu.multi-menu {\n  width: auto;\n}\n@media only screen and (max-width: 735px) {\n  .ant-popover.popover-menu.multi-menu {\n    max-width: 300px;\n  }\n}\n.origami-redeem-section {\n  max-width: 400px;\n}\n.origami-redeem-section .redeem-menu {\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  margin: 0;\n  list-style-type: none;\n  width: 100%;\n}\n.origami-redeem-section .redeem-menu .redeem-option {\n  flex-basis: auto;\n  padding: 0;\n  width: 100%;\n  text-align: left;\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 8px;\n}\n.origami-redeem-section .redeem-menu .market-link {\n  display: block;\n  cursor: pointer;\n  width: 100%;\n}\n.origami-redeem-section .redeem-menu .market-link:hover,\n.origami-redeem-section .redeem-menu .market-link:focus {\n  text-decoration: none;\n}\n.origami-redeem-section .redeem-menu .market-link:hover .link-label,\n.origami-redeem-section .redeem-menu .market-link:focus .link-label {\n  background-color: #F5F7FA;\n  border-radius: 8px;\n}\n.origami-redeem-section .redeem-menu .market-link.is-disabled {\n  cursor: not-allowed;\n}\n.origami-redeem-section .redeem-menu .icon {\n  position: relative;\n  width: 18px;\n  height: 18px;\n  margin: 0 8px 0 4px;\n}\n.origami-redeem-section .redeem-menu svg {\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n@media screen and (max-width: 735px) {\n  .origami-redeem-section .redeem-menu svg {\n    width: auto;\n  }\n}\n.origami-redeem-section .redeem-menu .link-label {\n  display: flex;\n  align-items: center;\n  flex-basis: auto;\n  width: 100%;\n  height: 100%;\n  margin-top: 10px / 2;\n  padding: 14px;\n  color: #000;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16px;\n  pointer-events: none;\n}\n@media screen and (max-width: 735px) {\n  .origami-redeem-section .redeem-menu .link-label {\n    padding: 0;\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n}\n.origami-redeem-section .redeem-menu .link-label .rewards-store-description {\n  display: flex;\n  flex-direction: column;\n  align-self: start;\n  max-width: 265px;\n}\n.origami-redeem-section .redeem-menu .link-label img {\n  height: 44px;\n  margin-right: 10px;\n  align-self: start;\n}\n.origami-redeem-section .redeem-menu .link-label .link-text {\n  font-size: 16px;\n  font-weight: 600;\n  color: black;\n  margin-bottom: 2px;\n  line-height: 24px;\n}\n@media screen and (max-width: 735px) {\n  .origami-redeem-section .redeem-menu .link-label .link-text {\n    font-size: 14px;\n    line-height: 20px;\n  }\n}\n.origami-redeem-section .redeem-menu .link-label .sub-text {\n  font-size: 14px;\n  font-weight: 400;\n  color: #59606D;\n  line-height: 20px;\n}\n@media screen and (max-width: 735px) {\n  .origami-redeem-section .redeem-menu .link-label .sub-text {\n    font-size: 12px;\n    line-height: 16px;\n  }\n}\n.origami-redeem-section .redeem-menu .origami-external-link-icon {\n  position: relative;\n  width: 24px;\n  height: 24px;\n  margin-left: auto;\n  color: #59606D;\n}\n@media screen and (max-width: 735px) {\n  .origami-redeem-section .redeem-menu .origami-external-link-icon {\n    height: 100%;\n    top: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
